/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		"d-game": 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"debug":"debug","gluckgames":"gluckgames","pariplay":"pariplay"}[chunkId]||chunkId) + "-" + "7cbb8e4d9579c492e60d" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./assets/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("suga", [], factory);
	else if(typeof exports === 'object')
		exports["suga"] = factory();
	else
		root["suga"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(30);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Device = function () {
    function Device() {
        _classCallCheck(this, Device);
    }

    _createClass(Device, null, [{
        key: 'isInIframe',

        /**
         * @return {boolean} Are we in a iFrame
         */
        value: function isInIframe() {
            return self !== top;
        }

        /**
         * @return {boolean|string} Which IE browser are we
         */

    }, {
        key: 'whichIE',
        value: function whichIE() {
            var myNav = navigator.userAgent.toLowerCase();

            if (myNav.indexOf('msie') !== -1) {
                return parseInt(myNav.split('msie')[1], 10);
            }

            return false;
        }

        /**
         * @return {boolean} is this a webkit browser
         */

    }, {
        key: 'isWebkit',
        value: function isWebkit() {
            return (/WebKit/.test(navigator.userAgent)
            );
        }

        /**
         * @return {boolean} is this iOS
         */

    }, {
        key: 'isIOS',
        value: function isIOS() {
            return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
            );
        }

        /**
         * @return {boolean} is this a touch device
         */

    }, {
        key: 'isTouchscreen',
        value: function isTouchscreen() {
            return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        }

        /**
         * @return {boolean} is the device orientation landscape
         */

    }, {
        key: 'isLandscape',
        value: function isLandscape() {
            var v = Device.getViewport();

            var w = v.w;
            var h = v.h;

            var isLandscape = false;

            if (w > h) {
                isLandscape = true;
            }

            return isLandscape;
        }

        /**
         * @return {number} pixel density 1|2 no higher
         */

    }, {
        key: 'getDpi',
        value: function getDpi() {
            var dpi = Math.floor(window.devicePixelRatio);

            if (dpi > 2) {
                return 2;
            }

            return dpi;
        }

        /**
         * Gets the resource postfix.
         *
         * @param  {number}  dpi  The dpi
         * @return {string}  The resource postfix.
         */

    }, {
        key: 'getResPostfix',
        value: function getResPostfix(dpi) {
            if (!dpi) {
                dpi = Device.getDpi();
            }

            if (dpi === 1) {
                return '';
            }
            var postfix = '@' + dpi + 'x';

            return postfix;
        }

        /**
         * @return {object} the viewport vp.w (width) & vp.h (height)
         */

    }, {
        key: 'getViewport',
        value: function getViewport() {
            var vp = {
                w: Math.floor(document.documentElement.clientWidth, window.innerWidth || 0),
                h: Math.floor(document.documentElement.clientHeight, window.innerHeight || 0)
            };

            return vp;
        }

        /**
         * @param {number} throttleMs - How many ms to throttle
         * @param {function} callback - Event handler
         */

    }, {
        key: 'resize',
        value: function resize(throttleMs, callback) {
            window.addEventListener('resize', function () {
                var vp = Device.getViewport();

                callback(vp);
            });
        }

        /**
         * @param {function} callback - Event handler
         * @return {object} reference to the listener
         */

    }, {
        key: 'pageVisibility',
        value: function pageVisibility(callback) {
            var hidden = void 0;
            var visibilityChange = void 0;

            var handleVisibilityChange = function handleVisibilityChange() {
                if (document[hidden]) {
                    callback(false);

                    return;
                }

                callback(true);
            };

            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                hidden = 'hidden';
                visibilityChange = 'visibilitychange';
            } else if (typeof document.mozHidden !== 'undefined') {
                hidden = 'mozHidden';
                visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                hidden = 'msHidden';
                visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                hidden = 'webkitHidden';
                visibilityChange = 'webkitvisibilitychange';
            }

            // Handle page visibility change
            return document.addEventListener(visibilityChange, handleVisibilityChange, false);
        }

        /**
         * Toggle Fulscreen
         *
         * @param  {DOMElement}   element  The element
         * @return {Boolean}  is fullscreen
         */

    }, {
        key: 'toggleFullscreen',
        value: function toggleFullscreen(element) {
            if (Device.fullscreenElement()) {
                return Device.exitFullscreen();
            }

            return Device.enterFullscreen(element);
        }

        /**
         * Enter Dullscreen
         *
         * @param  {DOMElement}  element  The element
         * @return {Boolean}     WHether we successfully made it into fulscreen
         */

    }, {
        key: 'enterFullscreen',
        value: function enterFullscreen(element) {
            var isFullscreen = false;

            if (element.requestFullscreen) {
                isFullscreen = true;
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                isFullscreen = true;
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                isFullscreen = true;
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                isFullscreen = true;
                element.msRequestFullscreen();
            }

            return isFullscreen;
        }

        /**
         * Leave Fullscreen
         *
         * @return {Boolean}  nolonger in Fullscreen
         */

    }, {
        key: 'exitFullscreen',
        value: function exitFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }

            return false;
        }

        /**
         * Are we currently in Fullscreen
         *
         * @return {Boolean}  Are we currently in Fullscreen
         */

    }, {
        key: 'fullscreenElement',
        value: function fullscreenElement() {
            return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
        }

        /**
         * Is fullscreen possible on this device
         *
         * @return {Boolean}  Is fullscreen possible on this device
         */

    }, {
        key: 'fullscreenEnabled',
        value: function fullscreenEnabled() {
            return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
        }

        /**
         * Adds a clock.
         *
         * @param  {DOMElement}  element  The element
         */

    }, {
        key: 'addClock',
        value: function addClock(element) {
            var clock = document.createElement('div');

            clock.id = 'clock';
            clock.innerHTML = Device.timeNow();

            clock.style.position = 'absolute';
            clock.style.top = '10px';
            clock.style.right = '10px';
            clock.style.zIndex = 99999;
            clock.style.color = '#FFFFFF';
            clock.style.backgroundColor = '#000000';
            clock.style.padding = '5px';
            clock.style.borderRadius = '2px';

            element.appendChild(clock);

            Device.updateClock();
        }

        /**
         * Removes the clock.
         */

    }, {
        key: 'removeClock',
        value: function removeClock() {
            window.setTimeout(Device.prototype.clockTimer);

            var clock = document.getElementById('clock');

            if (!clock) return;
            clock.parentNode.removeChild(clock);
        }

        /**
         * Update the time
         */

    }, {
        key: 'updateClock',
        value: function updateClock() {
            Device.prototype.clockTimer = window.setTimeout(function () {
                var clock = document.getElementById('clock');

                if (!clock) return;
                clock.innerHTML = Device.timeNow();
                Device.updateClock();
            }, 60 * 1000);
        }

        /**
         * Get time right now as 13:10
         *
         * @return {string}  The time
         */

    }, {
        key: 'timeNow',
        value: function timeNow() {
            console.log('TimeNow');
            var d = new Date();
            var h = (d.getHours() < 10 ? '0' : '') + d.getHours();
            var m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
            return h + ':' + m;
        }

        /**
         * Listen for fullscreen changes
         */

    }, {
        key: 'listenForFullscreenChanges',
        value: function listenForFullscreenChanges() {
            if (document.addEventListener) {
                document.addEventListener('webkitfullscreenchange', handler, false);
                document.addEventListener('mozfullscreenchange', handler, false);
                document.addEventListener('fullscreenchange', handler, false);
                document.addEventListener('MSFullscreenChange', handler, false);
            }

            function handler(val) {
                if (Device.fullscreenElement()) {
                    Device.addClock(Device.fullscreenElement());
                } else {
                    Device.removeClock();
                }
            }
        }
    }]);

    return Device;
}();

exports.default = Device;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Network = function () {
    function Network() {
        _classCallCheck(this, Network);
    }

    _createClass(Network, null, [{
        key: 'getJSON',

        /**
         * @param {string} url - Url of json file
         * @param {string} version - To version the urls
         * @param {Function} callback - Completion handler
         */
        value: function getJSON(url, version, callback) {
            url = url + '?v=' + version;

            var request = new XMLHttpRequest();

            // request.timeout = 120000;

            request.open('GET', url, true);

            request.onload = function () {
                return Network.handler(request, callback);
            };

            request.onerror = function (err) {
                return callback(err, null, request.status);
            };

            request.ontimeout = function () {
                return callback('timeout', null, request.status);
            };

            request.send();
        }

        /**
         * Handler function
         *
         * @param  {XMLHttpRequest}    request   The request
         * @param  {Function}  callback  The callback
         */

    }, {
        key: 'handler',
        value: function handler(request, callback) {
            var data = void 0;

            try {
                data = JSON.parse(request.responseText);
            } catch (err) {
                callback(err, null, request.status);

                return;
            }

            callback(null, data, request.status);
        }
    }]);

    return Network;
}();

exports.default = Network;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Progress = function () {
    function Progress() {
        _classCallCheck(this, Progress);
    }

    _createClass(Progress, null, [{
        key: 'init',


        /**
         * Instanitate and selec dom element
         * @param  {string} selector - css selector for getting element
         * @return {SUGA.Progress} for chaining
         */
        value: function init(selector) {
            this.prototype.percent = 0;
            this.prototype.queue = [];
            this.prototype.hasStarted = false;
            this.prototype.isProcessingQueue = false;
            this.prototype.doneDelay = 3000;
            this.prototype.incDelay = 20;

            this.prototype.selector = selector;
            this.prototype.container = document.getElementById(selector);

            this.prototype.bg = document.createElement('div');
            this.prototype.bg.id = 'progress-bg';
            this.prototype.container.appendChild(this.prototype.bg);

            this.prototype.bar = document.createElement('div');
            this.prototype.bar.id = 'progress-bar';
            this.prototype.bg.appendChild(this.prototype.bar);

            this.prototype.label = document.createElement('p');
            this.prototype.label.id = 'progress-percent';
            this.prototype.label.innerHTML = this.prototype.percent + '%';
            this.prototype.container.appendChild(this.prototype.label);

            return this;
        }

        /**
         * Starts progressing
         * @return {SUGA.Progress} for chaining
         */

    }, {
        key: 'start',
        value: function start() {
            this.prototype.bar.style.display = 'block';
            this.prototype.hasStarted = true;

            return this;
        }

        /**
        * Make progress bar end
        * @return {SUGA.Progress} for chaining
        */

    }, {
        key: 'done',
        value: function done() {
            clearTimeout(this.prototype.queueTimer);

            this.prototype.queue = [];
            this.prototype.hasStarted = false;
            this.prototype.isProcessingQueue = false;
            this.prototype.percent = 0;
            this.prototype.bar.style.display = 'none';
            this.prototype.bar.style.width = this.percent + '%';
            this.prototype.label.innerHTML = this.percent + '%';

            return this;
        }

        /**
        * Set percentage
        * @param {number} percentage - Progress percentage
        * @return {SUGA.Progress} for chaining
        */

    }, {
        key: 'set',
        value: function set(percentage) {
            if (!this.prototype.hasStarted) {
                return this;
            }

            this.prototype.queue.push(percentage);

            if (!this.prototype.isProcessingQueue) {
                Progress.processQueue();
            }

            return this;
        }

        /**
         * Process the queue
         * @private
         */

    }, {
        key: 'processQueue',
        value: function processQueue() {
            var _this = this;

            if (this.prototype.queue.length === 0) {
                this.prototype.isProcessingQueue = false;

                return;
            }

            this.prototype.isProcessingQueue = true;

            var amount = this.prototype.queue.shift();

            this.prototype.percent = amount * 100;

            this.prototype.queueTimer = setTimeout(function () {
                if (_this.prototype.percent >= 100) {
                    _this.prototype.percent = 100;
                }

                _this.prototype.bar.style.width = _this.prototype.percent + '%';

                _this.prototype.label.innerHTML = Math.round(_this.prototype.percent) + '%';

                if (_this.prototype.queue.length === 0 && _this.prototype.percent === 100 && _this.prototype.onComplete) {
                    Progress.onComplete();
                }

                Progress.processQueue();
            }, this.prototype.incDelay);
        }

        /**
         * Bump the bar a little
         * @return {SUGA.Progress} for chaining
         */

    }, {
        key: 'increment',
        value: function increment() {
            Progress.set(this.prototype.percent + 0.1 * this.prototype.percent);

            return this;
        }

        /**
         * Destroy this thing
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            Progress.done();

            this.prototype.container.innerHTML = '';

            delete this.prototype.selector;
            delete this.prototype.container;
            delete this.prototype.bg;
            delete this.prototype.bar;
            delete this.prototype.label;
        }
    }]);

    return Progress;
}();

exports.default = Progress;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(34);
var foreach = __webpack_require__(29);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(0);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(0);
var ES = __webpack_require__(21);
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(8);

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Currency & number formatting helper
 *
 * @example
 *
 * const currency = new SUGA.Currency(SUGA.Data)
 * const options = currency.setup("de-DE","EUR")
 * const formattedStr = currency.localize(1234.56,true,true)
 * // formattedStr is "1.234,56.00"
 */
var Currency = function () {
    /**
     * @typedef {Object} Options
     * @property {string} format - The format, e.g. `%s%v` is €10
     * @property {string} decimal - The decimal delimiter
     * @property {string} thousand - The thousand delimiter
     * @property {string} symbol - The currency symbol
     */

    /**
     * @param {object} data - currency data
     * @param {object} data.defaults - the most common currency formatting
     * @param {object} data.locales - the locale fallback
     * @param {object} data.currencies - the alternative formatting
     * @returns {SUGA.Currency} for chaining
     */
    function Currency(data) {
        _classCallCheck(this, Currency);

        this.defaults = data.defaults;
        this.locales = data.locales;
        this.currencies = data.currencies;

        return this;
    }

    /**
     * @param {string} locale - localeCode e.g. de-AT
     * @param {string} currency - currencyCode e.g. EUR
     * @returns {Options} the determined options
     */


    _createClass(Currency, [{
        key: 'setup',
        value: function setup(locale, currency) {
            if (!currency || currency === '') {
                throw new Error('No currency code provided');
            }

            if (!locale || locale === '') {
                throw new Error('No locale code provided');
            }

            var cc = currency.toUpperCase();
            var lc = locale;

            // if de-DE or hu-HU make de or hu
            var parts = lc.toLowerCase().split('-');

            if (parts[1] && parts[0] === parts[1]) {
                lc = parts[0];
            }

            var format = void 0;
            var decimal = void 0;
            var thousand = void 0;
            var symbol = void 0;

            // get the symbol
            symbol = this._lookFor(this.currencies.s, cc);

            // attempt to get formatting data for locale
            format = this._lookFor(this.locales.f, lc);
            decimal = this._lookFor(this.locales.d, lc);
            thousand = this._lookFor(this.locales.t, lc);

            // fallback to defaults if we have no data
            if (!format) {
                format = this.defaults.format;
            }
            if (!decimal) {
                decimal = this.defaults.decimal;
            }
            if (!thousand) {
                thousand = this.defaults.thousand;
            }

            // if no symbol use currency code
            if (!symbol) {
                symbol = cc;
                // if no format aswell use a different format
                format = this.defaults.noSymbolFormat;
            }

            thousand = this.nbspToSpace(thousand);
            decimal = this.nbspToSpace(decimal);

            this.options = {
                format: format,
                decimal: decimal,
                thousand: thousand,
                symbol: symbol
            };

            return this.options;
        }

        /**
         * Method that seaches throw data looking for matches
         *
         * @private
         * @param {array} data - data to search through
         * @param {string} query - item we are looking for
         * @return {object} What we found
         */

    }, {
        key: '_lookFor',
        value: function _lookFor(data, query) {
            for (var key in data) {
                var val = data[key];

                for (var i = 0, len = val.length; i < len; i++) {
                    if (val[i] === query) {
                        return key;
                    }
                }
            }

            return null;
        }

        /**
         * Determines if not numeric.
         *
         * @param  {Any}   n  { parameter_description }
         * @return {Boolean}  True if not numeric, False otherwise.
         */

    }, {
        key: 'isNotNumeric',
        value: function isNotNumeric(n) {
            return !(!isNaN(parseFloat(n)) && isFinite(n));
        }

        /**
         * @return {string} The current currency symbol
         */

    }, {
        key: 'getCurrencySymbol',
        value: function getCurrencySymbol() {
            return this.options.symbol;
        }

        /**
         * @param {number} amount - amount to format
         * @param {boolean} [showSymbol] - Should include symbol in formatting
         * @param {boolean} [show00] - should show `00` e.g. €13.00 = €13 but €12.10 = €12.10
         * @return {string} The localized representation of the given amount
         */

    }, {
        key: 'localize',
        value: function localize(amount, showSymbol, show00) {
            if (amount === '') {
                return '';
            }

            amount = parseFloat(amount);

            if (this.isNotNumeric(amount)) {
                console.error('Amount is not valid: ', amount); // eslint-disable-line

                return '';
            }

            if (show00 === undefined) {
                show00 = true;
            }

            amount = this.roundToDecimal(amount);
            var precision = this.getPrecision(amount, show00);
            var value = this.formatNumber(amount, precision, this.options);

            if (showSymbol === undefined) {
                showSymbol = true;
            }

            if (!showSymbol) {
                return value;
            }

            var result = this.options.format;

            result = result.replace('%s', this.options.symbol);
            result = result.replace('%v', value);

            return result;
        }

        /**
         * @param {number} amount - amount to format
         * @param {number} precision - number of decimal places
         * @param {object} options - formatter options
         * @return {string} The localized representation of the given amount with no symbol
         */

    }, {
        key: 'formatNumber',
        value: function formatNumber(amount, precision, options) {
            var usePrecision = precision;
            var negative = amount < 0 ? '-' : '';
            var base = String(parseInt(Math.abs(amount || 0).toFixed(usePrecision), 10));
            var mod = base.length > 3 ? base.length % 3 : 0;

            return negative + (mod ? base.substr(0, mod) + options.thousand : '') + base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + options.thousand) + (usePrecision ? options.decimal + Math.abs(amount).toFixed(usePrecision).split('.')[1] : '');
        }

        /**
         * @private
         * @param {number} amount - amount to format
         * @param {boolean} show00 - should show `00` e.g. €13.00 = €13 but €12.10 = €12.10
         * @return {string} The localized representation of the given amount with no symbol
         */

    }, {
        key: 'getPrecision',
        value: function getPrecision(amount, show00) {
            if (show00) {
                return 2;
            }

            if (amount % 1 !== 0) {
                return 2;
            }

            return 0;
        }

        /**
         * @private
         * @param {number} amount - amount to format
         * @return {number} Converts 10.967 = 10.97
         */

    }, {
        key: 'roundToDecimal',
        value: function roundToDecimal(amount) {
            return Math.round(amount * 100) / 100;
        }

        /**
         * @private
         * @param {number} char - character to test
         * @return {number} Returns a whitespace char in place of a nbsp
         */

    }, {
        key: 'nbspToSpace',
        value: function nbspToSpace(char) {
            if (char.charCodeAt(0) === 160) {
                char = String.fromCharCode(32);
            }

            return char;
        }
    }]);

    return Currency;
}();

exports.default = Currency;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var data = {
    defaults: {
        format: '%s%v',
        decimal: '.',
        thousand: ',',
        noSymbolFormat: '%s %v'
    },
    locales: {
        f: {
            '%s %v': ['ar', 'ar-AE', 'ar-BH', 'ar-DJ', 'ar-DZ', 'ar-EG', 'ar-EH', 'ar-ER', 'ar-IL', 'ar-IQ', 'ar-JO', 'ar-KM', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-MR', 'ar-OM', 'ar-PS', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SO', 'ar-SS', 'ar-SY', 'ar-TD', 'ar-TN', 'ar-YE', 'az', 'az-Latn', 'de-AT', 'de-CH', 'de-LI', 'en-AT', 'en-CH', 'en-IN', 'en-NL', 'en-US-POSIX', 'es-AR', 'es-CO', 'es-PY', 'es-UY', 'fr-CH', 'hy', 'it-CH', 'mk', 'mn', 'ms-BN', 'my', 'nb', 'nb-SJ', 'ne', 'ne-IN', 'nl', 'nl-AW', 'nl-BQ', 'nl-CW', 'nl-SR', 'nl-SX', 'pa', 'pa-Guru', 'root', 'ta', 'ta-LK', 'ta-MY', 'ta-SG', 'to', 'ur', 'ur-IN', 'vi'],
            '%v %s': ['be', 'bg', 'bs', 'bs-Latn', 'ca', 'ca-AD', 'ca-ES-VALENCIA', 'ca-FR', 'ca-IT', 'cs', 'da', 'da-GL', 'de', 'de-BE', 'de-LU', 'el', 'el-CY', 'en-150', 'en-BE', 'en-DE', 'en-DK', 'en-FI', 'en-SE', 'en-SI', 'es', 'es-EA', 'es-IC', 'es-PH', 'et', 'eu', 'fi', 'fo', 'fo-DK', 'fr', 'fr-BE', 'fr-BF', 'fr-BI', 'fr-BJ', 'fr-BL', 'fr-CA', 'fr-CD', 'fr-CF', 'fr-CG', 'fr-CI', 'fr-CM', 'fr-DJ', 'fr-DZ', 'fr-GA', 'fr-GF', 'fr-GN', 'fr-GP', 'fr-GQ', 'fr-HT', 'fr-KM', 'fr-LU', 'fr-MA', 'fr-MC', 'fr-MF', 'fr-MG', 'fr-ML', 'fr-MQ', 'fr-MR', 'fr-MU', 'fr-NC', 'fr-NE', 'fr-PF', 'fr-PM', 'fr-RE', 'fr-RW', 'fr-SC', 'fr-SN', 'fr-SY', 'fr-TD', 'fr-TG', 'fr-TN', 'fr-VU', 'fr-WF', 'fr-YT', 'he', 'hr', 'hr-BA', 'hu', 'is', 'it', 'it-SM', 'ka', 'kk', 'ky', 'lt', 'lv', 'nl-BE', 'pl', 'pt-AO', 'pt-CV', 'pt-GW', 'pt-MO', 'pt-MZ', 'pt-PT', 'pt-ST', 'pt-TL', 'ro', 'ro-MD', 'ru', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-UA', 'sk', 'sl', 'sq', 'sq-MK', 'sq-XK', 'sr', 'sr-Cyrl', 'sr-Cyrl-BA', 'sr-Cyrl-ME', 'sr-Cyrl-XK', 'sr-Latn', 'sr-Latn-BA', 'sr-Latn-ME', 'sr-Latn-XK', 'sv', 'sv-SE', 'sv-AX', 'sv-FI', 'tr', 'tr-CY', 'uk', 'uz', 'uz-Latn'],
            '%v%s': ['bn', 'bn-IN']
        },
        d: {
            ',': ['af', 'af-NA', 'ar-DZ', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-MR', 'ar-TN', 'az', 'az-Latn', 'be', 'bg', 'bs', 'bs-Latn', 'ca', 'ca-AD', 'ca-ES-VALENCIA', 'ca-FR', 'ca-IT', 'cs', 'da', 'da-GL', 'de', 'de-AT', 'de-BE', 'de-LU', 'el', 'el-CY', 'en-150', 'en-AT', 'en-BE', 'en-CH', 'en-DE', 'en-DK', 'en-FI', 'en-NL', 'en-SE', 'en-SI', 'en-ZA', 'es', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-EA', 'es-EC', 'es-GQ', 'es-IC', 'es-PH', 'es-PY', 'es-UY', 'es-VE', 'et', 'eu', 'fi', 'fo', 'fo-DK', 'fr', 'fr-BE', 'fr-BF', 'fr-BI', 'fr-BJ', 'fr-BL', 'fr-CA', 'fr-CD', 'fr-CF', 'fr-CG', 'fr-CI', 'fr-CM', 'fr-DJ', 'fr-DZ', 'fr-GA', 'fr-GF', 'fr-GN', 'fr-GP', 'fr-GQ', 'fr-HT', 'fr-KM', 'fr-LU', 'fr-MA', 'fr-MC', 'fr-MF', 'fr-MG', 'fr-ML', 'fr-MQ', 'fr-MR', 'fr-MU', 'fr-NC', 'fr-NE', 'fr-PF', 'fr-PM', 'fr-RE', 'fr-RW', 'fr-SC', 'fr-SN', 'fr-SY', 'fr-TD', 'fr-TG', 'fr-TN', 'fr-VU', 'fr-WF', 'fr-YT', 'gl', 'hr', 'hr-BA', 'hu', 'hy', 'id', 'is', 'it', 'it-SM', 'ka', 'kk', 'km', 'ky', 'lo', 'lt', 'lv', 'mk', 'ms-BN', 'nb', 'nb-SJ', 'nl', 'nl-AW', 'nl-BE', 'nl-BQ', 'nl-CW', 'nl-SR', 'nl-SX', 'pl', 'pt', 'pt-AO', 'pt-CV', 'pt-GW', 'pt-MO', 'pt-MZ', 'pt-PT', 'pt-ST', 'pt-TL', 'ro', 'ro-MD', 'ru', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-UA', 'sk', 'sl', 'sq', 'sq-MK', 'sq-XK', 'sr', 'sr-Cyrl', 'sr-Cyrl-BA', 'sr-Cyrl-ME', 'sr-Cyrl-XK', 'sr-Latn', 'sr-Latn-BA', 'sr-Latn-ME', 'sr-Latn-XK', 'sv', 'sv-SE', 'sv-AX', 'sv-FI', 'sw-CD', 'tr', 'tr-CY', 'uk', 'uz', 'uz-Latn', 'vi']
        },
        t: {
            ' ': ['af', 'af-NA', 'be', 'bg', 'cs', 'de-AT', 'en-FI', 'en-SE', 'en-ZA', 'es-CR', 'et', 'fi', 'fr', 'fr-BF', 'fr-BI', 'fr-BJ', 'fr-BL', 'fr-CA', 'fr-CD', 'fr-CF', 'fr-CG', 'fr-CH', 'fr-CI', 'fr-CM', 'fr-DJ', 'fr-DZ', 'fr-GA', 'fr-GF', 'fr-GN', 'fr-GP', 'fr-GQ', 'fr-HT', 'fr-KM', 'fr-MC', 'fr-MF', 'fr-MG', 'fr-ML', 'fr-MQ', 'fr-MR', 'fr-MU', 'fr-NC', 'fr-NE', 'fr-PF', 'fr-PM', 'fr-RE', 'fr-RW', 'fr-SC', 'fr-SN', 'fr-SY', 'fr-TD', 'fr-TG', 'fr-TN', 'fr-VU', 'fr-WF', 'fr-YT', 'hu', 'ka', 'kk', 'ky', 'lt', 'lv', 'nb', 'nb-SJ', 'pl', 'pt-AO', 'pt-CV', 'pt-GW', 'pt-MO', 'pt-MZ', 'pt-PT', 'pt-ST', 'pt-TL', 'ru', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-UA', 'sk', 'sq', 'sq-MK', 'sq-XK', 'sv', 'sv-SE', 'sv-AX', 'sv-FI', 'uk', 'uz', 'uz-Latn'],
            '.': ['ar-DZ', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-MR', 'ar-TN', 'az', 'az-Latn', 'bs', 'bs-Latn', 'ca', 'ca-AD', 'ca-ES-VALENCIA', 'ca-FR', 'ca-IT', 'da', 'da-GL', 'de', 'de-BE', 'de-LU', 'el', 'el-CY', 'en-150', 'en-AT', 'en-BE', 'en-CH', 'en-DE', 'en-DK', 'en-NL', 'en-SI', 'es', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-EA', 'es-EC', 'es-GQ', 'es-IC', 'es-PH', 'es-PY', 'es-UY', 'es-VE', 'eu', 'fo', 'fo-DK', 'fr-BE', 'fr-LU', 'fr-MA', 'gl', 'hr', 'hr-BA', 'hy', 'id', 'is', 'it', 'it-SM', 'km', 'lo', 'mk', 'ms-BN', 'nl', 'nl-AW', 'nl-BE', 'nl-BQ', 'nl-CW', 'nl-SR', 'nl-SX', 'pt', 'ro', 'ro-MD', 'sl', 'sr', 'sr-Cyrl', 'sr-Cyrl-BA', 'sr-Cyrl-ME', 'sr-Cyrl-XK', 'sr-Latn', 'sr-Latn-BA', 'sr-Latn-ME', 'sr-Latn-XK', 'sw-CD', 'tr', 'tr-CY', 'vi'],
            '\'': ['de-CH', 'de-LI', 'it-CH']
        }
    },
    currencies: {
        s: {
            '€': ['EUR'],
            '£': ['GBP'],
            kr: ['DKK', 'SEK', 'NOK'],
            $: ['AUD', 'CAD', 'NZD', 'USD', 'HKD', 'SGD'],
            Դ: ['AMD'],
            R$: ['BRL'],
            Kč: ['CZK'],
            '¥': ['JPY', 'CNY'],
            zł: ['PLN'],
            Ft: ['HUF'],
            '₦': ['NGN'],
            '৳': ['BDT'],
            CHF: ['CHF'],
            Rp: ['IDR'],
            '₩': ['KRW'],
            '₨': ['LKR'],
            RM: ['MYR'],
            C$: ['NIO'],
            '₱': ['PHP'],
            '₽': ['RUB'],
            '฿': ['THB'],
            R: ['ZAR'],
            '₺': ['TRY']
        }
    }
};

exports.default = data;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Event = function () {
    function Event() {
        _classCallCheck(this, Event);
    }

    _createClass(Event, null, [{
        key: 'trigger',

        /**
         * @param {string} eventName - Name of event to listen for e.g. 'resize'
         * @param {object} eventData - The data to send along
         * @return {object} Reference to the dispatched event
         */
        value: function trigger(eventName, eventData) {
            if (!eventData) {
                eventData = '';
            }

            var event = new CustomEvent(eventName, { detail: eventData });

            return document.dispatchEvent(event);
        }

        /**
         * @param {string} eventName - Name of event to listen for e.g. 'resize'
         * @param {object} callback - Event handler
         * @param {bool} onlyOnce - Should only fire once
         * @return {object} Reference to the callback function
         */

    }, {
        key: 'on',
        value: function on(eventName, callback, onlyOnce) {
            if (onlyOnce === undefined) {
                onlyOnce = false;
            }

            var _callback = function _callback(e) {
                if (onlyOnce) {
                    Event.off(eventName, _callback);
                }

                callback(e.detail, e);
            };

            document.addEventListener(eventName, _callback, false);

            return _callback;
        }

        /**
          * @param {string} eventName - Name of event to listen for e.g. 'resize'
          * @param {object} callback - Event handler
          * @return {object} Reference to the callback function
          */

    }, {
        key: 'once',
        value: function once(eventName, callback) {
            return Event.on(eventName, callback, true);
        }

        /**
          * @param {string} eventName - Name of event to listen for e.g. 'resize'
          * @param {object} callback - Event handler to remove
          */

    }, {
        key: 'off',
        value: function off(eventName, callback) {
            document.removeEventListener(eventName, callback, false);
        }
    }]);

    return Event;
}();

exports.default = Event;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _webfontloader = __webpack_require__(40);

var _webfontloader2 = _interopRequireDefault(_webfontloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Font = function () {
    function Font() {
        _classCallCheck(this, Font);
    }

    _createClass(Font, null, [{
        key: 'loadFonts',

        /**
         * @param {array} names - List of fonts to load
         * @param {string} url - To css file
         * @param {string} version - To version the urls
         * @param {function} callback - Completion handler
         */
        value: function loadFonts(names, url, version, callback) {
            if (!names || !url || !version) {
                throw new Error('Missing arguements');
            }

            url = url + '?v=' + version;

            _webfontloader2.default.load({
                // google:
                //   families: names
                custom: {
                    families: names,
                    urls: [url]
                },

                active: function active() {
                    var styles = Font.getStylesFromNames(names);

                    if (callback) {
                        callback(styles);
                    }
                },

                inactive: function inactive() {
                    if (callback) {
                        callback(null);
                    }
                }
            });
        }

        /**
         * @private
         * @param {array} names - List of fonts to load
         * @param {function} TextConstructor - A constructor to pre-make all fonts
         *                                   e.g. PIXI.Text
         * @return {array} All the constructed text objects
         */

    }, {
        key: 'getStylesFromNames',
        value: function getStylesFromNames(names) {
            if (!names) {
                throw new Error('Missing names arguement');
            }

            var tmp = [];

            for (var i = names.length - 1; i >= 0; i--) {
                var name = names[i];
                var nameParts = name.split(':');

                if (nameParts[1]) {
                    var weights = nameParts[1].split(',');

                    for (var _i = weights.length - 1; _i >= 0; _i--) {
                        var weight = weights[_i];

                        var font = {
                            fontFamily: nameParts[0],
                            fontWeight: weight[1] + '00'
                        };

                        tmp.push(font);
                    }
                } else {
                    var _font = {
                        fontFamily: nameParts[0],
                        fontWeight: 400
                    };

                    tmp.push(_font);
                }
            }

            return tmp;
        }
    }]);

    return Font;
}();

exports.default = Font;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _progress = __webpack_require__(3);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class for image manager.
 */
var Loader = function () {
    function Loader() {
        _classCallCheck(this, Loader);
    }

    _createClass(Loader, null, [{
        key: 'loadAsset',

        /**
        * Loads an asset.
        *
        * @param  {String}    url       The url
        * @param  {Function}  callback  The callback
        */
        value: function loadAsset(url, callback) {
            Loader.loadAssets([url], callback);
        }

        /**
        * Loads assets.
        *
        * @param  {String}    urls      The urls
        * @param  {Function}  callback  The callback
        */

    }, {
        key: 'loadAssets',
        value: function loadAssets(urls, callback) {
            if (!this.prototype.loader) {
                this.prototype.loader = new PIXI.loaders.Loader();
            }

            if (!this.prototype.allNamespaces) {
                this.prototype.allNamespaces = [];
            }

            urls = window.UTIL.uniq(urls);

            var tmp = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Array.from(urls)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var url = _step.value;

                    if (!this.prototype.loader.resources[url]) {
                        tmp.push(url);

                        var extension = url.split('.').pop();

                        if (extension === 'json') {
                            this.prototype.allNamespaces.push(url);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (!tmp.length) {
                callback('All assets already loaded', null);

                return;
            }

            this.prototype.loader.defaultQueryString = 'v=' + window.__version;
            this.prototype.loader.add(tmp);

            this.prototype.loader.on('progress', function (progress) {
                _progress2.default.set(progress.progress / 100);
            });

            this.prototype.loader.on('error', function (err) {
                callback(err, null);
            });

            this.prototype.loader.once('complete', function (result) {
                callback(null, result);
            });

            this.prototype.loader.load();
        }

        /**
         * Makes an array of textures from name.
         *
         * @param  {String}  name  The name
         * @return {Array}   Sorted array of textures
         */

    }, {
        key: 'makeTexturesFromName',
        value: function makeTexturesFromName(name) {
            var textures = [];

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Array.from(this.prototype.allNamespaces)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var namespace = _step2.value;

                    var newTextures = Loader.makeTexturesFromNamespace(namespace, name);

                    textures = textures.concat(newTextures);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            window.UTIL.sortArrayByKey(textures, ['__name']);

            return textures;
        }

        /**
         * Makes an array of textures from namespace.
         *
         * @param  {String}  namespace  The namespace
         * @param  {String}  name       The name
         * @return {Array}   Sorted array of textures
         */

    }, {
        key: 'makeTexturesFromNamespace',
        value: function makeTexturesFromNamespace(namespace, name) {
            var textures = this.prototype.loader.resources[namespace].textures;

            var re = new RegExp(name, 'g');

            var tmp = [];

            for (var key in textures) {
                var value = textures[key];

                if (key.match(re)) {
                    value.__name = key;
                    tmp.push(value);
                }
            }

            return tmp;
        }

        /**
         * Gets the sprite sheet image names.
         *
         * @return {Array}  The sprite sheet image names.
         */

    }, {
        key: 'getSpriteSheetImageNames',
        value: function getSpriteSheetImageNames() {
            var tmp = [];

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = Array.from(this.prototype.allNamespaces)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var resourceName = _step3.value;

                    tmp.push(resourceName + '_image');
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return tmp;
        }

        /**
         * Determines if we already have a resource
         *
         * @param  {String}  key  The key
         * @return {Boolean}  True if asset exists else False
         */

    }, {
        key: 'exists',
        value: function exists(key) {
            return !!this.prototype.loader.resources[key];
        }
    }]);

    return Loader;
}();

exports.default = Loader;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _network = __webpack_require__(2);

var _network2 = _interopRequireDefault(_network);

var _nodePolyglot = __webpack_require__(33);

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Locale = function () {
    /**
     * Constructs the object.
     *
     * @param  {string}       defaultLocale  - A locale like 'en'
     * @param  {string}       url            - Url to the dir with the lang files
     * @param  {string}       version        The app version
     * @return {SUGA.Locale}  For chaining
     */
    function Locale(defaultLocale, url, version) {
        _classCallCheck(this, Locale);

        this.url = url;
        this.defaultLocale = defaultLocale;
        this.version = version;

        this.polyglot = new _nodePolyglot2.default({
            warn: function warn(m) {
                return console.warn(m);
            }
        });

        return this;
    }

    /**
     * reset locale files
     */


    _createClass(Locale, [{
        key: 'clearLocales',
        value: function clearLocales() {
            this.polyglot.clear();
            this.hasDefaultLocale = false;
        }

        /**
         * @param {string} localeCode - e.g. en, en-GB
         * @param {function} callback - Completion handler
         */

    }, {
        key: 'setLocale',
        value: function setLocale(localeCode, callback) {
            var chain = this.getLoadingChain(localeCode, this.defaultLocale);

            this.loadLocaleData(chain, callback);
        }

        /**
         * @private
         * @param {string} localeCode - e.g. en, en-GB
         * @param {string} defaultCode - typically 'en'
         * @return {array} locales to load and in order
         */

    }, {
        key: 'getLoadingChain',
        value: function getLoadingChain(localeCode, defaultCode) {
            var chain = [defaultCode];

            if (localeCode === defaultCode || localeCode.length < 2) {
                return chain;
            }

            chain.push(localeCode.substr(0, 2));

            if (localeCode.length <= 4 || localeCode[2] !== '-') {
                return chain;
            }

            chain.push(localeCode);

            return chain;
        }

        /**
         * @private
         * @param {array} chain - e.g. en, en-GB
         * @param {function} callback - Completion handler
         */

    }, {
        key: 'loadLocaleData',
        value: function loadLocaleData(chain, callback) {
            var _this = this;

            var localeCode = chain.shift();

            var path = this.url + localeCode + '.json';

            // get base
            _network2.default.getJSON(path, this.version, function (err, json) {
                if (err) {
                    callback(err);
                }

                if (json && !err) {
                    _this.polyglot.extend(json);
                    _this.polyglot.locale(localeCode);
                }

                // is this an extended code
                if (chain.length > 0) {
                    _this.loadLocaleData(chain, callback);
                } else {
                    callback(null);
                }
            });
        }

        /**
         * Transalate string
         *
         * @param {string} string - phrase to localize
         * @param {object} vars - variables to interpolate
         * @return {string} Localized phrase
         */

    }, {
        key: 'str',
        value: function str(string, vars) {
            return this.polyglot.t(string, vars);
        }
    }]);

    return Locale;
}();

exports.default = Locale;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Reality = function () {
    function Reality() {
        _classCallCheck(this, Reality);
    }

    _createClass(Reality, null, [{
        key: 'init',

        /**
         * Initialzes the thing
         *
         * @param  {number}        interval  - Seconds between notifcations
         * @param  {function}      callback  - Reality check trigger handler
         * @param  {boolean}       debug     The debug
         * @return {SUGA.Reality}  for chaining
         */
        value: function init(interval, callback) {
            var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.prototype.elapsed = 0;
            this.prototype.started = false;
            this.prototype.startTime = null;
            this.prototype.needsToShowRealityCheck = false;
            this.prototype.allowedToShowRealityCheck = false;
            this.prototype.debug = debug;

            if (interval) {
                Reality.setInterval(interval);
            }

            if (callback) {
                Reality.setHandler(callback);
            }

            this.prototype.isInitialized = true;

            return this;
        }

        /**
         * @param {number} interval - Seconds between notifcations
         */

    }, {
        key: 'setInterval',
        value: function setInterval(interval) {
            if (interval) {
                this.prototype.interval = interval;
            }
        }

        /**
         * @param {number} [callback] - Reality check trigger handler
         */

    }, {
        key: 'setHandler',
        value: function setHandler(callback) {
            if (callback) {
                this.prototype.triggerHandler = callback;
            }
        }

        /**
         * @param {number} [interval] - Seconds between notifcations
         * @param {function} [callback] - Function called when reality check triggered
         */

    }, {
        key: 'start',
        value: function start(interval, callback) {
            if (!this.prototype.isInitialized) {
                throw new Error('Reality check is not initialized');
            }

            if (this.prototype.started) {
                return;
            }

            if (interval) {
                Reality.setInterval(interval);
            }

            if (callback) {
                Reality.setHandler(callback);
            }

            this.prototype.started = true;
            this.prototype.startTime = new Date().getTime();
            this.prototype.lastTime = this.prototype.startTime;

            Reality.loopInterval();
        }

        /**
         * Every n milliseconds check if time has lapsed
         * @private
         */

    }, {
        key: 'loopInterval',
        value: function loopInterval() {
            var _this = this;

            window.setInterval(function () {
                if (_this.prototype.debug) {
                    console.log(_this.prototype.elapsed / 1000, _this.prototype.interval); // eslint-disable-line
                }

                _this.prototype.currentTime = new Date().getTime();
                _this.prototype.elapsed = _this.prototype.currentTime - _this.prototype.lastTime;

                if (_this.prototype.elapsed > _this.prototype.interval * 1000) {
                    _this.prototype.lastTime = new Date().getTime();

                    Reality.tryToShowRealityCheck();
                }
            }, 1000); // Check interval every 1 seconds
        }

        /**
         * A method lets you tell when to & not to trigger a message
         * @param {boolean} allowedToShowRealityCheck - whether one can trigger a message
         * @return {boolean} Flag whether a check was triggered or not
         */

    }, {
        key: 'canShowRealityCheck',
        value: function canShowRealityCheck(allowedToShowRealityCheck) {
            this.prototype.allowedToShowRealityCheck = allowedToShowRealityCheck;

            if (this.prototype.allowedToShowRealityCheck && this.prototype.needsToShowRealityCheck) {
                Reality.triggerRealityCheck();

                return true;
            }

            return false;
        }

        /**
         * Try and trigger a reality check, if we are allowed
         */

    }, {
        key: 'tryToShowRealityCheck',
        value: function tryToShowRealityCheck() {
            if (!this.prototype.allowedToShowRealityCheck) {
                this.prototype.needsToShowRealityCheck = true;

                return;
            }

            Reality.triggerRealityCheck();
        }

        /**
         * @private
         */

    }, {
        key: 'triggerRealityCheck',
        value: function triggerRealityCheck() {
            this.prototype.needsToShowRealityCheck = false;

            var now = new Date().getTime();
            var duration = now - this.prototype.startTime;
            var timeObj = Reality.msToTime(duration);

            this.prototype.triggerHandler(timeObj);
        }

        /**
         * @private
         * @param {number} milli - Milliseconds
         * @return {object} time object with hours and minutes
         */

    }, {
        key: 'msToTime',
        value: function msToTime(milli) {
            var hours = parseInt(milli / (1000 * 60 * 60), 10);
            var mins = Math.round(milli / 1000 / 60) % 60;

            var res = {
                hours: hours,
                minutes: mins
            };

            return res;
        }
    }]);

    return Reality;
}();

exports.default = Reality;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _howlerCoreMin = __webpack_require__(31);

var _device = __webpack_require__(1);

var _device2 = _interopRequireDefault(_device);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Sound = function () {
    function Sound() {
        _classCallCheck(this, Sound);
    }

    _createClass(Sound, null, [{
        key: 'init',


        /**
         * @typedef  {Object}      SoundOpts
         * @property {string}      masterVolume        - the volume of all tracks
         * @property {string}      volumes             - the volume of the individual tracks
         * @property {string}      mute                - Tis playback silent
         * @property {string}      audioSpriteObj      - json sprite sheet object (see Howler docs)
         * @property {string}      mp3                 - url to the audio mp3 files
         * @property {string}      ogg                 - url to the audio ogg files
         * @property {DOMElement}  element             - element to listen for startclick;
         * @property {Boolean}     startOnInteraction  - whether to start immediately or after user interaction
         * @property {Boolean}     autoMute.           - mute audio when the window is not in focus
         */

        /**
         * Constructs the object.
         *
         * @param  {SoundOpts}  options   The options
         * @param  {Function}   callback  The callback
         */
        value: function init(options, callback) {
            Sound.prototype.masterVolume = options.masterVolume;
            Sound.prototype.volumes = options.volumes;
            Sound.prototype.mute = options.mute;
            Sound.prototype.audioSpriteObj = options.audioSpriteObj;
            Sound.prototype.mp3 = options.mp3;
            Sound.prototype.ogg = options.ogg;
            Sound.prototype.ids = {};
            Sound.prototype.element = options.element;
            Sound.prototype.startOnInteraction = options.startOnInteraction;
            Sound.prototype.autoMute = options.autoMute;

            // add some features to Howler
            Sound.extend();

            if (options.startOnInteraction) {
                Sound.startAudioOnInteraction(callback);
            } else {
                Sound.startAudio(callback);
            }

            if (options.autoMute) {
                Sound.startAutoMute();
            }
        }

        /**
         * Create and start the audio
         *
         * @param  {Function}  callback  The callback
         */

    }, {
        key: 'startAudio',
        value: function startAudio(callback) {
            _howlerCoreMin.Howler.mute(Sound.prototype.mute);

            Sound.prototype.sound = new _howlerCoreMin.Howl({
                src: [Sound.prototype.ogg, Sound.prototype.mp3],
                volume: Sound.prototype.masterVolume,
                sprite: Sound.prototype.audioSpriteObj.sprite,

                onloaderror: function onloaderror(id, error) {
                    if (callback) callback(error);
                },

                onload: function onload() {
                    if (callback) callback(null);
                }
            }); // start bg audio
        }

        /**
         * Starts audio on user interaction.
         *
         * @param  {Function}  callback  The callback
         */

    }, {
        key: 'startAudioOnInteraction',
        value: function startAudioOnInteraction(callback) {
            // Handler function to start Audio on first user interaction
            function startAudio() {
                // remove listener after first touch
                Sound.prototype.element.removeEventListener('touchend', startAudio, false);

                // load the audio files
                Sound.startAudio(callback);
            }

            // add a touch listener in order to start the audio from user interaction
            Sound.prototype.element.addEventListener('touchend', startAudio, false);
        }

        /**
         * Starts the event listener which will pause sound s when page is not visible.
         */

    }, {
        key: 'startAutoMute',
        value: function startAutoMute() {
            _device2.default.pageVisibility(function (isVisible) {
                if (isVisible) {
                    Sound.resumeAll();
                } else {
                    Sound.pauseAll();
                }
            });
        }

        /**
         * Sets the mute.
         *
         * @param  {Function}  newValue  The new value
         */

    }, {
        key: 'setMute',
        value: function setMute(newValue) {
            Sound.prototype.mute = newValue;

            _howlerCoreMin.Howler.mute(newValue);
        }

        /**
         * Play a sound by key and volume
         *
         * @param  {string}   key               The key
         * @param  {number}   vol               The volume
         * @param  {boolean}  onlyIfNotPlaying  Only if not already playing
         * @return {string}   id of playing sound
         */

    }, {
        key: 'play',
        value: function play(key, vol, onlyIfNotPlaying) {
            if (!Sound.prototype.sound) {
                return null;
            }

            if (onlyIfNotPlaying && Sound.prototype.sound.isPlayingByName(key)) {
                return null;
            }

            var id = Sound.prototype.sound.play(key);

            if (vol === null || vol === undefined) {
                vol = 1;
            }

            if (Sound.prototype.volumes[key] !== undefined) {
                vol *= Sound.prototype.volumes[key];
            }

            Sound.prototype.sound.volume(vol, id);

            Sound.prototype.ids[key] = id;

            // Pause if trying to play a sound while page
            // isnt visible
            if (document.hidden && Sound.prototype.autoMute) {
                Sound.prototype.sound.pause(id);
            }

            return id;
        }

        /**
         * Pleases an array of sounds in sequence
         *
         * @param  {Array}     sequence  The sequence
         * @param  {Function}  cb        Called on completion
         * @return {Function} the cancel sequence function
         */

    }, {
        key: 'playSequence',
        value: function playSequence(sequence, cb) {
            if (Sound.prototype.sound) {
                return Sound.prototype.sound.playSequence(sequence, cb);
            }

            return null;
        }

        /**
         * Pause all sounds
         */

    }, {
        key: 'pauseAll',
        value: function pauseAll() {
            if (Sound.prototype.sound) {
                Sound.prototype.sound.pause();
            }
        }

        /**
         * Resum all sounds
         */

    }, {
        key: 'resumeAll',
        value: function resumeAll() {
            if (Sound.prototype.sound) {
                Sound.prototype.sound.unpause(Sound.prototype.volumes);
            }
        }

        /**
         * Stop sound by key
         *
         * @param  {string}  key  The key/name of sound
         */

    }, {
        key: 'stop',
        value: function stop(key) {
            if (Sound.prototype.sound) {
                Sound.prototype.sound.killByName(key);
            }
        }

        /**
         * Fade sound
         *
         * @param  {string}  key   The key/name of sound
         * @param  {number}  to    Ending volume
         * @param  {number}  d     Duration
         */

    }, {
        key: 'fade',
        value: function fade(key, to, d) {
            if (d === null) {
                d = 2000;
            }

            var id = Sound.prototype.ids[key];

            if (!Sound.prototype.sound || !id) {
                return;
            }

            var from = Sound.prototype.sound.getSoundById(id)._volume;

            if (Sound.prototype.volumes[key] !== undefined) {
                to *= Sound.prototype.volumes[key];
            }

            Sound.prototype.sound.fade(from, to, d, id);
        }

        /**
         * Extend the functionality of Howler
         */

    }, {
        key: 'extend',
        value: function extend() {
            function unpause(volumes) {
                var self = this;
                var id = void 0;
                var i = 0;

                while (i < self._sounds.length) {
                    if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        var track = self._sounds[i];

                        id = track._id;
                        self.play(id, volumes[track._sprite]);
                    }
                    i++;
                }

                return self;
            }

            /**
             * Kill track by name
             *
             * @param  {String}  name  The name
             * @return {Object}  Self fo chaining
             */
            function killByName(name) {
                var self = this;
                var id = void 0;
                var track = void 0;
                var i = 0;

                while (i < self._sounds.length) {
                    track = self._sounds[i];
                    if (track._sprite && track._sprite === name) {
                        id = self._sounds[i]._id;
                        self.stop(id);
                    }
                    i++;
                }

                return self;
            }

            function isPlayingByName(name) {
                var self = this;
                var track = void 0;
                var i = 0;

                while (i < self._sounds.length) {
                    track = self._sounds[i];
                    if (track._sprite && track._sprite === name && !track._paused && !track._ended) {
                        return true;
                    }
                    i++;
                }

                return false;
            }

            function getSoundById(id) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this._sounds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var sound = _step.value;

                        if (sound._id === id) {
                            return sound;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return null;
            }

            function playSequence(sequence, handler) {
                var _this = this;

                var stop = false;
                var playingId = void 0;

                var stopFn = function stopFn() {
                    stop = true;
                    _this.stop(playingId);
                    if (handler) handler();
                };

                var recursiveSequence = function recursiveSequence(seq) {
                    if (stop) {
                        seq = [];

                        return;
                    }

                    var item = seq.shift();

                    if (item) {
                        var _cb = function _cb(endedId) //eslint-disable-line
                        {
                            if (id === endedId) {
                                this.off('end', _cb);
                                recursiveSequence(seq);
                            }
                        };

                        var id = _this.play(item);

                        playingId = id;

                        _this.on('end', _cb);
                    } else if (handler) handler();
                };

                recursiveSequence(sequence);

                return stopFn;
            }

            _howlerCoreMin.Howl.prototype.unpause = unpause;
            _howlerCoreMin.Howl.prototype.killByName = killByName;
            _howlerCoreMin.Howl.prototype.isPlayingByName = isPlayingByName;
            _howlerCoreMin.Howl.prototype.getSoundById = getSoundById;
            _howlerCoreMin.Howl.prototype.playSequence = playSequence;
        }
    }]);

    return Sound;
}();

exports.default = Sound;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Tracking = function () {
    /**
     * Setup the game code
     *
     * @param  {string}  gameCode  The game code
     * @param  {string}  version   The version
     */
    function Tracking(gameCode, version) {
        _classCallCheck(this, Tracking);

        this.gameCode = gameCode;
        this.version = version;
        this.jsErrors();
    }

    /**
     * Track user events
     *
     * @param  {string}  label     The label
     * @param  {string}  category  The category
     * @param  {string}  action    The action
     * @param  {number}  count     The count
     * @return {object} data sent to GA
     */


    _createClass(Tracking, [{
        key: 'event',
        value: function event(label, category, action, count) {
            if (!category) category = 'button';
            if (!action) action = 'click';
            if (!count) count = 0;

            if (!window.ga) return null;

            var event = {
                hitType: 'event', // Required.
                eventCategory: category, // Required.
                eventAction: action, // Required.
                eventLabel: label,
                eventValue: count
            };

            // GA Event tracking
            window.ga('send', event);

            return event;
        }

        /**
         * Track js exceptions
         *
         * @param  {string}   desc   The description
         * @param  {boolean}  fatal  The fatal
         * @return {object} data sent to GA
         */

    }, {
        key: 'exception',
        value: function exception(desc, fatal) {
            if (!fatal) fatal = false;

            if (!window.ga) return null;

            var exception = {
                exDescription: desc,
                exFatal: fatal,
                appName: this.gameCode,
                appVersion: this.version
            };

            window.ga('send', 'exception', exception);

            return exception;
        }

        /**
         * watch for js errors
         */

    }, {
        key: 'jsErrors',
        value: function jsErrors() {
            var _this = this;

            window.addEventListener('error', function (err) {
                var lineAndColumnInfo = err.colno ? ' line:' + err.lineno + ', column:' + err.colno : ' line:' + err.lineno;
                var location = err.filename + lineAndColumnInfo + ' -> ' + navigator.userAgent;

                _this.event('JavaScript Error', err.message, location);
                _this.exception('JSERROR - ' + err.message);
            });
        }
    }]);

    return Tracking;
}();

exports.default = Tracking;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

try {
    var ce = new window.CustomEvent('test');
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
        // IE has problems with .preventDefault() on custom events
        // http://stackoverflow.com/questions/23349191
        throw new Error('Could not prevent default');
    }
} catch(e) {
  var CustomEvent = function(event, params) {
    var evt, origPrevent;
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };

    evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    origPrevent = evt.preventDefault;
    evt.preventDefault = function () {
      origPrevent.call(this);
      try {
        Object.defineProperty(this, 'defaultPrevented', {
          get: function () {
            return true;
          }
        });
      } catch(e) {
        this.defaultPrevented = true;
      }
    };
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent; // expose definition to window
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Data = exports.Network = exports.Tracking = exports.Sound = exports.Reality = exports.Loader = exports.Locale = exports.Progress = exports.Font = exports.Event = exports.Device = exports.Currency = undefined;

__webpack_require__(19);

var _currency = __webpack_require__(10);

var _currency2 = _interopRequireDefault(_currency);

var _device = __webpack_require__(1);

var _device2 = _interopRequireDefault(_device);

var _event = __webpack_require__(12);

var _event2 = _interopRequireDefault(_event);

var _font = __webpack_require__(13);

var _font2 = _interopRequireDefault(_font);

var _progress = __webpack_require__(3);

var _progress2 = _interopRequireDefault(_progress);

var _locale = __webpack_require__(15);

var _locale2 = _interopRequireDefault(_locale);

var _loader = __webpack_require__(14);

var _loader2 = _interopRequireDefault(_loader);

var _reality = __webpack_require__(16);

var _reality2 = _interopRequireDefault(_reality);

var _sound = __webpack_require__(17);

var _sound2 = _interopRequireDefault(_sound);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _network = __webpack_require__(2);

var _network2 = _interopRequireDefault(_network);

var _currency3 = __webpack_require__(11);

var _currency4 = _interopRequireDefault(_currency3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Currency = _currency2.default;
exports.Device = _device2.default;
exports.Event = _event2.default;
exports.Font = _font2.default;
exports.Progress = _progress2.default;
exports.Locale = _locale2.default;
exports.Loader = _loader2.default;
exports.Reality = _reality2.default;
exports.Sound = _sound2.default;
exports.Tracking = _tracking2.default;
exports.Network = _network2.default;
exports.Data = _currency4.default;


global.SUGA = exports; // eslint-disable-line
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(23);
var $isFinite = __webpack_require__(22);

var sign = __webpack_require__(25);
var mod = __webpack_require__(24);

var IsCallable = __webpack_require__(7);
var toPrimitive = __webpack_require__(26);

var has = __webpack_require__(6);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(27);

var isCallable = __webpack_require__(7);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(32)

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}


/***/ }),
/* 29 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! howler.js v2.0.4 | (c) 2013-2017, James Simpson of GoldFire Studios | MIT License | howlerjs.com */
!function(){"use strict";var e=function(){this.init()};e.prototype={init:function(){var e=this||n;return e._counter=1e3,e._codecs={},e._howls=[],e._muted=!1,e._volume=1,e._canPlayEvent="canplaythrough",e._navigator="undefined"!=typeof window&&window.navigator?window.navigator:null,e.masterGain=null,e.noAudio=!1,e.usingWebAudio=!0,e.autoSuspend=!0,e.ctx=null,e.mobileAutoEnable=!0,e._setup(),e},volume:function(e){var o=this||n;if(e=parseFloat(e),o.ctx||_(),void 0!==e&&e>=0&&e<=1){if(o._volume=e,o._muted)return o;o.usingWebAudio&&(o.masterGain.gain.value=e);for(var t=0;t<o._howls.length;t++)if(!o._howls[t]._webAudio)for(var r=o._howls[t]._getSoundIds(),a=0;a<r.length;a++){var u=o._howls[t]._soundById(r[a]);u&&u._node&&(u._node.volume=u._volume*e)}return o}return o._volume},mute:function(e){var o=this||n;o.ctx||_(),o._muted=e,o.usingWebAudio&&(o.masterGain.gain.value=e?0:o._volume);for(var t=0;t<o._howls.length;t++)if(!o._howls[t]._webAudio)for(var r=o._howls[t]._getSoundIds(),a=0;a<r.length;a++){var u=o._howls[t]._soundById(r[a]);u&&u._node&&(u._node.muted=!!e||u._muted)}return o},unload:function(){for(var e=this||n,o=e._howls.length-1;o>=0;o--)e._howls[o].unload();return e.usingWebAudio&&e.ctx&&void 0!==e.ctx.close&&(e.ctx.close(),e.ctx=null,_()),e},codecs:function(e){return(this||n)._codecs[e.replace(/^x-/,"")]},_setup:function(){var e=this||n;if(e.state=e.ctx?e.ctx.state||"running":"running",e._autoSuspend(),!e.usingWebAudio)if("undefined"!=typeof Audio)try{var o=new Audio;void 0===o.oncanplaythrough&&(e._canPlayEvent="canplay")}catch(n){e.noAudio=!0}else e.noAudio=!0;try{var o=new Audio;o.muted&&(e.noAudio=!0)}catch(e){}return e.noAudio||e._setupCodecs(),e},_setupCodecs:function(){var e=this||n,o=null;try{o="undefined"!=typeof Audio?new Audio:null}catch(n){return e}if(!o||"function"!=typeof o.canPlayType)return e;var t=o.canPlayType("audio/mpeg;").replace(/^no$/,""),r=e._navigator&&e._navigator.userAgent.match(/OPR\/([0-6].)/g),a=r&&parseInt(r[0].split("/")[1],10)<33;return e._codecs={mp3:!(a||!t&&!o.canPlayType("audio/mp3;").replace(/^no$/,"")),mpeg:!!t,opus:!!o.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/,""),ogg:!!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),oga:!!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),wav:!!o.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),aac:!!o.canPlayType("audio/aac;").replace(/^no$/,""),caf:!!o.canPlayType("audio/x-caf;").replace(/^no$/,""),m4a:!!(o.canPlayType("audio/x-m4a;")||o.canPlayType("audio/m4a;")||o.canPlayType("audio/aac;")).replace(/^no$/,""),mp4:!!(o.canPlayType("audio/x-mp4;")||o.canPlayType("audio/mp4;")||o.canPlayType("audio/aac;")).replace(/^no$/,""),weba:!!o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,""),webm:!!o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,""),dolby:!!o.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/,""),flac:!!(o.canPlayType("audio/x-flac;")||o.canPlayType("audio/flac;")).replace(/^no$/,"")},e},_enableMobileAudio:function(){var e=this||n,o=/iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(e._navigator&&e._navigator.userAgent),t=!!("ontouchend"in window||e._navigator&&e._navigator.maxTouchPoints>0||e._navigator&&e._navigator.msMaxTouchPoints>0);if(!e._mobileEnabled&&e.ctx&&(o||t)){e._mobileEnabled=!1,e._mobileUnloaded||44100===e.ctx.sampleRate||(e._mobileUnloaded=!0,e.unload()),e._scratchBuffer=e.ctx.createBuffer(1,1,22050);var r=function(){n._autoResume();var o=e.ctx.createBufferSource();o.buffer=e._scratchBuffer,o.connect(e.ctx.destination),void 0===o.start?o.noteOn(0):o.start(0),"function"==typeof e.ctx.resume&&e.ctx.resume(),o.onended=function(){o.disconnect(0),e._mobileEnabled=!0,e.mobileAutoEnable=!1,document.removeEventListener("touchend",r,!0)}};return document.addEventListener("touchend",r,!0),e}},_autoSuspend:function(){var e=this;if(e.autoSuspend&&e.ctx&&void 0!==e.ctx.suspend&&n.usingWebAudio){for(var o=0;o<e._howls.length;o++)if(e._howls[o]._webAudio)for(var t=0;t<e._howls[o]._sounds.length;t++)if(!e._howls[o]._sounds[t]._paused)return e;return e._suspendTimer&&clearTimeout(e._suspendTimer),e._suspendTimer=setTimeout(function(){e.autoSuspend&&(e._suspendTimer=null,e.state="suspending",e.ctx.suspend().then(function(){e.state="suspended",e._resumeAfterSuspend&&(delete e._resumeAfterSuspend,e._autoResume())}))},3e4),e}},_autoResume:function(){var e=this;if(e.ctx&&void 0!==e.ctx.resume&&n.usingWebAudio)return"running"===e.state&&e._suspendTimer?(clearTimeout(e._suspendTimer),e._suspendTimer=null):"suspended"===e.state?(e.ctx.resume().then(function(){e.state="running";for(var n=0;n<e._howls.length;n++)e._howls[n]._emit("resume")}),e._suspendTimer&&(clearTimeout(e._suspendTimer),e._suspendTimer=null)):"suspending"===e.state&&(e._resumeAfterSuspend=!0),e}};var n=new e,o=function(e){var n=this;if(!e.src||0===e.src.length)return void console.error("An array of source files must be passed with any new Howl.");n.init(e)};o.prototype={init:function(e){var o=this;return n.ctx||_(),o._autoplay=e.autoplay||!1,o._format="string"!=typeof e.format?e.format:[e.format],o._html5=e.html5||!1,o._muted=e.mute||!1,o._loop=e.loop||!1,o._pool=e.pool||5,o._preload="boolean"!=typeof e.preload||e.preload,o._rate=e.rate||1,o._sprite=e.sprite||{},o._src="string"!=typeof e.src?e.src:[e.src],o._volume=void 0!==e.volume?e.volume:1,o._duration=0,o._state="unloaded",o._sounds=[],o._endTimers={},o._queue=[],o._onend=e.onend?[{fn:e.onend}]:[],o._onfade=e.onfade?[{fn:e.onfade}]:[],o._onload=e.onload?[{fn:e.onload}]:[],o._onloaderror=e.onloaderror?[{fn:e.onloaderror}]:[],o._onpause=e.onpause?[{fn:e.onpause}]:[],o._onplay=e.onplay?[{fn:e.onplay}]:[],o._onstop=e.onstop?[{fn:e.onstop}]:[],o._onmute=e.onmute?[{fn:e.onmute}]:[],o._onvolume=e.onvolume?[{fn:e.onvolume}]:[],o._onrate=e.onrate?[{fn:e.onrate}]:[],o._onseek=e.onseek?[{fn:e.onseek}]:[],o._onresume=[],o._webAudio=n.usingWebAudio&&!o._html5,void 0!==n.ctx&&n.ctx&&n.mobileAutoEnable&&n._enableMobileAudio(),n._howls.push(o),o._autoplay&&o._queue.push({event:"play",action:function(){o.play()}}),o._preload&&o.load(),o},load:function(){var e=this,o=null;if(n.noAudio)return void e._emit("loaderror",null,"No audio support.");"string"==typeof e._src&&(e._src=[e._src]);for(var r=0;r<e._src.length;r++){var u,i;if(e._format&&e._format[r])u=e._format[r];else{if("string"!=typeof(i=e._src[r])){e._emit("loaderror",null,"Non-string found in selected audio sources - ignoring.");continue}u=/^data:audio\/([^;,]+);/i.exec(i),u||(u=/\.([^.]+)$/.exec(i.split("?",1)[0])),u&&(u=u[1].toLowerCase())}if(u||console.warn('No file extension was found. Consider using the "format" property or specify an extension.'),u&&n.codecs(u)){o=e._src[r];break}}return o?(e._src=o,e._state="loading","https:"===window.location.protocol&&"http:"===o.slice(0,5)&&(e._html5=!0,e._webAudio=!1),new t(e),e._webAudio&&a(e),e):void e._emit("loaderror",null,"No codec support for selected audio sources.")},play:function(e,o){var t=this,r=null;if("number"==typeof e)r=e,e=null;else{if("string"==typeof e&&"loaded"===t._state&&!t._sprite[e])return null;if(void 0===e){e="__default";for(var a=0,u=0;u<t._sounds.length;u++)t._sounds[u]._paused&&!t._sounds[u]._ended&&(a++,r=t._sounds[u]._id);1===a?e=null:r=null}}var i=r?t._soundById(r):t._inactiveSound();if(!i)return null;if(r&&!e&&(e=i._sprite||"__default"),"loaded"!==t._state){i._sprite=e,i._ended=!1;var d=i._id;return t._queue.push({event:"play",action:function(){t.play(d)}}),d}if(r&&!i._paused)return o||setTimeout(function(){t._emit("play",i._id)},0),i._id;t._webAudio&&n._autoResume();var _=Math.max(0,i._seek>0?i._seek:t._sprite[e][0]/1e3),s=Math.max(0,(t._sprite[e][0]+t._sprite[e][1])/1e3-_),l=1e3*s/Math.abs(i._rate);i._paused=!1,i._ended=!1,i._sprite=e,i._seek=_,i._start=t._sprite[e][0]/1e3,i._stop=(t._sprite[e][0]+t._sprite[e][1])/1e3,i._loop=!(!i._loop&&!t._sprite[e][2]);var c=i._node;if(t._webAudio){var f=function(){t._refreshBuffer(i);var e=i._muted||t._muted?0:i._volume;c.gain.setValueAtTime(e,n.ctx.currentTime),i._playStart=n.ctx.currentTime,void 0===c.bufferSource.start?i._loop?c.bufferSource.noteGrainOn(0,_,86400):c.bufferSource.noteGrainOn(0,_,s):i._loop?c.bufferSource.start(0,_,86400):c.bufferSource.start(0,_,s),l!==1/0&&(t._endTimers[i._id]=setTimeout(t._ended.bind(t,i),l)),o||setTimeout(function(){t._emit("play",i._id)},0)},p="running"===n.state;if("loaded"===t._state&&p)f();else{var v=p||"loaded"!==t._state?"load":"resume";t.once(v,f,p?i._id:null),t._clearTimer(i._id)}}else{var m=function(){c.currentTime=_,c.muted=i._muted||t._muted||n._muted||c.muted,c.volume=i._volume*n.volume(),c.playbackRate=i._rate,c.play(),l!==1/0&&(t._endTimers[i._id]=setTimeout(t._ended.bind(t,i),l)),o||t._emit("play",i._id)},h="loaded"===t._state&&(window&&window.ejecta||!c.readyState&&n._navigator.isCocoonJS);if(4===c.readyState||h)m();else{var g=function(){m(),c.removeEventListener(n._canPlayEvent,g,!1)};c.addEventListener(n._canPlayEvent,g,!1),t._clearTimer(i._id)}}return i._id},pause:function(e){var n=this;if("loaded"!==n._state)return n._queue.push({event:"pause",action:function(){n.pause(e)}}),n;for(var o=n._getSoundIds(e),t=0;t<o.length;t++){n._clearTimer(o[t]);var r=n._soundById(o[t]);if(r&&!r._paused&&(r._seek=n.seek(o[t]),r._rateSeek=0,r._paused=!0,n._stopFade(o[t]),r._node))if(n._webAudio){if(!r._node.bufferSource)continue;void 0===r._node.bufferSource.stop?r._node.bufferSource.noteOff(0):r._node.bufferSource.stop(0),n._cleanBuffer(r._node)}else isNaN(r._node.duration)&&r._node.duration!==1/0||r._node.pause();arguments[1]||n._emit("pause",r?r._id:null)}return n},stop:function(e,n){var o=this;if("loaded"!==o._state)return o._queue.push({event:"stop",action:function(){o.stop(e)}}),o;for(var t=o._getSoundIds(e),r=0;r<t.length;r++){o._clearTimer(t[r]);var a=o._soundById(t[r]);a&&(a._seek=a._start||0,a._rateSeek=0,a._paused=!0,a._ended=!0,o._stopFade(t[r]),a._node&&(o._webAudio?a._node.bufferSource&&(void 0===a._node.bufferSource.stop?a._node.bufferSource.noteOff(0):a._node.bufferSource.stop(0),o._cleanBuffer(a._node)):isNaN(a._node.duration)&&a._node.duration!==1/0||(a._node.currentTime=a._start||0,a._node.pause())),n||o._emit("stop",a._id))}return o},mute:function(e,o){var t=this;if("loaded"!==t._state)return t._queue.push({event:"mute",action:function(){t.mute(e,o)}}),t;if(void 0===o){if("boolean"!=typeof e)return t._muted;t._muted=e}for(var r=t._getSoundIds(o),a=0;a<r.length;a++){var u=t._soundById(r[a]);u&&(u._muted=e,t._webAudio&&u._node?u._node.gain.setValueAtTime(e?0:u._volume,n.ctx.currentTime):u._node&&(u._node.muted=!!n._muted||e),t._emit("mute",u._id))}return t},volume:function(){var e,o,t=this,r=arguments;if(0===r.length)return t._volume;if(1===r.length||2===r.length&&void 0===r[1]){t._getSoundIds().indexOf(r[0])>=0?o=parseInt(r[0],10):e=parseFloat(r[0])}else r.length>=2&&(e=parseFloat(r[0]),o=parseInt(r[1],10));var a;if(!(void 0!==e&&e>=0&&e<=1))return a=o?t._soundById(o):t._sounds[0],a?a._volume:0;if("loaded"!==t._state)return t._queue.push({event:"volume",action:function(){t.volume.apply(t,r)}}),t;void 0===o&&(t._volume=e),o=t._getSoundIds(o);for(var u=0;u<o.length;u++)(a=t._soundById(o[u]))&&(a._volume=e,r[2]||t._stopFade(o[u]),t._webAudio&&a._node&&!a._muted?a._node.gain.setValueAtTime(e,n.ctx.currentTime):a._node&&!a._muted&&(a._node.volume=e*n.volume()),t._emit("volume",a._id));return t},fade:function(e,o,t,r){var a=this,u=Math.abs(e-o),i=e>o?"out":"in",d=u/.01,_=d>0?t/d:t;if(_<4&&(d=Math.ceil(d/(4/_)),_=4),"loaded"!==a._state)return a._queue.push({event:"fade",action:function(){a.fade(e,o,t,r)}}),a;a.volume(e,r);for(var s=a._getSoundIds(r),l=0;l<s.length;l++){var c=a._soundById(s[l]);if(c){if(r||a._stopFade(s[l]),a._webAudio&&!c._muted){var f=n.ctx.currentTime,p=f+t/1e3;c._volume=e,c._node.gain.setValueAtTime(e,f),c._node.gain.linearRampToValueAtTime(o,p)}var v=e;c._interval=setInterval(function(n,t){d>0&&(v+="in"===i?.01:-.01),v=Math.max(0,v),v=Math.min(1,v),v=Math.round(100*v)/100,a._webAudio?(void 0===r&&(a._volume=v),t._volume=v):a.volume(v,n,!0),(o<e&&v<=o||o>e&&v>=o)&&(clearInterval(t._interval),t._interval=null,a.volume(o,n),a._emit("fade",n))}.bind(a,s[l],c),_)}}return a},_stopFade:function(e){var o=this,t=o._soundById(e);return t&&t._interval&&(o._webAudio&&t._node.gain.cancelScheduledValues(n.ctx.currentTime),clearInterval(t._interval),t._interval=null,o._emit("fade",e)),o},loop:function(){var e,n,o,t=this,r=arguments;if(0===r.length)return t._loop;if(1===r.length){if("boolean"!=typeof r[0])return!!(o=t._soundById(parseInt(r[0],10)))&&o._loop;e=r[0],t._loop=e}else 2===r.length&&(e=r[0],n=parseInt(r[1],10));for(var a=t._getSoundIds(n),u=0;u<a.length;u++)(o=t._soundById(a[u]))&&(o._loop=e,t._webAudio&&o._node&&o._node.bufferSource&&(o._node.bufferSource.loop=e,e&&(o._node.bufferSource.loopStart=o._start||0,o._node.bufferSource.loopEnd=o._stop)));return t},rate:function(){var e,o,t=this,r=arguments;if(0===r.length)o=t._sounds[0]._id;else if(1===r.length){var a=t._getSoundIds(),u=a.indexOf(r[0]);u>=0?o=parseInt(r[0],10):e=parseFloat(r[0])}else 2===r.length&&(e=parseFloat(r[0]),o=parseInt(r[1],10));var i;if("number"!=typeof e)return i=t._soundById(o),i?i._rate:t._rate;if("loaded"!==t._state)return t._queue.push({event:"rate",action:function(){t.rate.apply(t,r)}}),t;void 0===o&&(t._rate=e),o=t._getSoundIds(o);for(var d=0;d<o.length;d++)if(i=t._soundById(o[d])){i._rateSeek=t.seek(o[d]),i._playStart=t._webAudio?n.ctx.currentTime:i._playStart,i._rate=e,t._webAudio&&i._node&&i._node.bufferSource?i._node.bufferSource.playbackRate.value=e:i._node&&(i._node.playbackRate=e);var _=t.seek(o[d]),s=(t._sprite[i._sprite][0]+t._sprite[i._sprite][1])/1e3-_,l=1e3*s/Math.abs(i._rate);!t._endTimers[o[d]]&&i._paused||(t._clearTimer(o[d]),t._endTimers[o[d]]=setTimeout(t._ended.bind(t,i),l)),t._emit("rate",i._id)}return t},seek:function(){var e,o,t=this,r=arguments;if(0===r.length)o=t._sounds[0]._id;else if(1===r.length){var a=t._getSoundIds(),u=a.indexOf(r[0]);u>=0?o=parseInt(r[0],10):(o=t._sounds[0]._id,e=parseFloat(r[0]))}else 2===r.length&&(e=parseFloat(r[0]),o=parseInt(r[1],10));if(void 0===o)return t;if("loaded"!==t._state)return t._queue.push({event:"seek",action:function(){t.seek.apply(t,r)}}),t;var i=t._soundById(o);if(i){if(!("number"==typeof e&&e>=0)){if(t._webAudio){var d=t.playing(o)?n.ctx.currentTime-i._playStart:0,_=i._rateSeek?i._rateSeek-i._seek:0;return i._seek+(_+d*Math.abs(i._rate))}return i._node.currentTime}var s=t.playing(o);s&&t.pause(o,!0),i._seek=e,i._ended=!1,t._clearTimer(o),s&&t.play(o,!0),!t._webAudio&&i._node&&(i._node.currentTime=e),t._emit("seek",o)}return t},playing:function(e){var n=this;if("number"==typeof e){var o=n._soundById(e);return!!o&&!o._paused}for(var t=0;t<n._sounds.length;t++)if(!n._sounds[t]._paused)return!0;return!1},duration:function(e){var n=this,o=n._duration,t=n._soundById(e);return t&&(o=n._sprite[t._sprite][1]/1e3),o},state:function(){return this._state},unload:function(){for(var e=this,o=e._sounds,t=0;t<o.length;t++){if(o[t]._paused||e.stop(o[t]._id),!e._webAudio){/MSIE |Trident\//.test(n._navigator&&n._navigator.userAgent)||(o[t]._node.src="data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA"),o[t]._node.removeEventListener("error",o[t]._errorFn,!1),o[t]._node.removeEventListener(n._canPlayEvent,o[t]._loadFn,!1)}delete o[t]._node,e._clearTimer(o[t]._id);var a=n._howls.indexOf(e);a>=0&&n._howls.splice(a,1)}var u=!0;for(t=0;t<n._howls.length;t++)if(n._howls[t]._src===e._src){u=!1;break}return r&&u&&delete r[e._src],n.noAudio=!1,e._state="unloaded",e._sounds=[],e=null,null},on:function(e,n,o,t){var r=this,a=r["_on"+e];return"function"==typeof n&&a.push(t?{id:o,fn:n,once:t}:{id:o,fn:n}),r},off:function(e,n,o){var t=this,r=t["_on"+e],a=0;if("number"==typeof n&&(o=n,n=null),n||o)for(a=0;a<r.length;a++){var u=o===r[a].id;if(n===r[a].fn&&u||!n&&u){r.splice(a,1);break}}else if(e)t["_on"+e]=[];else{var i=Object.keys(t);for(a=0;a<i.length;a++)0===i[a].indexOf("_on")&&Array.isArray(t[i[a]])&&(t[i[a]]=[])}return t},once:function(e,n,o){var t=this;return t.on(e,n,o,1),t},_emit:function(e,n,o){for(var t=this,r=t["_on"+e],a=r.length-1;a>=0;a--)r[a].id&&r[a].id!==n&&"load"!==e||(setTimeout(function(e){e.call(this,n,o)}.bind(t,r[a].fn),0),r[a].once&&t.off(e,r[a].fn,r[a].id));return t},_loadQueue:function(){var e=this;if(e._queue.length>0){var n=e._queue[0];e.once(n.event,function(){e._queue.shift(),e._loadQueue()}),n.action()}return e},_ended:function(e){var o=this,t=e._sprite;if(!o._webAudio&&o._node&&!o._node.ended)return setTimeout(o._ended.bind(o,e),100),o;var r=!(!e._loop&&!o._sprite[t][2]);if(o._emit("end",e._id),!o._webAudio&&r&&o.stop(e._id,!0).play(e._id),o._webAudio&&r){o._emit("play",e._id),e._seek=e._start||0,e._rateSeek=0,e._playStart=n.ctx.currentTime;var a=1e3*(e._stop-e._start)/Math.abs(e._rate);o._endTimers[e._id]=setTimeout(o._ended.bind(o,e),a)}return o._webAudio&&!r&&(e._paused=!0,e._ended=!0,e._seek=e._start||0,e._rateSeek=0,o._clearTimer(e._id),o._cleanBuffer(e._node),n._autoSuspend()),o._webAudio||r||o.stop(e._id),o},_clearTimer:function(e){var n=this;return n._endTimers[e]&&(clearTimeout(n._endTimers[e]),delete n._endTimers[e]),n},_soundById:function(e){for(var n=this,o=0;o<n._sounds.length;o++)if(e===n._sounds[o]._id)return n._sounds[o];return null},_inactiveSound:function(){var e=this;e._drain();for(var n=0;n<e._sounds.length;n++)if(e._sounds[n]._ended)return e._sounds[n].reset();return new t(e)},_drain:function(){var e=this,n=e._pool,o=0,t=0;if(!(e._sounds.length<n)){for(t=0;t<e._sounds.length;t++)e._sounds[t]._ended&&o++;for(t=e._sounds.length-1;t>=0;t--){if(o<=n)return;e._sounds[t]._ended&&(e._webAudio&&e._sounds[t]._node&&e._sounds[t]._node.disconnect(0),e._sounds.splice(t,1),o--)}}},_getSoundIds:function(e){var n=this;if(void 0===e){for(var o=[],t=0;t<n._sounds.length;t++)o.push(n._sounds[t]._id);return o}return[e]},_refreshBuffer:function(e){var o=this;return e._node.bufferSource=n.ctx.createBufferSource(),e._node.bufferSource.buffer=r[o._src],e._panner?e._node.bufferSource.connect(e._panner):e._node.bufferSource.connect(e._node),e._node.bufferSource.loop=e._loop,e._loop&&(e._node.bufferSource.loopStart=e._start||0,e._node.bufferSource.loopEnd=e._stop),e._node.bufferSource.playbackRate.value=e._rate,o},_cleanBuffer:function(e){var n=this;if(n._scratchBuffer){e.bufferSource.onended=null,e.bufferSource.disconnect(0);try{e.bufferSource.buffer=n._scratchBuffer}catch(e){}}return e.bufferSource=null,n}};var t=function(e){this._parent=e,this.init()};t.prototype={init:function(){var e=this,o=e._parent;return e._muted=o._muted,e._loop=o._loop,e._volume=o._volume,e._rate=o._rate,e._seek=0,e._paused=!0,e._ended=!0,e._sprite="__default",e._id=++n._counter,o._sounds.push(e),e.create(),e},create:function(){var e=this,o=e._parent,t=n._muted||e._muted||e._parent._muted?0:e._volume;return o._webAudio?(e._node=void 0===n.ctx.createGain?n.ctx.createGainNode():n.ctx.createGain(),e._node.gain.setValueAtTime(t,n.ctx.currentTime),e._node.paused=!0,e._node.connect(n.masterGain)):(e._node=new Audio,e._errorFn=e._errorListener.bind(e),e._node.addEventListener("error",e._errorFn,!1),e._loadFn=e._loadListener.bind(e),e._node.addEventListener(n._canPlayEvent,e._loadFn,!1),e._node.src=o._src,e._node.preload="auto",e._node.volume=t*n.volume(),e._node.load()),e},reset:function(){var e=this,o=e._parent;return e._muted=o._muted,e._loop=o._loop,e._volume=o._volume,e._rate=o._rate,e._seek=0,e._rateSeek=0,e._paused=!0,e._ended=!0,e._sprite="__default",e._id=++n._counter,e},_errorListener:function(){var e=this;e._parent._emit("loaderror",e._id,e._node.error?e._node.error.code:0),e._node.removeEventListener("error",e._errorFn,!1)},_loadListener:function(){var e=this,o=e._parent;o._duration=Math.ceil(10*e._node.duration)/10,0===Object.keys(o._sprite).length&&(o._sprite={__default:[0,1e3*o._duration]}),"loaded"!==o._state&&(o._state="loaded",o._emit("load"),o._loadQueue()),e._node.removeEventListener(n._canPlayEvent,e._loadFn,!1)}};var r={},a=function(e){var n=e._src;if(r[n])return e._duration=r[n].duration,void d(e);if(/^data:[^;]+;base64,/.test(n)){for(var o=atob(n.split(",")[1]),t=new Uint8Array(o.length),a=0;a<o.length;++a)t[a]=o.charCodeAt(a);i(t.buffer,e)}else{var _=new XMLHttpRequest;_.open("GET",n,!0),_.responseType="arraybuffer",_.onload=function(){var n=(_.status+"")[0];if("0"!==n&&"2"!==n&&"3"!==n)return void e._emit("loaderror",null,"Failed loading audio file with status: "+_.status+".");i(_.response,e)},_.onerror=function(){e._webAudio&&(e._html5=!0,e._webAudio=!1,e._sounds=[],delete r[n],e.load())},u(_)}},u=function(e){try{e.send()}catch(n){e.onerror()}},i=function(e,o){n.ctx.decodeAudioData(e,function(e){e&&o._sounds.length>0&&(r[o._src]=e,d(o,e))},function(){o._emit("loaderror",null,"Decoding audio data failed.")})},d=function(e,n){n&&!e._duration&&(e._duration=n.duration),0===Object.keys(e._sprite).length&&(e._sprite={__default:[0,1e3*e._duration]}),"loaded"!==e._state&&(e._state="loaded",e._emit("load"),e._loadQueue())},_=function(){try{"undefined"!=typeof AudioContext?n.ctx=new AudioContext:"undefined"!=typeof webkitAudioContext?n.ctx=new webkitAudioContext:n.usingWebAudio=!1}catch(e){n.usingWebAudio=!1}var e=/iP(hone|od|ad)/.test(n._navigator&&n._navigator.platform),o=n._navigator&&n._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),t=o?parseInt(o[1],10):null;if(e&&t&&t<9){var r=/safari/.test(n._navigator&&n._navigator.userAgent.toLowerCase());(n._navigator&&n._navigator.standalone&&!r||n._navigator&&!n._navigator.standalone&&!r)&&(n.usingWebAudio=!1)}n.usingWebAudio&&(n.masterGain=void 0===n.ctx.createGain?n.ctx.createGainNode():n.ctx.createGain(),n.masterGain.gain.value=n._muted?0:1,n.masterGain.connect(n.ctx.destination)),n._setup()};"function"=="function"&&__webpack_require__(41)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return{Howler:n,Howl:o}}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)),"undefined"!=typeof exports&&(exports.Howler=n,exports.Howl=o),"undefined"!=typeof window?(window.HowlerGlobal=e,window.Howler=n,window.Howl=o,window.Sound=t):"undefined"!=typeof global&&(global.HowlerGlobal=e,global.Howler=n,global.Howl=o,global.Sound=t)}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__(28);
var warning = __webpack_require__(39);
var has = __webpack_require__(6);
var trim = __webpack_require__(37);

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter = '||||';

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    if (n % 100 >= 3 && n % 100 <= 10) return 3;
    return n % 100 >= 11 ? 4 : 5;
  },
  chinese: function () { return 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  french: function (n) { return n > 1 ? 1 : 0; },
  russian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
};

// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages = {
  arabic: ['ar'],
  chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
  german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['hr', 'ru', 'lt'],
  czech: ['cs', 'sk'],
  polish: ['pl'],
  icelandic: ['is']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

var dollarRegex = /\$/g;
var dollarBillsYall = '$$';
var tokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimeter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, tokenRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
    return replace.call(options[argument], dollarRegex, dollarBillsYall);
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = transformPhrase;

module.exports = Polyglot;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(35);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(0);
var define = __webpack_require__(5);

var implementation = __webpack_require__(8);
var getPolyfill = __webpack_require__(9);
var shim = __webpack_require__(38);

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(5);
var getPolyfill = __webpack_require__(9);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (process.env.NODE_ENV !== 'production') {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ]);
});
//# sourceMappingURL=suga.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.20.2
 * DATE: 2017-06-30
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("TweenMax",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},e=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},f=function(a,b,d){c.call(this,a,b,d),this._cycle=0,this._yoyo=this.vars.yoyo===!0||!!this.vars.yoyoEase,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._dirty=!0,this.render=f.prototype.render},g=1e-10,h=c._internals,i=h.isSelector,j=h.isArray,k=f.prototype=c.to({},.1,{}),l=[];f.version="1.20.2",k.constructor=f,k.kill()._gc=!1,f.killTweensOf=f.killDelayedCallsTo=c.killTweensOf,f.getTweensOf=c.getTweensOf,f.lagSmoothing=c.lagSmoothing,f.ticker=c.ticker,f.render=c.render,k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0||!!this.vars.yoyoEase,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._yoyoEase=null,this._uncache(!0),c.prototype.invalidate.call(this)},k.updateTo=function(a,b){var d,e=this.ratio,f=this.vars.immediateRender||a.immediateRender;b&&this._startTime<this._timeline._time&&(this._startTime=this._timeline._time,this._uncache(!1),this._gc?this._enabled(!0,!1):this._timeline.insert(this,this._startTime-this._delay));for(d in a)this.vars[d]=a[d];if(this._initted||f)if(b)this._initted=!1,f&&this.render(0,!0,!0);else if(this._gc&&this._enabled(!0,!1),this._notifyPluginsOfEnabled&&this._firstPT&&c._onPluginEvent("_onDisable",this),this._time/this._duration>.998){var g=this._totalTime;this.render(0,!0,!1),this._initted=!1,this.render(g,!0,!1)}else if(this._initted=!1,this._init(),this._time>0||f)for(var h,i=1/(1-e),j=this._firstPT;j;)h=j.s+j.c,j.c*=i,j.s=h-j.c,j=j._next;return this},k.render=function(a,b,d){this._initted||0===this._duration&&this.vars.repeat&&this.invalidate();var e,f,i,j,k,l,m,n,o,p=this._dirty?this.totalDuration():this._totalDuration,q=this._time,r=this._totalTime,s=this._cycle,t=this._duration,u=this._rawPrevTime;if(a>=p-1e-7&&a>=0?(this._totalTime=p,this._cycle=this._repeat,this._yoyo&&0!==(1&this._cycle)?(this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0):(this._time=t,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1),this._reversed||(e=!0,f="onComplete",d=d||this._timeline.autoRemoveChildren),0===t&&(this._initted||!this.vars.lazy||d)&&(this._startTime===this._timeline._duration&&(a=0),(0>u||0>=a&&a>=-1e-7||u===g&&"isPause"!==this.data)&&u!==a&&(d=!0,u>g&&(f="onReverseComplete")),this._rawPrevTime=n=!b||a||u===a?a:g)):1e-7>a?(this._totalTime=this._time=this._cycle=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==r||0===t&&u>0)&&(f="onReverseComplete",e=this._reversed),0>a&&(this._active=!1,0===t&&(this._initted||!this.vars.lazy||d)&&(u>=0&&(d=!0),this._rawPrevTime=n=!b||a||u===a?a:g)),this._initted||(d=!0)):(this._totalTime=this._time=a,0!==this._repeat&&(j=t+this._repeatDelay,this._cycle=this._totalTime/j>>0,0!==this._cycle&&this._cycle===this._totalTime/j&&a>=r&&this._cycle--,this._time=this._totalTime-this._cycle*j,this._yoyo&&0!==(1&this._cycle)&&(this._time=t-this._time,o=this._yoyoEase||this.vars.yoyoEase,o&&(this._yoyoEase||(o!==!0||this._initted?this._yoyoEase=o=o===!0?this._ease:o instanceof Ease?o:Ease.map[o]:(o=this.vars.ease,this._yoyoEase=o=o?o instanceof Ease?o:"function"==typeof o?new Ease(o,this.vars.easeParams):Ease.map[o]||c.defaultEase:c.defaultEase)),this.ratio=o?1-o.getRatio((t-this._time)/t):0)),this._time>t?this._time=t:this._time<0&&(this._time=0)),this._easeType&&!o?(k=this._time/t,l=this._easeType,m=this._easePower,(1===l||3===l&&k>=.5)&&(k=1-k),3===l&&(k*=2),1===m?k*=k:2===m?k*=k*k:3===m?k*=k*k*k:4===m&&(k*=k*k*k*k),1===l?this.ratio=1-k:2===l?this.ratio=k:this._time/t<.5?this.ratio=k/2:this.ratio=1-k/2):o||(this.ratio=this._ease.getRatio(this._time/t))),q===this._time&&!d&&s===this._cycle)return void(r!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!d&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=q,this._totalTime=r,this._rawPrevTime=u,this._cycle=s,h.lazyTweens.push(this),void(this._lazy=[a,b]);!this._time||e||o?e&&this._ease._calcEnd&&!o&&(this.ratio=this._ease.getRatio(0===this._time?0:1)):this.ratio=this._ease.getRatio(this._time/t)}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==q&&a>=0&&(this._active=!0),0===r&&(2===this._initted&&a>0&&this._init(),this._startAt&&(a>=0?this._startAt.render(a,b,d):f||(f="_dummyGS")),this.vars.onStart&&(0!==this._totalTime||0===t)&&(b||this._callback("onStart"))),i=this._firstPT;i;)i.f?i.t[i.p](i.c*this.ratio+i.s):i.t[i.p]=i.c*this.ratio+i.s,i=i._next;this._onUpdate&&(0>a&&this._startAt&&this._startTime&&this._startAt.render(a,b,d),b||(this._totalTime!==r||f)&&this._callback("onUpdate")),this._cycle!==s&&(b||this._gc||this.vars.onRepeat&&this._callback("onRepeat")),f&&(!this._gc||d)&&(0>a&&this._startAt&&!this._onUpdate&&this._startTime&&this._startAt.render(a,b,d),e&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[f]&&this._callback(f),0===t&&this._rawPrevTime===g&&n!==g&&(this._rawPrevTime=0))},f.to=function(a,b,c){return new f(a,b,c)},f.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new f(a,b,c)},f.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new f(a,b,d)},f.staggerTo=f.allTo=function(a,b,g,h,k,m,n){h=h||0;var o,p,q,r,s=0,t=[],u=function(){g.onComplete&&g.onComplete.apply(g.onCompleteScope||this,arguments),k.apply(n||g.callbackScope||this,m||l)},v=g.cycle,w=g.startAt&&g.startAt.cycle;for(j(a)||("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a))),a=a||[],0>h&&(a=d(a),a.reverse(),h*=-1),o=a.length-1,q=0;o>=q;q++){p={};for(r in g)p[r]=g[r];if(v&&(e(p,a,q),null!=p.duration&&(b=p.duration,delete p.duration)),w){w=p.startAt={};for(r in g.startAt)w[r]=g.startAt[r];e(p.startAt,a,q)}p.delay=s+(p.delay||0),q===o&&k&&(p.onComplete=u),t[q]=new f(a[q],b,p),s+=h}return t},f.staggerFrom=f.allFrom=function(a,b,c,d,e,g,h){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,f.staggerTo(a,b,c,d,e,g,h)},f.staggerFromTo=f.allFromTo=function(a,b,c,d,e,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,f.staggerTo(a,b,d,e,g,h,i)},f.delayedCall=function(a,b,c,d,e){return new f(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,useFrames:e,overwrite:0})},f.set=function(a,b){return new f(a,0,b)},f.isTweening=function(a){return c.getTweensOf(a,!0).length>0};var m=function(a,b){for(var d=[],e=0,f=a._first;f;)f instanceof c?d[e++]=f:(b&&(d[e++]=f),d=d.concat(m(f,b)),e=d.length),f=f._next;return d},n=f.getAllTweens=function(b){return m(a._rootTimeline,b).concat(m(a._rootFramesTimeline,b))};f.killAll=function(a,c,d,e){null==c&&(c=!0),null==d&&(d=!0);var f,g,h,i=n(0!=e),j=i.length,k=c&&d&&e;for(h=0;j>h;h++)g=i[h],(k||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&(a?g.totalTime(g._reversed?0:g.totalDuration()):g._enabled(!1,!1))},f.killChildTweensOf=function(a,b){if(null!=a){var e,g,k,l,m,n=h.tweenLookup;if("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a)),j(a))for(l=a.length;--l>-1;)f.killChildTweensOf(a[l],b);else{e=[];for(k in n)for(g=n[k].target.parentNode;g;)g===a&&(e=e.concat(n[k].tweens)),g=g.parentNode;for(m=e.length,l=0;m>l;l++)b&&e[l].totalTime(e[l].totalDuration()),e[l]._enabled(!1,!1)}}};var o=function(a,c,d,e){c=c!==!1,d=d!==!1,e=e!==!1;for(var f,g,h=n(e),i=c&&d&&e,j=h.length;--j>-1;)g=h[j],(i||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&g.paused(a)};return f.pauseAll=function(a,b,c){o(!0,a,b,c)},f.resumeAll=function(a,b,c){o(!1,a,b,c)},f.globalTimeScale=function(b){var d=a._rootTimeline,e=c.ticker.time;return arguments.length?(b=b||g,d._startTime=e-(e-d._startTime)*d._timeScale/b,d=a._rootFramesTimeline,e=c.ticker.frame,d._startTime=e-(e-d._startTime)*d._timeScale/b,d._timeScale=a._rootTimeline._timeScale=b,b):d._timeScale},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.duration=function(b){return arguments.length?a.prototype.duration.call(this,b):this._duration},k.totalDuration=function(a){return arguments.length?-1===this._repeat?this:this.duration((a-this._repeat*this._repeatDelay)/(this._repeat+1)):(this._dirty&&(this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat,this._dirty=!1),this._totalDuration)},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},f},!0),_gsScope._gsDefine("TimelineLite",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){b.call(this,a),this._labels={},this.autoRemoveChildren=this.vars.autoRemoveChildren===!0,this.smoothChildTiming=this.vars.smoothChildTiming===!0,this._sortChildren=!0,this._onUpdate=this.vars.onUpdate;var c,d,e=this.vars;for(d in e)c=e[d],i(c)&&-1!==c.join("").indexOf("{self}")&&(e[d]=this._swapSelfInParams(c));i(e.tweens)&&this.add(e.tweens,0,e.align,e.stagger)},e=1e-10,f=c._internals,g=d._internals={},h=f.isSelector,i=f.isArray,j=f.lazyTweens,k=f.lazyRender,l=_gsScope._gsDefine.globals,m=function(a){var b,c={};for(b in a)c[b]=a[b];return c},n=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},o=g.pauseCallback=function(){},p=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},q=d.prototype=new b;return d.version="1.20.2",q.constructor=d,q.kill()._gc=q._forcingPlayhead=q._hasPause=!1,q.to=function(a,b,d,e){var f=d.repeat&&l.TweenMax||c;return b?this.add(new f(a,b,d),e):this.set(a,d,e)},q.from=function(a,b,d,e){return this.add((d.repeat&&l.TweenMax||c).from(a,b,d),e)},q.fromTo=function(a,b,d,e,f){var g=e.repeat&&l.TweenMax||c;return b?this.add(g.fromTo(a,b,d,e),f):this.set(a,e,f)},q.staggerTo=function(a,b,e,f,g,i,j,k){var l,o,q=new d({onComplete:i,onCompleteParams:j,callbackScope:k,smoothChildTiming:this.smoothChildTiming}),r=e.cycle;for("string"==typeof a&&(a=c.selector(a)||a),a=a||[],h(a)&&(a=p(a)),f=f||0,0>f&&(a=p(a),a.reverse(),f*=-1),o=0;o<a.length;o++)l=m(e),l.startAt&&(l.startAt=m(l.startAt),l.startAt.cycle&&n(l.startAt,a,o)),r&&(n(l,a,o),null!=l.duration&&(b=l.duration,delete l.duration)),q.to(a[o],b,l,o*f);return this.add(q,g)},q.staggerFrom=function(a,b,c,d,e,f,g,h){return c.immediateRender=0!=c.immediateRender,c.runBackwards=!0,this.staggerTo(a,b,c,d,e,f,g,h)},q.staggerFromTo=function(a,b,c,d,e,f,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,this.staggerTo(a,b,d,e,f,g,h,i)},q.call=function(a,b,d,e){return this.add(c.delayedCall(0,a,b,d),e)},q.set=function(a,b,d){return d=this._parseTimeOrLabel(d,0,!0),null==b.immediateRender&&(b.immediateRender=d===this._time&&!this._paused),this.add(new c(a,0,b),d)},d.exportRoot=function(a,b){a=a||{},null==a.smoothChildTiming&&(a.smoothChildTiming=!0);var e,f,g=new d(a),h=g._timeline;for(null==b&&(b=!0),h._remove(g,!0),g._startTime=0,g._rawPrevTime=g._time=g._totalTime=h._time,e=h._first;e;)f=e._next,b&&e instanceof c&&e.target===e.vars.onComplete||g.add(e,e._startTime-e._delay),e=f;return h.add(g,0),g},q.add=function(e,f,g,h){var j,k,l,m,n,o;if("number"!=typeof f&&(f=this._parseTimeOrLabel(f,0,!0,e)),!(e instanceof a)){if(e instanceof Array||e&&e.push&&i(e)){for(g=g||"normal",h=h||0,j=f,k=e.length,l=0;k>l;l++)i(m=e[l])&&(m=new d({tweens:m})),this.add(m,j),"string"!=typeof m&&"function"!=typeof m&&("sequence"===g?j=m._startTime+m.totalDuration()/m._timeScale:"start"===g&&(m._startTime-=m.delay())),j+=h;return this._uncache(!0)}if("string"==typeof e)return this.addLabel(e,f);if("function"!=typeof e)throw"Cannot add "+e+" into the timeline; it is not a tween, timeline, function, or string.";e=c.delayedCall(0,e)}if(b.prototype.add.call(this,e,f),e._time&&e.render((this.rawTime()-e._startTime)*e._timeScale,!1,!1),(this._gc||this._time===this._duration)&&!this._paused&&this._duration<this.duration())for(n=this,o=n.rawTime()>e._startTime;n._timeline;)o&&n._timeline.smoothChildTiming?n.totalTime(n._totalTime,!0):n._gc&&n._enabled(!0,!1),n=n._timeline;return this},q.remove=function(b){if(b instanceof a){this._remove(b,!1);var c=b._timeline=b.vars.useFrames?a._rootFramesTimeline:a._rootTimeline;return b._startTime=(b._paused?b._pauseTime:c._time)-(b._reversed?b.totalDuration()-b._totalTime:b._totalTime)/b._timeScale,this}if(b instanceof Array||b&&b.push&&i(b)){for(var d=b.length;--d>-1;)this.remove(b[d]);return this}return"string"==typeof b?this.removeLabel(b):this.kill(null,b)},q._remove=function(a,c){b.prototype._remove.call(this,a,c);var d=this._last;return d?this._time>this.duration()&&(this._time=this._duration,this._totalTime=this._totalDuration):this._time=this._totalTime=this._duration=this._totalDuration=0,this},q.append=function(a,b){return this.add(a,this._parseTimeOrLabel(null,b,!0,a))},q.insert=q.insertMultiple=function(a,b,c,d){return this.add(a,b||0,c,d)},q.appendMultiple=function(a,b,c,d){return this.add(a,this._parseTimeOrLabel(null,b,!0,a),c,d)},q.addLabel=function(a,b){return this._labels[a]=this._parseTimeOrLabel(b),this},q.addPause=function(a,b,d,e){var f=c.delayedCall(0,o,d,e||this);return f.vars.onComplete=f.vars.onReverseComplete=b,f.data="isPause",this._hasPause=!0,this.add(f,a)},q.removeLabel=function(a){return delete this._labels[a],this},q.getLabelTime=function(a){return null!=this._labels[a]?this._labels[a]:-1},q._parseTimeOrLabel=function(b,c,d,e){var f,g;if(e instanceof a&&e.timeline===this)this.remove(e);else if(e&&(e instanceof Array||e.push&&i(e)))for(g=e.length;--g>-1;)e[g]instanceof a&&e[g].timeline===this&&this.remove(e[g]);if(f=this.duration()>99999999999?this.recent().endTime(!1):this._duration,"string"==typeof c)return this._parseTimeOrLabel(c,d&&"number"==typeof b&&null==this._labels[c]?b-f:0,d);if(c=c||0,"string"!=typeof b||!isNaN(b)&&null==this._labels[b])null==b&&(b=f);else{if(g=b.indexOf("="),-1===g)return null==this._labels[b]?d?this._labels[b]=f+c:c:this._labels[b]+c;c=parseInt(b.charAt(g-1)+"1",10)*Number(b.substr(g+1)),b=g>1?this._parseTimeOrLabel(b.substr(0,g-1),0,d):f}return Number(b)+c},q.seek=function(a,b){return this.totalTime("number"==typeof a?a:this._parseTimeOrLabel(a),b!==!1)},q.stop=function(){return this.paused(!0)},q.gotoAndPlay=function(a,b){return this.play(a,b)},q.gotoAndStop=function(a,b){return this.pause(a,b)},q.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,g,h,i,l,m,n=this._dirty?this.totalDuration():this._totalDuration,o=this._time,p=this._startTime,q=this._timeScale,r=this._paused;if(a>=n-1e-7&&a>=0)this._totalTime=this._time=n,this._reversed||this._hasPausedChild()||(f=!0,h="onComplete",i=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||this._rawPrevTime<0||this._rawPrevTime===e)&&this._rawPrevTime!==a&&this._first&&(i=!0,this._rawPrevTime>e&&(h="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,a=n+1e-4;else if(1e-7>a)if(this._totalTime=this._time=0,(0!==o||0===this._duration&&this._rawPrevTime!==e&&(this._rawPrevTime>0||0>a&&this._rawPrevTime>=0))&&(h="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(i=f=!0,h="onReverseComplete"):this._rawPrevTime>=0&&this._first&&(i=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(i=!0)}else{if(this._hasPause&&!this._forcingPlayhead&&!b){if(a>=o)for(d=this._first;d&&d._startTime<=a&&!l;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(l=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!l;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(l=d),d=d._prev;l&&(this._time=a=l._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}this._totalTime=this._time=this._rawPrevTime=a}if(this._time!==o&&this._first||c||i||l){if(this._initted||(this._initted=!0),this._active||!this._paused&&this._time!==o&&a>0&&(this._active=!0),0===o&&this.vars.onStart&&(0===this._time&&this._duration||b||this._callback("onStart")),m=this._time,m>=o)for(d=this._first;d&&(g=d._next,m===this._time&&(!this._paused||r));)(d._active||d._startTime<=m&&!d._paused&&!d._gc)&&(l===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=g;else for(d=this._last;d&&(g=d._prev,m===this._time&&(!this._paused||r));){if(d._active||d._startTime<=o&&!d._paused&&!d._gc){if(l===d){for(l=d._prev;l&&l.endTime()>this._time;)l.render(l._reversed?l.totalDuration()-(a-l._startTime)*l._timeScale:(a-l._startTime)*l._timeScale,b,c),l=l._prev;l=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=g}this._onUpdate&&(b||(j.length&&k(),this._callback("onUpdate"))),h&&(this._gc||(p===this._startTime||q!==this._timeScale)&&(0===this._time||n>=this.totalDuration())&&(f&&(j.length&&k(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[h]&&this._callback(h)))}},q._hasPausedChild=function(){for(var a=this._first;a;){if(a._paused||a instanceof d&&a._hasPausedChild())return!0;a=a._next}return!1},q.getChildren=function(a,b,d,e){e=e||-9999999999;for(var f=[],g=this._first,h=0;g;)g._startTime<e||(g instanceof c?b!==!1&&(f[h++]=g):(d!==!1&&(f[h++]=g),a!==!1&&(f=f.concat(g.getChildren(!0,b,d)),h=f.length))),g=g._next;return f},q.getTweensOf=function(a,b){var d,e,f=this._gc,g=[],h=0;for(f&&this._enabled(!0,!0),d=c.getTweensOf(a),e=d.length;--e>-1;)(d[e].timeline===this||b&&this._contains(d[e]))&&(g[h++]=d[e]);return f&&this._enabled(!1,!0),g},q.recent=function(){return this._recent},q._contains=function(a){for(var b=a.timeline;b;){if(b===this)return!0;b=b.timeline}return!1},q.shiftChildren=function(a,b,c){c=c||0;for(var d,e=this._first,f=this._labels;e;)e._startTime>=c&&(e._startTime+=a),e=e._next;if(b)for(d in f)f[d]>=c&&(f[d]+=a);return this._uncache(!0)},q._kill=function(a,b){if(!a&&!b)return this._enabled(!1,!1);for(var c=b?this.getTweensOf(b):this.getChildren(!0,!0,!1),d=c.length,e=!1;--d>-1;)c[d]._kill(a,b)&&(e=!0);return e},q.clear=function(a){var b=this.getChildren(!1,!0,!0),c=b.length;for(this._time=this._totalTime=0;--c>-1;)b[c]._enabled(!1,!1);return a!==!1&&(this._labels={}),this._uncache(!0)},q.invalidate=function(){for(var b=this._first;b;)b.invalidate(),b=b._next;return a.prototype.invalidate.call(this)},q._enabled=function(a,c){if(a===this._gc)for(var d=this._first;d;)d._enabled(a,!0),d=d._next;return b.prototype._enabled.call(this,a,c)},q.totalTime=function(b,c,d){this._forcingPlayhead=!0;var e=a.prototype.totalTime.apply(this,arguments);return this._forcingPlayhead=!1,e},q.duration=function(a){return arguments.length?(0!==this.duration()&&0!==a&&this.timeScale(this._duration/a),this):(this._dirty&&this.totalDuration(),this._duration)},q.totalDuration=function(a){if(!arguments.length){if(this._dirty){for(var b,c,d=0,e=this._last,f=999999999999;e;)b=e._prev,e._dirty&&e.totalDuration(),e._startTime>f&&this._sortChildren&&!e._paused?this.add(e,e._startTime-e._delay):f=e._startTime,e._startTime<0&&!e._paused&&(d-=e._startTime,this._timeline.smoothChildTiming&&(this._startTime+=e._startTime/this._timeScale),this.shiftChildren(-e._startTime,!1,-9999999999),f=0),c=e._startTime+e._totalDuration/e._timeScale,c>d&&(d=c),e=b;this._duration=this._totalDuration=d,this._dirty=!1}return this._totalDuration}return a&&this.totalDuration()?this.timeScale(this._totalDuration/a):this},q.paused=function(b){if(!b)for(var c=this._first,d=this._time;c;)c._startTime===d&&"isPause"===c.data&&(c._rawPrevTime=0),c=c._next;return a.prototype.paused.apply(this,arguments)},q.usesFrames=function(){for(var b=this._timeline;b._timeline;)b=b._timeline;return b===a._rootFramesTimeline},q.rawTime=function(a){return a&&(this._paused||this._repeat&&this.time()>0&&this.totalProgress()<1)?this._totalTime%(this._duration+this._repeatDelay):this._paused?this._totalTime:(this._timeline.rawTime(a)-this._startTime)*this._timeScale},d},!0),_gsScope._gsDefine("TimelineMax",["TimelineLite","TweenLite","easing.Ease"],function(a,b,c){var d=function(b){a.call(this,b),this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._cycle=0,this._yoyo=this.vars.yoyo===!0,this._dirty=!0},e=1e-10,f=b._internals,g=f.lazyTweens,h=f.lazyRender,i=_gsScope._gsDefine.globals,j=new c(null,null,1,0),k=d.prototype=new a;return k.constructor=d,k.kill()._gc=!1,d.version="1.20.2",k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),a.prototype.invalidate.call(this)},k.addCallback=function(a,c,d,e){return this.add(b.delayedCall(0,a,d,e),c)},k.removeCallback=function(a,b){if(a)if(null==b)this._kill(null,a);else for(var c=this.getTweensOf(a,!1),d=c.length,e=this._parseTimeOrLabel(b);--d>-1;)c[d]._startTime===e&&c[d]._enabled(!1,!1);return this},k.removePause=function(b){return this.removeCallback(a._internals.pauseCallback,b)},k.tweenTo=function(a,c){c=c||{};var d,e,f,g={ease:j,useFrames:this.usesFrames(),immediateRender:!1},h=c.repeat&&i.TweenMax||b;for(e in c)g[e]=c[e];return g.time=this._parseTimeOrLabel(a),d=Math.abs(Number(g.time)-this._time)/this._timeScale||.001,f=new h(this,d,g),g.onStart=function(){f.target.paused(!0),f.vars.time!==f.target.time()&&d===f.duration()&&f.duration(Math.abs(f.vars.time-f.target.time())/f.target._timeScale),c.onStart&&c.onStart.apply(c.onStartScope||c.callbackScope||f,c.onStartParams||[])},f},k.tweenFromTo=function(a,b,c){c=c||{},a=this._parseTimeOrLabel(a),c.startAt={onComplete:this.seek,onCompleteParams:[a],callbackScope:this},c.immediateRender=c.immediateRender!==!1;var d=this.tweenTo(b,c);return d.duration(Math.abs(d.vars.time-a)/this._timeScale||.001)},k.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,i,j,k,l,m,n,o=this._dirty?this.totalDuration():this._totalDuration,p=this._duration,q=this._time,r=this._totalTime,s=this._startTime,t=this._timeScale,u=this._rawPrevTime,v=this._paused,w=this._cycle;if(a>=o-1e-7&&a>=0)this._locked||(this._totalTime=o,this._cycle=this._repeat),this._reversed||this._hasPausedChild()||(f=!0,j="onComplete",k=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||0>u||u===e)&&u!==a&&this._first&&(k=!0,u>e&&(j="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,this._yoyo&&0!==(1&this._cycle)?this._time=a=0:(this._time=p,a=p+1e-4);else if(1e-7>a)if(this._locked||(this._totalTime=this._cycle=0),this._time=0,(0!==q||0===p&&u!==e&&(u>0||0>a&&u>=0)&&!this._locked)&&(j="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(k=f=!0,j="onReverseComplete"):u>=0&&this._first&&(k=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=p||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(k=!0)}else if(0===p&&0>u&&(k=!0),this._time=this._rawPrevTime=a,this._locked||(this._totalTime=a,0!==this._repeat&&(l=p+this._repeatDelay,this._cycle=this._totalTime/l>>0,0!==this._cycle&&this._cycle===this._totalTime/l&&a>=r&&this._cycle--,this._time=this._totalTime-this._cycle*l,this._yoyo&&0!==(1&this._cycle)&&(this._time=p-this._time),this._time>p?(this._time=p,a=p+1e-4):this._time<0?this._time=a=0:a=this._time)),this._hasPause&&!this._forcingPlayhead&&!b){if(a=this._time,a>=q||this._repeat&&w!==this._cycle)for(d=this._first;d&&d._startTime<=a&&!m;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(m=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!m;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(m=d),d=d._prev;m&&m._startTime<p&&(this._time=a=m._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}if(this._cycle!==w&&!this._locked){var x=this._yoyo&&0!==(1&w),y=x===(this._yoyo&&0!==(1&this._cycle)),z=this._totalTime,A=this._cycle,B=this._rawPrevTime,C=this._time;if(this._totalTime=w*p,this._cycle<w?x=!x:this._totalTime+=p,this._time=q,this._rawPrevTime=0===p?u-1e-4:u,this._cycle=w,this._locked=!0,q=x?0:p,this.render(q,b,0===p),b||this._gc||this.vars.onRepeat&&(this._cycle=A,this._locked=!1,this._callback("onRepeat")),q!==this._time)return;if(y&&(this._cycle=w,this._locked=!0,q=x?p+1e-4:-1e-4,this.render(q,!0,!1)),this._locked=!1,this._paused&&!v)return;this._time=C,this._totalTime=z,this._cycle=A,this._rawPrevTime=B}if(!(this._time!==q&&this._first||c||k||m))return void(r!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(this._initted||(this._initted=!0),this._active||!this._paused&&this._totalTime!==r&&a>0&&(this._active=!0),0===r&&this.vars.onStart&&(0===this._totalTime&&this._totalDuration||b||this._callback("onStart")),n=this._time,n>=q)for(d=this._first;d&&(i=d._next,n===this._time&&(!this._paused||v));)(d._active||d._startTime<=this._time&&!d._paused&&!d._gc)&&(m===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=i;else for(d=this._last;d&&(i=d._prev,n===this._time&&(!this._paused||v));){if(d._active||d._startTime<=q&&!d._paused&&!d._gc){if(m===d){for(m=d._prev;m&&m.endTime()>this._time;)m.render(m._reversed?m.totalDuration()-(a-m._startTime)*m._timeScale:(a-m._startTime)*m._timeScale,b,c),m=m._prev;m=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=i}this._onUpdate&&(b||(g.length&&h(),this._callback("onUpdate"))),j&&(this._locked||this._gc||(s===this._startTime||t!==this._timeScale)&&(0===this._time||o>=this.totalDuration())&&(f&&(g.length&&h(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[j]&&this._callback(j)))},k.getActive=function(a,b,c){null==a&&(a=!0),null==b&&(b=!0),null==c&&(c=!1);var d,e,f=[],g=this.getChildren(a,b,c),h=0,i=g.length;for(d=0;i>d;d++)e=g[d],e.isActive()&&(f[h++]=e);return f},k.getLabelAfter=function(a){a||0!==a&&(a=this._time);var b,c=this.getLabelsArray(),d=c.length;for(b=0;d>b;b++)if(c[b].time>a)return c[b].name;return null},k.getLabelBefore=function(a){null==a&&(a=this._time);for(var b=this.getLabelsArray(),c=b.length;--c>-1;)if(b[c].time<a)return b[c].name;return null},k.getLabelsArray=function(){var a,b=[],c=0;for(a in this._labels)b[c++]={time:this._labels[a],name:a};return b.sort(function(a,b){return a.time-b.time}),b},k.invalidate=function(){return this._locked=!1,a.prototype.invalidate.call(this)},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()||0},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()||0},k.totalDuration=function(b){return arguments.length?-1!==this._repeat&&b?this.timeScale(this.totalDuration()/b):this:(this._dirty&&(a.prototype.totalDuration.call(this),this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat),this._totalDuration)},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},k.currentLabel=function(a){return arguments.length?this.seek(a,!0):this.getLabelBefore(this._time+1e-8)},d},!0),function(){var a=180/Math.PI,b=[],c=[],d=[],e={},f=_gsScope._gsDefine.globals,g=function(a,b,c,d){c===d&&(c=d-(d-b)/1e6),a===b&&(b=a+(c-a)/1e6),this.a=a,this.b=b,this.c=c,this.d=d,this.da=d-a,this.ca=c-a,this.ba=b-a},h=",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",i=function(a,b,c,d){var e={a:a},f={},g={},h={c:d},i=(a+b)/2,j=(b+c)/2,k=(c+d)/2,l=(i+j)/2,m=(j+k)/2,n=(m-l)/8;return e.b=i+(a-i)/4,f.b=l+n,e.c=f.a=(e.b+f.b)/2,f.c=g.a=(l+m)/2,g.b=m-n,h.b=k+(d-k)/4,g.c=h.a=(g.b+h.b)/2,[e,f,g,h]},j=function(a,e,f,g,h){var j,k,l,m,n,o,p,q,r,s,t,u,v,w=a.length-1,x=0,y=a[0].a;for(j=0;w>j;j++)n=a[x],k=n.a,l=n.d,m=a[x+1].d,h?(t=b[j],u=c[j],v=(u+t)*e*.25/(g?.5:d[j]||.5),o=l-(l-k)*(g?.5*e:0!==t?v/t:0),p=l+(m-l)*(g?.5*e:0!==u?v/u:0),q=l-(o+((p-o)*(3*t/(t+u)+.5)/4||0))):(o=l-(l-k)*e*.5,p=l+(m-l)*e*.5,q=l-(o+p)/2),o+=q,p+=q,n.c=r=o,0!==j?n.b=y:n.b=y=n.a+.6*(n.c-n.a),n.da=l-k,n.ca=r-k,n.ba=y-k,f?(s=i(k,y,r,l),a.splice(x,1,s[0],s[1],s[2],s[3]),x+=4):x++,y=p;n=a[x],n.b=y,n.c=y+.4*(n.d-y),n.da=n.d-n.a,n.ca=n.c-n.a,n.ba=y-n.a,f&&(s=i(n.a,y,n.c,n.d),a.splice(x,1,s[0],s[1],s[2],s[3]))},k=function(a,d,e,f){var h,i,j,k,l,m,n=[];if(f)for(a=[f].concat(a),i=a.length;--i>-1;)"string"==typeof(m=a[i][d])&&"="===m.charAt(1)&&(a[i][d]=f[d]+Number(m.charAt(0)+m.substr(2)));if(h=a.length-2,0>h)return n[0]=new g(a[0][d],0,0,a[0][d]),n;for(i=0;h>i;i++)j=a[i][d],k=a[i+1][d],n[i]=new g(j,0,0,k),e&&(l=a[i+2][d],b[i]=(b[i]||0)+(k-j)*(k-j),c[i]=(c[i]||0)+(l-k)*(l-k));return n[i]=new g(a[i][d],0,0,a[i+1][d]),n},l=function(a,f,g,i,l,m){var n,o,p,q,r,s,t,u,v={},w=[],x=m||a[0];l="string"==typeof l?","+l+",":h,null==f&&(f=1);for(o in a[0])w.push(o);if(a.length>1){for(u=a[a.length-1],t=!0,n=w.length;--n>-1;)if(o=w[n],Math.abs(x[o]-u[o])>.05){t=!1;break}t&&(a=a.concat(),m&&a.unshift(m),a.push(a[1]),m=a[a.length-3])}for(b.length=c.length=d.length=0,n=w.length;--n>-1;)o=w[n],e[o]=-1!==l.indexOf(","+o+","),v[o]=k(a,o,e[o],m);for(n=b.length;--n>-1;)b[n]=Math.sqrt(b[n]),c[n]=Math.sqrt(c[n]);if(!i){for(n=w.length;--n>-1;)if(e[o])for(p=v[w[n]],s=p.length-1,q=0;s>q;q++)r=p[q+1].da/c[q]+p[q].da/b[q]||0,d[q]=(d[q]||0)+r*r;for(n=d.length;--n>-1;)d[n]=Math.sqrt(d[n])}for(n=w.length,q=g?4:1;--n>-1;)o=w[n],p=v[o],j(p,f,g,i,e[o]),t&&(p.splice(0,q),p.splice(p.length-q,q));return v},m=function(a,b,c){b=b||"soft";var d,e,f,h,i,j,k,l,m,n,o,p={},q="cubic"===b?3:2,r="soft"===b,s=[];if(r&&c&&(a=[c].concat(a)),null==a||a.length<q+1)throw"invalid Bezier data";
for(m in a[0])s.push(m);for(j=s.length;--j>-1;){for(m=s[j],p[m]=i=[],n=0,l=a.length,k=0;l>k;k++)d=null==c?a[k][m]:"string"==typeof(o=a[k][m])&&"="===o.charAt(1)?c[m]+Number(o.charAt(0)+o.substr(2)):Number(o),r&&k>1&&l-1>k&&(i[n++]=(d+i[n-2])/2),i[n++]=d;for(l=n-q+1,n=0,k=0;l>k;k+=q)d=i[k],e=i[k+1],f=i[k+2],h=2===q?0:i[k+3],i[n++]=o=3===q?new g(d,e,f,h):new g(d,(2*e+d)/3,(2*e+f)/3,f);i.length=n}return p},n=function(a,b,c){for(var d,e,f,g,h,i,j,k,l,m,n,o=1/c,p=a.length;--p>-1;)for(m=a[p],f=m.a,g=m.d-f,h=m.c-f,i=m.b-f,d=e=0,k=1;c>=k;k++)j=o*k,l=1-j,d=e-(e=(j*j*g+3*l*(j*h+l*i))*j),n=p*c+k-1,b[n]=(b[n]||0)+d*d},o=function(a,b){b=b>>0||6;var c,d,e,f,g=[],h=[],i=0,j=0,k=b-1,l=[],m=[];for(c in a)n(a[c],g,b);for(e=g.length,d=0;e>d;d++)i+=Math.sqrt(g[d]),f=d%b,m[f]=i,f===k&&(j+=i,f=d/b>>0,l[f]=m,h[f]=j,i=0,m=[]);return{length:j,lengths:h,segments:l}},p=_gsScope._gsDefine.plugin({propName:"bezier",priority:-1,version:"1.3.8",API:2,global:!0,init:function(a,b,c){this._target=a,b instanceof Array&&(b={values:b}),this._func={},this._mod={},this._props=[],this._timeRes=null==b.timeResolution?6:parseInt(b.timeResolution,10);var d,e,f,g,h,i=b.values||[],j={},k=i[0],n=b.autoRotate||c.vars.orientToBezier;this._autoRotate=n?n instanceof Array?n:[["x","y","rotation",n===!0?0:Number(n)||0]]:null;for(d in k)this._props.push(d);for(f=this._props.length;--f>-1;)d=this._props[f],this._overwriteProps.push(d),e=this._func[d]="function"==typeof a[d],j[d]=e?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]():parseFloat(a[d]),h||j[d]!==i[0][d]&&(h=j);if(this._beziers="cubic"!==b.type&&"quadratic"!==b.type&&"soft"!==b.type?l(i,isNaN(b.curviness)?1:b.curviness,!1,"thruBasic"===b.type,b.correlate,h):m(i,b.type,j),this._segCount=this._beziers[d].length,this._timeRes){var p=o(this._beziers,this._timeRes);this._length=p.length,this._lengths=p.lengths,this._segments=p.segments,this._l1=this._li=this._s1=this._si=0,this._l2=this._lengths[0],this._curSeg=this._segments[0],this._s2=this._curSeg[0],this._prec=1/this._curSeg.length}if(n=this._autoRotate)for(this._initialRotations=[],n[0]instanceof Array||(this._autoRotate=n=[n]),f=n.length;--f>-1;){for(g=0;3>g;g++)d=n[f][g],this._func[d]="function"==typeof a[d]?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]:!1;d=n[f][2],this._initialRotations[f]=(this._func[d]?this._func[d].call(this._target):this._target[d])||0,this._overwriteProps.push(d)}return this._startRatio=c.vars.runBackwards?1:0,!0},set:function(b){var c,d,e,f,g,h,i,j,k,l,m=this._segCount,n=this._func,o=this._target,p=b!==this._startRatio;if(this._timeRes){if(k=this._lengths,l=this._curSeg,b*=this._length,e=this._li,b>this._l2&&m-1>e){for(j=m-1;j>e&&(this._l2=k[++e])<=b;);this._l1=k[e-1],this._li=e,this._curSeg=l=this._segments[e],this._s2=l[this._s1=this._si=0]}else if(b<this._l1&&e>0){for(;e>0&&(this._l1=k[--e])>=b;);0===e&&b<this._l1?this._l1=0:e++,this._l2=k[e],this._li=e,this._curSeg=l=this._segments[e],this._s1=l[(this._si=l.length-1)-1]||0,this._s2=l[this._si]}if(c=e,b-=this._l1,e=this._si,b>this._s2&&e<l.length-1){for(j=l.length-1;j>e&&(this._s2=l[++e])<=b;);this._s1=l[e-1],this._si=e}else if(b<this._s1&&e>0){for(;e>0&&(this._s1=l[--e])>=b;);0===e&&b<this._s1?this._s1=0:e++,this._s2=l[e],this._si=e}h=(e+(b-this._s1)/(this._s2-this._s1))*this._prec||0}else c=0>b?0:b>=1?m-1:m*b>>0,h=(b-c*(1/m))*m;for(d=1-h,e=this._props.length;--e>-1;)f=this._props[e],g=this._beziers[f][c],i=(h*h*g.da+3*d*(h*g.ca+d*g.ba))*h+g.a,this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i;if(this._autoRotate){var q,r,s,t,u,v,w,x=this._autoRotate;for(e=x.length;--e>-1;)f=x[e][2],v=x[e][3]||0,w=x[e][4]===!0?1:a,g=this._beziers[x[e][0]],q=this._beziers[x[e][1]],g&&q&&(g=g[c],q=q[c],r=g.a+(g.b-g.a)*h,t=g.b+(g.c-g.b)*h,r+=(t-r)*h,t+=(g.c+(g.d-g.c)*h-t)*h,s=q.a+(q.b-q.a)*h,u=q.b+(q.c-q.b)*h,s+=(u-s)*h,u+=(q.c+(q.d-q.c)*h-u)*h,i=p?Math.atan2(u-s,t-r)*w+v:this._initialRotations[e],this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i)}}}),q=p.prototype;p.bezierThrough=l,p.cubicToQuadratic=i,p._autoCSS=!0,p.quadraticToCubic=function(a,b,c){return new g(a,(2*b+a)/3,(2*b+c)/3,c)},p._cssRegister=function(){var a=f.CSSPlugin;if(a){var b=a._internals,c=b._parseToProxy,d=b._setPluginRatio,e=b.CSSPropTween;b._registerComplexSpecialProp("bezier",{parser:function(a,b,f,g,h,i){b instanceof Array&&(b={values:b}),i=new p;var j,k,l,m=b.values,n=m.length-1,o=[],q={};if(0>n)return h;for(j=0;n>=j;j++)l=c(a,m[j],g,h,i,n!==j),o[j]=l.end;for(k in b)q[k]=b[k];return q.values=o,h=new e(a,"bezier",0,0,l.pt,2),h.data=l,h.plugin=i,h.setRatio=d,0===q.autoRotate&&(q.autoRotate=!0),!q.autoRotate||q.autoRotate instanceof Array||(j=q.autoRotate===!0?0:Number(q.autoRotate),q.autoRotate=null!=l.end.left?[["left","top","rotation",j,!1]]:null!=l.end.x?[["x","y","rotation",j,!1]]:!1),q.autoRotate&&(g._transform||g._enableTransforms(!1),l.autoRotate=g._target._gsTransform,l.proxy.rotation=l.autoRotate.rotation||0,g._overwriteProps.push("rotation")),i._onInitTween(l.proxy,q,g._tween),h}})}},q._mod=function(a){for(var b,c=this._overwriteProps,d=c.length;--d>-1;)b=a[c[d]],b&&"function"==typeof b&&(this._mod[c[d]]=b)},q._kill=function(a){var b,c,d=this._props;for(b in this._beziers)if(b in a)for(delete this._beziers[b],delete this._func[b],c=d.length;--c>-1;)d[c]===b&&d.splice(c,1);if(d=this._autoRotate)for(c=d.length;--c>-1;)a[d[c][2]]&&d.splice(c,1);return this._super._kill.call(this,a)}}(),_gsScope._gsDefine("plugins.CSSPlugin",["plugins.TweenPlugin","TweenLite"],function(a,b){var c,d,e,f,g=function(){a.call(this,"css"),this._overwriteProps.length=0,this.setRatio=g.prototype.setRatio},h=_gsScope._gsDefine.globals,i={},j=g.prototype=new a("css");j.constructor=g,g.version="1.20.0",g.API=2,g.defaultTransformPerspective=0,g.defaultSkewType="compensated",g.defaultSmoothOrigin=!0,j="px",g.suffixMap={top:j,right:j,bottom:j,left:j,width:j,height:j,fontSize:j,padding:j,margin:j,perspective:j,lineHeight:""};var k,l,m,n,o,p,q,r,s=/(?:\-|\.|\b)(\d|\.|e\-)+/g,t=/(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,u=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,v=/(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,w=/(?:\d|\-|\+|=|#|\.)*/g,x=/opacity *= *([^)]*)/i,y=/opacity:([^;]*)/i,z=/alpha\(opacity *=.+?\)/i,A=/^(rgb|hsl)/,B=/([A-Z])/g,C=/-([a-z])/gi,D=/(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,E=function(a,b){return b.toUpperCase()},F=/(?:Left|Right|Width)/i,G=/(M11|M12|M21|M22)=[\d\-\.e]+/gi,H=/progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,I=/,(?=[^\)]*(?:\(|$))/gi,J=/[\s,\(]/i,K=Math.PI/180,L=180/Math.PI,M={},N={style:{}},O=_gsScope.document||{createElement:function(){return N}},P=function(a,b){return O.createElementNS?O.createElementNS(b||"http://www.w3.org/1999/xhtml",a):O.createElement(a)},Q=P("div"),R=P("img"),S=g._internals={_specialProps:i},T=(_gsScope.navigator||{}).userAgent||"",U=function(){var a=T.indexOf("Android"),b=P("a");return m=-1!==T.indexOf("Safari")&&-1===T.indexOf("Chrome")&&(-1===a||parseFloat(T.substr(a+8,2))>3),o=m&&parseFloat(T.substr(T.indexOf("Version/")+8,2))<6,n=-1!==T.indexOf("Firefox"),(/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(T)||/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(T))&&(p=parseFloat(RegExp.$1)),b?(b.style.cssText="top:1px;opacity:.55;",/^0.55/.test(b.style.opacity)):!1}(),V=function(a){return x.test("string"==typeof a?a:(a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?parseFloat(RegExp.$1)/100:1},W=function(a){_gsScope.console&&console.log(a)},X="",Y="",Z=function(a,b){b=b||Q;var c,d,e=b.style;if(void 0!==e[a])return a;for(a=a.charAt(0).toUpperCase()+a.substr(1),c=["O","Moz","ms","Ms","Webkit"],d=5;--d>-1&&void 0===e[c[d]+a];);return d>=0?(Y=3===d?"ms":c[d],X="-"+Y.toLowerCase()+"-",Y+a):null},$=O.defaultView?O.defaultView.getComputedStyle:function(){},_=g.getStyle=function(a,b,c,d,e){var f;return U||"opacity"!==b?(!d&&a.style[b]?f=a.style[b]:(c=c||$(a))?f=c[b]||c.getPropertyValue(b)||c.getPropertyValue(b.replace(B,"-$1").toLowerCase()):a.currentStyle&&(f=a.currentStyle[b]),null==e||f&&"none"!==f&&"auto"!==f&&"auto auto"!==f?f:e):V(a)},aa=S.convertToPixels=function(a,c,d,e,f){if("px"===e||!e&&"lineHeight"!==c)return d;if("auto"===e||!d)return 0;var h,i,j,k=F.test(c),l=a,m=Q.style,n=0>d,o=1===d;if(n&&(d=-d),o&&(d*=100),"lineHeight"!==c||e)if("%"===e&&-1!==c.indexOf("border"))h=d/100*(k?a.clientWidth:a.clientHeight);else{if(m.cssText="border:0 solid red;position:"+_(a,"position")+";line-height:0;","%"!==e&&l.appendChild&&"v"!==e.charAt(0)&&"rem"!==e)m[k?"borderLeftWidth":"borderTopWidth"]=d+e;else{if(l=a.parentNode||O.body,-1!==_(l,"display").indexOf("flex")&&(m.position="absolute"),i=l._gsCache,j=b.ticker.frame,i&&k&&i.time===j)return i.width*d/100;m[k?"width":"height"]=d+e}l.appendChild(Q),h=parseFloat(Q[k?"offsetWidth":"offsetHeight"]),l.removeChild(Q),k&&"%"===e&&g.cacheWidths!==!1&&(i=l._gsCache=l._gsCache||{},i.time=j,i.width=h/d*100),0!==h||f||(h=aa(a,c,d,e,!0))}else i=$(a).lineHeight,a.style.lineHeight=d,h=parseFloat($(a).lineHeight),a.style.lineHeight=i;return o&&(h/=100),n?-h:h},ba=S.calculateOffset=function(a,b,c){if("absolute"!==_(a,"position",c))return 0;var d="left"===b?"Left":"Top",e=_(a,"margin"+d,c);return a["offset"+d]-(aa(a,b,parseFloat(e),e.replace(w,""))||0)},ca=function(a,b){var c,d,e,f={};if(b=b||$(a,null))if(c=b.length)for(;--c>-1;)e=b[c],(-1===e.indexOf("-transform")||Da===e)&&(f[e.replace(C,E)]=b.getPropertyValue(e));else for(c in b)(-1===c.indexOf("Transform")||Ca===c)&&(f[c]=b[c]);else if(b=a.currentStyle||a.style)for(c in b)"string"==typeof c&&void 0===f[c]&&(f[c.replace(C,E)]=b[c]);return U||(f.opacity=V(a)),d=Ra(a,b,!1),f.rotation=d.rotation,f.skewX=d.skewX,f.scaleX=d.scaleX,f.scaleY=d.scaleY,f.x=d.x,f.y=d.y,Fa&&(f.z=d.z,f.rotationX=d.rotationX,f.rotationY=d.rotationY,f.scaleZ=d.scaleZ),f.filters&&delete f.filters,f},da=function(a,b,c,d,e){var f,g,h,i={},j=a.style;for(g in c)"cssText"!==g&&"length"!==g&&isNaN(g)&&(b[g]!==(f=c[g])||e&&e[g])&&-1===g.indexOf("Origin")&&("number"==typeof f||"string"==typeof f)&&(i[g]="auto"!==f||"left"!==g&&"top"!==g?""!==f&&"auto"!==f&&"none"!==f||"string"!=typeof b[g]||""===b[g].replace(v,"")?f:0:ba(a,g),void 0!==j[g]&&(h=new sa(j,g,j[g],h)));if(d)for(g in d)"className"!==g&&(i[g]=d[g]);return{difs:i,firstMPT:h}},ea={width:["Left","Right"],height:["Top","Bottom"]},fa=["marginLeft","marginRight","marginTop","marginBottom"],ga=function(a,b,c){if("svg"===(a.nodeName+"").toLowerCase())return(c||$(a))[b]||0;if(a.getCTM&&Oa(a))return a.getBBox()[b]||0;var d=parseFloat("width"===b?a.offsetWidth:a.offsetHeight),e=ea[b],f=e.length;for(c=c||$(a,null);--f>-1;)d-=parseFloat(_(a,"padding"+e[f],c,!0))||0,d-=parseFloat(_(a,"border"+e[f]+"Width",c,!0))||0;return d},ha=function(a,b){if("contain"===a||"auto"===a||"auto auto"===a)return a+" ";(null==a||""===a)&&(a="0 0");var c,d=a.split(" "),e=-1!==a.indexOf("left")?"0%":-1!==a.indexOf("right")?"100%":d[0],f=-1!==a.indexOf("top")?"0%":-1!==a.indexOf("bottom")?"100%":d[1];if(d.length>3&&!b){for(d=a.split(", ").join(",").split(","),a=[],c=0;c<d.length;c++)a.push(ha(d[c]));return a.join(",")}return null==f?f="center"===e?"50%":"0":"center"===f&&(f="50%"),("center"===e||isNaN(parseFloat(e))&&-1===(e+"").indexOf("="))&&(e="50%"),a=e+" "+f+(d.length>2?" "+d[2]:""),b&&(b.oxp=-1!==e.indexOf("%"),b.oyp=-1!==f.indexOf("%"),b.oxr="="===e.charAt(1),b.oyr="="===f.charAt(1),b.ox=parseFloat(e.replace(v,"")),b.oy=parseFloat(f.replace(v,"")),b.v=a),b||a},ia=function(a,b){return"function"==typeof a&&(a=a(r,q)),"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2)):parseFloat(a)-parseFloat(b)||0},ja=function(a,b){return"function"==typeof a&&(a=a(r,q)),null==a?b:"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2))+b:parseFloat(a)||0},ka=function(a,b,c,d){var e,f,g,h,i,j=1e-6;return"function"==typeof a&&(a=a(r,q)),null==a?h=b:"number"==typeof a?h=a:(e=360,f=a.split("_"),i="="===a.charAt(1),g=(i?parseInt(a.charAt(0)+"1",10)*parseFloat(f[0].substr(2)):parseFloat(f[0]))*(-1===a.indexOf("rad")?1:L)-(i?0:b),f.length&&(d&&(d[c]=b+g),-1!==a.indexOf("short")&&(g%=e,g!==g%(e/2)&&(g=0>g?g+e:g-e)),-1!==a.indexOf("_cw")&&0>g?g=(g+9999999999*e)%e-(g/e|0)*e:-1!==a.indexOf("ccw")&&g>0&&(g=(g-9999999999*e)%e-(g/e|0)*e)),h=b+g),j>h&&h>-j&&(h=0),h},la={aqua:[0,255,255],lime:[0,255,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,255],navy:[0,0,128],white:[255,255,255],fuchsia:[255,0,255],olive:[128,128,0],yellow:[255,255,0],orange:[255,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[255,0,0],pink:[255,192,203],cyan:[0,255,255],transparent:[255,255,255,0]},ma=function(a,b,c){return a=0>a?a+1:a>1?a-1:a,255*(1>6*a?b+(c-b)*a*6:.5>a?c:2>3*a?b+(c-b)*(2/3-a)*6:b)+.5|0},na=g.parseColor=function(a,b){var c,d,e,f,g,h,i,j,k,l,m;if(a)if("number"==typeof a)c=[a>>16,a>>8&255,255&a];else{if(","===a.charAt(a.length-1)&&(a=a.substr(0,a.length-1)),la[a])c=la[a];else if("#"===a.charAt(0))4===a.length&&(d=a.charAt(1),e=a.charAt(2),f=a.charAt(3),a="#"+d+d+e+e+f+f),a=parseInt(a.substr(1),16),c=[a>>16,a>>8&255,255&a];else if("hsl"===a.substr(0,3))if(c=m=a.match(s),b){if(-1!==a.indexOf("="))return a.match(t)}else g=Number(c[0])%360/360,h=Number(c[1])/100,i=Number(c[2])/100,e=.5>=i?i*(h+1):i+h-i*h,d=2*i-e,c.length>3&&(c[3]=Number(a[3])),c[0]=ma(g+1/3,d,e),c[1]=ma(g,d,e),c[2]=ma(g-1/3,d,e);else c=a.match(s)||la.transparent;c[0]=Number(c[0]),c[1]=Number(c[1]),c[2]=Number(c[2]),c.length>3&&(c[3]=Number(c[3]))}else c=la.black;return b&&!m&&(d=c[0]/255,e=c[1]/255,f=c[2]/255,j=Math.max(d,e,f),k=Math.min(d,e,f),i=(j+k)/2,j===k?g=h=0:(l=j-k,h=i>.5?l/(2-j-k):l/(j+k),g=j===d?(e-f)/l+(f>e?6:0):j===e?(f-d)/l+2:(d-e)/l+4,g*=60),c[0]=g+.5|0,c[1]=100*h+.5|0,c[2]=100*i+.5|0),c},oa=function(a,b){var c,d,e,f=a.match(pa)||[],g=0,h="";if(!f.length)return a;for(c=0;c<f.length;c++)d=f[c],e=a.substr(g,a.indexOf(d,g)-g),g+=e.length+d.length,d=na(d,b),3===d.length&&d.push(1),h+=e+(b?"hsla("+d[0]+","+d[1]+"%,"+d[2]+"%,"+d[3]:"rgba("+d.join(","))+")";return h+a.substr(g)},pa="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";for(j in la)pa+="|"+j+"\\b";pa=new RegExp(pa+")","gi"),g.colorStringFilter=function(a){var b,c=a[0]+" "+a[1];pa.test(c)&&(b=-1!==c.indexOf("hsl(")||-1!==c.indexOf("hsla("),a[0]=oa(a[0],b),a[1]=oa(a[1],b)),pa.lastIndex=0},b.defaultStringFilter||(b.defaultStringFilter=g.colorStringFilter);var qa=function(a,b,c,d){if(null==a)return function(a){return a};var e,f=b?(a.match(pa)||[""])[0]:"",g=a.split(f).join("").match(u)||[],h=a.substr(0,a.indexOf(g[0])),i=")"===a.charAt(a.length-1)?")":"",j=-1!==a.indexOf(" ")?" ":",",k=g.length,l=k>0?g[0].replace(s,""):"";return k?e=b?function(a){var b,m,n,o;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(o=a.replace(I,"|").split("|"),n=0;n<o.length;n++)o[n]=e(o[n]);return o.join(",")}if(b=(a.match(pa)||[f])[0],m=a.split(b).join("").match(u)||[],n=m.length,k>n--)for(;++n<k;)m[n]=c?m[(n-1)/2|0]:g[n];return h+m.join(j)+j+b+i+(-1!==a.indexOf("inset")?" inset":"")}:function(a){var b,f,m;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(f=a.replace(I,"|").split("|"),m=0;m<f.length;m++)f[m]=e(f[m]);return f.join(",")}if(b=a.match(u)||[],m=b.length,k>m--)for(;++m<k;)b[m]=c?b[(m-1)/2|0]:g[m];return h+b.join(j)+i}:function(a){return a}},ra=function(a){return a=a.split(","),function(b,c,d,e,f,g,h){var i,j=(c+"").split(" ");for(h={},i=0;4>i;i++)h[a[i]]=j[i]=j[i]||j[(i-1)/2>>0];return e.parse(b,h,f,g)}},sa=(S._setPluginRatio=function(a){this.plugin.setRatio(a);for(var b,c,d,e,f,g=this.data,h=g.proxy,i=g.firstMPT,j=1e-6;i;)b=h[i.v],i.r?b=Math.round(b):j>b&&b>-j&&(b=0),i.t[i.p]=b,i=i._next;if(g.autoRotate&&(g.autoRotate.rotation=g.mod?g.mod(h.rotation,this.t):h.rotation),1===a||0===a)for(i=g.firstMPT,f=1===a?"e":"b";i;){if(c=i.t,c.type){if(1===c.type){for(e=c.xs0+c.s+c.xs1,d=1;d<c.l;d++)e+=c["xn"+d]+c["xs"+(d+1)];c[f]=e}}else c[f]=c.s+c.xs0;i=i._next}},function(a,b,c,d,e){this.t=a,this.p=b,this.v=c,this.r=e,d&&(d._prev=this,this._next=d)}),ta=(S._parseToProxy=function(a,b,c,d,e,f){var g,h,i,j,k,l=d,m={},n={},o=c._transform,p=M;for(c._transform=null,M=b,d=k=c.parse(a,b,d,e),M=p,f&&(c._transform=o,l&&(l._prev=null,l._prev&&(l._prev._next=null)));d&&d!==l;){if(d.type<=1&&(h=d.p,n[h]=d.s+d.c,m[h]=d.s,f||(j=new sa(d,"s",h,j,d.r),d.c=0),1===d.type))for(g=d.l;--g>0;)i="xn"+g,h=d.p+"_"+i,n[h]=d.data[i],m[h]=d[i],f||(j=new sa(d,i,h,j,d.rxp[i]));d=d._next}return{proxy:m,end:n,firstMPT:j,pt:k}},S.CSSPropTween=function(a,b,d,e,g,h,i,j,k,l,m){this.t=a,this.p=b,this.s=d,this.c=e,this.n=i||b,a instanceof ta||f.push(this.n),this.r=j,this.type=h||0,k&&(this.pr=k,c=!0),this.b=void 0===l?d:l,this.e=void 0===m?d+e:m,g&&(this._next=g,g._prev=this)}),ua=function(a,b,c,d,e,f){var g=new ta(a,b,c,d-c,e,-1,f);return g.b=c,g.e=g.xs0=d,g},va=g.parseComplex=function(a,b,c,d,e,f,h,i,j,l){c=c||f||"","function"==typeof d&&(d=d(r,q)),h=new ta(a,b,0,0,h,l?2:1,null,!1,i,c,d),d+="",e&&pa.test(d+c)&&(d=[c,d],g.colorStringFilter(d),c=d[0],d=d[1]);var m,n,o,p,u,v,w,x,y,z,A,B,C,D=c.split(", ").join(",").split(" "),E=d.split(", ").join(",").split(" "),F=D.length,G=k!==!1;for((-1!==d.indexOf(",")||-1!==c.indexOf(","))&&(D=D.join(" ").replace(I,", ").split(" "),E=E.join(" ").replace(I,", ").split(" "),F=D.length),F!==E.length&&(D=(f||"").split(" "),F=D.length),h.plugin=j,h.setRatio=l,pa.lastIndex=0,m=0;F>m;m++)if(p=D[m],u=E[m],x=parseFloat(p),x||0===x)h.appendXtra("",x,ia(u,x),u.replace(t,""),G&&-1!==u.indexOf("px"),!0);else if(e&&pa.test(p))B=u.indexOf(")")+1,B=")"+(B?u.substr(B):""),C=-1!==u.indexOf("hsl")&&U,z=u,p=na(p,C),u=na(u,C),y=p.length+u.length>6,y&&!U&&0===u[3]?(h["xs"+h.l]+=h.l?" transparent":"transparent",h.e=h.e.split(E[m]).join("transparent")):(U||(y=!1),C?h.appendXtra(z.substr(0,z.indexOf("hsl"))+(y?"hsla(":"hsl("),p[0],ia(u[0],p[0]),",",!1,!0).appendXtra("",p[1],ia(u[1],p[1]),"%,",!1).appendXtra("",p[2],ia(u[2],p[2]),y?"%,":"%"+B,!1):h.appendXtra(z.substr(0,z.indexOf("rgb"))+(y?"rgba(":"rgb("),p[0],u[0]-p[0],",",!0,!0).appendXtra("",p[1],u[1]-p[1],",",!0).appendXtra("",p[2],u[2]-p[2],y?",":B,!0),y&&(p=p.length<4?1:p[3],h.appendXtra("",p,(u.length<4?1:u[3])-p,B,!1))),pa.lastIndex=0;else if(v=p.match(s)){if(w=u.match(t),!w||w.length!==v.length)return h;for(o=0,n=0;n<v.length;n++)A=v[n],z=p.indexOf(A,o),h.appendXtra(p.substr(o,z-o),Number(A),ia(w[n],A),"",G&&"px"===p.substr(z+A.length,2),0===n),o=z+A.length;h["xs"+h.l]+=p.substr(o)}else h["xs"+h.l]+=h.l||h["xs"+h.l]?" "+u:u;if(-1!==d.indexOf("=")&&h.data){for(B=h.xs0+h.data.s,m=1;m<h.l;m++)B+=h["xs"+m]+h.data["xn"+m];h.e=B+h["xs"+m]}return h.l||(h.type=-1,h.xs0=h.e),h.xfirst||h},wa=9;for(j=ta.prototype,j.l=j.pr=0;--wa>0;)j["xn"+wa]=0,j["xs"+wa]="";j.xs0="",j._next=j._prev=j.xfirst=j.data=j.plugin=j.setRatio=j.rxp=null,j.appendXtra=function(a,b,c,d,e,f){var g=this,h=g.l;return g["xs"+h]+=f&&(h||g["xs"+h])?" "+a:a||"",c||0===h||g.plugin?(g.l++,g.type=g.setRatio?2:1,g["xs"+g.l]=d||"",h>0?(g.data["xn"+h]=b+c,g.rxp["xn"+h]=e,g["xn"+h]=b,g.plugin||(g.xfirst=new ta(g,"xn"+h,b,c,g.xfirst||g,0,g.n,e,g.pr),g.xfirst.xs0=0),g):(g.data={s:b+c},g.rxp={},g.s=b,g.c=c,g.r=e,g)):(g["xs"+h]+=b+(d||""),g)};var xa=function(a,b){b=b||{},this.p=b.prefix?Z(a)||a:a,i[a]=i[this.p]=this,this.format=b.formatter||qa(b.defaultValue,b.color,b.collapsible,b.multi),b.parser&&(this.parse=b.parser),this.clrs=b.color,this.multi=b.multi,this.keyword=b.keyword,this.dflt=b.defaultValue,this.pr=b.priority||0},ya=S._registerComplexSpecialProp=function(a,b,c){"object"!=typeof b&&(b={parser:c});var d,e,f=a.split(","),g=b.defaultValue;for(c=c||[g],d=0;d<f.length;d++)b.prefix=0===d&&b.prefix,b.defaultValue=c[d]||g,e=new xa(f[d],b)},za=S._registerPluginProp=function(a){if(!i[a]){var b=a.charAt(0).toUpperCase()+a.substr(1)+"Plugin";ya(a,{parser:function(a,c,d,e,f,g,j){var k=h.com.greensock.plugins[b];return k?(k._cssRegister(),i[d].parse(a,c,d,e,f,g,j)):(W("Error: "+b+" js file not loaded."),f)}})}};j=xa.prototype,j.parseComplex=function(a,b,c,d,e,f){var g,h,i,j,k,l,m=this.keyword;if(this.multi&&(I.test(c)||I.test(b)?(h=b.replace(I,"|").split("|"),i=c.replace(I,"|").split("|")):m&&(h=[b],i=[c])),i){for(j=i.length>h.length?i.length:h.length,g=0;j>g;g++)b=h[g]=h[g]||this.dflt,c=i[g]=i[g]||this.dflt,m&&(k=b.indexOf(m),l=c.indexOf(m),k!==l&&(-1===l?h[g]=h[g].split(m).join(""):-1===k&&(h[g]+=" "+m)));b=h.join(", "),c=i.join(", ")}return va(a,this.p,b,c,this.clrs,this.dflt,d,this.pr,e,f)},j.parse=function(a,b,c,d,f,g,h){return this.parseComplex(a.style,this.format(_(a,this.p,e,!1,this.dflt)),this.format(b),f,g)},g.registerSpecialProp=function(a,b,c){ya(a,{parser:function(a,d,e,f,g,h,i){var j=new ta(a,e,0,0,g,2,e,!1,c);return j.plugin=h,j.setRatio=b(a,d,f._tween,e),j},priority:c})},g.useSVGTransformAttr=!0;var Aa,Ba="scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),Ca=Z("transform"),Da=X+"transform",Ea=Z("transformOrigin"),Fa=null!==Z("perspective"),Ga=S.Transform=function(){this.perspective=parseFloat(g.defaultTransformPerspective)||0,this.force3D=g.defaultForce3D!==!1&&Fa?g.defaultForce3D||"auto":!1},Ha=_gsScope.SVGElement,Ia=function(a,b,c){var d,e=O.createElementNS("http://www.w3.org/2000/svg",a),f=/([a-z])([A-Z])/g;for(d in c)e.setAttributeNS(null,d.replace(f,"$1-$2").toLowerCase(),c[d]);return b.appendChild(e),e},Ja=O.documentElement||{},Ka=function(){var a,b,c,d=p||/Android/i.test(T)&&!_gsScope.chrome;return O.createElementNS&&!d&&(a=Ia("svg",Ja),b=Ia("rect",a,{width:100,height:50,x:100}),c=b.getBoundingClientRect().width,b.style[Ea]="50% 50%",b.style[Ca]="scaleX(0.5)",d=c===b.getBoundingClientRect().width&&!(n&&Fa),Ja.removeChild(a)),d}(),La=function(a,b,c,d,e,f){var h,i,j,k,l,m,n,o,p,q,r,s,t,u,v=a._gsTransform,w=Qa(a,!0);v&&(t=v.xOrigin,u=v.yOrigin),(!d||(h=d.split(" ")).length<2)&&(n=a.getBBox(),0===n.x&&0===n.y&&n.width+n.height===0&&(n={x:parseFloat(a.hasAttribute("x")?a.getAttribute("x"):a.hasAttribute("cx")?a.getAttribute("cx"):0)||0,y:parseFloat(a.hasAttribute("y")?a.getAttribute("y"):a.hasAttribute("cy")?a.getAttribute("cy"):0)||0,width:0,height:0}),b=ha(b).split(" "),h=[(-1!==b[0].indexOf("%")?parseFloat(b[0])/100*n.width:parseFloat(b[0]))+n.x,(-1!==b[1].indexOf("%")?parseFloat(b[1])/100*n.height:parseFloat(b[1]))+n.y]),c.xOrigin=k=parseFloat(h[0]),c.yOrigin=l=parseFloat(h[1]),d&&w!==Pa&&(m=w[0],n=w[1],o=w[2],p=w[3],q=w[4],r=w[5],s=m*p-n*o,s&&(i=k*(p/s)+l*(-o/s)+(o*r-p*q)/s,j=k*(-n/s)+l*(m/s)-(m*r-n*q)/s,k=c.xOrigin=h[0]=i,l=c.yOrigin=h[1]=j)),v&&(f&&(c.xOffset=v.xOffset,c.yOffset=v.yOffset,v=c),e||e!==!1&&g.defaultSmoothOrigin!==!1?(i=k-t,j=l-u,v.xOffset+=i*w[0]+j*w[2]-i,v.yOffset+=i*w[1]+j*w[3]-j):v.xOffset=v.yOffset=0),f||a.setAttribute("data-svg-origin",h.join(" "))},Ma=function(a){var b,c=P("svg",this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),d=this.parentNode,e=this.nextSibling,f=this.style.cssText;if(Ja.appendChild(c),c.appendChild(this),this.style.display="block",a)try{b=this.getBBox(),this._originalGetBBox=this.getBBox,this.getBBox=Ma}catch(g){}else this._originalGetBBox&&(b=this._originalGetBBox());return e?d.insertBefore(this,e):d.appendChild(this),Ja.removeChild(c),this.style.cssText=f,b},Na=function(a){try{return a.getBBox()}catch(b){return Ma.call(a,!0)}},Oa=function(a){return!(!(Ha&&a.getCTM&&Na(a))||a.parentNode&&!a.ownerSVGElement)},Pa=[1,0,0,1,0,0],Qa=function(a,b){var c,d,e,f,g,h,i=a._gsTransform||new Ga,j=1e5,k=a.style;if(Ca?d=_(a,Da,null,!0):a.currentStyle&&(d=a.currentStyle.filter.match(G),d=d&&4===d.length?[d[0].substr(4),Number(d[2].substr(4)),Number(d[1].substr(4)),d[3].substr(4),i.x||0,i.y||0].join(","):""),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,!Ca||!(h="none"===$(a).display)&&a.parentNode||(h&&(f=k.display,k.display="block"),a.parentNode||(g=1,Ja.appendChild(a)),d=_(a,Da,null,!0),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,f?k.display=f:h&&Va(k,"display"),g&&Ja.removeChild(a)),(i.svg||a.getCTM&&Oa(a))&&(c&&-1!==(k[Ca]+"").indexOf("matrix")&&(d=k[Ca],c=0),e=a.getAttribute("transform"),c&&e&&(-1!==e.indexOf("matrix")?(d=e,c=0):-1!==e.indexOf("translate")&&(d="matrix(1,0,0,1,"+e.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",")+")",c=0))),c)return Pa;for(e=(d||"").match(s)||[],wa=e.length;--wa>-1;)f=Number(e[wa]),e[wa]=(g=f-(f|=0))?(g*j+(0>g?-.5:.5)|0)/j+f:f;return b&&e.length>6?[e[0],e[1],e[4],e[5],e[12],e[13]]:e},Ra=S.getTransform=function(a,c,d,e){if(a._gsTransform&&d&&!e)return a._gsTransform;var f,h,i,j,k,l,m=d?a._gsTransform||new Ga:new Ga,n=m.scaleX<0,o=2e-5,p=1e5,q=Fa?parseFloat(_(a,Ea,c,!1,"0 0 0").split(" ")[2])||m.zOrigin||0:0,r=parseFloat(g.defaultTransformPerspective)||0;if(m.svg=!(!a.getCTM||!Oa(a)),m.svg&&(La(a,_(a,Ea,c,!1,"50% 50%")+"",m,a.getAttribute("data-svg-origin")),Aa=g.useSVGTransformAttr||Ka),f=Qa(a),f!==Pa){if(16===f.length){var s,t,u,v,w,x=f[0],y=f[1],z=f[2],A=f[3],B=f[4],C=f[5],D=f[6],E=f[7],F=f[8],G=f[9],H=f[10],I=f[12],J=f[13],K=f[14],M=f[11],N=Math.atan2(D,H);m.zOrigin&&(K=-m.zOrigin,I=F*K-f[12],J=G*K-f[13],K=H*K+m.zOrigin-f[14]),m.rotationX=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=B*v+F*w,t=C*v+G*w,u=D*v+H*w,F=B*-w+F*v,G=C*-w+G*v,H=D*-w+H*v,M=E*-w+M*v,B=s,C=t,D=u),N=Math.atan2(-z,H),m.rotationY=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=x*v-F*w,t=y*v-G*w,u=z*v-H*w,G=y*w+G*v,H=z*w+H*v,M=A*w+M*v,x=s,y=t,z=u),N=Math.atan2(y,x),m.rotation=N*L,N&&(v=Math.cos(N),w=Math.sin(N),s=x*v+y*w,t=B*v+C*w,u=F*v+G*w,y=y*v-x*w,C=C*v-B*w,G=G*v-F*w,x=s,B=t,F=u),m.rotationX&&Math.abs(m.rotationX)+Math.abs(m.rotation)>359.9&&(m.rotationX=m.rotation=0,m.rotationY=180-m.rotationY),N=Math.atan2(B,C),m.scaleX=(Math.sqrt(x*x+y*y+z*z)*p+.5|0)/p,m.scaleY=(Math.sqrt(C*C+D*D)*p+.5|0)/p,m.scaleZ=(Math.sqrt(F*F+G*G+H*H)*p+.5|0)/p,x/=m.scaleX,B/=m.scaleY,y/=m.scaleX,C/=m.scaleY,Math.abs(N)>o?(m.skewX=N*L,B=0,"simple"!==m.skewType&&(m.scaleY*=1/Math.cos(N))):m.skewX=0,m.perspective=M?1/(0>M?-M:M):0,m.x=I,m.y=J,m.z=K,m.svg&&(m.x-=m.xOrigin-(m.xOrigin*x-m.yOrigin*B),m.y-=m.yOrigin-(m.yOrigin*y-m.xOrigin*C))}else if(!Fa||e||!f.length||m.x!==f[4]||m.y!==f[5]||!m.rotationX&&!m.rotationY){var O=f.length>=6,P=O?f[0]:1,Q=f[1]||0,R=f[2]||0,S=O?f[3]:1;m.x=f[4]||0,m.y=f[5]||0,i=Math.sqrt(P*P+Q*Q),j=Math.sqrt(S*S+R*R),k=P||Q?Math.atan2(Q,P)*L:m.rotation||0,l=R||S?Math.atan2(R,S)*L+k:m.skewX||0,m.scaleX=i,m.scaleY=j,m.rotation=k,m.skewX=l,Fa&&(m.rotationX=m.rotationY=m.z=0,m.perspective=r,m.scaleZ=1),m.svg&&(m.x-=m.xOrigin-(m.xOrigin*P+m.yOrigin*R),m.y-=m.yOrigin-(m.xOrigin*Q+m.yOrigin*S))}Math.abs(m.skewX)>90&&Math.abs(m.skewX)<270&&(n?(m.scaleX*=-1,m.skewX+=m.rotation<=0?180:-180,m.rotation+=m.rotation<=0?180:-180):(m.scaleY*=-1,m.skewX+=m.skewX<=0?180:-180)),m.zOrigin=q;for(h in m)m[h]<o&&m[h]>-o&&(m[h]=0)}return d&&(a._gsTransform=m,m.svg&&(Aa&&a.style[Ca]?b.delayedCall(.001,function(){Va(a.style,Ca)}):!Aa&&a.getAttribute("transform")&&b.delayedCall(.001,function(){a.removeAttribute("transform")}))),m},Sa=function(a){var b,c,d=this.data,e=-d.rotation*K,f=e+d.skewX*K,g=1e5,h=(Math.cos(e)*d.scaleX*g|0)/g,i=(Math.sin(e)*d.scaleX*g|0)/g,j=(Math.sin(f)*-d.scaleY*g|0)/g,k=(Math.cos(f)*d.scaleY*g|0)/g,l=this.t.style,m=this.t.currentStyle;if(m){c=i,i=-j,j=-c,b=m.filter,l.filter="";var n,o,q=this.t.offsetWidth,r=this.t.offsetHeight,s="absolute"!==m.position,t="progid:DXImageTransform.Microsoft.Matrix(M11="+h+", M12="+i+", M21="+j+", M22="+k,u=d.x+q*d.xPercent/100,v=d.y+r*d.yPercent/100;if(null!=d.ox&&(n=(d.oxp?q*d.ox*.01:d.ox)-q/2,o=(d.oyp?r*d.oy*.01:d.oy)-r/2,u+=n-(n*h+o*i),v+=o-(n*j+o*k)),s?(n=q/2,o=r/2,t+=", Dx="+(n-(n*h+o*i)+u)+", Dy="+(o-(n*j+o*k)+v)+")"):t+=", sizingMethod='auto expand')",-1!==b.indexOf("DXImageTransform.Microsoft.Matrix(")?l.filter=b.replace(H,t):l.filter=t+" "+b,(0===a||1===a)&&1===h&&0===i&&0===j&&1===k&&(s&&-1===t.indexOf("Dx=0, Dy=0")||x.test(b)&&100!==parseFloat(RegExp.$1)||-1===b.indexOf(b.indexOf("Alpha"))&&l.removeAttribute("filter")),!s){var y,z,A,B=8>p?1:-1;for(n=d.ieOffsetX||0,o=d.ieOffsetY||0,d.ieOffsetX=Math.round((q-((0>h?-h:h)*q+(0>i?-i:i)*r))/2+u),d.ieOffsetY=Math.round((r-((0>k?-k:k)*r+(0>j?-j:j)*q))/2+v),wa=0;4>wa;wa++)z=fa[wa],y=m[z],c=-1!==y.indexOf("px")?parseFloat(y):aa(this.t,z,parseFloat(y),y.replace(w,""))||0,A=c!==d[z]?2>wa?-d.ieOffsetX:-d.ieOffsetY:2>wa?n-d.ieOffsetX:o-d.ieOffsetY,l[z]=(d[z]=Math.round(c-A*(0===wa||2===wa?1:B)))+"px"}}},Ta=S.set3DTransformRatio=S.setTransformRatio=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t,u,v,w,x,y,z=this.data,A=this.t.style,B=z.rotation,C=z.rotationX,D=z.rotationY,E=z.scaleX,F=z.scaleY,G=z.scaleZ,H=z.x,I=z.y,J=z.z,L=z.svg,M=z.perspective,N=z.force3D,O=z.skewY,P=z.skewX;if(O&&(P+=O,B+=O),((1===a||0===a)&&"auto"===N&&(this.tween._totalTime===this.tween._totalDuration||!this.tween._totalTime)||!N)&&!J&&!M&&!D&&!C&&1===G||Aa&&L||!Fa)return void(B||P||L?(B*=K,x=P*K,y=1e5,c=Math.cos(B)*E,f=Math.sin(B)*E,d=Math.sin(B-x)*-F,g=Math.cos(B-x)*F,x&&"simple"===z.skewType&&(b=Math.tan(x-O*K),b=Math.sqrt(1+b*b),d*=b,g*=b,O&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b)),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset,Aa&&(z.xPercent||z.yPercent)&&(q=this.t.getBBox(),H+=.01*z.xPercent*q.width,I+=.01*z.yPercent*q.height),q=1e-6,q>H&&H>-q&&(H=0),q>I&&I>-q&&(I=0)),u=(c*y|0)/y+","+(f*y|0)/y+","+(d*y|0)/y+","+(g*y|0)/y+","+H+","+I+")",L&&Aa?this.t.setAttribute("transform","matrix("+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+E+",0,0,"+F+","+H+","+I+")");if(n&&(q=1e-4,q>E&&E>-q&&(E=G=2e-5),q>F&&F>-q&&(F=G=2e-5),!M||z.z||z.rotationX||z.rotationY||(M=0)),B||P)B*=K,r=c=Math.cos(B),s=f=Math.sin(B),P&&(B-=P*K,r=Math.cos(B),s=Math.sin(B),"simple"===z.skewType&&(b=Math.tan((P-O)*K),b=Math.sqrt(1+b*b),r*=b,s*=b,z.skewY&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b))),d=-s,g=r;else{if(!(D||C||1!==G||M||L))return void(A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) translate3d(":"translate3d(")+H+"px,"+I+"px,"+J+"px)"+(1!==E||1!==F?" scale("+E+","+F+")":""));c=g=1,d=f=0}k=1,e=h=i=j=l=m=0,o=M?-1/M:0,p=z.zOrigin,q=1e-6,v=",",w="0",B=D*K,B&&(r=Math.cos(B),s=Math.sin(B),i=-s,l=o*-s,e=c*s,h=f*s,k=r,o*=r,c*=r,f*=r),B=C*K,B&&(r=Math.cos(B),s=Math.sin(B),b=d*r+e*s,t=g*r+h*s,j=k*s,m=o*s,e=d*-s+e*r,h=g*-s+h*r,k*=r,o*=r,d=b,g=t),1!==G&&(e*=G,h*=G,k*=G,o*=G),1!==F&&(d*=F,g*=F,j*=F,m*=F),1!==E&&(c*=E,f*=E,i*=E,l*=E),(p||L)&&(p&&(H+=e*-p,I+=h*-p,J+=k*-p+p),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset),q>H&&H>-q&&(H=w),q>I&&I>-q&&(I=w),q>J&&J>-q&&(J=0)),u=z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix3d(":"matrix3d(",u+=(q>c&&c>-q?w:c)+v+(q>f&&f>-q?w:f)+v+(q>i&&i>-q?w:i),u+=v+(q>l&&l>-q?w:l)+v+(q>d&&d>-q?w:d)+v+(q>g&&g>-q?w:g),C||D||1!==G?(u+=v+(q>j&&j>-q?w:j)+v+(q>m&&m>-q?w:m)+v+(q>e&&e>-q?w:e),u+=v+(q>h&&h>-q?w:h)+v+(q>k&&k>-q?w:k)+v+(q>o&&o>-q?w:o)+v):u+=",0,0,0,0,1,0,",u+=H+v+I+v+J+v+(M?1+-J/M:1)+")",A[Ca]=u};j=Ga.prototype,j.x=j.y=j.z=j.skewX=j.skewY=j.rotation=j.rotationX=j.rotationY=j.zOrigin=j.xPercent=j.yPercent=j.xOffset=j.yOffset=0,j.scaleX=j.scaleY=j.scaleZ=1,ya("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",{parser:function(a,b,c,d,f,h,i){if(d._lastParsedTransform===i)return f;d._lastParsedTransform=i;var j,k=i.scale&&"function"==typeof i.scale?i.scale:0;"function"==typeof i[c]&&(j=i[c],i[c]=b),k&&(i.scale=k(r,a));var l,m,n,o,p,s,t,u,v,w=a._gsTransform,x=a.style,y=1e-6,z=Ba.length,A=i,B={},C="transformOrigin",D=Ra(a,e,!0,A.parseTransform),E=A.transform&&("function"==typeof A.transform?A.transform(r,q):A.transform);if(D.skewType=A.skewType||D.skewType||g.defaultSkewType,d._transform=D,E&&"string"==typeof E&&Ca)m=Q.style,
m[Ca]=E,m.display="block",m.position="absolute",O.body.appendChild(Q),l=Ra(Q,null,!1),"simple"===D.skewType&&(l.scaleY*=Math.cos(l.skewX*K)),D.svg&&(s=D.xOrigin,t=D.yOrigin,l.x-=D.xOffset,l.y-=D.yOffset,(A.transformOrigin||A.svgOrigin)&&(E={},La(a,ha(A.transformOrigin),E,A.svgOrigin,A.smoothOrigin,!0),s=E.xOrigin,t=E.yOrigin,l.x-=E.xOffset-D.xOffset,l.y-=E.yOffset-D.yOffset),(s||t)&&(u=Qa(Q,!0),l.x-=s-(s*u[0]+t*u[2]),l.y-=t-(s*u[1]+t*u[3]))),O.body.removeChild(Q),l.perspective||(l.perspective=D.perspective),null!=A.xPercent&&(l.xPercent=ja(A.xPercent,D.xPercent)),null!=A.yPercent&&(l.yPercent=ja(A.yPercent,D.yPercent));else if("object"==typeof A){if(l={scaleX:ja(null!=A.scaleX?A.scaleX:A.scale,D.scaleX),scaleY:ja(null!=A.scaleY?A.scaleY:A.scale,D.scaleY),scaleZ:ja(A.scaleZ,D.scaleZ),x:ja(A.x,D.x),y:ja(A.y,D.y),z:ja(A.z,D.z),xPercent:ja(A.xPercent,D.xPercent),yPercent:ja(A.yPercent,D.yPercent),perspective:ja(A.transformPerspective,D.perspective)},p=A.directionalRotation,null!=p)if("object"==typeof p)for(m in p)A[m]=p[m];else A.rotation=p;"string"==typeof A.x&&-1!==A.x.indexOf("%")&&(l.x=0,l.xPercent=ja(A.x,D.xPercent)),"string"==typeof A.y&&-1!==A.y.indexOf("%")&&(l.y=0,l.yPercent=ja(A.y,D.yPercent)),l.rotation=ka("rotation"in A?A.rotation:"shortRotation"in A?A.shortRotation+"_short":"rotationZ"in A?A.rotationZ:D.rotation,D.rotation,"rotation",B),Fa&&(l.rotationX=ka("rotationX"in A?A.rotationX:"shortRotationX"in A?A.shortRotationX+"_short":D.rotationX||0,D.rotationX,"rotationX",B),l.rotationY=ka("rotationY"in A?A.rotationY:"shortRotationY"in A?A.shortRotationY+"_short":D.rotationY||0,D.rotationY,"rotationY",B)),l.skewX=ka(A.skewX,D.skewX),l.skewY=ka(A.skewY,D.skewY)}for(Fa&&null!=A.force3D&&(D.force3D=A.force3D,o=!0),n=D.force3D||D.z||D.rotationX||D.rotationY||l.z||l.rotationX||l.rotationY||l.perspective,n||null==A.scale||(l.scaleZ=1);--z>-1;)v=Ba[z],E=l[v]-D[v],(E>y||-y>E||null!=A[v]||null!=M[v])&&(o=!0,f=new ta(D,v,D[v],E,f),v in B&&(f.e=B[v]),f.xs0=0,f.plugin=h,d._overwriteProps.push(f.n));return E=A.transformOrigin,D.svg&&(E||A.svgOrigin)&&(s=D.xOffset,t=D.yOffset,La(a,ha(E),l,A.svgOrigin,A.smoothOrigin),f=ua(D,"xOrigin",(w?D:l).xOrigin,l.xOrigin,f,C),f=ua(D,"yOrigin",(w?D:l).yOrigin,l.yOrigin,f,C),(s!==D.xOffset||t!==D.yOffset)&&(f=ua(D,"xOffset",w?s:D.xOffset,D.xOffset,f,C),f=ua(D,"yOffset",w?t:D.yOffset,D.yOffset,f,C)),E="0px 0px"),(E||Fa&&n&&D.zOrigin)&&(Ca?(o=!0,v=Ea,E=(E||_(a,v,e,!1,"50% 50%"))+"",f=new ta(x,v,0,0,f,-1,C),f.b=x[v],f.plugin=h,Fa?(m=D.zOrigin,E=E.split(" "),D.zOrigin=(E.length>2&&(0===m||"0px"!==E[2])?parseFloat(E[2]):m)||0,f.xs0=f.e=E[0]+" "+(E[1]||"50%")+" 0px",f=new ta(D,"zOrigin",0,0,f,-1,f.n),f.b=m,f.xs0=f.e=D.zOrigin):f.xs0=f.e=E):ha(E+"",D)),o&&(d._transformType=D.svg&&Aa||!n&&3!==this._transformType?2:3),j&&(i[c]=j),k&&(i.scale=k),f},prefix:!0}),ya("boxShadow",{defaultValue:"0px 0px 0px 0px #999",prefix:!0,color:!0,multi:!0,keyword:"inset"}),ya("borderRadius",{defaultValue:"0px",parser:function(a,b,c,f,g,h){b=this.format(b);var i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],z=a.style;for(q=parseFloat(a.offsetWidth),r=parseFloat(a.offsetHeight),i=b.split(" "),j=0;j<y.length;j++)this.p.indexOf("border")&&(y[j]=Z(y[j])),m=l=_(a,y[j],e,!1,"0px"),-1!==m.indexOf(" ")&&(l=m.split(" "),m=l[0],l=l[1]),n=k=i[j],o=parseFloat(m),t=m.substr((o+"").length),u="="===n.charAt(1),u?(p=parseInt(n.charAt(0)+"1",10),n=n.substr(2),p*=parseFloat(n),s=n.substr((p+"").length-(0>p?1:0))||""):(p=parseFloat(n),s=n.substr((p+"").length)),""===s&&(s=d[c]||t),s!==t&&(v=aa(a,"borderLeft",o,t),w=aa(a,"borderTop",o,t),"%"===s?(m=v/q*100+"%",l=w/r*100+"%"):"em"===s?(x=aa(a,"borderLeft",1,"em"),m=v/x+"em",l=w/x+"em"):(m=v+"px",l=w+"px"),u&&(n=parseFloat(m)+p+s,k=parseFloat(l)+p+s)),g=va(z,y[j],m+" "+l,n+" "+k,!1,"0px",g);return g},prefix:!0,formatter:qa("0px 0px 0px 0px",!1,!0)}),ya("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius",{defaultValue:"0px",parser:function(a,b,c,d,f,g){return va(a.style,c,this.format(_(a,c,e,!1,"0px 0px")),this.format(b),!1,"0px",f)},prefix:!0,formatter:qa("0px 0px",!1,!0)}),ya("backgroundPosition",{defaultValue:"0 0",parser:function(a,b,c,d,f,g){var h,i,j,k,l,m,n="background-position",o=e||$(a,null),q=this.format((o?p?o.getPropertyValue(n+"-x")+" "+o.getPropertyValue(n+"-y"):o.getPropertyValue(n):a.currentStyle.backgroundPositionX+" "+a.currentStyle.backgroundPositionY)||"0 0"),r=this.format(b);if(-1!==q.indexOf("%")!=(-1!==r.indexOf("%"))&&r.split(",").length<2&&(m=_(a,"backgroundImage").replace(D,""),m&&"none"!==m)){for(h=q.split(" "),i=r.split(" "),R.setAttribute("src",m),j=2;--j>-1;)q=h[j],k=-1!==q.indexOf("%"),k!==(-1!==i[j].indexOf("%"))&&(l=0===j?a.offsetWidth-R.width:a.offsetHeight-R.height,h[j]=k?parseFloat(q)/100*l+"px":parseFloat(q)/l*100+"%");q=h.join(" ")}return this.parseComplex(a.style,q,r,f,g)},formatter:ha}),ya("backgroundSize",{defaultValue:"0 0",formatter:function(a){return a+="",ha(-1===a.indexOf(" ")?a+" "+a:a)}}),ya("perspective",{defaultValue:"0px",prefix:!0}),ya("perspectiveOrigin",{defaultValue:"50% 50%",prefix:!0}),ya("transformStyle",{prefix:!0}),ya("backfaceVisibility",{prefix:!0}),ya("userSelect",{prefix:!0}),ya("margin",{parser:ra("marginTop,marginRight,marginBottom,marginLeft")}),ya("padding",{parser:ra("paddingTop,paddingRight,paddingBottom,paddingLeft")}),ya("clip",{defaultValue:"rect(0px,0px,0px,0px)",parser:function(a,b,c,d,f,g){var h,i,j;return 9>p?(i=a.currentStyle,j=8>p?" ":",",h="rect("+i.clipTop+j+i.clipRight+j+i.clipBottom+j+i.clipLeft+")",b=this.format(b).split(",").join(j)):(h=this.format(_(a,this.p,e,!1,this.dflt)),b=this.format(b)),this.parseComplex(a.style,h,b,f,g)}}),ya("textShadow",{defaultValue:"0px 0px 0px #999",color:!0,multi:!0}),ya("autoRound,strictUnits",{parser:function(a,b,c,d,e){return e}}),ya("border",{defaultValue:"0px solid #000",parser:function(a,b,c,d,f,g){var h=_(a,"borderTopWidth",e,!1,"0px"),i=this.format(b).split(" "),j=i[0].replace(w,"");return"px"!==j&&(h=parseFloat(h)/aa(a,"borderTopWidth",1,j)+j),this.parseComplex(a.style,this.format(h+" "+_(a,"borderTopStyle",e,!1,"solid")+" "+_(a,"borderTopColor",e,!1,"#000")),i.join(" "),f,g)},color:!0,formatter:function(a){var b=a.split(" ");return b[0]+" "+(b[1]||"solid")+" "+(a.match(pa)||["#000"])[0]}}),ya("borderWidth",{parser:ra("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}),ya("float,cssFloat,styleFloat",{parser:function(a,b,c,d,e,f){var g=a.style,h="cssFloat"in g?"cssFloat":"styleFloat";return new ta(g,h,0,0,e,-1,c,!1,0,g[h],b)}});var Ua=function(a){var b,c=this.t,d=c.filter||_(this.data,"filter")||"",e=this.s+this.c*a|0;100===e&&(-1===d.indexOf("atrix(")&&-1===d.indexOf("radient(")&&-1===d.indexOf("oader(")?(c.removeAttribute("filter"),b=!_(this.data,"filter")):(c.filter=d.replace(z,""),b=!0)),b||(this.xn1&&(c.filter=d=d||"alpha(opacity="+e+")"),-1===d.indexOf("pacity")?0===e&&this.xn1||(c.filter=d+" alpha(opacity="+e+")"):c.filter=d.replace(x,"opacity="+e))};ya("opacity,alpha,autoAlpha",{defaultValue:"1",parser:function(a,b,c,d,f,g){var h=parseFloat(_(a,"opacity",e,!1,"1")),i=a.style,j="autoAlpha"===c;return"string"==typeof b&&"="===b.charAt(1)&&(b=("-"===b.charAt(0)?-1:1)*parseFloat(b.substr(2))+h),j&&1===h&&"hidden"===_(a,"visibility",e)&&0!==b&&(h=0),U?f=new ta(i,"opacity",h,b-h,f):(f=new ta(i,"opacity",100*h,100*(b-h),f),f.xn1=j?1:0,i.zoom=1,f.type=2,f.b="alpha(opacity="+f.s+")",f.e="alpha(opacity="+(f.s+f.c)+")",f.data=a,f.plugin=g,f.setRatio=Ua),j&&(f=new ta(i,"visibility",0,0,f,-1,null,!1,0,0!==h?"inherit":"hidden",0===b?"hidden":"inherit"),f.xs0="inherit",d._overwriteProps.push(f.n),d._overwriteProps.push(c)),f}});var Va=function(a,b){b&&(a.removeProperty?(("ms"===b.substr(0,2)||"webkit"===b.substr(0,6))&&(b="-"+b),a.removeProperty(b.replace(B,"-$1").toLowerCase())):a.removeAttribute(b))},Wa=function(a){if(this.t._gsClassPT=this,1===a||0===a){this.t.setAttribute("class",0===a?this.b:this.e);for(var b=this.data,c=this.t.style;b;)b.v?c[b.p]=b.v:Va(c,b.p),b=b._next;1===a&&this.t._gsClassPT===this&&(this.t._gsClassPT=null)}else this.t.getAttribute("class")!==this.e&&this.t.setAttribute("class",this.e)};ya("className",{parser:function(a,b,d,f,g,h,i){var j,k,l,m,n,o=a.getAttribute("class")||"",p=a.style.cssText;if(g=f._classNamePT=new ta(a,d,0,0,g,2),g.setRatio=Wa,g.pr=-11,c=!0,g.b=o,k=ca(a,e),l=a._gsClassPT){for(m={},n=l.data;n;)m[n.p]=1,n=n._next;l.setRatio(1)}return a._gsClassPT=g,g.e="="!==b.charAt(1)?b:o.replace(new RegExp("(?:\\s|^)"+b.substr(2)+"(?![\\w-])"),"")+("+"===b.charAt(0)?" "+b.substr(2):""),a.setAttribute("class",g.e),j=da(a,k,ca(a),i,m),a.setAttribute("class",o),g.data=j.firstMPT,a.style.cssText=p,g=g.xfirst=f.parse(a,j.difs,g,h)}});var Xa=function(a){if((1===a||0===a)&&this.data._totalTime===this.data._totalDuration&&"isFromStart"!==this.data.data){var b,c,d,e,f,g=this.t.style,h=i.transform.parse;if("all"===this.e)g.cssText="",e=!0;else for(b=this.e.split(" ").join("").split(","),d=b.length;--d>-1;)c=b[d],i[c]&&(i[c].parse===h?e=!0:c="transformOrigin"===c?Ea:i[c].p),Va(g,c);e&&(Va(g,Ca),f=this.t._gsTransform,f&&(f.svg&&(this.t.removeAttribute("data-svg-origin"),this.t.removeAttribute("transform")),delete this.t._gsTransform))}};for(ya("clearProps",{parser:function(a,b,d,e,f){return f=new ta(a,d,0,0,f,2),f.setRatio=Xa,f.e=b,f.pr=-10,f.data=e._tween,c=!0,f}}),j="bezier,throwProps,physicsProps,physics2D".split(","),wa=j.length;wa--;)za(j[wa]);j=g.prototype,j._firstPT=j._lastParsedTransform=j._transform=null,j._onInitTween=function(a,b,h,j){if(!a.nodeType)return!1;this._target=q=a,this._tween=h,this._vars=b,r=j,k=b.autoRound,c=!1,d=b.suffixMap||g.suffixMap,e=$(a,""),f=this._overwriteProps;var n,p,s,t,u,v,w,x,z,A=a.style;if(l&&""===A.zIndex&&(n=_(a,"zIndex",e),("auto"===n||""===n)&&this._addLazySet(A,"zIndex",0)),"string"==typeof b&&(t=A.cssText,n=ca(a,e),A.cssText=t+";"+b,n=da(a,n,ca(a)).difs,!U&&y.test(b)&&(n.opacity=parseFloat(RegExp.$1)),b=n,A.cssText=t),b.className?this._firstPT=p=i.className.parse(a,b.className,"className",this,null,null,b):this._firstPT=p=this.parse(a,b,null),this._transformType){for(z=3===this._transformType,Ca?m&&(l=!0,""===A.zIndex&&(w=_(a,"zIndex",e),("auto"===w||""===w)&&this._addLazySet(A,"zIndex",0)),o&&this._addLazySet(A,"WebkitBackfaceVisibility",this._vars.WebkitBackfaceVisibility||(z?"visible":"hidden"))):A.zoom=1,s=p;s&&s._next;)s=s._next;x=new ta(a,"transform",0,0,null,2),this._linkCSSP(x,null,s),x.setRatio=Ca?Ta:Sa,x.data=this._transform||Ra(a,e,!0),x.tween=h,x.pr=-1,f.pop()}if(c){for(;p;){for(v=p._next,s=t;s&&s.pr>p.pr;)s=s._next;(p._prev=s?s._prev:u)?p._prev._next=p:t=p,(p._next=s)?s._prev=p:u=p,p=v}this._firstPT=t}return!0},j.parse=function(a,b,c,f){var g,h,j,l,m,n,o,p,s,t,u=a.style;for(g in b){if(n=b[g],"function"==typeof n&&(n=n(r,q)),h=i[g])c=h.parse(a,n,g,this,c,f,b);else{if("--"===g.substr(0,2)){this._tween._propLookup[g]=this._addTween.call(this._tween,a.style,"setProperty",$(a).getPropertyValue(g)+"",n+"",g,!1,g);continue}m=_(a,g,e)+"",s="string"==typeof n,"color"===g||"fill"===g||"stroke"===g||-1!==g.indexOf("Color")||s&&A.test(n)?(s||(n=na(n),n=(n.length>3?"rgba(":"rgb(")+n.join(",")+")"),c=va(u,g,m,n,!0,"transparent",c,0,f)):s&&J.test(n)?c=va(u,g,m,n,!0,null,c,0,f):(j=parseFloat(m),o=j||0===j?m.substr((j+"").length):"",(""===m||"auto"===m)&&("width"===g||"height"===g?(j=ga(a,g,e),o="px"):"left"===g||"top"===g?(j=ba(a,g,e),o="px"):(j="opacity"!==g?0:1,o="")),t=s&&"="===n.charAt(1),t?(l=parseInt(n.charAt(0)+"1",10),n=n.substr(2),l*=parseFloat(n),p=n.replace(w,"")):(l=parseFloat(n),p=s?n.replace(w,""):""),""===p&&(p=g in d?d[g]:o),n=l||0===l?(t?l+j:l)+p:b[g],o!==p&&(""!==p||"lineHeight"===g)&&(l||0===l)&&j&&(j=aa(a,g,j,o),"%"===p?(j/=aa(a,g,100,"%")/100,b.strictUnits!==!0&&(m=j+"%")):"em"===p||"rem"===p||"vw"===p||"vh"===p?j/=aa(a,g,1,p):"px"!==p&&(l=aa(a,g,l,p),p="px"),t&&(l||0===l)&&(n=l+j+p)),t&&(l+=j),!j&&0!==j||!l&&0!==l?void 0!==u[g]&&(n||n+""!="NaN"&&null!=n)?(c=new ta(u,g,l||j||0,0,c,-1,g,!1,0,m,n),c.xs0="none"!==n||"display"!==g&&-1===g.indexOf("Style")?n:m):W("invalid "+g+" tween value: "+b[g]):(c=new ta(u,g,j,l-j,c,0,g,k!==!1&&("px"===p||"zIndex"===g),0,m,n),c.xs0=p))}f&&c&&!c.plugin&&(c.plugin=f)}return c},j.setRatio=function(a){var b,c,d,e=this._firstPT,f=1e-6;if(1!==a||this._tween._time!==this._tween._duration&&0!==this._tween._time)if(a||this._tween._time!==this._tween._duration&&0!==this._tween._time||this._tween._rawPrevTime===-1e-6)for(;e;){if(b=e.c*a+e.s,e.r?b=Math.round(b):f>b&&b>-f&&(b=0),e.type)if(1===e.type)if(d=e.l,2===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2;else if(3===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3;else if(4===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4;else if(5===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4+e.xn4+e.xs5;else{for(c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}else-1===e.type?e.t[e.p]=e.xs0:e.setRatio&&e.setRatio(a);else e.t[e.p]=b+e.xs0;e=e._next}else for(;e;)2!==e.type?e.t[e.p]=e.b:e.setRatio(a),e=e._next;else for(;e;){if(2!==e.type)if(e.r&&-1!==e.type)if(b=Math.round(e.s+e.c),e.type){if(1===e.type){for(d=e.l,c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}}else e.t[e.p]=b+e.xs0;else e.t[e.p]=e.e;else e.setRatio(a);e=e._next}},j._enableTransforms=function(a){this._transform=this._transform||Ra(this._target,e,!0),this._transformType=this._transform.svg&&Aa||!a&&3!==this._transformType?2:3};var Ya=function(a){this.t[this.p]=this.e,this.data._linkCSSP(this,this._next,null,!0)};j._addLazySet=function(a,b,c){var d=this._firstPT=new ta(a,b,0,0,this._firstPT,2);d.e=c,d.setRatio=Ya,d.data=this},j._linkCSSP=function(a,b,c,d){return a&&(b&&(b._prev=a),a._next&&(a._next._prev=a._prev),a._prev?a._prev._next=a._next:this._firstPT===a&&(this._firstPT=a._next,d=!0),c?c._next=a:d||null!==this._firstPT||(this._firstPT=a),a._next=b,a._prev=c),a},j._mod=function(a){for(var b=this._firstPT;b;)"function"==typeof a[b.p]&&a[b.p]===Math.round&&(b.r=1),b=b._next},j._kill=function(b){var c,d,e,f=b;if(b.autoAlpha||b.alpha){f={};for(d in b)f[d]=b[d];f.opacity=1,f.autoAlpha&&(f.visibility=1)}for(b.className&&(c=this._classNamePT)&&(e=c.xfirst,e&&e._prev?this._linkCSSP(e._prev,c._next,e._prev._prev):e===this._firstPT&&(this._firstPT=c._next),c._next&&this._linkCSSP(c._next,c._next._next,e._prev),this._classNamePT=null),c=this._firstPT;c;)c.plugin&&c.plugin!==d&&c.plugin._kill&&(c.plugin._kill(b),d=c.plugin),c=c._next;return a.prototype._kill.call(this,f)};var Za=function(a,b,c){var d,e,f,g;if(a.slice)for(e=a.length;--e>-1;)Za(a[e],b,c);else for(d=a.childNodes,e=d.length;--e>-1;)f=d[e],g=f.type,f.style&&(b.push(ca(f)),c&&c.push(f)),1!==g&&9!==g&&11!==g||!f.childNodes.length||Za(f,b,c)};return g.cascadeTo=function(a,c,d){var e,f,g,h,i=b.to(a,c,d),j=[i],k=[],l=[],m=[],n=b._internals.reservedProps;for(a=i._targets||i.target,Za(a,k,m),i.render(c,!0,!0),Za(a,l),i.render(0,!0,!0),i._enabled(!0),e=m.length;--e>-1;)if(f=da(m[e],k[e],l[e]),f.firstMPT){f=f.difs;for(g in d)n[g]&&(f[g]=d[g]);h={};for(g in f)h[g]=k[e][g];j.push(b.fromTo(m[e],c,h,f))}return j},a.activate([g]),g},!0),function(){var a=_gsScope._gsDefine.plugin({propName:"roundProps",version:"1.6.0",priority:-1,API:2,init:function(a,b,c){return this._tween=c,!0}}),b=function(a){for(;a;)a.f||a.blob||(a.m=Math.round),a=a._next},c=a.prototype;c._onInitAllProps=function(){for(var a,c,d,e=this._tween,f=e.vars.roundProps.join?e.vars.roundProps:e.vars.roundProps.split(","),g=f.length,h={},i=e._propLookup.roundProps;--g>-1;)h[f[g]]=Math.round;for(g=f.length;--g>-1;)for(a=f[g],c=e._firstPT;c;)d=c._next,c.pg?c.t._mod(h):c.n===a&&(2===c.f&&c.t?b(c.t._firstPT):(this._add(c.t,a,c.s,c.c),d&&(d._prev=c._prev),c._prev?c._prev._next=d:e._firstPT===c&&(e._firstPT=d),c._next=c._prev=null,e._propLookup[a]=i)),c=d;return!1},c._add=function(a,b,c,d){this._addTween(a,b,c,c+d,b,Math.round),this._overwriteProps.push(b)}}(),function(){_gsScope._gsDefine.plugin({propName:"attr",API:2,version:"0.6.1",init:function(a,b,c,d){var e,f;if("function"!=typeof a.setAttribute)return!1;for(e in b)f=b[e],"function"==typeof f&&(f=f(d,a)),this._addTween(a,"setAttribute",a.getAttribute(e)+"",f+"",e,!1,e),this._overwriteProps.push(e);return!0}})}(),_gsScope._gsDefine.plugin({propName:"directionalRotation",version:"0.3.1",API:2,init:function(a,b,c,d){"object"!=typeof b&&(b={rotation:b}),this.finals={};var e,f,g,h,i,j,k=b.useRadians===!0?2*Math.PI:360,l=1e-6;for(e in b)"useRadians"!==e&&(h=b[e],"function"==typeof h&&(h=h(d,a)),j=(h+"").split("_"),f=j[0],g=parseFloat("function"!=typeof a[e]?a[e]:a[e.indexOf("set")||"function"!=typeof a["get"+e.substr(3)]?e:"get"+e.substr(3)]()),h=this.finals[e]="string"==typeof f&&"="===f.charAt(1)?g+parseInt(f.charAt(0)+"1",10)*Number(f.substr(2)):Number(f)||0,i=h-g,j.length&&(f=j.join("_"),-1!==f.indexOf("short")&&(i%=k,i!==i%(k/2)&&(i=0>i?i+k:i-k)),-1!==f.indexOf("_cw")&&0>i?i=(i+9999999999*k)%k-(i/k|0)*k:-1!==f.indexOf("ccw")&&i>0&&(i=(i-9999999999*k)%k-(i/k|0)*k)),(i>l||-l>i)&&(this._addTween(a,e,g,g+i,e),this._overwriteProps.push(e)));return!0},set:function(a){var b;if(1!==a)this._super.setRatio.call(this,a);else for(b=this._firstPT;b;)b.f?b.t[b.p](this.finals[b.p]):b.t[b.p]=this.finals[b.p],b=b._next}})._autoCSS=!0,_gsScope._gsDefine("easing.Back",["easing.Ease"],function(a){var b,c,d,e=_gsScope.GreenSockGlobals||_gsScope,f=e.com.greensock,g=2*Math.PI,h=Math.PI/2,i=f._class,j=function(b,c){var d=i("easing."+b,function(){},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,d},k=a.register||function(){},l=function(a,b,c,d,e){var f=i("easing."+a,{easeOut:new b,easeIn:new c,easeInOut:new d},!0);return k(f,a),f},m=function(a,b,c){this.t=a,this.v=b,c&&(this.next=c,c.prev=this,this.c=c.v-b,this.gap=c.t-a)},n=function(b,c){var d=i("easing."+b,function(a){this._p1=a||0===a?a:1.70158,this._p2=1.525*this._p1},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,e.config=function(a){return new d(a)},d},o=l("Back",n("BackOut",function(a){return(a-=1)*a*((this._p1+1)*a+this._p1)+1}),n("BackIn",function(a){return a*a*((this._p1+1)*a-this._p1)}),n("BackInOut",function(a){return(a*=2)<1?.5*a*a*((this._p2+1)*a-this._p2):.5*((a-=2)*a*((this._p2+1)*a+this._p2)+2)})),p=i("easing.SlowMo",function(a,b,c){b=b||0===b?b:.7,null==a?a=.7:a>1&&(a=1),this._p=1!==a?b:0,this._p1=(1-a)/2,this._p2=a,this._p3=this._p1+this._p2,this._calcEnd=c===!0},!0),q=p.prototype=new a;return q.constructor=p,q.getRatio=function(a){var b=a+(.5-a)*this._p;return a<this._p1?this._calcEnd?1-(a=1-a/this._p1)*a:b-(a=1-a/this._p1)*a*a*a*b:a>this._p3?this._calcEnd?1-(a=(a-this._p3)/this._p1)*a:b+(a-b)*(a=(a-this._p3)/this._p1)*a*a*a:this._calcEnd?1:b},p.ease=new p(.7,.7),q.config=p.config=function(a,b,c){return new p(a,b,c)},b=i("easing.SteppedEase",function(a,b){a=a||1,this._p1=1/a,this._p2=a+(b?0:1),this._p3=b?1:0},!0),q=b.prototype=new a,q.constructor=b,q.getRatio=function(a){return 0>a?a=0:a>=1&&(a=.999999999),((this._p2*a|0)+this._p3)*this._p1},q.config=b.config=function(a,c){return new b(a,c)},c=i("easing.RoughEase",function(b){b=b||{};for(var c,d,e,f,g,h,i=b.taper||"none",j=[],k=0,l=0|(b.points||20),n=l,o=b.randomize!==!1,p=b.clamp===!0,q=b.template instanceof a?b.template:null,r="number"==typeof b.strength?.4*b.strength:.4;--n>-1;)c=o?Math.random():1/l*n,d=q?q.getRatio(c):c,"none"===i?e=r:"out"===i?(f=1-c,e=f*f*r):"in"===i?e=c*c*r:.5>c?(f=2*c,e=f*f*.5*r):(f=2*(1-c),e=f*f*.5*r),o?d+=Math.random()*e-.5*e:n%2?d+=.5*e:d-=.5*e,p&&(d>1?d=1:0>d&&(d=0)),j[k++]={x:c,y:d};for(j.sort(function(a,b){return a.x-b.x}),h=new m(1,1,null),n=l;--n>-1;)g=j[n],h=new m(g.x,g.y,h);this._prev=new m(0,0,0!==h.t?h:h.next)},!0),q=c.prototype=new a,q.constructor=c,q.getRatio=function(a){var b=this._prev;if(a>b.t){for(;b.next&&a>=b.t;)b=b.next;b=b.prev}else for(;b.prev&&a<=b.t;)b=b.prev;return this._prev=b,b.v+(a-b.t)/b.gap*b.c},q.config=function(a){return new c(a)},c.ease=new c,l("Bounce",j("BounceOut",function(a){return 1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375}),j("BounceIn",function(a){return(a=1-a)<1/2.75?1-7.5625*a*a:2/2.75>a?1-(7.5625*(a-=1.5/2.75)*a+.75):2.5/2.75>a?1-(7.5625*(a-=2.25/2.75)*a+.9375):1-(7.5625*(a-=2.625/2.75)*a+.984375)}),j("BounceInOut",function(a){var b=.5>a;return a=b?1-2*a:2*a-1,a=1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375,b?.5*(1-a):.5*a+.5})),l("Circ",j("CircOut",function(a){return Math.sqrt(1-(a-=1)*a)}),j("CircIn",function(a){return-(Math.sqrt(1-a*a)-1)}),j("CircInOut",function(a){return(a*=2)<1?-.5*(Math.sqrt(1-a*a)-1):.5*(Math.sqrt(1-(a-=2)*a)+1)})),d=function(b,c,d){var e=i("easing."+b,function(a,b){this._p1=a>=1?a:1,this._p2=(b||d)/(1>a?a:1),this._p3=this._p2/g*(Math.asin(1/this._p1)||0),this._p2=g/this._p2},!0),f=e.prototype=new a;return f.constructor=e,f.getRatio=c,f.config=function(a,b){return new e(a,b)},e},l("Elastic",d("ElasticOut",function(a){return this._p1*Math.pow(2,-10*a)*Math.sin((a-this._p3)*this._p2)+1},.3),d("ElasticIn",function(a){return-(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2))},.3),d("ElasticInOut",function(a){return(a*=2)<1?-.5*(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2)):this._p1*Math.pow(2,-10*(a-=1))*Math.sin((a-this._p3)*this._p2)*.5+1},.45)),l("Expo",j("ExpoOut",function(a){return 1-Math.pow(2,-10*a)}),j("ExpoIn",function(a){return Math.pow(2,10*(a-1))-.001}),j("ExpoInOut",function(a){return(a*=2)<1?.5*Math.pow(2,10*(a-1)):.5*(2-Math.pow(2,-10*(a-1)))})),l("Sine",j("SineOut",function(a){return Math.sin(a*h)}),j("SineIn",function(a){return-Math.cos(a*h)+1}),j("SineInOut",function(a){return-.5*(Math.cos(Math.PI*a)-1)})),i("easing.EaseLookup",{find:function(b){return a.map[b]}},!0),k(e.SlowMo,"SlowMo","ease,"),k(c,"RoughEase","ease,"),k(b,"SteppedEase","ease,"),o},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a,b){"use strict";var c={},d=a.document,e=a.GreenSockGlobals=a.GreenSockGlobals||a;if(!e.TweenLite){var f,g,h,i,j,k=function(a){var b,c=a.split("."),d=e;for(b=0;b<c.length;b++)d[c[b]]=d=d[c[b]]||{};return d},l=k("com.greensock"),m=1e-10,n=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},o=function(){},p=function(){var a=Object.prototype.toString,b=a.call([]);return function(c){return null!=c&&(c instanceof Array||"object"==typeof c&&!!c.push&&a.call(c)===b)}}(),q={},r=function(d,f,g,h){this.sc=q[d]?q[d].sc:[],q[d]=this,this.gsClass=null,this.func=g;var i=[];this.check=function(j){for(var l,m,n,o,p=f.length,s=p;--p>-1;)(l=q[f[p]]||new r(f[p],[])).gsClass?(i[p]=l.gsClass,s--):j&&l.sc.push(this);if(0===s&&g){if(m=("com.greensock."+d).split("."),n=m.pop(),o=k(m.join("."))[n]=this.gsClass=g.apply(g,i),h)if(e[n]=c[n]=o,"undefined"!=typeof module&&module.exports)if(d===b){module.exports=c[b]=o;for(p in c)o[p]=c[p]}else c[b]&&(c[b][n]=o);else"function"=="function"&&__webpack_require__(107)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return o}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));for(p=0;p<this.sc.length;p++)this.sc[p].check()}},this.check(!0)},s=a._gsDefine=function(a,b,c,d){return new r(a,b,c,d)},t=l._class=function(a,b,c){return b=b||function(){},s(a,[],function(){return b},c),b};s.globals=e;var u=[0,0,1,1],v=t("easing.Ease",function(a,b,c,d){this._func=a,this._type=c||0,this._power=d||0,this._params=b?u.concat(b):u},!0),w=v.map={},x=v.register=function(a,b,c,d){for(var e,f,g,h,i=b.split(","),j=i.length,k=(c||"easeIn,easeOut,easeInOut").split(",");--j>-1;)for(f=i[j],e=d?t("easing."+f,null,!0):l.easing[f]||{},g=k.length;--g>-1;)h=k[g],w[f+"."+h]=w[h+f]=e[h]=a.getRatio?a:a[h]||new a};for(h=v.prototype,h._calcEnd=!1,h.getRatio=function(a){if(this._func)return this._params[0]=a,this._func.apply(null,this._params);var b=this._type,c=this._power,d=1===b?1-a:2===b?a:.5>a?2*a:2*(1-a);return 1===c?d*=d:2===c?d*=d*d:3===c?d*=d*d*d:4===c&&(d*=d*d*d*d),1===b?1-d:2===b?d:.5>a?d/2:1-d/2},f=["Linear","Quad","Cubic","Quart","Quint,Strong"],g=f.length;--g>-1;)h=f[g]+",Power"+g,x(new v(null,null,1,g),h,"easeOut",!0),x(new v(null,null,2,g),h,"easeIn"+(0===g?",easeNone":"")),x(new v(null,null,3,g),h,"easeInOut");w.linear=l.easing.Linear.easeIn,w.swing=l.easing.Quad.easeInOut;var y=t("events.EventDispatcher",function(a){this._listeners={},this._eventTarget=a||this});h=y.prototype,h.addEventListener=function(a,b,c,d,e){e=e||0;var f,g,h=this._listeners[a],k=0;for(this!==i||j||i.wake(),null==h&&(this._listeners[a]=h=[]),g=h.length;--g>-1;)f=h[g],f.c===b&&f.s===c?h.splice(g,1):0===k&&f.pr<e&&(k=g+1);h.splice(k,0,{c:b,s:c,up:d,pr:e})},h.removeEventListener=function(a,b){var c,d=this._listeners[a];if(d)for(c=d.length;--c>-1;)if(d[c].c===b)return void d.splice(c,1)},h.dispatchEvent=function(a){var b,c,d,e=this._listeners[a];if(e)for(b=e.length,b>1&&(e=e.slice(0)),c=this._eventTarget;--b>-1;)d=e[b],d&&(d.up?d.c.call(d.s||c,{type:a,target:c}):d.c.call(d.s||c))};var z=a.requestAnimationFrame,A=a.cancelAnimationFrame,B=Date.now||function(){return(new Date).getTime()},C=B();for(f=["ms","moz","webkit","o"],g=f.length;--g>-1&&!z;)z=a[f[g]+"RequestAnimationFrame"],A=a[f[g]+"CancelAnimationFrame"]||a[f[g]+"CancelRequestAnimationFrame"];t("Ticker",function(a,b){var c,e,f,g,h,k=this,l=B(),n=b!==!1&&z?"auto":!1,p=500,q=33,r="tick",s=function(a){var b,d,i=B()-C;i>p&&(l+=i-q),C+=i,k.time=(C-l)/1e3,b=k.time-h,(!c||b>0||a===!0)&&(k.frame++,h+=b+(b>=g?.004:g-b),d=!0),a!==!0&&(f=e(s)),d&&k.dispatchEvent(r)};y.call(k),k.time=k.frame=0,k.tick=function(){s(!0)},k.lagSmoothing=function(a,b){p=a||1/m,q=Math.min(b,p,0)},k.sleep=function(){null!=f&&(n&&A?A(f):clearTimeout(f),e=o,f=null,k===i&&(j=!1))},k.wake=function(a){null!==f?k.sleep():a?l+=-C+(C=B()):k.frame>10&&(C=B()-p+5),e=0===c?o:n&&z?z:function(a){return setTimeout(a,1e3*(h-k.time)+1|0)},k===i&&(j=!0),s(2)},k.fps=function(a){return arguments.length?(c=a,g=1/(c||60),h=this.time+g,void k.wake()):c},k.useRAF=function(a){return arguments.length?(k.sleep(),n=a,void k.fps(c)):n},k.fps(a),setTimeout(function(){"auto"===n&&k.frame<5&&"hidden"!==d.visibilityState&&k.useRAF(!1)},1500)}),h=l.Ticker.prototype=new l.events.EventDispatcher,h.constructor=l.Ticker;var D=t("core.Animation",function(a,b){if(this.vars=b=b||{},this._duration=this._totalDuration=a||0,this._delay=Number(b.delay)||0,this._timeScale=1,this._active=b.immediateRender===!0,this.data=b.data,this._reversed=b.reversed===!0,X){j||i.wake();var c=this.vars.useFrames?W:X;c.add(this,c._time),this.vars.paused&&this.paused(!0)}});i=D.ticker=new l.Ticker,h=D.prototype,h._dirty=h._gc=h._initted=h._paused=!1,h._totalTime=h._time=0,h._rawPrevTime=-1,h._next=h._last=h._onUpdate=h._timeline=h.timeline=null,h._paused=!1;var E=function(){j&&B()-C>2e3&&"hidden"!==d.visibilityState&&i.wake();var a=setTimeout(E,2e3);a.unref&&a.unref()};E(),h.play=function(a,b){return null!=a&&this.seek(a,b),this.reversed(!1).paused(!1)},h.pause=function(a,b){return null!=a&&this.seek(a,b),this.paused(!0)},h.resume=function(a,b){return null!=a&&this.seek(a,b),this.paused(!1)},h.seek=function(a,b){return this.totalTime(Number(a),b!==!1)},h.restart=function(a,b){return this.reversed(!1).paused(!1).totalTime(a?-this._delay:0,b!==!1,!0)},h.reverse=function(a,b){return null!=a&&this.seek(a||this.totalDuration(),b),this.reversed(!0).paused(!1)},h.render=function(a,b,c){},h.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,(this._gc||!this.timeline)&&this._enabled(!0),this},h.isActive=function(){var a,b=this._timeline,c=this._startTime;return!b||!this._gc&&!this._paused&&b.isActive()&&(a=b.rawTime(!0))>=c&&a<c+this.totalDuration()/this._timeScale-1e-7},h._enabled=function(a,b){return j||i.wake(),this._gc=!a,this._active=this.isActive(),b!==!0&&(a&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!a&&this.timeline&&this._timeline._remove(this,!0)),!1},h._kill=function(a,b){return this._enabled(!1,!1)},h.kill=function(a,b){return this._kill(a,b),this},h._uncache=function(a){for(var b=a?this:this.timeline;b;)b._dirty=!0,b=b.timeline;return this},h._swapSelfInParams=function(a){for(var b=a.length,c=a.concat();--b>-1;)"{self}"===a[b]&&(c[b]=this);return c},h._callback=function(a){var b=this.vars,c=b[a],d=b[a+"Params"],e=b[a+"Scope"]||b.callbackScope||this,f=d?d.length:0;switch(f){case 0:c.call(e);break;case 1:c.call(e,d[0]);break;case 2:c.call(e,d[0],d[1]);break;default:c.apply(e,d)}},h.eventCallback=function(a,b,c,d){if("on"===(a||"").substr(0,2)){var e=this.vars;if(1===arguments.length)return e[a];null==b?delete e[a]:(e[a]=b,e[a+"Params"]=p(c)&&-1!==c.join("").indexOf("{self}")?this._swapSelfInParams(c):c,e[a+"Scope"]=d),"onUpdate"===a&&(this._onUpdate=b)}return this},h.delay=function(a){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+a-this._delay),this._delay=a,this):this._delay},h.duration=function(a){return arguments.length?(this._duration=this._totalDuration=a,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==a&&this.totalTime(this._totalTime*(a/this._duration),!0),this):(this._dirty=!1,this._duration)},h.totalDuration=function(a){return this._dirty=!1,arguments.length?this.duration(a):this._totalDuration},h.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(a>this._duration?this._duration:a,b)):this._time},h.totalTime=function(a,b,c){if(j||i.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(0>a&&!c&&(a+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var d=this._totalDuration,e=this._timeline;if(a>d&&!c&&(a=d),this._startTime=(this._paused?this._pauseTime:e._time)-(this._reversed?d-a:a)/this._timeScale,e._dirty||this._uncache(!1),e._timeline)for(;e._timeline;)e._timeline._time!==(e._startTime+e._totalTime)/e._timeScale&&e.totalTime(e._totalTime,!0),e=e._timeline}this._gc&&this._enabled(!0,!1),(this._totalTime!==a||0===this._duration)&&(J.length&&Z(),this.render(a,b,!1),J.length&&Z())}return this},h.progress=h.totalProgress=function(a,b){var c=this.duration();return arguments.length?this.totalTime(c*a,b):c?this._time/c:this.ratio},h.startTime=function(a){return arguments.length?(a!==this._startTime&&(this._startTime=a,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,a-this._delay)),this):this._startTime},h.endTime=function(a){return this._startTime+(0!=a?this.totalDuration():this.duration())/this._timeScale},h.timeScale=function(a){if(!arguments.length)return this._timeScale;if(a=a||m,this._timeline&&this._timeline.smoothChildTiming){var b=this._pauseTime,c=b||0===b?b:this._timeline.totalTime();this._startTime=c-(c-this._startTime)*this._timeScale/a}return this._timeScale=a,this._uncache(!1)},h.reversed=function(a){return arguments.length?(a!=this._reversed&&(this._reversed=a,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},h.paused=function(a){if(!arguments.length)return this._paused;var b,c,d=this._timeline;return a!=this._paused&&d&&(j||a||i.wake(),b=d.rawTime(),c=b-this._pauseTime,!a&&d.smoothChildTiming&&(this._startTime+=c,this._uncache(!1)),this._pauseTime=a?b:null,this._paused=a,this._active=this.isActive(),!a&&0!==c&&this._initted&&this.duration()&&(b=d.smoothChildTiming?this._totalTime:(b-this._startTime)/this._timeScale,this.render(b,b===this._totalTime,!0))),this._gc&&!a&&this._enabled(!0,!1),this};var F=t("core.SimpleTimeline",function(a){D.call(this,0,a),this.autoRemoveChildren=this.smoothChildTiming=!0});h=F.prototype=new D,h.constructor=F,h.kill()._gc=!1,h._first=h._last=h._recent=null,h._sortChildren=!1,h.add=h.insert=function(a,b,c,d){var e,f;if(a._startTime=Number(b||0)+a._delay,a._paused&&this!==a._timeline&&(a._pauseTime=a._startTime+(this.rawTime()-a._startTime)/a._timeScale),
a.timeline&&a.timeline._remove(a,!0),a.timeline=a._timeline=this,a._gc&&a._enabled(!0,!0),e=this._last,this._sortChildren)for(f=a._startTime;e&&e._startTime>f;)e=e._prev;return e?(a._next=e._next,e._next=a):(a._next=this._first,this._first=a),a._next?a._next._prev=a:this._last=a,a._prev=e,this._recent=a,this._timeline&&this._uncache(!0),this},h._remove=function(a,b){return a.timeline===this&&(b||a._enabled(!1,!0),a._prev?a._prev._next=a._next:this._first===a&&(this._first=a._next),a._next?a._next._prev=a._prev:this._last===a&&(this._last=a._prev),a._next=a._prev=a.timeline=null,a===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},h.render=function(a,b,c){var d,e=this._first;for(this._totalTime=this._time=this._rawPrevTime=a;e;)d=e._next,(e._active||a>=e._startTime&&!e._paused&&!e._gc)&&(e._reversed?e.render((e._dirty?e.totalDuration():e._totalDuration)-(a-e._startTime)*e._timeScale,b,c):e.render((a-e._startTime)*e._timeScale,b,c)),e=d},h.rawTime=function(){return j||i.wake(),this._totalTime};var G=t("TweenLite",function(b,c,d){if(D.call(this,c,d),this.render=G.prototype.render,null==b)throw"Cannot tween a null target.";this.target=b="string"!=typeof b?b:G.selector(b)||b;var e,f,g,h=b.jquery||b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType),i=this.vars.overwrite;if(this._overwrite=i=null==i?V[G.defaultOverwrite]:"number"==typeof i?i>>0:V[i],(h||b instanceof Array||b.push&&p(b))&&"number"!=typeof b[0])for(this._targets=g=n(b),this._propLookup=[],this._siblings=[],e=0;e<g.length;e++)f=g[e],f?"string"!=typeof f?f.length&&f!==a&&f[0]&&(f[0]===a||f[0].nodeType&&f[0].style&&!f.nodeType)?(g.splice(e--,1),this._targets=g=g.concat(n(f))):(this._siblings[e]=$(f,this,!1),1===i&&this._siblings[e].length>1&&aa(f,this,null,1,this._siblings[e])):(f=g[e--]=G.selector(f),"string"==typeof f&&g.splice(e+1,1)):g.splice(e--,1);else this._propLookup={},this._siblings=$(b,this,!1),1===i&&this._siblings.length>1&&aa(b,this,null,1,this._siblings);(this.vars.immediateRender||0===c&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-m,this.render(Math.min(0,-this._delay)))},!0),H=function(b){return b&&b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType)},I=function(a,b){var c,d={};for(c in a)U[c]||c in b&&"transform"!==c&&"x"!==c&&"y"!==c&&"width"!==c&&"height"!==c&&"className"!==c&&"border"!==c||!(!R[c]||R[c]&&R[c]._autoCSS)||(d[c]=a[c],delete a[c]);a.css=d};h=G.prototype=new D,h.constructor=G,h.kill()._gc=!1,h.ratio=0,h._firstPT=h._targets=h._overwrittenProps=h._startAt=null,h._notifyPluginsOfEnabled=h._lazy=!1,G.version="1.20.2",G.defaultEase=h._ease=new v(null,null,1,1),G.defaultOverwrite="auto",G.ticker=i,G.autoSleep=120,G.lagSmoothing=function(a,b){i.lagSmoothing(a,b)},G.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(G.selector=c,c(b)):"undefined"==typeof d?b:d.querySelectorAll?d.querySelectorAll(b):d.getElementById("#"===b.charAt(0)?b.substr(1):b)};var J=[],K={},L=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,M=/[\+-]=-?[\.\d]/,N=function(a){for(var b,c=this._firstPT,d=1e-6;c;)b=c.blob?1===a&&this.end?this.end:a?this.join(""):this.start:c.c*a+c.s,c.m?b=c.m(b,this._target||c.t):d>b&&b>-d&&!c.blob&&(b=0),c.f?c.fp?c.t[c.p](c.fp,b):c.t[c.p](b):c.t[c.p]=b,c=c._next},O=function(a,b,c,d){var e,f,g,h,i,j,k,l=[],m=0,n="",o=0;for(l.start=a,l.end=b,a=l[0]=a+"",b=l[1]=b+"",c&&(c(l),a=l[0],b=l[1]),l.length=0,e=a.match(L)||[],f=b.match(L)||[],d&&(d._next=null,d.blob=1,l._firstPT=l._applyPT=d),i=f.length,h=0;i>h;h++)k=f[h],j=b.substr(m,b.indexOf(k,m)-m),n+=j||!h?j:",",m+=j.length,o?o=(o+1)%5:"rgba("===j.substr(-5)&&(o=1),k===e[h]||e.length<=h?n+=k:(n&&(l.push(n),n=""),g=parseFloat(e[h]),l.push(g),l._firstPT={_next:l._firstPT,t:l,p:l.length-1,s:g,c:("="===k.charAt(1)?parseInt(k.charAt(0)+"1",10)*parseFloat(k.substr(2)):parseFloat(k)-g)||0,f:0,m:o&&4>o?Math.round:0}),m+=k.length;return n+=b.substr(m),n&&l.push(n),l.setRatio=N,M.test(b)&&(l.end=0),l},P=function(a,b,c,d,e,f,g,h,i){"function"==typeof d&&(d=d(i||0,a));var j,k=typeof a[b],l="function"!==k?"":b.indexOf("set")||"function"!=typeof a["get"+b.substr(3)]?b:"get"+b.substr(3),m="get"!==c?c:l?g?a[l](g):a[l]():a[b],n="string"==typeof d&&"="===d.charAt(1),o={t:a,p:b,s:m,f:"function"===k,pg:0,n:e||b,m:f?"function"==typeof f?f:Math.round:0,pr:0,c:n?parseInt(d.charAt(0)+"1",10)*parseFloat(d.substr(2)):parseFloat(d)-m||0};return("number"!=typeof m||"number"!=typeof d&&!n)&&(g||isNaN(m)||!n&&isNaN(d)||"boolean"==typeof m||"boolean"==typeof d?(o.fp=g,j=O(m,n?parseFloat(o.s)+o.c:d,h||G.defaultStringFilter,o),o={t:j,p:"setRatio",s:0,c:1,f:2,pg:0,n:e||b,pr:0,m:0}):(o.s=parseFloat(m),n||(o.c=parseFloat(d)-o.s||0))),o.c?((o._next=this._firstPT)&&(o._next._prev=o),this._firstPT=o,o):void 0},Q=G._internals={isArray:p,isSelector:H,lazyTweens:J,blobDif:O},R=G._plugins={},S=Q.tweenLookup={},T=0,U=Q.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1,yoyoEase:1},V={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},W=D._rootFramesTimeline=new F,X=D._rootTimeline=new F,Y=30,Z=Q.lazyRender=function(){var a,b=J.length;for(K={};--b>-1;)a=J[b],a&&a._lazy!==!1&&(a.render(a._lazy[0],a._lazy[1],!0),a._lazy=!1);J.length=0};X._startTime=i.time,W._startTime=i.frame,X._active=W._active=!0,setTimeout(Z,1),D._updateRoot=G.render=function(){var a,b,c;if(J.length&&Z(),X.render((i.time-X._startTime)*X._timeScale,!1,!1),W.render((i.frame-W._startTime)*W._timeScale,!1,!1),J.length&&Z(),i.frame>=Y){Y=i.frame+(parseInt(G.autoSleep,10)||120);for(c in S){for(b=S[c].tweens,a=b.length;--a>-1;)b[a]._gc&&b.splice(a,1);0===b.length&&delete S[c]}if(c=X._first,(!c||c._paused)&&G.autoSleep&&!W._first&&1===i._listeners.tick.length){for(;c&&c._paused;)c=c._next;c||i.sleep()}}},i.addEventListener("tick",D._updateRoot);var $=function(a,b,c){var d,e,f=a._gsTweenID;if(S[f||(a._gsTweenID=f="t"+T++)]||(S[f]={target:a,tweens:[]}),b&&(d=S[f].tweens,d[e=d.length]=b,c))for(;--e>-1;)d[e]===b&&d.splice(e,1);return S[f].tweens},_=function(a,b,c,d){var e,f,g=a.vars.onOverwrite;return g&&(e=g(a,b,c,d)),g=G.onOverwrite,g&&(f=g(a,b,c,d)),e!==!1&&f!==!1},aa=function(a,b,c,d,e){var f,g,h,i;if(1===d||d>=4){for(i=e.length,f=0;i>f;f++)if((h=e[f])!==b)h._gc||h._kill(null,a,b)&&(g=!0);else if(5===d)break;return g}var j,k=b._startTime+m,l=[],n=0,o=0===b._duration;for(f=e.length;--f>-1;)(h=e[f])===b||h._gc||h._paused||(h._timeline!==b._timeline?(j=j||ba(b,0,o),0===ba(h,j,o)&&(l[n++]=h)):h._startTime<=k&&h._startTime+h.totalDuration()/h._timeScale>k&&((o||!h._initted)&&k-h._startTime<=2e-10||(l[n++]=h)));for(f=n;--f>-1;)if(h=l[f],2===d&&h._kill(c,a,b)&&(g=!0),2!==d||!h._firstPT&&h._initted){if(2!==d&&!_(h,b))continue;h._enabled(!1,!1)&&(g=!0)}return g},ba=function(a,b,c){for(var d=a._timeline,e=d._timeScale,f=a._startTime;d._timeline;){if(f+=d._startTime,e*=d._timeScale,d._paused)return-100;d=d._timeline}return f/=e,f>b?f-b:c&&f===b||!a._initted&&2*m>f-b?m:(f+=a.totalDuration()/a._timeScale/e)>b+m?0:f-b-m};h._init=function(){var a,b,c,d,e,f,g=this.vars,h=this._overwrittenProps,i=this._duration,j=!!g.immediateRender,k=g.ease;if(g.startAt){this._startAt&&(this._startAt.render(-1,!0),this._startAt.kill()),e={};for(d in g.startAt)e[d]=g.startAt[d];if(e.overwrite=!1,e.immediateRender=!0,e.lazy=j&&g.lazy!==!1,e.startAt=e.delay=null,e.onUpdate=g.onUpdate,e.onUpdateScope=g.onUpdateScope||g.callbackScope||this,this._startAt=G.to(this.target,0,e),j)if(this._time>0)this._startAt=null;else if(0!==i)return}else if(g.runBackwards&&0!==i)if(this._startAt)this._startAt.render(-1,!0),this._startAt.kill(),this._startAt=null;else{0!==this._time&&(j=!1),c={};for(d in g)U[d]&&"autoCSS"!==d||(c[d]=g[d]);if(c.overwrite=0,c.data="isFromStart",c.lazy=j&&g.lazy!==!1,c.immediateRender=j,this._startAt=G.to(this.target,0,c),j){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=k=k?k instanceof v?k:"function"==typeof k?new v(k,g.easeParams):w[k]||G.defaultEase:G.defaultEase,g.easeParams instanceof Array&&k.config&&(this._ease=k.config.apply(k,g.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(f=this._targets.length,a=0;f>a;a++)this._initProps(this._targets[a],this._propLookup[a]={},this._siblings[a],h?h[a]:null,a)&&(b=!0);else b=this._initProps(this.target,this._propLookup,this._siblings,h,0);if(b&&G._onPluginEvent("_onInitAllProps",this),h&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),g.runBackwards)for(c=this._firstPT;c;)c.s+=c.c,c.c=-c.c,c=c._next;this._onUpdate=g.onUpdate,this._initted=!0},h._initProps=function(b,c,d,e,f){var g,h,i,j,k,l;if(null==b)return!1;K[b._gsTweenID]&&Z(),this.vars.css||b.style&&b!==a&&b.nodeType&&R.css&&this.vars.autoCSS!==!1&&I(this.vars,b);for(g in this.vars)if(l=this.vars[g],U[g])l&&(l instanceof Array||l.push&&p(l))&&-1!==l.join("").indexOf("{self}")&&(this.vars[g]=l=this._swapSelfInParams(l,this));else if(R[g]&&(j=new R[g])._onInitTween(b,this.vars[g],this,f)){for(this._firstPT=k={_next:this._firstPT,t:j,p:"setRatio",s:0,c:1,f:1,n:g,pg:1,pr:j._priority,m:0},h=j._overwriteProps.length;--h>-1;)c[j._overwriteProps[h]]=this._firstPT;(j._priority||j._onInitAllProps)&&(i=!0),(j._onDisable||j._onEnable)&&(this._notifyPluginsOfEnabled=!0),k._next&&(k._next._prev=k)}else c[g]=P.call(this,b,g,"get",l,g,0,null,this.vars.stringFilter,f);return e&&this._kill(e,b)?this._initProps(b,c,d,e,f):this._overwrite>1&&this._firstPT&&d.length>1&&aa(b,this,c,this._overwrite,d)?(this._kill(c,b),this._initProps(b,c,d,e,f)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(K[b._gsTweenID]=!0),i)},h.render=function(a,b,c){var d,e,f,g,h=this._time,i=this._duration,j=this._rawPrevTime;if(a>=i-1e-7&&a>=0)this._totalTime=this._time=i,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1,this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===i&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>j||0>=a&&a>=-1e-7||j===m&&"isPause"!==this.data)&&j!==a&&(c=!0,j>m&&(e="onReverseComplete")),this._rawPrevTime=g=!b||a||j===a?a:m);else if(1e-7>a)this._totalTime=this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==h||0===i&&j>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===i&&(this._initted||!this.vars.lazy||c)&&(j>=0&&(j!==m||"isPause"!==this.data)&&(c=!0),this._rawPrevTime=g=!b||a||j===a?a:m)),(!this._initted||this._startAt&&this._startAt.progress())&&(c=!0);else if(this._totalTime=this._time=a,this._easeType){var k=a/i,l=this._easeType,n=this._easePower;(1===l||3===l&&k>=.5)&&(k=1-k),3===l&&(k*=2),1===n?k*=k:2===n?k*=k*k:3===n?k*=k*k*k:4===n&&(k*=k*k*k*k),1===l?this.ratio=1-k:2===l?this.ratio=k:.5>a/i?this.ratio=k/2:this.ratio=1-k/2}else this.ratio=this._ease.getRatio(a/i);if(this._time!==h||c){if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=this._totalTime=h,this._rawPrevTime=j,J.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/i):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==h&&a>=0&&(this._active=!0),0===h&&(this._startAt&&(a>=0?this._startAt.render(a,b,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._time||0===i)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&a!==-1e-4&&this._startAt.render(a,b,c),b||(this._time!==h||d||c)&&this._callback("onUpdate")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&a!==-1e-4&&this._startAt.render(a,b,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===i&&this._rawPrevTime===m&&g!==m&&(this._rawPrevTime=0))}},h._kill=function(a,b,c){if("all"===a&&(a=null),null==a&&(null==b||b===this.target))return this._lazy=!1,this._enabled(!1,!1);b="string"!=typeof b?b||this._targets||this.target:G.selector(b)||b;var d,e,f,g,h,i,j,k,l,m=c&&this._time&&c._startTime===this._startTime&&this._timeline===c._timeline;if((p(b)||H(b))&&"number"!=typeof b[0])for(d=b.length;--d>-1;)this._kill(a,b[d],c)&&(i=!0);else{if(this._targets){for(d=this._targets.length;--d>-1;)if(b===this._targets[d]){h=this._propLookup[d]||{},this._overwrittenProps=this._overwrittenProps||[],e=this._overwrittenProps[d]=a?this._overwrittenProps[d]||{}:"all";break}}else{if(b!==this.target)return!1;h=this._propLookup,e=this._overwrittenProps=a?this._overwrittenProps||{}:"all"}if(h){if(j=a||h,k=a!==e&&"all"!==e&&a!==h&&("object"!=typeof a||!a._tempKill),c&&(G.onOverwrite||this.vars.onOverwrite)){for(f in j)h[f]&&(l||(l=[]),l.push(f));if((l||!a)&&!_(this,c,b,l))return!1}for(f in j)(g=h[f])&&(m&&(g.f?g.t[g.p](g.s):g.t[g.p]=g.s,i=!0),g.pg&&g.t._kill(j)&&(i=!0),g.pg&&0!==g.t._overwriteProps.length||(g._prev?g._prev._next=g._next:g===this._firstPT&&(this._firstPT=g._next),g._next&&(g._next._prev=g._prev),g._next=g._prev=null),delete h[f]),k&&(e[f]=1);!this._firstPT&&this._initted&&this._enabled(!1,!1)}}return i},h.invalidate=function(){return this._notifyPluginsOfEnabled&&G._onPluginEvent("_onDisable",this),this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],D.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-m,this.render(Math.min(0,-this._delay))),this},h._enabled=function(a,b){if(j||i.wake(),a&&this._gc){var c,d=this._targets;if(d)for(c=d.length;--c>-1;)this._siblings[c]=$(d[c],this,!0);else this._siblings=$(this.target,this,!0)}return D.prototype._enabled.call(this,a,b),this._notifyPluginsOfEnabled&&this._firstPT?G._onPluginEvent(a?"_onEnable":"_onDisable",this):!1},G.to=function(a,b,c){return new G(a,b,c)},G.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new G(a,b,c)},G.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new G(a,b,d)},G.delayedCall=function(a,b,c,d,e){return new G(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,lazy:!1,useFrames:e,overwrite:0})},G.set=function(a,b){return new G(a,0,b)},G.getTweensOf=function(a,b){if(null==a)return[];a="string"!=typeof a?a:G.selector(a)||a;var c,d,e,f;if((p(a)||H(a))&&"number"!=typeof a[0]){for(c=a.length,d=[];--c>-1;)d=d.concat(G.getTweensOf(a[c],b));for(c=d.length;--c>-1;)for(f=d[c],e=c;--e>-1;)f===d[e]&&d.splice(c,1)}else if(a._gsTweenID)for(d=$(a).concat(),c=d.length;--c>-1;)(d[c]._gc||b&&!d[c].isActive())&&d.splice(c,1);return d||[]},G.killTweensOf=G.killDelayedCallsTo=function(a,b,c){"object"==typeof b&&(c=b,b=!1);for(var d=G.getTweensOf(a,b),e=d.length;--e>-1;)d[e]._kill(c,a)};var ca=t("plugins.TweenPlugin",function(a,b){this._overwriteProps=(a||"").split(","),this._propName=this._overwriteProps[0],this._priority=b||0,this._super=ca.prototype},!0);if(h=ca.prototype,ca.version="1.19.0",ca.API=2,h._firstPT=null,h._addTween=P,h.setRatio=N,h._kill=function(a){var b,c=this._overwriteProps,d=this._firstPT;if(null!=a[this._propName])this._overwriteProps=[];else for(b=c.length;--b>-1;)null!=a[c[b]]&&c.splice(b,1);for(;d;)null!=a[d.n]&&(d._next&&(d._next._prev=d._prev),d._prev?(d._prev._next=d._next,d._prev=null):this._firstPT===d&&(this._firstPT=d._next)),d=d._next;return!1},h._mod=h._roundProps=function(a){for(var b,c=this._firstPT;c;)b=a[this._propName]||null!=c.n&&a[c.n.split(this._propName+"_").join("")],b&&"function"==typeof b&&(2===c.f?c.t._applyPT.m=b:c.m=b),c=c._next},G._onPluginEvent=function(a,b){var c,d,e,f,g,h=b._firstPT;if("_onInitAllProps"===a){for(;h;){for(g=h._next,d=e;d&&d.pr>h.pr;)d=d._next;(h._prev=d?d._prev:f)?h._prev._next=h:e=h,(h._next=d)?d._prev=h:f=h,h=g}h=b._firstPT=e}for(;h;)h.pg&&"function"==typeof h.t[a]&&h.t[a]()&&(c=!0),h=h._next;return c},ca.activate=function(a){for(var b=a.length;--b>-1;)a[b].API===ca.API&&(R[(new a[b])._propName]=a[b]);return!0},s.plugin=function(a){if(!(a&&a.propName&&a.init&&a.API))throw"illegal plugin definition.";var b,c=a.propName,d=a.priority||0,e=a.overwriteProps,f={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},g=t("plugins."+c.charAt(0).toUpperCase()+c.substr(1)+"Plugin",function(){ca.call(this,c,d),this._overwriteProps=e||[]},a.global===!0),h=g.prototype=new ca(c);h.constructor=g,g.API=a.API;for(b in f)"function"==typeof a[b]&&(h[f[b]]=a[b]);return g.version=a.version,ca.activate([g]),g},f=a._gsQueue){for(g=0;g<f.length;g++)f[g]();for(h in q)q[h].func||a.console.log("GSAP encountered missing dependency: "+h)}j=!1}}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenMax");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/logo-title@2x.png";

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/frame-center-spec-overlay.png";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/frame-center-spec-overlay@2x.png";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/button-hover.png";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/button-hover@2x.png";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/button-normal.png";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/button-normal@2x.png";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/frame-center.png";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/frame-center@2x.png";

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GameModel;
/* eslint-disable func-names */

/**
 * Class for game model.
 */
function GameModel() {}

/**
 * Gets the font with variations.
 *
 * @return {String}  The font with variations.
 */
GameModel.prototype.getFontWithVariations = function () {
    return this.font + this.fontVariations;
};

/**
 * Gets the stake.
 *
 * @return {Number}  The stake.
 */
GameModel.prototype.getStake = function () {
    if (this.stake !== undefined) {
        return this.stake;
    }
    return this.defaultStake;
};

/**
 * Gets the currency multiplier.
 *
 * @return {Number}  The currency multiplier.
 */
GameModel.prototype.getCurrencyMultiplier = function () {
    return this.defaultStake / this.baseMultiplier;
};

/**
 * Determines if out of tickets.
 *
 * @return {boolean}  True if out of tickets, False otherwise.
 */
GameModel.prototype.isOutOfTickets = function () {
    var bm = this.isBasketMode();
    var hr = this.hasRoundsLeft();

    var res = false;

    if (bm && !hr) {
        res = true;
    }

    return res;
};

/**
 * Determines if out of funds.
 *
 * @return {Boolean}  True if out of funds, False otherwise.
 */
GameModel.prototype.isOutOfFunds = function () {
    var bm = this.isBasketMode();
    var ba = this.getBalance();

    if (!bm && ba <= 0) {
        return true;
    }

    return false;
};

/**
 * Gets the help url.
 *
 * @return {String}  The help url.
 */
GameModel.prototype.getHelpUrl = function () {
    if (!this.showHelpButton) {
        return null;
    }

    var mu = this.getCurrencyMultiplier();
    var cc = this.currencyCode;
    var rc = false; // 888 Hack to hide RC info in help file

    var url = this.helpUrl + '&data=cc-' + cc + '$mu-' + mu + '$rc-' + rc + '&v=' + window.__version;

    if (this.apiGameCode) {
        url = url.replace(this.gameCode, 'PP_HTML5_FelineQueen60');
    }

    return url;
};

/**
 * Determines if maximum prize.
 *
 * @param  {Number}   index  The index
 * @return {Boolean}  True if maximum prize, False otherwise.
 */
GameModel.prototype.isMaxPrize = function (index) {
    return this.maxPrize === Number(index);
};

/**
 * Gets the status.
 *
 * @return {StatusModel}  The status.
 */
GameModel.prototype.getStatus = function () {
    return this.status;
};

/**
 * Gets the balance.
 *
 * @return {Number}  The balance.
 */
GameModel.prototype.getBalance = function () {
    var s = this.getStatus();

    if (!s) {
        return null;
    }

    return s.balance;
};

/**
 * Sets the balance.
 *
 * @param  {Number}  v  { parameter_description }
 */
GameModel.prototype.setBalance = function (v) {
    var s = this.getStatus();

    if (!s) {
        return;
    }

    s.balance = v;
};

/**
 * Gets the financial mode.
 *
 * @return {Number}  The financial mode.
 */
GameModel.prototype.getFinancialMode = function () {
    var s = this.getStatus();

    if (!s) {
        return null;
    }

    return s.financialMode;
};

/**
 * Determines if basket mode.
 *
 * @return {boolean}  True if basket mode, False otherwise.
 */
GameModel.prototype.isBasketMode = function () {
    return this.getFinancialMode() === 1;
};

/**
 * Gets the rounds left.
 *
 * @return {Number}  The rounds left.
 */
GameModel.prototype.getRoundsLeft = function () {
    var s = this.getStatus();

    if (!s) {
        return null;
    }

    return s.roundsLeft;
};

/**
 * Sets the rounds left.
 *
 * @param  {Number}  v  { parameter_description }
 */
GameModel.prototype.setRoundsLeft = function (v) {
    var s = this.getStatus();

    if (!s) {
        return;
    }

    s.roundsLeft = v;
};

/**
 * Determines if it has rounds left.
 *
 * @return {Boolean}  True if has rounds left, False otherwise.
 */
GameModel.prototype.hasRoundsLeft = function () {
    return this.getRoundsLeft() > 0;
};

/**
 * Gets the sound.
 *
 * @return {Number}  The sound.
 */
GameModel.prototype.setSoundAndMute = function () {
    var s = this.sound;

    if (typeof s === 'number') {
        if (s > 0) {
            this.defaultVolume = s;
            this.setMute(false);
        } else {
            this.setMute(true);
        }
    } else if (typeof s === 'boolean') {
        this.setMute(!s);
    } else {
        var muteString = window.localStorage.getItem('mute');

        this.setMute(muteString !== 'false');
    }

    return this.defaultVolume;
};

/**
 * Gets the sound.
 *
 * @return {Number}  The sound.
 */
GameModel.prototype.getSound = function () {
    return this.defaultVolume;
};

/**
 * Gets the mute.
 *
 * @return {Boolean}  The mute.
 */
GameModel.prototype.getMute = function () {
    console.log('getMute', this.mute);
    return this.mute;
};

/**
 * Sets the mute.
 *
 * @param  {Boolean}  v  { parameter_description }
 */
GameModel.prototype.setMute = function (v) {
    console.log('setMute', v);
    this.mute = v;
    window.localStorage.setItem('mute', v);
};

GameModel.prototype.isAutoplaying = function (before, after, stake) {
    return this.autoplayRounds > 0;
};

GameModel.prototype.decreaseAutoplay = function () {
    return this.autoplayedRounds -= 1;
};

GameModel.prototype.resetAutoplay = function () {
    this.hasUserStartedAutoplay = false;
    this.autoplayWin = 0;
    this.autoplayLoss = 0;
    return this.autoplayedRounds = this.autoplayRounds;
};

GameModel.prototype.stopAutoplay = function () {
    this.hasUserStartedAutoplay = false;
    this.autoplayWin = 0;
    this.autoplayLoss = 0;
    this.autoplayedRounds = 0;
    this.autoplayRounds = 0;
};

GameModel.prototype.updateAutoplayState = function (win, loss) {
    if (!this.isAutoplaying()) {
        return 0;
    }

    this.autoplayWin += win;
    this.autoplayLoss += loss;

    var reason = null;

    if (win >= this.singleWin && this.singleWin > 0) {
        reason = __t.str('Single win limit reached!');
    } else if (this.autoplayLoss - this.autoplayWin >= this.lossLimit && this.lossLimit > 0) {
        reason = __t.str('Loss limit reached!');
    }

    if (reason !== null) {
        this.autoplayedRounds = 0;
    }

    return reason;
};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ImageModel;
/**
 * Class for image model.
 */
function ImageModel(dpi, res) {
    // shared sprites
    this.uiJSON = __webpack_require__(110)("./buttons" + res + ".json");
    this.uiURL = __webpack_require__(111)("./buttons" + res + ".png");

    // shared images
    this.buttonSecondaryNormalImage = __webpack_require__(109)("./button-secondary-normal" + res + ".png");
    this.buttonSecondaryHoverImage = __webpack_require__(108)("./button-secondary-hover" + res + ".png");

    this.preload = [this.buttonSecondaryNormalImage, this.buttonSecondaryHoverImage, this.uiJSON];

    return this;
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
/* !
 * VERSION: 0.2.1
 * DATE: 2017-01-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope = typeof module !== 'undefined' && module.exports && typeof global !== 'undefined' ? global : this || window;

(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    _gsScope._gsDefine('easing.CustomEase', ['easing.Ease'], function (a) {
        var b = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
            c = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
            d = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi,
            e = /[cLlsS]/g,
            f = 'CustomEase only accepts Cubic Bezier data.',
            g = function g(a, b, c, d, e, f, h, i, j, k, l) {
            var m = void 0,
                n = (a + c) / 2,
                o = (b + d) / 2,
                p = (c + e) / 2,
                q = (d + f) / 2,
                r = (e + h) / 2,
                s = (f + i) / 2,
                t = (n + p) / 2,
                u = (o + q) / 2,
                v = (p + r) / 2,
                w = (q + s) / 2,
                x = (t + v) / 2,
                y = (u + w) / 2,
                z = h - a,
                A = i - b,
                B = Math.abs((c - h) * A - (d - i) * z),
                C = Math.abs((e - h) * A - (f - i) * z);

            return k || (k = [{ x: a, y: b }, { x: h, y: i }], l = 1), k.splice(l || k.length - 1, 0, { x: x, y: y }), (B + C) * (B + C) > j * (z * z + A * A) && (m = k.length, g(a, b, n, o, t, u, x, y, j, k, l), g(x, y, v, w, r, s, h, i, j, k, l + 1 + (k.length - m))), k;
        },
            h = function h(a) {
            var b = void 0,
                e = void 0,
                g = void 0,
                h = void 0,
                i = void 0,
                j = void 0,
                k = void 0,
                l = void 0,
                m = void 0,
                n = void 0,
                o = void 0,
                p = ('' + a).replace(d, function (a) {
                var b = Number(a);

                return b < 1e-4 && b > -1e-4 ? 0 : b;
            }).match(c) || [],
                q = [],
                r = 0,
                s = 0,
                t = p.length,
                u = 2;

            for (b = 0; t > b; b++) {
                if (m = h, isNaN(p[b]) ? (h = p[b].toUpperCase(), i = h !== p[b]) : b--, e = Number(p[b + 1]), g = Number(p[b + 2]), i && (e += r, g += s), b || (k = e, l = g), h === 'M') {
                    j && j.length < 8 && (q.length -= 1, u = 0), r = k = e, s = l = g, j = [e, g], u = 2, q.push(j), b += 2, h = 'L';
                } else if (h === 'C') {
                    j || (j = [0, 0]), j[u++] = e, j[u++] = g, i || (r = s = 0), j[u++] = r + Number(p[b + 3]), j[u++] = s + Number(p[b + 4]), j[u++] = r += Number(p[b + 5]), j[u++] = s += Number(p[b + 6]), b += 6;
                } else if (h === 'S') {
                    m === 'C' || m === 'S' ? (n = r - j[u - 4], o = s - j[u - 3], j[u++] = r + n, j[u++] = s + o) : (j[u++] = r, j[u++] = s), j[u++] = e, j[u++] = g, i || (r = s = 0), j[u++] = r += Number(p[b + 3]), j[u++] = s += Number(p[b + 4]), b += 4;
                } else {
                    if (h !== 'L' && h !== 'Z') {
                        throw f;
                    }h === 'Z' && (e = k, g = l, j.closed = !0), (h === 'L' || Math.abs(r - e) > 0.5 || Math.abs(s - g) > 0.5) && (j[u++] = r + (e - r) / 3, j[u++] = s + (g - s) / 3, j[u++] = r + 2 * (e - r) / 3, j[u++] = s + 2 * (g - s) / 3, j[u++] = e, j[u++] = g, h === 'L' && (b += 2)), r = e, s = g;
                }
            }

            return q[0];
        },
            i = function i(a) {
            var b = void 0,
                c = a.length,
                d = 999999999999;

            for (b = 1; c > b; b += 6) {
                Number(a[b]) < d && (d = Number(a[b]));
            }

            return d;
        },
            j = function j(a, b, c) {
            c || c === 0 || (c = Math.max(Number(a[a.length - 1]), Number(a[1])));var d = void 0,
                e = -1 * Number(a[0]),
                f = -c,
                g = a.length,
                h = 1 / (Number(a[g - 2]) + e),
                j = -b || (Math.abs(Number(a[g - 1]) - Number(a[1])) < 0.01 * (Number(a[g - 2]) - Number(a[0])) ? i(a) + f : Number(a[g - 1]) + f);

            for (j = j ? 1 / j : -h, d = 0; g > d; d += 2) {
                a[d] = (Number(a[d]) + e) * h, a[d + 1] = (Number(a[d + 1]) + f) * j;
            }
        },
            k = function k(a) {
            var b = this.lookup[a * this.l | 0] || this.lookup[this.l - 1];

            return b.nx < a && (b = b.n), b.y + (a - b.x) / b.cx * b.cy;
        },
            l = function l(b, c, d) {
            this._calcEnd = !0, this.id = b, b && (a.map[b] = this), this.getRatio = k, this.setData(c, d);
        },
            m = l.prototype = new a();

        return m.constructor = l, m.setData = function (a, c) {
            a = a || '0,0,1,1';var d = void 0,
                i = void 0,
                k = void 0,
                l = void 0,
                m = void 0,
                n = void 0,
                o = void 0,
                p = void 0,
                q = void 0,
                r = void 0,
                s = a.match(b),
                t = 1,
                u = [];

            if (c = c || {}, r = c.precision || 1, this.data = a, this.lookup = [], this.points = u, this.fast = r <= 1, (e.test(a) || a.indexOf('M') !== -1 && a.indexOf('C') === -1) && (s = h(a)), d = s.length, d === 4) {
                s.unshift(0, 0), s.push(1, 1), d = 8;
            } else if ((d - 2) % 6) {
                throw f;
            }for ((Number(s[0]) !== 0 || Number(s[d - 2]) !== 1) && j(s, c.height, c.originY), this.rawBezier = s, l = 2; d > l; l += 6) {
                i = { x: Number(s[l - 2]), y: Number(s[l - 1]) }, k = { x: Number(s[l + 4]), y: Number(s[l + 5]) }, u.push(i, k), g(i.x, i.y, Number(s[l]), Number(s[l + 1]), Number(s[l + 2]), Number(s[l + 3]), k.x, k.y, 1 / (2e5 * r), u, u.length - 1);
            }for (d = u.length, l = 0; d > l; l++) {
                o = u[l], p = u[l - 1] || o, o.x > p.x || p.y !== o.y && p.x === o.x || o === p ? (p.cx = o.x - p.x, p.cy = o.y - p.y, p.n = o, p.nx = o.x, this.fast && l > 1 && Math.abs(p.cy / p.cx - u[l - 2].cy / u[l - 2].cx) > 2 && (this.fast = !1), p.cx < t && (p.cx ? t = p.cx : (p.cx = 0.001, l === d - 1 && (p.x -= 0.001, t = Math.min(t, 0.001), this.fast = !1)))) : (u.splice(l--, 1), d--);
            }if (d = 1 / t + 1 | 0, this.l = d, m = 1 / d, n = 0, o = u[0], this.fast) {
                for (l = 0; d > l; l++) {
                    q = l * m, o.nx < q && (o = u[++n]), i = o.y + (q - o.x) / o.cx * o.cy, this.lookup[l] = { x: q, cx: m, y: i, cy: 0, nx: 9 }, l && (this.lookup[l - 1].cy = i - this.lookup[l - 1].y);
                }this.lookup[d - 1].cy = u[u.length - 1].y - i;
            } else {
                for (l = 0; d > l; l++) {
                    o.nx < l * m && (o = u[++n]), this.lookup[l] = o;
                }n < u.length - 1 && (this.lookup[l - 1] = u[u.length - 2]);
            }

            return this._calcEnd = u[u.length - 1].y !== 1 || u[0].y !== 0, this;
        }, m.getRatio = k, m.getSVGData = function (a) {
            return l.getSVGData(this, a);
        }, l.create = function (a, b, c) {
            return new l(a, b, c);
        }, l.version = '0.2.1', l.bezierToPoints = g, l.get = function (b) {
            return a.map[b];
        }, l.getSVGData = function (b, c) {
            c = c || {};var d = void 0,
                e = void 0,
                f = void 0,
                g = void 0,
                h = void 0,
                i = void 0,
                j = void 0,
                k = void 0,
                l = void 0,
                m = void 0,
                n = 1e3,
                o = c.width || 100,
                p = c.height || 100,
                q = c.x || 0,
                r = (c.y || 0) + p,
                s = c.path;

            if (c.invert && (p = -p, r = 0), b = b.getRatio ? b : a.map[b] || console.log('No ease found: ', b), b.rawBezier) {
                for (d = [], j = b.rawBezier.length, f = 0; j > f; f += 2) {
                    d.push(((q + b.rawBezier[f] * o) * n | 0) / n + ',' + ((r + b.rawBezier[f + 1] * -p) * n | 0) / n);
                }d[0] = 'M' + d[0], d[1] = 'C' + d[1];
            } else {
                for (d = ['M' + q + ',' + r], j = Math.max(5, 200 * (c.precision || 1)), g = 1 / j, j += 2, k = 5 / j, l = ((q + g * o) * n | 0) / n, m = ((r + b.getRatio(g) * -p) * n | 0) / n, e = (m - r) / (l - q), f = 2; j > f; f++) {
                    h = ((q + f * g * o) * n | 0) / n, i = ((r + b.getRatio(f * g) * -p) * n | 0) / n, (Math.abs((i - m) / (h - l) - e) > k || f === j - 1) && (d.push(l + ',' + m), e = (i - m) / (h - l)), l = h, m = i;
                }
            }

            return s && (typeof s === 'string' ? document.querySelector(s) : s).setAttribute('d', d.join(' ')), d.join(' ');
        }, l;
    }, !0);
}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(), function (a) {
    var b = function b() {
        return (_gsScope.GreenSockGlobals || _gsScope)[a];
    };

     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : typeof module !== 'undefined' && module.exports && (require('tween'), module.exports = b());
}('CustomEase');
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    /**
     * Constructs the object.
     */
    function Images() {
        _classCallCheck(this, Images);

        this.logo = __webpack_require__(120)("./logo-title" + __postfix + ".png");
        this.bg = __webpack_require__(112)("./background" + __postfix + ".jpg");
        this.btnBgImage = __webpack_require__(113)("./button" + __postfix + ".png");
        this.btnNormalImage = __webpack_require__(115)("./button-normal" + __postfix + ".png");
        this.btnHoverImage = __webpack_require__(114)("./button-hover" + __postfix + ".png");
        this.star = __webpack_require__(122)("./star" + __postfix + ".png");
        this.char = __webpack_require__(116)("./character" + __postfix + ".png");
        this.wheel = __webpack_require__(123)("./wheel1" + __postfix + ".png");
        this.frame = __webpack_require__(117)("./frame" + __postfix + ".png");
        this.button = __webpack_require__(118)("./frame-center" + __postfix + ".png");
        this.buttonIcon = __webpack_require__(121)("./spin-sign" + __postfix + ".png");
        this.buttonReflection = __webpack_require__(119)("./frame-center-spec-overlay" + __postfix + ".png");

        this.buttonPulseJSON = __webpack_require__(124)("./green-button" + __postfix + ".json");
        this.buttonPulse = __webpack_require__(125)("./green-button" + __postfix + ".png");
        this.winFrameJSON = __webpack_require__(102);
        this.winFrame = __webpack_require__(74);
        this.winSignJSON = __webpack_require__(126)("./win-sign" + __postfix + ".json");
        this.winSign = __webpack_require__(127)("./win-sign" + __postfix + ".png");
        this.handJSON = __webpack_require__(100);
        this.hand = __webpack_require__(72);
        this.sasJSON = __webpack_require__(101);
        this.sas = __webpack_require__(73);
    }

    /**
     * Gets images needed to be preloaded
     *
     * @return {Array}  of image urls
     */


    _createClass(Images, [{
        key: "preload",
        value: function preload() {
            return [this.logo, this.bg, this.btnBgImage, this.btnNormalImage, this.btnHoverImage, this.star, this.char, this.hand, this.star, this.wheel, this.frame, this.button, this.buttonIcon, this.buttonReflection, this.buttonPulseJSON, this.winFrameJSON, this.winFrame, this.winSignJSON, this.handJSON, this.sasJSON];
        }
    }]);

    return Images;
}();

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tween__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tween___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tween__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/**
 * Foreground visualization of the data that model contains.
 */

var View = function (_PIXI$Container) {
    _inherits(View, _PIXI$Container);

    /**
     * Initialize
     *
     * @param  {Object}  size    The size
     * @param  {Object}  images  The images
     */
    function View(size, images) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this));

        _this.size = size;
        _this.url = images.star;

        _this.addStar(0);
        _this.addStar(2);
        _this.addStar(3);
        _this.addStar(4);
        return _this;
    }

    /**
     * Called on resize
     *
     * @param  {Object}  size  The size data
     */


    _createClass(View, [{
        key: 'resize',
        value: function resize(size) {
            this.size = size;
        }

        /**
         * Adds a star.
         *
         * @param  {Number}  delay  The time before adding the star
         */

    }, {
        key: 'addStar',
        value: function addStar(delay) {
            var _this2 = this;

            var star = new PIXI.Sprite.fromImage(this.url);

            star.x = Math.floor(Math.random() * this.size.width);
            star.y = Math.floor(Math.random() * this.size.height);
            star.anchor.set(0.5);
            star.scale.set(1);
            star.alpha = 0;

            this.addChild(star);

            var duration = 0.7;

            var fade = {
                alpha: 1,
                repeat: 1,
                yoyo: true,
                delay: delay,
                onComplete: function onComplete() {
                    star.removeSelf();
                    _this2.addStar(0);
                }
            };

            var rotate = {
                rotation: 6,
                ease: Linear.easeNone,
                delay: delay
            };

            var scale = {
                x: 1.5,
                y: 1.5,
                repeat: 1,
                yoyo: true,
                delay: delay
            };

            __WEBPACK_IMPORTED_MODULE_0_tween___default.a.to(star, duration, fade);
            __WEBPACK_IMPORTED_MODULE_0_tween___default.a.to(star, duration * 2, rotate);
            __WEBPACK_IMPORTED_MODULE_0_tween___default.a.to(star.scale, duration, scale);
        }
    }]);

    return View;
}(PIXI.Container);

/* harmony default export */ __webpack_exports__["default"] = (View);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    empty: true
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wheel_view__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_wheel_model__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spin_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_suga__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_suga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_suga__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Game visualization of the data that model contains.
 */

var GameView = function (_PIXI$Container) {
    _inherits(GameView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}           size             The size
     * @param  {Object}           options          The options
     * @param  {ThemeImageModel}  themeImageModel  The theme image model
     */
    function GameView(size, options, themeImageModel) {
        _classCallCheck(this, GameView);

        var _this = _possibleConstructorReturn(this, (GameView.__proto__ || Object.getPrototypeOf(GameView)).call(this));

        _this.placeBet = options.placeBet;
        _this.endBet = options.endBet;
        _this.resultShown = options.resultShown;
        _this.stopAutoplayHandler = options.stopAutoplay;

        _this.scales = [1, 0.66, 0.4];
        _this.forcedDelayAtStart = 1;
        _this.forcedDelayAtEnd = 0;
        _this.playing = false;
        _this.gameYOffset = 70;

        _this.wheelOptions = {
            count: 9,
            startRevolutions: 5,
            startDuration: 2,
            startDelay: 0.2,
            stopRevolutions: 2,
            stopDuration: 2,
            stopDelay: 0.8,
            bounceDegrees: 3,
            bounceDuration: 0.2,
            sasRevolutions: 10,
            sasDuration: 9.3,
            sasDelay: 0,
            sasIndex: 5,
            sasBounceDegrees: 5.0,
            sasBounceDuration: 0.5,
            map: [8, 6, 4, 2, 9, 7, 5, 3, 1]
        };

        _this.wheelsModel = new __WEBPACK_IMPORTED_MODULE_1__model_wheel_model__["a" /* default */](_this.wheelOptions);

        _this.addWheel(size, themeImageModel.wheel, _this.scales, _this.wheelOptions.count);

        _this.addWinOutline();

        var mask = _this.addFrameMaskAndSas(size, themeImageModel.frame);

        _this.wheelView.mask = mask;

        _this.addButton(size, themeImageModel.button, themeImageModel.buttonIcon, themeImageModel.buttonReflection, options.font);

        var ticketIdStyle = {
            fontSize: 9,
            fontFamily: options.font,
            fill: 0xffffff
        };

        if (options.showTicketId) {
            _this.addTicketId(ticketIdStyle);
        }

        var winStyle = {
            fontFamily: options.font,
            fill: 0xffffff
        };
        _this.addWinSign(size, winStyle);
        return _this;
    }

    /**
     * Used to reset the game for example after replays
     */


    _createClass(GameView, [{
        key: 'reset',
        value: function reset() {
            this.sas.visible = false;
            this.sign.visible = false;
            this.winOutline.visible = false;
            this.wheelView.reset();
            this.button.reset();
            this.isAuto = false; // look here
        }

        /**
         * lets setup based off a bet
         *
         * @param  {BetModel}  betModel  The bet model
         */

    }, {
        key: 'executeBet',
        value: function executeBet(betModel) {
            var _this2 = this;

            this.playing = true;

            this.stopWinSign();
            this.stopWinOutline();
            this.hideSasInstantly();
            this.isAuto = betModel.isAutoplay || betModel.isReplay;

            // stop win sound
            this.stopWinSound();

            // show the ticketId
            this.updateTicketId(betModel.ticket.id);

            // build the animation data
            var model = this.wheelsModel.build(betModel);

            // animations
            this.button.spin(1800, 4);
            this.button.showStopText(this.forcedDelayAtStart, this.isAuto);

            // increase volume
            __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].fade('music', 1, 1000);

            this.showSas(model.hasSas, model.wheels[1].totalDuration);

            PIXI.setTimeout(1, function () {
                _this2.enableInteraction();
            });

            // spin the wheel
            this.wheelView.spin(model, function () {
                var amount = betModel.ticket.totalWinAmount;

                _this2.completed(betModel);
            });
        }

        /**
         * Stop spinning / End the round
         *
         */

    }, {
        key: 'stop',
        value: function stop() {
            if (!this.playing) {
                return;
            }

            this.playing = false;

            this.button.hideText(this.isAuto);
            this.button.stopSpin();

            this.hideSasInstantly();
        }

        /**
         * Called after games ends
         *
         * @param  {Boolean}  isWin   Indicates if window
         * @param  {Number}   amount  The win amount
         */

    }, {
        key: 'completed',
        value: function completed(betModel) {
            var _this3 = this;

            var delay = betModel.ticket.isWin ? 0 : 1;

            // fade out text
            this.stop();
            this.endSounds();
            this.hideSas(delay);

            // win
            if (betModel.ticket.isWin) {
                var promises = [this.playWinSound(betModel.ticket.winIndex), this.showWinSign(betModel.ticket.totalWinAmount)];

                Promise.all(promises).then(function () {
                    return _this3.endBet(betModel);
                }).catch(function (err) {
                    throw new Error(err);
                });
                this.showWinOutline();
            }

            // loss
            else {
                    this.endBet(betModel);
                }

            this.button.showSpinText(this.forcedDelayAtEnd, this.isAuto);
            this.enableInteraction();

            this.resultShown(betModel);
        }

        /**
         * Ends sounds.
         */

    }, {
        key: 'endSounds',
        value: function endSounds() {
            __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].fade('music', 0.2, 2000);
        }

        /**
         * Adds a frame.
         *
         * @param  {Object}         size  The size
         * @param  {String}         url   The url
         * @return {PIXI.Graphics}  The mask
         */

    }, {
        key: 'addFrameMaskAndSas',
        value: function addFrameMaskAndSas(size, url) {
            this.frame = new PIXI.Sprite.fromImage(url);
            this.addChild(this.frame);
            this.frame.x = Math.round((size.defaultWidth - this.frame.width) / 2);
            this.frame.y = this.gameYOffset;

            var mask = new PIXI.Graphics();

            mask.beginFill(0xFF3300, 0.5);
            mask.moveTo(10, 60);
            mask.lineTo(this.frame.width / 2, 10);
            mask.lineTo(this.frame.width - 10, 60);
            mask.lineTo(this.frame.width - 60, 240);
            mask.lineTo(this.frame.width / 2, this.frame.height);
            mask.lineTo(60, 240);
            mask.lineTo(10, 60);
            mask.endFill();

            this.frame.addChild(mask);

            var textures = __WEBPACK_IMPORTED_MODULE_3_suga__["Loader"].makeTexturesFromName('sas');

            this.sas = new PIXI.extras.AnimatedSprite(textures);
            this.frame.addChild(this.sas);
            this.sas.anchor.set(0.5);
            this.sas.scale.set(1 / __dpi * 2);
            this.sas.animationSpeed = 0.2;
            this.sas.alpha = 0;
            this.sas.x = this.frame.width / 2;
            this.sas.y = 51;

            return mask;
        }

        /**
         * Adds the eye button.
         *
         * @param  {String}  size           The size
         * @param  {String}  url            The url
         * @param  {String}  iconUrl        The icon url
         * @param  {String}  reflectionUrl  The reflection url
         * @param  {String}  font           The font
         */

    }, {
        key: 'addButton',
        value: function addButton(size, url, iconUrl, reflectionUrl, font) {
            var _this4 = this;

            var handler = function handler(e) {
                return _this4.buttonClick();
            };
            this.button = new __WEBPACK_IMPORTED_MODULE_2__spin_button__["a" /* default */](size, url, iconUrl, reflectionUrl, font, handler);
            this.addChild(this.button);
            this.button.y = 317;
            this.button.x = 117;
        }

        /**
         * On Button Click
         */

    }, {
        key: 'buttonClick',
        value: function buttonClick() {
            this.button.disable();

            if (!this.wheelView.spinning && !this.isAuto) {
                this.placeBet();
            } else {
                __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].stop('sas-louder');
                this.wheelView.stop();
                this.stop();

                if (this.sasTimer) {
                    this.sasTimer.clear();
                }

                if (this.isAuto) {
                    this.stopAutoplay();
                }
            }
        }
    }, {
        key: 'stopAutoplay',
        value: function stopAutoplay() {
            this.resetAutoplay();
            this.stopAutoplayHandler();
        }
    }, {
        key: 'resetAutoplay',
        value: function resetAutoplay() {
            this.isAuto = false;
            this.button.showSpinText(0, false);
        }

        /**
         * On space bar hit
         */

    }, {
        key: 'spacebarHit',
        value: function spacebarHit() {
            if (!this.button.interactiveChildren) {
                return;
            }
            this.buttonClick();
        }

        /**
         * Adds a wheel.
         *
         * @param  {Object}  size        The size
         * @param  {String}  url         The url
         * @param  {Array}   scales      The scales
         * @param  {Number}  prizeCount  The prize count
         */

    }, {
        key: 'addWheel',
        value: function addWheel(size, url, scales, prizeCount) {
            this.wheelView = new __WEBPACK_IMPORTED_MODULE_0__wheel_view__["a" /* default */](url, scales, prizeCount);
            this.addChild(this.wheelView);
            this.wheelView.y = 30 + this.gameYOffset;
            this.wheelView.x = (size.defaultWidth - 550) / 2;
        }
    }, {
        key: 'addTicketId',
        value: function addTicketId(style) {
            this.ticketId = new PIXI.Text('', style);
            this.ticketId.position.set(255, 370);
            this.ticketId.alpha = 0.5;
            this.ticketId.rotation = -0.6;
            this.addChild(this.ticketId);
        }
    }, {
        key: 'updateTicketId',
        value: function updateTicketId(ticketId) {
            if (!this.ticketId) {
                return;
            }

            if (ticketId === 0) {
                ticketId = 'DEMO';
            } else {
                ticketId = "#" + ticketId;
            }

            this.ticketId.text = ticketId;
        }

        /**
         * Shows the SAS animation
         *
         * @param  {Object}  sas  The sas model
         */

    }, {
        key: 'showSas',
        value: function showSas(hasSas, delay) {
            if (!hasSas) {
                return;
            }

            var opts = {
                alpha: 1,
                delay: delay
            };

            this.sas.alpha = 0;
            this.sas.visible = true;
            this.sas.play();
            this.sasTween = window.TweenMax.to(this.sas, 0.5, opts);

            this.sasTimer = PIXI.setTimeout(delay, function () {
                __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].play('sas-louder', 1);
                __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].fade('music', 0.1, 2000);
            });
        }

        /**
         * Hides the sas instantly.
         */

    }, {
        key: 'hideSasInstantly',
        value: function hideSasInstantly() {
            // if we are still waiting
            if (this.hideSasTween) {
                this.hideSasTween.kill();
            }

            if (this.sasTween) {
                this.sasTween.kill();
                this.sas.stop();
                this.sas.visible = false;
                this.sas.alpha = 0;
            }
        }

        /**
         * Hides the sas over time with fade out.
         *
         * @param  {Number}    delay  The delay
         * @param  {Function}  cb     Completion handler
         */

    }, {
        key: 'hideSas',
        value: function hideSas(delay, cb) {
            var _this5 = this;

            var afterSasRemoval = function afterSasRemoval() {
                if (_this5.sas) {
                    _this5.sas.stop();
                    _this5.sas.visible = false;
                    _this5.sas.alpha = 0;
                }
                if (cb) {
                    cb();
                }
            };

            var options = {
                alpha: 0,
                onComplete: afterSasRemoval
            };

            this.hideSasTween = window.TweenMax.to(this.sas, delay, options);
        }

        /**
         * Adds a window sign.
         *
         * @param  {Object}  size   The size
         * @param  {Object}  style  The style
         */

    }, {
        key: 'addWinSign',
        value: function addWinSign(size, style) {
            var textures = __WEBPACK_IMPORTED_MODULE_3_suga__["Loader"].makeTexturesFromName('win-sign');

            this.sign = new PIXI.extras.AnimatedSprite(textures);
            this.addChild(this.sign);
            this.sign.animationSpeed = 0.2;
            this.sign.loop = false;
            this.sign.visible = false;
            this.sign.centerX(size.defaultWidth);
            this.sign.y = 10;

            this.signLabel = new PIXI.Text('', style);
            this.sign.addChild(this.signLabel);
            this.signLabel.centerX();
            this.signLabel.centerY();
            this.signLabel.visible = false;
        }

        /**
         * Shows the window sign.
         *
         * @param  {Number}  amount  The amount
         * @return {Promise}  { description_of_the_return_value }
         */

    }, {
        key: 'showWinSign',
        value: function showWinSign(amount, cb) {
            var _this6 = this;

            return new Promise(function (resolve) {
                _this6.sign.onComplete = function () {
                    _this6.signLabel.alpha = 0;
                    _this6.signLabel.visible = true;
                    window.TweenMax.to(_this6.signLabel, 0.1, { alpha: 1, onComplete: resolve });
                    if (cb) {
                        cb();
                    }
                };
                _this6.sign.visible = true;
                _this6.sign.animationSpeed = 0.3;
                _this6.sign.play();

                _this6.signLabel.text = __c.localize(amount);
                _this6.signLabel.centerX();
                _this6.signLabel.centerY();
                _this6.signLabel.clarify();
            });
        }

        /**
         * Stops a window sign.
         */

    }, {
        key: 'stopWinSign',
        value: function stopWinSign() {
            var _this7 = this;

            var opts = {
                alpha: 0,
                onComplete: function onComplete() {
                    _this7.signLabel.visible = false;
                    _this7.sign.animationSpeed = -0.5;
                    _this7.sign.play();

                    _this7.sign.onComplete = function () {
                        _this7.sign.visible = false;
                    };
                }
            };

            window.TweenMax.to(this.signLabel, 0.05, opts);
        }

        /**
         * Adds a window outline.
         */

    }, {
        key: 'addWinOutline',
        value: function addWinOutline() {
            var textures = __WEBPACK_IMPORTED_MODULE_3_suga__["Loader"].makeTexturesFromName('win-frame');

            this.winOutline = new PIXI.extras.AnimatedSprite(textures);
            this.wheelView.addChild(this.winOutline);
            this.winOutline.animationSpeed = 0.2;
            this.winOutline.visible = false;
            this.winOutline.alpha = 0;
            this.winOutline.centerX();
            this.winOutline.y = 13;
        }

        /**
         * Shows the window outline.
         */

    }, {
        key: 'showWinOutline',
        value: function showWinOutline() {
            this.winOutline.visible = true;
            this.winOutline.play();
            window.TweenMax.to(this.winOutline, 0.05, { alpha: 1 });
        }

        /**
         * Stops a window outline.
         */

    }, {
        key: 'stopWinOutline',
        value: function stopWinOutline() {
            var _this8 = this;

            window.TweenMax.to(this.winOutline, 0.05, { alpha: 0, onComplete: function onComplete() {
                    _this8.winOutline.visible = false;
                    _this8.winOutline.stop();
                } });
        }
    }, {
        key: 'playWinSound',
        value: function playWinSound(index) {
            var _this9 = this;

            return new Promise(function (resolve) {
                switch (index) {
                    case 1:
                    case 2:
                        _this9.stopSequence = __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].playSequence(['win'], resolve);
                        break;
                    case 3:
                    case 4:
                        _this9.stopSequence = __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].playSequence(['win', 'win'], resolve);
                        break;
                    case 5:
                    case 6:
                        _this9.stopSequence = __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].playSequence(['win', 'win', 'win'], resolve);
                        break;
                    default:
                        _this9.stopSequence = __WEBPACK_IMPORTED_MODULE_3_suga__["Sound"].playSequence(['win', 'win', 'win', 'win'], resolve);
                }
            });
        }
    }, {
        key: 'stopWinSound',
        value: function stopWinSound() {
            if (this.stopSequence) {
                this.stopSequence();
            }
        }
    }, {
        key: 'enableInteraction',
        value: function enableInteraction() {
            this.button.enable();
        }
    }, {
        key: 'disableInteraction',
        value: function disableInteraction() {
            this.button.disable();
        }
    }]);

    return GameView;
}(PIXI.Container);

/* harmony default export */ __webpack_exports__["default"] = (GameView);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_suga__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_suga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_suga__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/**
 * Foreground visualization of the data that model contains.
 */

var View = function (_PIXI$Container) {
    _inherits(View, _PIXI$Container);

    function View() {
        _classCallCheck(this, View);

        return _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).apply(this, arguments));
    }

    _createClass(View, [{
        key: 'init',

        /**
         * Initialize
         *
         * @param  {Object}  images  The images
         */
        value: function init(images) {
            this.z = 2;

            var handTextures = __WEBPACK_IMPORTED_MODULE_0_suga__["Loader"].makeTexturesFromName('hand');

            this.hand = new PIXI.extras.AnimatedSprite(handTextures);
            this.addChild(this.hand);
            this.hand.x = 10;
            this.hand.y = 5;
            this.hand.scale.set(1.2);
            this.hand.play();
            this.hand.animationSpeed = 0.1;

            this.character = new PIXI.Sprite.fromImage(images.char);
            this.addChild(this.character);
            this.character.x = 55;
        }
    }]);

    return View;
}(PIXI.Container);

/* harmony default export */ __webpack_exports__["default"] = (View);

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/fonts.css";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sound/audio-sprite.json";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sound/audio-sprite.mp3";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sound/audio-sprite.ogg";

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = {"gameWidth":360,"gameHeight":518,"defaultVolume":0.6,"defaultCurrency":"EUR","defaultLanguage":"en","hideLoaderDelay":200}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = {"LOAD_GAME_FAILED":{"title":"Game Error","msg":"The Game you are trying to open is temporarily unavailable. Please try again in a few moments.","fatal":true,"showServerMsg":true,"buttons":[{"textKey":"Reload game","action":"reload"},{"textKey":"Home","action":"home"}]},"LOAD_CONFIG_FAILED":{"title":"Game Error","msg":"Game does not exist. Please try another title.","fatal":true,"showServerMsg":true},"WAITING_ON_BALANCE":{"title":"Retrieving Balance","msg":"Temporary problem. Please wait.","fatal":false,"showServerMsg":true},"WAITING_ON_BALANCE_FAILED":{"title":"Temporary Problem","msg":"Please load the game again.","fatal":false,"showServerMsg":true,"buttons":[{"textKey":"Reload game","action":"reload"}]},"NO_TICKETS_LEFT":{"code":112,"title":"No tickets left...","msg":"The next big win could be just around the corner. Get more tickets now.","fatal":true,"showServerMsg":false,"buttons":[{"textKey":"Okay","action":"hide-error"},{"textKey":"Get more tickets","action":"buy-more"},{"textKey":"Home","action":"home"}]},"INSUFFICIENT_FUNDS":{"code":112,"title":"Oops","msg":"You have insufficient funds","fatal":true,"showServerMsg":false,"buttons":[{"textKey":"Okay","action":"hide-error"},{"textKey":"Deposit","action":"cashier"},{"textKey":"Home","action":"home"}]},"PLACE_BET_FAILED":{"title":"Game Error","msg":"Bet was not placed. Please try again.","fatal":false,"showServerMsg":true,"buttons":[{"textKey":"Okay","action":"hide-error"},{"textKey":"Quit","action":"home"}]},"WAITING_ON_NOTIFICATION":{"title":"Placing bet","msg":"This is taking longer than expected. Please wait.","fatal":false,"showServerMsg":true},"GAME_QUIT":{"title":"Game Quit","msg":"You have quit the game.","fatal":true,"showServerMsg":true},"REPLAY_START":{"title":"Last round not finished","msg":"The previous unseen round will now be replayed","fatal":false,"showServerMsg":true,"buttons":[{"textKey":"Okay","action":"start-replay"}]},"REPLAY_DONE":{"title":"Replay finished","msg":"The replay has finished, you will now return to the game","fatal":false,"showServerMsg":true,"buttons":[{"textKey":"Okay","action":"end-replay"}]},"REALITY_CHECK":{"title":"Hello there!","msg":"","fatal":false,"showServerMsg":true,"buttons":[{"textKey":"Continue","action":"hide-reality-check"},{"textKey":"History","action":"history"},{"textKey":"Quit","action":"home"}]}}

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    return defaultLogger;
}));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cs.json": 77,
	"./de.json": 78,
	"./en.json": 79,
	"./hu.json": 80,
	"./pl.json": 81,
	"./pt.json": 82,
	"./sk.json": 83,
	"./sv.json": 84
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.eot": 87,
	"./proximasoft-bold-webfont.eot": 90,
	"./proximasoft-regular-webfont.eot": 94
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.svg": 46,
	"./proximasoft-bold-webfont.svg": 47,
	"./proximasoft-regular-webfont.svg": 48
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.ttf": 88,
	"./proximasoft-bold-webfont.ttf": 91,
	"./proximasoft-regular-webfont.ttf": 95
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.woff": 89,
	"./proximasoft-bold-webfont.woff": 92,
	"./proximasoft-regular-webfont.woff": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./proximasoft-bold-webfont.woff2": 93,
	"./proximasoft-regular-webfont.woff2": 97
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue", [], factory);
	else if(typeof exports === 'object')
		exports["vue"] = factory();
	else
		root["vue"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for base button.
 */
var Button = function (_PIXI$Container) {
    _inherits(Button, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  options  The options
     */
    function Button(options) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

        _this.tag = 'button';

        _this.isEnabled = true;
        _this.interactive = true;
        _this.buttonMode = true;

        if (options.tapped) {
            _this.tapped = options.tapped;
        }

        if (options.remainActive) {
            _this.remainActive = options.remainActive;
        } else {
            _this.remainActive = false;
        }

        _this.options = options;

        if (options.bgUrl) {
            _this.bg = new PIXI.Sprite.fromImage(options.bgUrl);
            _this.addChild(_this.bg);
        }

        if (typeof options.normalUrl === 'string') {
            _this.normal = new PIXI.Sprite.fromImage(options.normalUrl);
        } else {
            _this.normal = new PIXI.Sprite(options.normalUrl);
        }

        if (typeof options.hoverUrl === 'string') {
            _this.hover = new PIXI.Sprite.fromImage(options.hoverUrl);
        } else {
            _this.hover = new PIXI.Sprite(options.hoverUrl);
        }

        _this.addChild(_this.normal);
        _this.addChild(_this.hover);

        if (options.text) {
            _this.text = new PIXI.Text(options.text, options.textStyle);
            _this.addChild(_this.text);
            _this.text.x = Math.round((_this.normal.width - _this.text.width) / 2);
            _this.text.y = Math.round((_this.normal.height - _this.text.height) / 2);
        }

        if (options.tint) {
            _this.normal.tint = options.tint;
            _this.hover.tint = options.tint;
            if (_this.text) {
                _this.text.tint = options.tint;
            }
        }

        if (options.iconUrl) {
            _this.icon = new PIXI.Sprite.fromImage(options.iconUrl);
            _this.addChild(_this.icon);
            _this.icon.centerX();
            _this.icon.centerY();
        }

        _this.reset();
        return _this;
    }

    /**
     * Pixi Pointer event
     *
     * @param  {UIEvent}  e  The event
     */


    _createClass(Button, [{
        key: 'pointerdown',
        value: function pointerdown(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();
        }

        /**
         * Pixi Pointer event
         */

    }, {
        key: 'pointerover',
        value: function pointerover() {
            if (!this.isEnabled) {
                return;
            }

            if (this.hovered) {
                this.hovered();
            }

            this.hover.visible = true;
            this.normal.visible = false;

            this.isHovered = true;
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerup',
        value: function pointerup(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();

            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointertap',
        value: function pointertap(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();

            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerout',
        value: function pointerout() {
            this.reset();
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerupoutside',
        value: function pointerupoutside() {
            this.reset();
        }

        /**
         * Reset
         */

    }, {
        key: 'reset',
        value: function reset() {
            if (this.hover) {
                this.hover.visible = false;
            }
            if (this.normal) {
                this.normal.visible = true;
            }

            this.isHovered = false;
        }

        /**
         * Enable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.reset();
            this.interactive = true;
            this.buttonMode = true;
            this.alpha = 1;

            this.isEnabled = true;
        }

        /**
         * Disable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.reset();
            this.interactive = false;
            this.buttonMode = false;
            this.alpha = 0.5;

            this.isEnabled = false;
        }

        /**
         * @private
         * Button pressed action
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: '_tapped',
        value: function _tapped(e) {
            if (this.tapped) {
                this.tapped(e);
            } else {
                throw new Error('Button has no Action');
            }

            if (!this.remainActive) {
                this.disable();
            }
        }
    }, {
        key: 'startBlinking',
        value: function startBlinking() {
            var _this2 = this;

            if (this.blinkInterval) {
                return;
            }

            this.blinkInterval = window.setInterval(function () {
                if (_this2.isHovered || !_this2.isEnabled) {
                    return;
                }

                if (_this2.blinkActive) {
                    _this2.hover.visible = false;
                    _this2.normal.visible = true;
                    _this2.blinkActive = false;
                } else {
                    _this2.hover.visible = true;
                    _this2.normal.visible = false;
                    _this2.blinkActive = true;
                }
            }, this.options.blink * 1000);
        }
    }, {
        key: 'stopBlinking',
        value: function stopBlinking() {
            window.clearInterval(this.blinkInterval);
            this.blinkInterval = null;
            this.reset();
        }
    }]);

    return Button;
}(PIXI.Container);

exports.default = Button;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _stats = __webpack_require__(14);

var _stats2 = _interopRequireDefault(_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class for canvas manager.
 */
var CanvasManager = function () {
    /**
     * @typedef {Object} CanvasManagerOptions
     * @property {Boolean} showFPS          - Whether to show the FPS counter
     * @property {Object} backgroundAnchor  - Coordinates of BG Anchor {x 0.5, y: 1}
     * @property {Number} transitionSpeed   - The speed of the parallax scroll
     * @property {Number} parallaxBgOffeset - The amount the BG should parallax scroll
     * @property {Number} defaultGameWidth  - The width the game starts width
     * @property {Number} defaultGameHeight - The height the game starts width
     */

    /**
     * Constructs the object.
     *
     * @param  {CanvasManagerOptions}  options        - The options
     * @param  {PIXI.Container}        bottomBarView  - The bottom bar view
     * @param  {PIXI.Sprite}           gameBg         - The game background
     */
    function CanvasManager(options, bottomBarView, gameBg) {
        var _this = this;

        _classCallCheck(this, CanvasManager);

        this.views = [];
        this.overlays = [];
        this.historyStates = [];
        this.isTransitioning = false;

        this.fixedAspect = options.fixedAspect;

        if (options.forceCanvas === undefined) {
            console.error('missing options.forceCanvas');
        }

        this.dpi = options.dpi;
        this.showFPS = options.showFPS; // true
        this.forceCanvas = options.forceCanvas; // true
        this.backgroundAnchor = options.backgroundAnchor;
        this.transitionSpeed = options.transitionSpeed;
        this.parallaxBgOffeset = options.parallaxBgOffeset;
        this.defaultGameWidth = options.defaultGameWidth;
        this.defaultGameHeight = options.defaultGameHeight;
        this.font = options.font;

        this.onPageVisibility = options.onPageVisibility;
        this.onResize = options.onResize;

        this.bottomBarView = bottomBarView;
        this.gameBg = gameBg;

        this.buttonOffset = 150;
        this.buttonPadding = 56;

        if (options.buttonOffset !== undefined) {
            this.buttonOffset = options.buttonOffset;
        }

        if (options.buttonPadding !== undefined) {
            this.buttonPadding = options.buttonPadding;
        }

        this.gameDimensions = {
            scale: 1,
            width: this.defaultGameWidth,
            height: this.defaultGameWidth
        };

        // History events
        window.onpopstate = function (e) {
            return _this.popHistory(e);
        };

        // document/window events
        window.SUGA.Device.resize(50, function (data) {
            return _this.sizeToFit(data);
        });
        window.SUGA.Device.pageVisibility(function (isVisible) {
            return _this.pageVisibility(isVisible);
        });
    }

    /**
     * Start rendering the canvas
     */


    _createClass(CanvasManager, [{
        key: 'renderCanvas',
        value: function renderCanvas() {
            this.canvasContainerEle = document.getElementById('canvas-container');
            this.canvasEle = document.getElementById('canvas');

            // stage options
            var rendererOptions = {
                view: this.canvasEle,
                transparent: true,
                autoResize: true,
                antialias: false,
                resolution: this.dpi,
                clearBeforeRender: false,
                forceCanvas: this.forceCanvas
            };

            var w = this.defaultGameWidth;
            var h = this.defaultGameHeight;

            // create renderer
            this.app = new PIXI.Application(w, h, rendererOptions);
            this.renderer = this.app.renderer;
            this.renderer.backgroundColor = 0xFF66CC;

            // add global ticker
            window.__ticker = this.app.ticker;

            // add stage
            this.outerStage = this.app.stage;
            this.innerStage = new PIXI.Container();
            this.outerStage.addChild(this.innerStage);

            // const bg = new PIXI.Graphics()
            // bg.beginFill(0x000000, 0.5)
            // bg.drawRect(0,0,w,h)
            // bg.endFill()
            // this.innerStage.addChild(bg)

            this.disableScrolling();

            // show FPS stat
            if (this.showFPS) {
                var stats = new _stats2.default();

                document.body.appendChild(stats.dom);
                this.app.ticker.add(function () {
                    return stats.update();
                });
            }

            this.addBackground(w, h);
            this.addUiBars();
        }

        /**
         * Shows the canvas ele.
         */

    }, {
        key: 'showCanvasEle',
        value: function showCanvasEle() {
            this.canvasEle.style.display = 'block';
        }

        /**
         * fits views to dimensions
         *
         * @return {Object}  Returns the new dimensions
         */

    }, {
        key: 'sizeToFit',
        value: function sizeToFit() {
            var rendererH = void 0;
            var rendererW = void 0;

            if (!this.canvasEle) {
                return this.gameDimensions;
            }

            // get viewport dimensions
            var vp = window.SUGA.Device.getViewport();

            var gW = this.defaultGameWidth;
            var gH = this.defaultGameHeight;

            // build ratios
            var widthGrowthRatio = vp.w / gW;
            var heightGrowthRatio = vp.h / gH;

            if (!this.fixedAspect) {
                // determine the ratio that fits
                if (heightGrowthRatio > widthGrowthRatio) {
                    rendererW = gW;
                    rendererH = Math.round(vp.h * gW / vp.w);
                } else {
                    rendererW = Math.round(vp.w * gH / vp.h);
                    rendererH = gH;
                }

                this.renderer.resize(rendererW, rendererH);

                this.canvasEle.style.width = vp.w + 'px';
                this.canvasEle.style.height = vp.h + 'px';

                this.centerBg(rendererW, rendererH);
            } else {
                var w = void 0;
                var h = void 0;

                // determine the ratio that fits
                if (heightGrowthRatio < widthGrowthRatio) {
                    w = Math.round(gW * heightGrowthRatio);
                    h = vp.h;
                } else {
                    h = Math.round(gH * widthGrowthRatio);
                    w = vp.w;
                }

                this.canvasEle.style.width = w + 'px';
                this.canvasEle.style.height = h + 'px';

                rendererW = gW;
                rendererH = gH;
            }

            this.canvasContainerEle.style.width = vp.w + 'px';
            this.canvasContainerEle.style.height = vp.h + 'px';

            // #set new gameDimensions
            var ratio = vp.w / rendererW;

            // center stage
            var x = Math.round((rendererW - gW) / 2);
            var y = Math.round((rendererH - gH) / 2);

            y = 0;
            this.innerStage.position.set(x, y);

            this.rendererWidth = rendererW;
            this.gameWidth = this.defaultGameWidth;

            this.gameDimensions = {
                scale: ratio,
                width: rendererW,
                height: rendererH,
                defaultWidth: this.defaultGameWidth,
                defaultHeight: this.defaultGameHeight,
                viewportWidth: vp.w,
                viewportHeight: vp.h,
                stage: {
                    x: this.innerStage.x,
                    y: this.innerStage.y
                }
            };

            if (this.bottomBarView) {
                this.bottomBarView.resize(rendererW, rendererH);
            }

            if (this.settingsView) {
                this.settingsView.resize(this.gameDimensions);
            }

            if (this.foregroundView && this.foregroundView.resize) {
                this.foregroundView.resize(this.gameDimensions);
            }

            if (this.backgroundView && this.backgroundView.resize) {
                this.backgroundView.resize(this.gameDimensions);
            }

            this.resizeViews(this.gameDimensions);

            this.onResize(this.gameDimensions);

            return this.gameDimensions;
        }

        /**
         * Place buttons for all views and overlays
         *
         * @param  {Object}  gameDimensions  The game dimensions
         */

    }, {
        key: 'resizeViews',
        value: function resizeViews(gameDimensions) {
            var allViews = this.views.concat(this.overlays);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = allViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var view = _step.value;

                    this.resizeView(view, gameDimensions);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'resizeView',
        value: function resizeView(view, gameDimensions) {
            if (view.resize) {
                view.resize(gameDimensions);
            }

            if (view.buttons) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = view.buttons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var button = _step2.value;

                        this.placeButton(button, gameDimensions.height);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        }

        /**
         * Reposition buttons Y axis
         *
         * @param  {PIXI.DisplayObject}  button  The button
         * @param  {Number}              height  The game height
         * @return {PIXI.DisplayObject}  The modified button
         */

    }, {
        key: 'placeButton',
        value: function placeButton(button, height) {
            if (!button) {
                return null;
            }

            button.y = Math.round(height - this.buttonOffset - this.buttonPadding * button.order);

            button.centerX();

            return button;
        }

        /**
         * Called when the page becomes visible or not
         *
         * @param  {boolean}  isVisible  Indicates if visible
         */

    }, {
        key: 'pageVisibility',
        value: function pageVisibility(isVisible) {
            if (isVisible) {
                this.app.start();
            } else {
                this.app.stop();
            }

            if (this.onPageVisibility) {
                this.onPageVisibility(isVisible);
            }
        }

        /**
         * Adds a background.
         *
         * @param  {Number}  w  width
         * @param  {Number}  h  height
         */

    }, {
        key: 'addBackground',
        value: function addBackground(w, h) {
            this.gameBg.anchor.set(this.backgroundAnchor.x, this.backgroundAnchor.y);
            this.outerStage.addChildAt(this.gameBg, 0);

            if (!this.fixedAspect) {
                this.centerBg(w, h);
            } else {
                // this.gameBg.width = w
                // this.gameBg.height = h
            }
        }

        /**
         * FIXME - Should be more abstracted
         * Adds a settings view.
         *
         * @param  {PIXI.Container}  settingsView  The settings view
         */

    }, {
        key: 'addSettingsView',
        value: function addSettingsView(settingsView) {
            this.settingsView = settingsView;
            this.outerStage.addChildAt(this.settingsView, 2);
        }

        /**
         * Adds user interface bars.
         */

    }, {
        key: 'addUiBars',
        value: function addUiBars() {
            this.outerStage.addChild(this.bottomBarView);
        }

        /**
         * Brings UI to top Z index
         */

    }, {
        key: 'bringUiToFront',
        value: function bringUiToFront() {
            if (this.settingsView) {
                this.settingsView.bringToFront();
            }
            this.bottomBarView.bringToFront();
        }

        /**
         * Adds a background view.
         *
         * @param  {PIXI.Sprite}    backgroundView  The background view
         * @param  {Function}  cb   Handler after background view is completed
         */

    }, {
        key: 'addBackgroundView',
        value: function addBackgroundView(backgroundView) {
            this.backgroundView = backgroundView;
            this.outerStage.addChildAt(this.backgroundView, 1);
        }

        /**
         * Adds a foreground view.
         *
         * @param  {PIXI.Sprite}    foregroundView  The foreground view
         * @param  {Function}  cb   Handler after foreground view is completed
         */

    }, {
        key: 'addForegroundView',
        value: function addForegroundView(foregroundView) {
            this.foregroundView = foregroundView;
            this.outerStage.addChildAt(this.foregroundView, 3);
        }

        /**
         * Center the background in the view
         *
         * @param  {Number}  width   The width
         * @param  {Number}  height  The height
         */

    }, {
        key: 'centerBg',
        value: function centerBg(width, height) {
            if (this.gameBg) {
                this.scaleToFill(width, height, this.gameBg, this.parallaxBgOffeset);

                this.gameBg.originalX = this.gameBg.position.x;
            }
        }

        /**
         * Scale sprite to fill canvas
         *
         * @param  {Number}       width            The width
         * @param  {Number}       height           The height
         * @param  {PIXI.Sprite}  sprite           The sprite
         * @param  {number}       parallaxPadding  The parallax padding
         */

    }, {
        key: 'scaleToFill',
        value: function scaleToFill(width, height, sprite, parallaxPadding) {
            var ratio = void 0;
            var rW = width + parallaxPadding;
            var rH = height;
            var bgW = sprite.texture.width;
            var bgH = sprite.texture.height;

            if (this.backgroundAnchor.x > 0) {
                rW = rW + parallaxPadding / this.backgroundAnchor.x;
            }

            var ratioW = rW / bgW;
            var ratioH = rH / bgH;

            var rAspect = rW / rH;
            var bgAspect = bgW / bgH;

            if (rAspect > bgAspect) {
                ratio = ratioW;
            } else {
                ratio = ratioH;
            }

            // center
            var x = Math.floor(rW * this.backgroundAnchor.x) - (rW - width - parallaxPadding) / 2;
            var y = Math.floor(rH * this.backgroundAnchor.y);

            sprite.scale.set(ratio, ratio);

            sprite.position.set(x, y);
        }
    }, {
        key: 'addView',
        value: function addView(view) {
            // put view on stage
            this.innerStage.addChild(view);

            // add view to our stack
            this.views.push(view);
        }

        /**
         * Pushes a view.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: 'pushView',
        value: function pushView(view) {
            var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!animate) {
                this.addView(view);
                return;
            }

            // prevent mulitple views in the overlay stack
            if (this.isViewShowing(view.name)) {
                return;
            }

            this._pushView(view);

            this.bringUiToFront();
        }

        /**
         * @private
         * Pushes a view.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: '_pushView',
        value: function _pushView(view) {
            var _this2 = this;

            var currentView = void 0;

            // only push one view at a time
            if (this.isTransitioning) {
                return;
            }
            this.isTransitioning = true;

            // if we are pushing an html page above the canvas
            if (view.isHTML) {
                window.SUGA.Reality.canShowRealityCheck(false);
            }

            // is this the root view
            var isRootView = this.views.length < 1;

            // fire event on view, if defined
            if (view.willShow) {
                view.willShow();
            }

            // if this will not be the first view in the stack
            // then we will animate its movement
            if (!isRootView) {
                // add a push state
                this.pushHistory(view.name);

                // put view just out of screen to the right
                view.x = this.rendererWidth;

                // get current view
                currentView = window.UTIL.lastItem(this.views);

                // make view non-interactive
                currentView.interactiveChildren = false;

                // make static snap shot of view
                // currentView.cacheAsBitmap = true

                // fire event on previous view, if defined
                if (currentView.willHide) {
                    currentView.willHide();
                }
            }

            // put view on stage
            this.innerStage.addChild(view);

            // add view to our stack
            this.views.push(view);

            // align stuff before we push it
            this.resizeView(view, this.gameDimensions);

            // dont animate if this the first view
            if (isRootView) {
                if (view.didShow) {
                    view.didShow();
                }

                this.isTransitioning = false;

                return;
            }

            // calculate parallax x offset
            var newX = this.gameBg.position.x - this.parallaxBgOffeset;

            // animate background parallax
            TweenMax.to(this.gameBg, this.transitionSpeed / 1000, { x: newX });

            // slide in new view
            var options = {
                x: 0,

                onUpdate: function onUpdate() {
                    if (view.showingProgress) {
                        var ratio = view.x / _this2.rendererWidth;
                        var domX = window.innerWidth * ratio;

                        view.showingProgress(domX);
                    }
                },

                onComplete: function onComplete() {
                    if (view.didShow) {
                        view.didShow();
                    }

                    _this2.isTransitioning = false;
                }
            };

            TweenMax.to(view, this.transitionSpeed / 1000, options);

            // slide out old view
            options = {

                x: -this.innerStage.x - this.gameWidth,

                onComplete: function onComplete() {
                    currentView.renderable = false;

                    if (currentView.didHide) {
                        currentView.didHide();
                    }
                }
            };

            TweenMax.to(currentView, this.transitionSpeed / 1000, options);
        }
    }, {
        key: 'removeView',
        value: function removeView() {
            var view = this.views.pop();
            view.removeSelf();
        }

        /**
         * Pop view from stack
         *
         * @return {Boolean}  did we pop a view
         */

    }, {
        key: 'popView',
        value: function popView() {
            var _this3 = this;

            var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this.isTransitioning || this.views.length < 1) {
                return false;
            }

            if (!animate) {

                this.removeView();
                return;
            }

            this.isTransitioning = true;

            var isRootView = this.views.length === 1;

            var view = this.views.pop();

            if (view.willHide) {
                view.willHide();
            }

            // if we are popping an html page
            if (view.isHTML) {
                window.SUGA.Reality.canShowRealityCheck(true);
            }

            var nextView = window.UTIL.lastItem(this.views);

            if (nextView) {
                if (nextView.willShow) {
                    nextView.willShow();
                }
                nextView.interactiveChildren = true;
                nextView.renderable = true;
            }
            // // nextView.cacheAsBitmap = false

            // if (this.views.length === 1)
            // {
            //     this.rootViewShown();
            // }

            if (isRootView) {
                if (view.didHide) {
                    view.didHide();
                }
                view.removeSelf();
                this.isTransitioning = false;

                return true;
            }

            // animate background parallax
            TweenMax.to(this.gameBg, this.transitionSpeed / 1000, { x: this.gameBg.originalX });

            // slide in new view
            var options = {
                x: this.rendererWidth,
                onUpdate: function onUpdate() {
                    if (view.showingProgress) {
                        var ratio = view.x / _this3.rendererWidth;
                        var domX = window.innerWidth * ratio;

                        view.showingProgress(domX);
                    }
                },
                onComplete: function onComplete() {
                    if (view.didHide) {
                        view.didHide();
                    }

                    view.removeSelf();
                }
            };

            TweenMax.to(view, this.transitionSpeed / 1000, options);

            // slide out old view
            options = {
                x: 0,
                onComplete: function onComplete() {
                    if (nextView.didShow) {
                        nextView.didShow();
                    }

                    _this3.isTransitioning = false;
                }
            };

            TweenMax.to(nextView, this.transitionSpeed / 1000, options);

            return true;
        }

        /**
         * Pop all views
         */

    }, {
        key: 'popAllViews',
        value: function popAllViews() {
            for (var i = this.views.length - 1; i >= 0; i -= 1) {
                this.popView();
            }
        }

        /**
         * Determines if view showing.
         *
         * @param  {boolean}  name  The name
         * @return {boolean}  True if view showing, False otherwise.
         */

    }, {
        key: 'isViewShowing',
        value: function isViewShowing(name) {
            var v = window.UTIL.lastItem(this.views);

            if (v && v.name && v.name === name) {
                return true;
            }

            return false;
        }

        /**
         * Pushes an overlay.
         *
         * @param  {PIXI.Container}  overlayView  The overlay view
         */

    }, {
        key: 'pushOverlay',
        value: function pushOverlay(overlayView) {
            // prevent mulitple views in the overlay stack
            if (this.isOverlayShowing(overlayView.name)) {
                return;
            }

            this._pushOverlay(overlayView);

            this.bringUiToFront();
        }

        /**
         * @private
         *
         * Pushes an overlay.
         *
         * @param  {PIXI.Container}  overlayView  The overlay view
         */

    }, {
        key: '_pushOverlay',
        value: function _pushOverlay(overlayView) {
            this.disableUserActions();

            var currentView = window.UTIL.lastItem(this.views);

            if (currentView) {
                currentView.interactiveChildren = false;
            }

            this.outerStage.addChild(overlayView);

            this.overlays.push(overlayView);

            // align stuff before we push it
            this.resizeView(overlayView, this.gameDimensions);
        }

        /**
         * Pop an overlay
         *
         * @param  {boolean}  suppressEvents  The suppress events
         * @return {boolean}  { description_of_the_return_value }
         */

    }, {
        key: 'popOverlay',
        value: function popOverlay(suppressEvents) {
            var _this4 = this;

            if (!suppressEvents) {
                suppressEvents = false;
            }

            if (this.overlays.length < 1) {
                return false;
            }

            var isLastOverlay = this.overlays.length === 1;

            var view = window.UTIL.lastItem(this.views);

            if (isLastOverlay) {
                if (view.willShow) {
                    view.willShow();
                }
            }

            var overlayView = this.overlays.pop();

            if (!suppressEvents) {
                this.enableUserActions();
            }

            var currentView = window.UTIL.lastItem(this.views);

            clearTimeout(this.overlayTimer);
            currentView.interactiveChildren = true;
            currentView.filters = null;

            overlayView.hide(function () {
                _this4.outerStage.removeChild(overlayView);

                if (isLastOverlay && view.didShow) {
                    view.didShow();
                }
            });

            return true;
        }

        /**
         * Pup all the overlays
         *
         * @param  {Boolean}  suppressEvents  The suppress events
         */

    }, {
        key: 'popAllOverlays',
        value: function popAllOverlays(suppressEvents) {
            for (var i = this.views.length - 1; i >= 0; i -= 1) {
                this.popOverlay(suppressEvents);
            }
        }

        /**
         * Determines if overlay showing.
         *
         * @param  {String}  name  The name
         * @return {Boolean}  True if overlay showing, False otherwise.
         */

    }, {
        key: 'isOverlayShowing',
        value: function isOverlayShowing(name) {
            var o = window.UTIL.lastItem(this.overlays);

            if (o && o.name && o.name === name) {
                return true;
            }

            return false;
        }

        /**
         * Determines if it has overlay.
         *
         * @return {boolean}  True if has overlay, False otherwise.
         */

    }, {
        key: 'hasOverlay',
        value: function hasOverlay() {
            return this.overlays.length > 0;
        }

        /**
         * Pushes an initialize history.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: 'pushInitHistory',
        value: function pushInitHistory(view) {
            this.historyStates.push(view);

            history.pushState(this.historyStates, 'sub-menu', null);
        }

        /**
         * Pushes a history.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: 'pushHistory',
        value: function pushHistory(view) {
            this.historyStates.push(view);

            history.replaceState(this.historyStates, 'sub-menu', null);
        }

        /**
         * Pop a history
         */

    }, {
        key: 'popHistory',
        value: function popHistory() {
            if (this.historyStates.length > 1) {
                this.historyStates.pop();

                window.history.pushState(this.historyStates, 'sub-menu', null);
                this.popView();

                return;
            }

            window.history.back();
        }

        /**
         * Navigate back
         */

    }, {
        key: 'back',
        value: function back() {
            this.popHistory();
        }

        /**
         * Force a real back navigation
         */

    }, {
        key: 'forceBack',
        value: function forceBack() {
            this.historyStates = [];

            window.history.back();
        }

        /**
         * User hit space bar
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'spacebarHit',
        value: function spacebarHit(e) {
            if (this.isTransitioning) {
                return;
            }

            e.preventDefault();

            var tmp = this.views.concat(this.overlays);

            for (var i = tmp.length - 1; i >= 0; i--) {

                var view = tmp[i];

                if (view && view.spacebarHit) {
                    view.spacebarHit(e);

                    return;
                }
            }
        }

        /**
         * Enables the user actions.
         */

    }, {
        key: 'enableUserActions',
        value: function enableUserActions() {
            var _this5 = this;

            this.bottomBarView.enableNavigationButtons();

            this.innerStage.interactiveChildren = true;

            document.onkeydown = function (e) {
                e = e || window.event;

                if (e.keyCode === 32) {
                    _this5.spacebarHit(e);
                }
            };
        }

        /**
         * Disables the user actions.
         */

    }, {
        key: 'disableUserActions',
        value: function disableUserActions() {
            this.innerStage.interactiveChildren = false;
            this.bottomBarView.disableNavigationButtons();
            document.onkeydown = null;
        }

        /**
         * Enables the scrolling.
         */

    }, {
        key: 'enableScrolling',
        value: function enableScrolling() {
            this.renderer.plugins.interaction.autoPreventDefault = false;

            this.canvasEle.style['touch-action'] = 'pan-y';
        }

        /**
         * Disables the scrolling.
         */

    }, {
        key: 'disableScrolling',
        value: function disableScrolling() {
            this.renderer.plugins.interaction.autoPreventDefault = true;

            this.canvasEle.style['touch-action'] = 'none';
        }
    }]);

    return CanvasManager;
}();

exports.default = CanvasManager;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function extend(dpi) {
    function bringToFront() {
        if (this.parent) {
            var parent = this.parent;


            parent.removeChild(this);
            parent.addChild(this);
        }
    }
    window.PIXI.DisplayObject.prototype.bringToFront = bringToFront;

    function zSort() {
        function sortIt(a, b) {
            if (a.z < b.z) {
                return -1;
            }
            if (a.z > b.z) {
                return 1;
            }

            return 0;
        }

        this.children = this.children.sort(sortIt);
    }
    window.PIXI.DisplayObject.prototype.zSort = zSort;

    function getByTag(tag) {
        if (!this.children || !this.children.length) {
            return null;
        }

        var objects = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Array.from(this.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var child = _step.value;

                if (child.tag === tag) {
                    objects.push(child);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (objects.length > 1) {
            return objects;
        }

        if (objects.length === 1) {
            return objects[0];
        }

        return null;
    }
    window.PIXI.DisplayObject.prototype.getByTag = getByTag;

    function removeAllChildren() {
        while (this.children[0]) {
            this.children[0].removeChildren();
            this.removeChild(this.children[0]);
        }
    }
    window.PIXI.DisplayObject.prototype.removeAllChildren = removeAllChildren;

    function removeSelf() {
        if (this.parent) {
            this.parent.removeChild(this);
        }
    }
    window.PIXI.DisplayObject.prototype.removeSelf = removeSelf;

    function centerX(width) {
        if (!width) {
            if (this.parent) {
                width = this.parent.width;
            } else {
                return;
            }
        }

        var anchorX = 0;

        if (this.anchor) {
            anchorX = this.anchor.x;
        }

        this.position.x = Math.floor((width - this.width) / 2 + this.width * anchorX);
    }
    window.PIXI.Container.prototype.centerX = centerX;

    function centerY(height) {
        if (!height) {
            if (this.parent) {
                height = this.parent.height;
            } else {
                return;
            }
        }

        var anchorY = 0;

        if (this.anchor) {
            anchorY = this.anchor.y;
        }

        this.position.y = Math.floor((height - this.height) / 2 + this.width * anchorY);
    }
    window.PIXI.Container.prototype.centerY = centerY;

    function centerAtPoint(x, y) {
        this.x = Math.round(x - this.width / 2) + 1;

        this.y = Math.round(y - this.height / 2);
    }
    window.PIXI.Container.prototype.centerAtPoint = centerAtPoint;

    function clarify() {
        this.resolution = dpi;

        this.updateText();
    }
    window.PIXI.Text.prototype.clarify = clarify;

    function sizeToFit(width, scaleUp) {
        if (scaleUp === null || scaleUp === undefined) {
            scaleUp = true;
        }

        var w = this.width;
        var h = this.height;

        while (this.width > width) {
            this.style.fontSize--;
        }

        var ratio = this.width / w;
        var change = h - this.height * ratio;

        this.style.lineHeight -= change;
    }
    window.PIXI.Text.prototype.sizeToFit = sizeToFit;

    function timer(secs, cb) {
        var state = {
            stop: false,
            progress: 0
        };

        var ticker = function ticker(delta) {
            state.progress += delta;
            var elapsed = state.progress / 60;

            if (state.stop || elapsed > secs) {
                window.PIXI.ticker.shared.remove(ticker);
                cb();
            }
        };

        window.PIXI.ticker.shared.add(ticker);

        state.clear = function () {
            window.PIXI.ticker.shared.remove(ticker);
            state.stop = true;
        };

        return state;
    }

    window.PIXI.setTimeout = timer;
}

exports.extend = extend;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _buttons = __webpack_require__(11);

var _buttons2 = _interopRequireDefault(_buttons);

var _autoplayBar = __webpack_require__(9);

var _autoplayBar2 = _interopRequireDefault(_autoplayBar);

var _counter = __webpack_require__(12);

var _counter2 = _interopRequireDefault(_counter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Bottom bar visualization of the data that model contains.
 */
var BottomBarView = function (_PIXI$Container) {
    _inherits(BottomBarView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  gameModel        The game model
     * @param  {CurrencyManager}  currencyManager  The currency manager
     */
    function BottomBarView(gameModel, options, currencyManager) {
        _classCallCheck(this, BottomBarView);

        var _this = _possibleConstructorReturn(this, (BottomBarView.__proto__ || Object.getPrototypeOf(BottomBarView)).call(this));

        _this.w = 360;
        _this.h = 45;
        _this.bgAlpha = options.bgAlpha;
        _this.winAmount = 0;
        _this.totalPaid = 0;
        _this.textYOffset = 18;
        _this.textGap = 10;
        _this.showTickets = false;
        _this.infoGroupWidth = 80;
        _this.interactive = true;
        _this.counterTween = null;

        if (options.infoGroupWidth) {
            _this.infoGroupWidth = options.infoGroupWidth;
        }

        if (options.bgAlpha === undefined) {
            console.error('missing options.bgAlpha');
        }

        _this.gameModel = gameModel;

        var ticketsLabel = __t.str('Tickets left').toUpperCase();
        var betlabel = __t.str('Bet').toUpperCase();
        var balanceLabel = __t.str('Balance').toUpperCase();
        var totalLabel = __t.str('Total paid').toUpperCase();

        var letterSpacing = _this.determineLetterSpacing(2, 10, [ticketsLabel, betlabel, balanceLabel, totalLabel]);

        _this.labelStyle = {
            fontFamily: _this.gameModel.font,
            fontSize: 9,
            fontWeight: 400,
            fill: '#FFFFFF',
            wordWrap: false,
            lineHeight: 15,
            padding: 2,
            letterSpacing: letterSpacing
        };

        _this.valueStyle = {
            fontFamily: _this.gameModel.font,
            fontSize: 12,
            fontWeight: 400,
            fill: _this.gameModel.primaryColor,
            wordWrap: false,
            lineHeight: 15,
            padding: 2
        };

        _this.currencyManager = currencyManager;

        _this._setDimension(_this.gameModel.gameWidth, _this.gameModel.gameHeight);

        _this.showTickets = _this.gameModel.isBasketMode();
        _this.showHomeButton = _this.gameModel.showHomeButton;
        _this.showHelpButton = _this.gameModel.showHelpButton;

        _this.addAutoplayBar();
        _this.addBg();
        _this.addInfoContainer();

        var buttonOpts = {
            mute: gameModel.getMute(),
            primaryColor: gameModel.primaryColor,
            showHelpButton: gameModel.showHelpButton,
            showHomeButton: gameModel.showHomeButton,
            helpButtonHandler: options.onHelpClick,
            homeButtonHandler: options.onHomeClick,
            muteButtonHandler: options.onMuteClick,
            settingsButtonHandler: options.onSettingsClick,
            isBasketMode: _this.gameModel.isBasketMode(),
            fullscreenEnabled: options.fullscreenEnabled,
            fullscreenButtonHandler: options.onFullscreenClick
        };

        _this.buttonContainer = new _buttons2.default(buttonOpts);
        _this.addChild(_this.buttonContainer);

        var ticketX = 0;

        // prebought tickets
        if (_this.showTickets) {
            window.SUGA.Event.on('tickets', function (amount) {
                return _this.updateTicketCount(amount);
            });
            _this.addTickets(ticketsLabel, ticketX, _this.gameModel.getRoundsLeft());
            ticketX += _this.infoGroupWidth;
        }

        // buy from wallet
        else if (!_this.gameModel.dontShowStake) {

                var amount = _this.gameModel.getStake();

                try {
                    amount = _this.currencyManager.localize(amount, true, true);
                } catch (e) {
                    amount = '';
                }

                _this.addTickets(betlabel, ticketX, amount, options.onSettingsClick);
                ticketX += _this.infoGroupWidth;
            }

        if (options.showTotalPaid) {
            // total paid
            _this.addTotalPaid(totalLabel, ticketX);
            ticketX += _this.infoGroupWidth;
        }

        // balance
        if (!_this.gameModel.dontShowBalance) {
            _this.addBalance(balanceLabel, _this.gameModel.getBalance(), ticketX);
            window.SUGA.Event.on('balance', function (amount) {
                return _this.updateBalance(amount);
            });
            ticketX += _this.infoGroupWidth;
        }

        _this.infoContainerXOffset = ticketX;
        return _this;
    }

    /**
     * Sets the dimension.
     *
     * @param  {Number}  viewportWidth   The viewport width
     * @param  {Number}  viewportHeight  The viewport height
     */


    _createClass(BottomBarView, [{
        key: '_setDimension',
        value: function _setDimension(viewportWidth, viewportHeight) {
            this.w = viewportWidth;
            var y = viewportHeight - this.h;

            this.position.y = y;
        }

        /**
         * Adds a background.
         */

    }, {
        key: 'addBg',
        value: function addBg() {
            this.bg = new PIXI.Graphics();
            this.bg.beginFill(0x000000);
            this.bg.drawRect(0, 0, this.w, this.h);
            this.bg.endFill();
            this.bg.alpha = this.bgAlpha;
            this.addChildAt(this.bg, 1);
        }

        /**
         * Adds an information container.
         */

    }, {
        key: 'addInfoContainer',
        value: function addInfoContainer() {
            this.infoContainer = new PIXI.Container();
            this.addChild(this.infoContainer);
            this.infoContainer.x = this.width - this.infoGroupWidth * 2;
        }

        /**
         * Adds tickets.
         *
         * @param  {String}         label   The label
         * @param  {Number}         x       The x position
         * @param  {(PIXI|string)}  amount  The amount
         */

    }, {
        key: 'addTickets',
        value: function addTickets(label, x, amount, handler) {
            if (amount === null || amount === undefined) {
                amount = '';
            }

            var y = this.textYOffset;

            var container = new PIXI.Container();

            container.x = x;
            this.infoContainer.addChild(container);

            var bg = new PIXI.Graphics();

            bg.beginFill(0xFFCC66);
            bg.drawRect(0, 0, this.infoGroupWidth, this.h);
            bg.endFill();
            bg.alpha = 0;
            container.addChild(bg);

            if (!this.ticketLabel) {
                this.ticketLabel = new PIXI.Text(label, this.labelStyle);
            }

            container.addChild(this.ticketLabel);
            this.ticketLabel.centerX();
            this.ticketLabel.y = 11;
            this.ticketLabel.clarify();

            y = y + this.textGap;

            this.ticketValue = new PIXI.Text('' + amount, this.valueStyle);
            container.addChild(this.ticketValue);
            this.ticketValue.centerX();
            this.ticketValue.y = 21;
            this.ticketValue.clarify();

            if (!this.gameModel.isBasketMode() && this.settingsButtonHandler) {
                container.interactive = true;
                container.buttonMode = true;
                container.pointerup = function () {
                    return handler();
                };
            }
        }

        /**
         * Updates the ticket count
         *
         * @param  {Number}  amount  The amount
         */

    }, {
        key: 'updateTicketCount',
        value: function updateTicketCount(amount) {
            if (!this.gameModel.isBasketMode()) return;
            this.ticketValue.text = '' + amount;
        }
    }, {
        key: 'updateStake',
        value: function updateStake(stake) {
            if (this.gameModel.isBasketMode()) return;
            var amount = this.currencyManager.localize(stake, true, true);

            this.ticketValue.text = '' + amount;
            this.ticketValue.centerX();
        }

        /**
         * Adds a balance.
         *
         * @param  {Number}  amount  The amount
         * @param  {Number}  x       The x position
         */

    }, {
        key: 'addBalance',
        value: function addBalance(label, amount, x) {
            var _this2 = this;

            var y = this.textYOffset;

            var container = new PIXI.Container();

            container.x = x;
            this.infoContainer.addChild(container);

            var bg = new PIXI.Graphics();

            bg.beginFill(0xFFCC66);
            bg.drawRect(0, 0, this.infoGroupWidth, this.h);
            bg.endFill();
            bg.alpha = 0;
            container.addChild(bg);

            if (!this.balanceLabel) {
                this.balanceLabel = new PIXI.Text(label, this.labelStyle);
            }
            container.addChild(this.balanceLabel);
            this.balanceLabel.centerX();
            this.balanceLabel.y = 11;
            this.balanceLabel.clarify();

            y = y + this.textGap;

            var formatter = function formatter(amount) {
                if (amount === null || amount === undefined || amount < 0) {
                    return '';
                } else {
                    return _this2.currencyManager.localize(amount, true, true);
                }
            };

            var currencyMultiplier = this.gameModel.getCurrencyMultiplier();

            this.balanceValue = new _counter2.default('', this.valueStyle, formatter, currencyMultiplier, 1000);
            container.addChild(this.balanceValue);
            this.balanceValue.centerX();
            this.balanceValue.y = 21;
            this.balanceValue.clarify();

            this.setBalance(amount);
        }

        /**
         * Finish balance animation instantly
         */

    }, {
        key: 'instantFinishBalance',
        value: function instantFinishBalance() {

            return this.balanceValue.instantFinish();
        }

        /**
         * { function_description }
         *
         * @param  {Number}    newBalance  The new balance
         * @param  {Function}  cb          { parameter_description }
         */

    }, {
        key: 'updateBalance',
        value: function updateBalance(newBalance, cb) {
            if (!this.balanceValue) return;

            var newCount = {
                animate: newBalance.animate,
                count: newBalance.balance
            };
            return this.balanceValue.updateCount(newCount, cb);
        }

        /**
         * Sets the balance.
         *
         * @param  {(number|string)}  amount  The amount
         * @return {boolean}          { description_of_the_return_value }
         */

    }, {
        key: 'setBalance',
        value: function setBalance(amount) {
            if (!this.balanceValue) return;
            return this.balanceValue.setCount(amount);
        }

        /**
         * Center's the balance label
         */

    }, {
        key: 'centerBalance',
        value: function centerBalance() {
            if (!this.balanceValue) return;
            return this.balanceValue.centerX();
        }

        /**
         * Adds a balance.
         *
         * @param  {Number}  amount  The amount
         * @param  {Number}  x       The x position
         */

    }, {
        key: 'addTotalPaid',
        value: function addTotalPaid(label, x) {
            var _this3 = this;

            var y = this.textYOffset;

            var container = new PIXI.Container();
            container.x = x;
            this.infoContainer.addChild(container);

            var bg = new PIXI.Graphics();

            bg.beginFill(0xCCFF66);
            bg.drawRect(0, 0, this.infoGroupWidth, this.h);
            bg.endFill();
            bg.alpha = 0;
            container.addChild(bg);

            if (!this.totalPaidLabel) {
                this.totalPaidLabel = new PIXI.Text(label, this.labelStyle);
            }
            container.addChild(this.totalPaidLabel);
            this.totalPaidLabel.centerX();
            this.totalPaidLabel.y = 11;
            this.totalPaidLabel.clarify();

            y = y + this.textGap;

            var formatter = function formatter(amount) {
                if (amount === null || amount === undefined || amount < 0) {
                    return '';
                } else {
                    return _this3.currencyManager.localize(amount, true, true);
                }
            };

            var currencyMultiplier = this.gameModel.getCurrencyMultiplier();

            this.totalPaidValue = new _counter2.default('-', this.valueStyle, formatter, currencyMultiplier, 1000);
            container.addChild(this.totalPaidValue);
            this.totalPaidValue.centerX();
            this.totalPaidValue.y = 21;
            this.totalPaidValue.clarify();
        }
    }, {
        key: 'updateTotalPaid',
        value: function updateTotalPaid(amount, cb) {
            if (amount <= 0) return;

            this.totalPaid += amount;

            var newCount = {
                animate: true,
                count: this.totalPaid
            };

            return this.totalPaidValue.updateCount(newCount, cb);
        }
    }, {
        key: 'setTotalPaid',
        value: function setTotalPaid(amount) {

            return this.totalPaidValue.setCount(amount);
        }
    }, {
        key: 'resetTotalPaid',
        value: function resetTotalPaid() {

            this.totalPaidValue.instantFinish();
            this.totalPaid = 0;
            this.setTotalPaid(0);
        }
    }, {
        key: 'addAutoplayBar',
        value: function addAutoplayBar() {
            var options = {
                width: this.w,
                height: 21,
                font: this.gameModel.font,
                primaryColor: this.gameModel.primaryColor
            };

            this.autoplayBar = new _autoplayBar2.default(options);
            this.addChild(this.autoplayBar);
        }
    }, {
        key: 'updateAutoplay',
        value: function updateAutoplay(round, rounds) {
            this.autoplayBar.updateAutoplay(round, rounds);
        }
    }, {
        key: 'autoplayClearReason',
        value: function autoplayClearReason() {
            this.autoplayBar.autoplayClearReason();
        }
    }, {
        key: 'autoplayStopped',
        value: function autoplayStopped(reason) {
            this.autoplayBar.autoplayStopped(reason);
        }
    }, {
        key: 'toggleSettings',
        value: function toggleSettings(isOpen) {
            this.buttonContainer.toggleSettings(isOpen);
        }

        /**
         * Enables the navigation buttons.
         */

    }, {
        key: 'enableNavigationButtons',
        value: function enableNavigationButtons() {
            this.buttonContainer.enableNavigationButtons();
        }

        /**
         * Disables the navigation buttons.
         */

    }, {
        key: 'disableNavigationButtons',
        value: function disableNavigationButtons() {
            this.buttonContainer.disableNavigationButtons();
        }

        /**
         * Display the sound on button
         */

    }, {
        key: 'displaySoundOnButton',
        value: function displaySoundOnButton() {
            this.buttonContainer.displaySoundOnButton();
        }

        /**
         * Display the Sound off button
         */

    }, {
        key: 'displaySoundOffButton',
        value: function displaySoundOffButton() {
            this.buttonContainer.displaySoundOffButton();
        }

        /**
         * On resize
         *
         * @param  {Number}  rendererW  The renderer w
         * @param  {Number}  rendererH  The renderer h
         */

    }, {
        key: 'resize',
        value: function resize(rendererW, rendererH) {
            this._setDimension(rendererW, rendererH);
            this.removeChild(this.bg);
            this.bg = null;
            this.addBg();

            this.infoContainer.x = rendererW - this.infoContainerXOffset;
            this.infoContainer.bringToFront();

            this.autoplayBar.resize(rendererW);
        }
    }, {
        key: 'determineLetterSpacing',
        value: function determineLetterSpacing(defaultSpacing, maxLength, array) {
            var tmp = 0;
            array.forEach(function (label) {
                if (label.length > tmp) {
                    tmp = label.length;
                }
            });

            if (tmp <= maxLength) {
                return defaultSpacing;
            }

            return defaultSpacing * (maxLength / tmp);
        }
    }]);

    return BottomBarView;
}(PIXI.Container);

exports.default = BottomBarView;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Help visualization of the data that model contains.
 */
var HelpView = function (_PIXI$Container) {
    _inherits(HelpView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  size     The canvas size data
     * @param  {Object}  options  The options {helpUrl: , font:}
     */
    function HelpView(size, options) {
        _classCallCheck(this, HelpView);

        var _this = _possibleConstructorReturn(this, (HelpView.__proto__ || Object.getPrototypeOf(HelpView)).call(this));

        _this.name = 'HelpView';
        _this.visible = false;
        _this.isHTML = true;
        _this.balanceBarHeight = options.balanceBarHeight;
        _this.canClick = false;
        _this.isShowing = false;

        _this.backButtonHandler = options.onBackClick;

        _this.style = {
            fontFamily: options.font,
            fontSize: 22,
            fill: '#FFFFFF',
            align: 'center',
            lineHeight: 32
        };

        _this.addIframe(size, options.helpUrl);

        _this._size = size;
        return _this;
    }

    _createClass(HelpView, [{
        key: 'setBalanceBarHeight',
        value: function setBalanceBarHeight(h) {
            this.balanceBarHeight = h;
            this.resize(this._size);
        }

        /**
         * Animates the windows position when showing and hiding
         *
         * @param  {Nuber}  progress  The progress
         */

    }, {
        key: 'showingProgress',
        value: function showingProgress(progress) {
            progress = Math.round(progress);

            this.container.style.left = progress + 'px';
        }

        /**
         * Adds an iframe.
         *
         * @param  {Object}  size     The canvas size data
         * @param  {String}  helpUrl  The help url
         */

    }, {
        key: 'addIframe',
        value: function addIframe(size, helpUrl) {
            var _this2 = this;

            var vp = window.SUGA.Device.getViewport();
            var w = vp.w;


            this.iframe = document.createElement('iframe');
            this.iframe.src = helpUrl;
            // this.iframe.style.width = `${w}px`;

            this.container = document.getElementById('help-container');
            this.container.style.left = vp.w + 'px';
            this.container.style.bottom = Math.floor(this.balanceBarHeight * size.scale) + 'px';
            this.container.style.display = 'none';
            this.container.style.width = w + 'px';
            this.container.appendChild(this.iframe);

            // listen for the iframes button click
            var receiveMessage = function receiveMessage(event) {
                if (event.data === 'close-help') {
                    _this2.buttonClick();
                }
            };

            window.addEventListener('message', receiveMessage, false);
        }

        /**
         * On button click
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'buttonClick',
        value: function buttonClick(e) {
            if (!this.canClick) {
                return;
            }

            this.backButtonHandler();
            if (e) {
                e.stopPropagation();
            }
        }

        /**
         * Called on resize
         *
         * @param  {Object}  size  The size data
         */

    }, {
        key: 'resize',
        value: function resize(size) {
            if (!this.iframe) {
                return;
            }

            var w = size.viewportWidth;

            this.prevWidth = w;

            // this.iframe.style.width = `${w}px`;
            this.container.style.width = w + 'px';

            this.container.style.bottom = Math.floor(this.balanceBarHeight * size.scale) + 'px';

            this._size = size;
        }

        /**
         * Called before showing view
         */

    }, {
        key: 'willShow',
        value: function willShow() {
            this.container.style.display = 'block';
        }

        /**
         * Called after showing view
         */

    }, {
        key: 'didShow',
        value: function didShow() {
            this.canClick = true;
            this.isShowing = true;
        }

        /**
         * Called before hiding view
         */

    }, {
        key: 'willHide',
        value: function willHide() {
            this.canClick = false;
            this.isShowing = false;
        }

        /**
         * Called after hiding view
         */

    }, {
        key: 'didHide',
        value: function didHide() {
            this.container.style.display = 'none';
        }
    }]);

    return HelpView;
}(PIXI.Container);

exports.default = HelpView;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Menu visualization of the data that model contains.
 */
var MenuView = function (_PIXI$Container) {
    _inherits(MenuView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}           size             The size
     * @param  {Object}           options          The options
     * @param  {GameModel}        gameModel        The game model
     * @param  {ThemeImageModel}  themeImageModel  The theme image model
     */
    function MenuView(size, options, gameModel, themeImageModel, themeView) {
        _classCallCheck(this, MenuView);

        var _this = _possibleConstructorReturn(this, (MenuView.__proto__ || Object.getPrototypeOf(MenuView)).call(this));

        console.warn('this will be deprecated. move this view into your game');

        _this.canClick = false;
        _this.isRootView = true;
        _this.textY = 170;
        _this.buttons = [];

        _this.buttonHandler = options.buttonHandler;
        _this.showBuyMore = options.showBuyMore;
        _this.gameModel = gameModel;

        _this.addLogo(options.logoUrl, options.logoY, options.logoZ, size.defaultWidth);
        _this.addTagline(options.introText, options.introTextStyle, size.defaultWidth, size.height);

        var btnImages = {
            bgUrl: themeImageModel.btnBgImage,
            normalUrl: themeImageModel.btnNormalImage,
            hoverUrl: themeImageModel.btnHoverImage
        };

        _this.addPlayButton(btnImages);

        _this.addThemeView(themeView);

        _this.zSort();

        setTimeout(function () {
            _this.playButton.reset();

            if (options.isOutOfTickets && !_this.shouldShowBuyMore) {
                return _this.playButton.disable();
            }

            return _this.playButton.enable();
        }, 1);
        return _this;
    }

    /**
     * Adds a logo.
     *
     * @param  {String}  url     The logo url
     * @param  {Number}  logoY   The logo y position
     * @param  {Number}  width   The width
     */


    _createClass(MenuView, [{
        key: 'addLogo',
        value: function addLogo(url, logoY, logoZ, width) {
            if (this.logo) {
                this.logo.visible = true;

                return;
            }

            this.logo = new PIXI.Sprite.fromImage(url);

            this.logo.x = Math.round((width - this.logo.width) / 2);
            this.logo.y = logoY;
            this.logo.z = logoZ;

            this.addChild(this.logo);
        }

        /**
         * Adds a tagline.
         *
         * @param  {String}  introText  The intro text
         * @param  {String}  style      The intro text style
         * @param  {Number}  width      The width
         * @param  {Number}  height     The height
         */

    }, {
        key: 'addTagline',
        value: function addTagline(introText, style, width, height) {
            this.tagline = new PIXI.Text(introText, style);
            this.tagline.x = (width - this.tagline.width) / 2;
            this.tagline.y = height - this.textY;
            this.tagline.z = 3;
            this.addChild(this.tagline);

            this.tagline.clarify();
        }

        /**
         * Adds a theme view. e.g. A Specific caharacter
         *
         * @param  {ThemeImageModel}  themeImageModel  The theme image model
         */

    }, {
        key: 'addThemeView',
        value: function addThemeView(themeView) {
            this.themeView = themeView;

            this.addChild(this.themeView);
        }

        /**
         * Adds a play button.
         *
         * @param  {Object}  buttonImages  The button images
         */

    }, {
        key: 'addPlayButton',
        value: function addPlayButton(buttonImages) {
            var _this2 = this;

            if (this.playButton) {
                return;
            }

            this.playButton = new _button2.default(buttonImages);
            this.playButton.z = 3;
            this.playButton.tapped = function (e) {
                return _this2.playButtonClick(e);
            };
            this.playButton.order = 0;

            this.addChild(this.playButton);

            this.buttons.push(this.playButton);
        }

        /**
         * Play button click event handler
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'playButtonClick',
        value: function playButtonClick(e) {
            window.SUGA.Sound.play('spin-button');
            this.playButton.disable();

            // do we need to show it
            if (window.SUGA.Reality.canShowRealityCheck(true)) {
                return;
            }

            this.buttonHandler();

            if (e) {
                e.stopPropagation();
            }
        }

        /**
         * Spacbar press handler
         */

    }, {
        key: 'spacebarHit',
        value: function spacebarHit() {
            if (this.playButton.isEnabled) {
                this.playButtonClick();
            }
        }

        /**
         * Called when view will show
         */

    }, {
        key: 'willShow',
        value: function willShow() {
            if (this.gameModel.isOutOfTickets() && !this.showBuyMore) {
                this.playButton.disable();
            }

            this.playButton.enable();
        }

        /**
         * Called on resize
         *
         * @param  {Object}  size  The new size data
         */

    }, {
        key: 'resize',
        value: function resize(size) {
            if (this.tagline) {
                this.tagline.y = size.height - this.textY;
            }

            if (this.themeView) {
                this.themeView.y = size.height - this.themeView.height;
            }
        }
    }]);

    return MenuView;
}(PIXI.Container);

exports.default = MenuView;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Notification visualization of the data that model contains.
 */
var NotificationView = function (_PIXI$Container) {
    _inherits(NotificationView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  size     The size
     * @param  {Object}  options  The options
     */
    function NotificationView(size, options) {
        _classCallCheck(this, NotificationView);

        var _this = _possibleConstructorReturn(this, (NotificationView.__proto__ || Object.getPrototypeOf(NotificationView)).call(this));

        _this.overlayAlpha = 0.9;
        _this.buttons = [];
        _this.offset = 100;
        _this.padding = 56;

        if (options.padding !== undefined) {
            _this.padding = options.padding;
        }

        _this.style = {
            fontSize: 28,
            fontWeight: 100,
            fill: '#FFFFFF',
            align: 'center',
            lineHeight: 32,
            wordWrap: true,
            wordWrapWidth: 280
        };

        _this.msgStyle = {
            fontSize: 13,
            fontWeight: 100,
            align: 'center',
            fill: '#FFFFFF',
            lineHeight: 17,
            wordWrap: true,
            wordWrapWidth: 280
        };

        _this.buttonTextStyle = {
            fontSize: 13,
            fontWeight: 100,
            align: 'center',
            fill: '#FFFFFF',
            lineHeight: 17,
            wordWrap: true,
            wordWrapWidth: 280
        };

        _this.style.fontFamily = options.font;
        _this.msgStyle.fontFamily = options.font;
        _this.buttonTextStyle.fontFamily = options.font;

        _this.font = options.font;
        _this.primaryColor = options.primaryColor;
        _this.defaultWidth = size.defaultWidth;

        _this.showCashierButton = options.showCashierButton;
        _this.showHistoryButton = options.showHistoryButton;
        _this.showHomeButton = options.showHomeButton;
        _this.showBuyMoreButton = options.showBuyMoreButton;

        _this.buttonImages = options.buttonImages;

        _this.addBg(size);

        _this.inner = new PIXI.Container();
        _this.inner.position.set(size.stage.x, size.stage.y);
        _this.addChild(_this.inner);
        return _this;
    }

    /**
     * Adds a background.
     *
     * @param  {Object}  size  The size
     */


    _createClass(NotificationView, [{
        key: 'addBg',
        value: function addBg(size) {
            this.overlay = new PIXI.Graphics();
            this.overlay.beginFill(0x000000);
            this.overlay.drawRect(0, 0, size.width, size.height);
            this.overlay.endFill();
            this.overlay.alpha = 0;

            this.addChildAt(this.overlay, 0);
        }

        /**
         * Setups the view
         *
         * @param  {String}  title    The title
         * @param  {String}  message  The message
         * @param  {Array}  actions  The actions
         * @param  {Object}  size     The size
         */

    }, {
        key: 'setup',
        value: function setup(title, message, actions, size, cb) {
            this.addText(title, message, size);
            this.addButtons(actions, size);
            this.resize(size);
            this.showOverlay(function () {
                cb();
            });
        }

        /**
         * Hides view
         *
         * @param  {Function}  cb  Completion Handler
         */

    }, {
        key: 'hide',
        value: function hide(cb) {
            var _this2 = this;

            // next tick
            setTimeout(function () {
                if (_this2.text) {
                    _this2.text.visible = false;
                }

                _this2.removeButtons();

                _this2.hideOverlay(function () {
                    if (cb) {
                        cb();
                    }
                });
            }, 1);
        }

        /**
         * Adds text.
         *
         * @param  {String}  title  The title
         * @param  {String}  msg    The message
         * @param  {Object}  size   The size
         */

    }, {
        key: 'addText',
        value: function addText(title, msg, size) {
            if (this.text) {
                this.updateText(title, msg, size);
                this.text.visible = true;

                return;
            }

            this.text = new PIXI.Container();
            this.inner.addChild(this.text);

            title = __t.str(title);
            msg = __t.str(msg);

            this.titleText = new PIXI.Text(title, this.style);
            this.titleText.y = this.padding;
            this.text.addChild(this.titleText);
            this.titleText.clarify();
            this.titleText.centerX(size.defaultWidth);

            this.messageText = new PIXI.Text(msg, this.msgStyle);
            this.messageText.y = this.padding + this.titleText.y + this.titleText.height;
            this.text.addChild(this.messageText);
            this.messageText.clarify();

            this.messageText.centerX(size.defaultWidth);
        }

        /**
         * Update text
         *
         * @param  {String}  title  The title
         * @param  {String}  msg    The message
         * @param  {Object}  size   The size
         */

    }, {
        key: 'updateText',
        value: function updateText(title, msg, size) {
            this.titleText.text = __t.str(title);
            this.titleText.clarify();
            this.titleText.centerX(this.defaultWidth);

            this.updateMsg(msg, size);
            this.messageText.y = this.padding + this.titleText.y + this.titleText.height;
        }

        /**
         * Update msg
         *
         * @param  {String}  msg    The message
         * @param  {Object}  size   The size
         */

    }, {
        key: 'updateMsg',
        value: function updateMsg(msg, size) {
            if (!this.messageText) {
                return;
            }
            this.messageText.text = __t.str(msg);
            this.messageText.clarify();

            this.messageText.centerX(this.defaultWidth);
        }

        /**
         * Adds buttons.
         *
         * @param  {Array}  actions  The actions
         * @param  {Object}  size     The size
         * @return {Array}   { description_of_the_return_value }
         */

    }, {
        key: 'addButtons',
        value: function addButtons(actions, size) {
            this.removeButtons();

            actions = actions.reverse();

            var place = 0;

            var result = [];

            for (var i = 0; i < actions.length; i += 1) {
                var action = actions[i];
                var item = void 0;

                if (this.addButton(action, place, i, actions.length, size)) {
                    item = place;
                    place += 1;
                }

                result.push(item);
            }

            return result;
        }

        /**
         * Adds a button.
         *
         * @param  {String|Function}  action  The action
         * @param  {Number}           place   The place
         * @param  {Number}           i       Index of incrment
         * @param  {Number}           total   The total
         * @param  {Object}           size    The size
         * @return {Boolean}          Whether the button was placed
         */

    }, {
        key: 'addButton',
        value: function addButton(options, place, i, total, size) {
            if (!this.canPerformAction(options.action)) {
                return false;
            }

            options.tapped = function () {
                window.SUGA.Event.trigger(options.action);
            };

            options.remainActive = true;

            options.normalUrl = this.buttonImages.normalUrl;
            options.hoverUrl = this.buttonImages.hoverUrl;
            options.font = this.font;
            options.textStyle = this.buttonTextStyle;

            if (i === total - 1) {
                options.tint = this.primaryColor;
            } else {
                options.tint = 0xaaaaaa;
            }

            var button = new _button2.default(options);

            button.order = place;
            this.addChild(button);

            this.buttons.push(button);

            return true;
        }

        /**
         * Removes buttons.
         */

    }, {
        key: 'removeButtons',
        value: function removeButtons() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Array.from(this.buttons)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var button = _step.value;

                    button.removeSelf();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.buttons = [];
        }

        /**
         * Shows the overlay.
         *
         * @param  {Function}  cb  Completion handler
         */

    }, {
        key: 'showOverlay',
        value: function showOverlay(cb) {
            var to = {
                alpha: this.overlayAlpha,
                onComplete: cb
            };

            window.TweenMax.to(this.overlay, 300 / 1000, to);
        }

        /**
         * Hides the overlay.
         *
         * @param  {Function}  cb  Completion handler
         */

    }, {
        key: 'hideOverlay',
        value: function hideOverlay(cb) {
            if (!this.overlay) {
                if (cb) {
                    cb();
                }

                return;
            }

            var to = {
                alpha: 0,
                onComplete: function onComplete() {
                    if (cb) {
                        cb();
                    }
                }
            };

            window.TweenMax.to(this.overlay, 300 / 1000, to);
        }

        /**
         * On resize
         *
         * @param  {Object}  size  The size
         */

    }, {
        key: 'resize',
        value: function resize(size) {
            this.removeChild(this.overlay);

            this.addBg(size);

            if (this.parent) {
                this.overlay.alpha = this.overlayAlpha;
            } else {
                this.overlay.alpha = 0;
            }

            if (this.inner) {
                this.inner.position.set(size.stage.x, size.stage.y);
            }
        }

        /**
         * Determines ability to perform action.
         *
         * @param  {String}   action  The action
         * @return {Boolean}  True if able to perform action, False otherwise.
         */

    }, {
        key: 'canPerformAction',
        value: function canPerformAction(action) {
            switch (action) {
                case 'cashier':
                    if (!this.showCashierButton) {
                        return false;
                    }
                    break;
                case 'history':
                    if (!this.showHistoryButton) {
                        return false;
                    }
                    break;
                case 'home':
                    if (!this.showHomeButton) {
                        return false;
                    }
                    break;
                case 'buy-more':
                    if (!this.showBuyMoreButton) {
                        return false;
                    }
                    break;
            }

            return true;
        }
    }]);

    return NotificationView;
}(PIXI.Container);

exports.default = NotificationView;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slider = __webpack_require__(13);

var _slider2 = _interopRequireDefault(_slider);

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Foreground visualization of the data that model contains.
 */
var SettingsView = function (_PIXI$Container) {
    _inherits(SettingsView, _PIXI$Container);

    function SettingsView(size, options) {
        _classCallCheck(this, SettingsView);

        var _this = _possibleConstructorReturn(this, (SettingsView.__proto__ || Object.getPrototypeOf(SettingsView)).call(this));

        _this.formWidth = 274;

        _this.isOpen = false;
        _this.isAnimating = false;
        _this.interactive = true;
        _this.interactiveChildren = false;
        _this.visible = false;

        _this.options = options;

        _this.changedSettingsHandler = options.onChange;
        _this.submitSettingsHandler = options.onSubmit;
        _this.onVisibilityChange = options.onVisibilityChange;

        _this.model = {
            stake: options.stake,
            autoplayRounds: 0,
            lossLimit: 0,
            singleWin: 0
        };

        _this.addBg(size);

        _this.inner = new PIXI.Container();
        // this.inner.position.set(size.stage.x, size.stage.y);
        _this.addChild(_this.inner);

        var square = new PIXI.Graphics();
        square.beginFill(0x000000);
        square.drawRect(0, 0, _this.formWidth, 300);
        square.endFill();
        _this.inner.addChild(square

        // Title
        );var titleStyle = {
            fontSize: 18,
            fontFamily: options.font,
            fill: 0xFFFFFF
        };

        var titletext = __t.str('Settings').toUpperCase();

        _this.title = new PIXI.Text(titletext, titleStyle);
        _this.inner.addChild(_this.title);
        _this.title.centerX(_this.formWidth);
        _this.title.y = 24;

        _this.addCloseButton(size.width, 10, function () {
            return _this.close();
        });

        // Sliders
        var defaultOpts = {
            endCapLeft: window.SUGA.Loader.makeTexturesFromName('slider-corner-left')[0],
            endCapRight: window.SUGA.Loader.makeTexturesFromName('slider-corner-right')[0],
            handleImg: window.SUGA.Loader.makeTexturesFromName('btn-slider-normal')[0],
            barImg: window.SUGA.Loader.makeTexturesFromName('slider-tint')[0],
            font: options.font,
            primaryColor: options.primaryColor
        };

        // stake
        var x = 0;
        var stakeStops = options.stakes;

        _this.addStakeSlider(defaultOpts, _this.model.stake, options.balance, stakeStops, x, 100, options.paytable);

        // has Autoplay?
        if (!options.autoplayRounds || !options.autoplayRounds.length) return _possibleConstructorReturn(_this);

        // Autoplay Subtitle
        var subtitleStyle = {
            fontSize: 14,
            fontFamily: options.font,
            fill: 0xFFFFFF
        };

        var subtitletext = __t.str('Autoplay').toUpperCase();

        _this.subtitle = new PIXI.Text(subtitletext, subtitleStyle);
        _this.inner.addChild(_this.subtitle);
        _this.subtitle.centerX(_this.formWidth);
        _this.subtitle.y = 180;

        // Autoplay
        var roundsStops = [0].concat(options.autoplayRounds);
        var lossLimitStops = calculateLossLimitStops(roundsStops[1], options.stake);
        var singleWinStops = calculateSingleWinStops(options.paytable, options.stake);

        _this.addAutoplayRoundsSlider(defaultOpts, _this.model.autoplayRounds, roundsStops, x, 240);
        _this.addLossLimitSlider(defaultOpts, _this.model.lossLimit, lossLimitStops, x, 306);
        _this.addSingleWinSlider(defaultOpts, _this.model.singleWin, singleWinStops, x, 372);

        var innerX = (size.width - _this.formWidth) / 2;
        _this.inner.x = innerX;
        return _this;
    }

    _createClass(SettingsView, [{
        key: 'resetModel',
        value: function resetModel() {
            this.model.autoplayRounds = 0;
            this.sliderRounds.slide(0);
            this.sliderLossLimit.disable();
            this.sliderSingleWin.disable();
        }
    }, {
        key: 'resize',
        value: function resize(size) {
            this.removeChild(this.bg);
            this.bg = null;
            this.addBg(size);

            this.closedY = size.viewportHeight;

            if (!this.isOpen) {
                this.y = this.closedY;
            }

            // if (this.inner)
            // {
            //     this.inner.position.set(size.stage.x, size.stage.y);
            // }

            this.closeButton.x = size.width - this.closeButton.width - this.closeButton.padding;
        }
    }, {
        key: 'addBg',
        value: function addBg(size) {
            this.bg = createBg(size.width, size.height);
            this.addChildAt(this.bg, 0);
        }
    }, {
        key: 'addCloseButton',
        value: function addCloseButton(viewWidth, padding, closeHandler) {
            var options = {
                normalUrl: window.SUGA.Loader.makeTexturesFromName('btn-close-normal')[0],
                hoverUrl: window.SUGA.Loader.makeTexturesFromName('btn-close-hover')[0],
                tapped: closeHandler,
                remainActive: true
            };

            this.closeButton = new _button2.default(options);
            this.addChild(this.closeButton);
            this.closeButton.x = viewWidth - this.closeButton.width - padding;
            this.closeButton.y = padding;
            this.closeButton.padding = padding;
        }
    }, {
        key: 'addStakeSlider',
        value: function addStakeSlider(options, stake, balance, stops, x, y, paytable) {
            var _this2 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Stake'), sliderOptions.stops = stops, sliderOptions.isCurrency = true, sliderOptions.value = stake, sliderOptions.hasOff = false, sliderOptions.maxValue = balance;
            sliderOptions.onChange = function (value) {
                return _this2.stakeChanged(value);
            };

            this.sliderStake = new _slider2.default(sliderOptions);
            this.sliderStake.position.set(x, y);
            this.inner.addChild(this.sliderStake);
        }
    }, {
        key: 'addAutoplayRoundsSlider',
        value: function addAutoplayRoundsSlider(options, value, stops, x, y) {
            var _this3 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Rounds');
            sliderOptions.stops = stops;
            sliderOptions.isCurrency = false;
            sliderOptions.value = value;
            sliderOptions.hasOff = true;
            sliderOptions.onChange = function (value) {
                return _this3.roundsChanged(value);
            };

            this.sliderRounds = new _slider2.default(sliderOptions);
            this.sliderRounds.position.set(x, y);
            this.inner.addChild(this.sliderRounds);
        }
    }, {
        key: 'addLossLimitSlider',
        value: function addLossLimitSlider(options, value, stops, x, y) {
            var _this4 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Loss limit');
            sliderOptions.stops = stops;
            sliderOptions.isCurrency = true;
            sliderOptions.value = value;
            sliderOptions.hasOff = true;
            sliderOptions.enabled = false;
            sliderOptions.onChange = function (value) {
                return _this4.lossLimitChanged(value);
            };

            this.sliderLossLimit = new _slider2.default(sliderOptions);
            this.sliderLossLimit.position.set(x, y);
            this.inner.addChild(this.sliderLossLimit);
        }
    }, {
        key: 'addSingleWinSlider',
        value: function addSingleWinSlider(options, value, stops, x, y) {
            var _this5 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Stop on single win');
            sliderOptions.stops = stops;
            sliderOptions.isCurrency = true;
            sliderOptions.value = value;
            sliderOptions.hasOff = true;
            sliderOptions.enabled = false;
            sliderOptions.onChange = function (value) {
                return _this5.singleWinChanged(value);
            };

            this.sliderSingleWin = new _slider2.default(sliderOptions);
            this.sliderSingleWin.position.set(x, y);
            this.inner.addChild(this.sliderSingleWin);

            this.sliderSingleWin.name = 'sliderSingleWin';
        }
    }, {
        key: 'stakeChanged',
        value: function stakeChanged(stake) {
            this.model.stake = stake;

            if (this.sliderRounds && this.sliderRounds.value > 0) {
                this.changeLossLimit();
            }

            if (this.sliderSingleWin) {
                this.changeSingleWin();
            }

            this.changedSettingsHandler(this.model);
        }
    }, {
        key: 'roundsChanged',
        value: function roundsChanged(rounds) {
            this.model.autoplayRounds = rounds;

            if (rounds > 0) {
                this.sliderLossLimit.enable();
                this.sliderSingleWin.enable();
                this.changeLossLimit();
            } else {
                this.sliderLossLimit.disable();
                this.sliderSingleWin.disable();
            }

            this.validate();
        }
    }, {
        key: 'lossLimitChanged',
        value: function lossLimitChanged(lossLimit) {
            this.model.lossLimit = lossLimit;
            this.validate();
        }
    }, {
        key: 'singleWinChanged',
        value: function singleWinChanged(singleWin) {
            this.model.singleWin = singleWin;
        }
    }, {
        key: 'changeLossLimit',
        value: function changeLossLimit() {
            var isUK = this.options.ukRegulations;
            var stake = this.model.stake;
            var rounds = this.model.autoplayRounds;
            var lossLimit = this.model.lossLimit;
            var sliderLossStops = calculateLossLimitStops(rounds, stake);
            var newLossLimit = getClosestLowerValue(sliderLossStops, this.model.lossLimit);

            this.sliderLossLimit.setStops(sliderLossStops, newLossLimit);
            this.model.lossLimit = newLossLimit;
        }
    }, {
        key: 'changeSingleWin',
        value: function changeSingleWin() {
            var singleWinStops = calculateSingleWinStops(this.options.paytable, this.model.stake);
            var newSingleWin = getClosestLowerValue(singleWinStops, this.model.singleWin);

            this.sliderSingleWin.setStops(singleWinStops, newSingleWin);
            this.model.singleWin = newSingleWin;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var isUK = this.options.ukRegulations;
            var lossLimit = this.model.lossLimit;
            var rounds = this.model.autoplayRounds;

            if (isUK && rounds > 0 && lossLimit <= 0) {
                this.closeButton.disable();
                this.sliderLossLimit.showError();
            } else {
                this.closeButton.enable();
                this.sliderLossLimit.hideError();
            }
        }
    }, {
        key: 'open',
        value: function open(options) {
            var _this6 = this;

            if (this.isAnimating) return;

            this.isAnimating = true;
            this.visible = true;

            var ease = window.CustomEase.create('custom', 'M0,0,C0,0,0.714,1,0.714,1,0.714,1,0.734,0.948,0.858,0.948,0.966,0.948,1,1,1,1');

            this.onVisibilityChange(true);

            TweenMax.to(this, 0.6, { y: 0, ease: ease, onComplete: function onComplete() {
                    _this6.isOpen = true;
                    _this6.isAnimating = false;
                    _this6.interactiveChildren = true;
                } });
        }
    }, {
        key: 'close',
        value: function close() {
            var _this7 = this;

            if (this.isAnimating) return;
            if (!this.closeButton.isEnabled) return;

            this.isAnimating = true;

            this.onVisibilityChange(false);

            TweenMax.to(this, 0.3, { y: this.closedY, onComplete: function onComplete() {
                    _this7.isOpen = false;
                    _this7.isAnimating = false;
                    _this7.interactiveChildren = false;
                    _this7.visible = false;

                    _this7.submitSettingsHandler(_this7.model);
                } });
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        }
    }, {
        key: 'pointerdown',
        value: function pointerdown(e) {
            e.stopPropagation();
        }
    }, {
        key: 'pointerup',
        value: function pointerup(e) {
            e.stopPropagation();
        }
    }, {
        key: 'pointermove',
        value: function pointermove(e) {
            e.stopPropagation();
        }
    }]);

    return SettingsView;
}(PIXI.Container);

exports.default = SettingsView;


function createBg(w, h) {
    var bg = new PIXI.Graphics();

    bg.beginFill(0x000000, 0.9);
    bg.drawRect(0, 0, w, h);
    bg.endFill();

    return bg;
}

function calculateLossLimitStops(amount, stopSize) {
    amount += 1;

    return Array(amount).fill(0).map(function (i, j) {
        return Math.round(j * stopSize * 100) / 100;
    });
}

function calculateSingleWinStops(paytable, stake) {
    var array = [0].concat(paytable);

    return array.map(function (item) {
        return item * stake;
    });
}

function getClosestLowerValue(array, value) {
    var res = array[array.length - 1];
    var i = array.length - 1;

    while (i >= 0) {
        if (array[i] <= value) {
            res = array[i];
            break;
        }
        i -= 1;
    }

    return res;
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SettingsView = exports.NotificationView = exports.MenuView = exports.HelpView = exports.BottomBarView = exports.Button = exports.Pixi = exports.Canvas = undefined;

var _canvas = __webpack_require__(1);

var _canvas2 = _interopRequireDefault(_canvas);

var _pixiExtend = __webpack_require__(2);

var Pixi = _interopRequireWildcard(_pixiExtend);

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

var _bottomBarView = __webpack_require__(3);

var _bottomBarView2 = _interopRequireDefault(_bottomBarView);

var _helpView = __webpack_require__(4);

var _helpView2 = _interopRequireDefault(_helpView);

var _menuView = __webpack_require__(5);

var _menuView2 = _interopRequireDefault(_menuView);

var _notificationView = __webpack_require__(6);

var _notificationView2 = _interopRequireDefault(_notificationView);

var _settingsView = __webpack_require__(7);

var _settingsView2 = _interopRequireDefault(_settingsView);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Canvas = _canvas2.default;
exports.Pixi = Pixi;
exports.Button = _button2.default;
exports.BottomBarView = _bottomBarView2.default;
exports.HelpView = _helpView2.default;
exports.MenuView = _menuView2.default;
exports.NotificationView = _notificationView2.default;
exports.SettingsView = _settingsView2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Bottom bar visualization of the data that model contains.
 */
var AutoplayBar = function (_PIXI$Container) {
    _inherits(AutoplayBar, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  gameModel        The game model
     * @param  {CurrencyManager}  currencyManager  The currency manager
     */
    function AutoplayBar(options) {
        _classCallCheck(this, AutoplayBar);

        var _this = _possibleConstructorReturn(this, (AutoplayBar.__proto__ || Object.getPrototypeOf(AutoplayBar)).call(this));

        _this.addBg(options);

        _this.options = options;

        _this.visible = false;
        _this.isOpen = false;

        _this.yTextOffset = 4;
        return _this;
    }

    /**
     * Adds a background.
     */


    _createClass(AutoplayBar, [{
        key: 'addBg',
        value: function addBg(options) {
            this.bg = new PIXI.Graphics();
            this.bg.beginFill(options.primaryColor);
            this.bg.drawRect(0, 0, options.width, options.height);
            this.bg.endFill();
            // this.bg.alpha = 0.9;
            this.addChildAt(this.bg, 0);
        }
    }, {
        key: 'updateAutoplay',
        value: function updateAutoplay(round, rounds) {
            if (rounds <= 0) {
                this.close();

                return;
            }

            this.open();

            var label = round + '/' + rounds;

            if (!this.autoplayTitle) {
                var titleStyle = {
                    fill: 0x000000,
                    fontSize: 12,
                    fontFamily: this.options.font
                };
                var titleText = __t.str('Autoplay').toUpperCase();

                this.autoplayTitle = new PIXI.Text(titleText, titleStyle);
                this.addChild(this.autoplayTitle);
                this.autoplayTitle.position.set(10, this.yTextOffset);

                var countStyle = {
                    fill: 0xFFFFFF,
                    fontSize: 12,
                    fontFamily: this.options.font
                };

                this.autoplayCount = new PIXI.Text(label, countStyle);
                this.addChild(this.autoplayCount);
            } else {
                this.autoplayCount.text = label;
            }

            var x = this.autoplayTitle.x + this.autoplayTitle.width + 5;

            this.autoplayCount.position.set(x, this.yTextOffset);
        }
    }, {
        key: 'autoplayClearReason',
        value: function autoplayClearReason() {
            if (this.autoplayReason) {
                this.autoplayReason.text = '';
            }
        }
    }, {
        key: 'autoplayStopped',
        value: function autoplayStopped(reason) {
            reason = reason.toUpperCase();

            if (!this.autoplayReason) {
                var style = {
                    fill: 0x000000,
                    fontSize: 12,
                    fontFamily: this.options.font
                };

                this.autoplayReason = new PIXI.Text(reason, style);
                this.addChild(this.autoplayReason);
            } else {
                this.autoplayReason.text = reason;
            }

            var x = this.options.width - this.autoplayReason.width - 5;

            this.autoplayReason.position.set(x, this.yTextOffset);
        }
    }, {
        key: 'open',
        value: function open() {
            var _this2 = this;

            if (this.isAnimating || this.isOpen) return;

            this.autoplayClearReason();

            this.visible = true;

            window.TweenMax.to(this, 0.2, { y: -21, onComplete: function onComplete() {
                    _this2.isOpen = true;
                    _this2.interactiveChildren = true;
                } });
        }
    }, {
        key: 'close',
        value: function close() {
            var _this3 = this;

            if (this.isAnimating) return;

            window.TweenMax.to(this, 0.1, { y: 0, onComplete: function onComplete() {
                    _this3.isOpen = false;
                    _this3.visible = false;
                } });
        }
    }, {
        key: 'resize',
        value: function resize(width) {
            this.options.width = width;
            this.bg.removeSelf();
            this.addBg(this.options);

            if (this.autoplayReason) {
                this.autoplayReason.x = this.options.width - this.autoplayReason.width - 5;
            }
        }
    }]);

    return AutoplayBar;
}(PIXI.Container);

exports.default = AutoplayBar;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for base menu button.
 */
var Button = function (_PIXI$Container) {
    _inherits(Button, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  options  The options
     */
    function Button(options) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

        _this.options = options;

        _this.tag = 'button';

        _this.isEnabled = true;
        _this.interactive = true;
        _this.buttonMode = true;

        _this.action = null;
        _this.remainActive = true;

        _this.enable();
        _this.removeChildren();

        _this.normalBg = new PIXI.Sprite(options.buttonImage);

        _this.bg = new PIXI.Graphics();
        _this.bg.beginFill(options.tint, 0.1);
        _this.bg.drawRect(0, 0, _this.normalBg.width, _this.normalBg.height);
        _this.bg.endFill();
        _this.bg.visible = false;

        _this.addChild(_this.bg);
        _this.addChild(_this.normalBg);

        if (typeof options.toggleState === 'boolean') {
            if (options.toggleState) {
                _this.setOn();
            } else {
                _this.setOff();
            }
        }
        return _this;
    }

    /**
     * Pixi Pointer event
     *
     * @param  {UIEvent}  e  The event
     */


    _createClass(Button, [{
        key: 'pointerdown',
        value: function pointerdown(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();

            this.normalBg.tint = this.options.tint;
        }

        /**
         * Pixi Pointer event
         */

    }, {
        key: 'pointerover',
        value: function pointerover() {
            if (!this.isEnabled) {
                return;
            }

            if (this.hovered) {
                this.hovered();
            }

            this.normalBg.tint = this.options.tint;
            this.bg.visible = true;
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerup',
        value: function pointerup(e) {
            if (!this.isEnabled) {
                return;
            }

            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointertap',
        value: function pointertap(e) {
            if (!this.isEnabled) {
                return;
            }
            e.stopPropagation();
            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerout',
        value: function pointerout() {
            this.reset();
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerupoutside',
        value: function pointerupoutside() {
            this.reset();
        }

        /**
         * Reset
         */

    }, {
        key: 'reset',
        value: function reset() {
            if (this.normalBg) {
                this.normalBg.tint = 0xFFFFFF;
                this.bg.visible = false;
            }
        }

        /**
         * Enable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.reset();
            this.interactive = true;
            this.buttonMode = true;
            this.alpha = 1;

            this.isEnabled = true;
        }

        /**
         * Disable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.reset();
            this.interactive = false;
            this.buttonMode = false;
            this.alpha = 0.5;

            this.isEnabled = false;
        }

        /**
         * @private
         * Button pressed action
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: '_tapped',
        value: function _tapped(e) {
            if (this.tapped) {
                this.tapped(e);
            } else {
                throw new Error('Button has no Action');
            }

            if (!this.remainActive) {
                this.disable();
            }
        }

        /**
         * Turn Button on
         */

    }, {
        key: 'setOn',
        value: function setOn() {
            this.state = true;

            this.normalBg.texture = this.options.buttonImage;
        }

        /**
         * Turn button off
         */

    }, {
        key: 'setOff',
        value: function setOff() {
            this.state = false;

            this.normalBg.texture = this.options.buttonOffImage;
        }

        /**
         * Toggle state
         *
         * @return {Boolean}  True if on false if off
         */

    }, {
        key: 'toggleState',
        value: function toggleState() {
            if (this.state) {
                this.setOff();
            } else {
                this.setOn();
            }

            return this.state;
        }
    }]);

    return Button;
}(PIXI.Container);

exports.default = Button;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _button = __webpack_require__(10);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonContainer = function (_PIXI$Container) {
    _inherits(ButtonContainer, _PIXI$Container);

    function ButtonContainer(options) {
        _classCallCheck(this, ButtonContainer);

        var _this = _possibleConstructorReturn(this, (ButtonContainer.__proto__ || Object.getPrototypeOf(ButtonContainer)).call(this));

        Object.assign(_this, options);

        _this.buttonYOffset = 0;

        var color = options.primaryColor;
        var mute = options.mute;

        var x = 0;

        if (_this.showHomeButton) {
            _this.addHomeButton(x, color);
            _this.addLine(x);
            x += 45;
        }

        _this.addSoundButton(x, color, mute);
        _this.addLine(x);
        x += 45;

        if (_this.showHelpButton) {
            _this.addHelpButton(x, color);
            _this.addLine(x);
            x += 45;
        }

        if (!_this.isBasketMode && _this.settingsButtonHandler) {
            _this.addSettingsButton(x, color);
            _this.addLine(x);
        }

        if (options.fullscreenEnabled) {
            _this.addFullscreenButton(x, color, false);
            _this.addLine(x);
        }
        return _this;
    }

    /**
     * Adds a line.
     *
     * @param  {Number}  x  The x position
     */


    _createClass(ButtonContainer, [{
        key: 'addLine',
        value: function addLine(x) {
            x = x + 45;
            var graphics = new PIXI.Graphics();

            graphics.lineStyle(1, 0xffffff);
            graphics.moveTo(x, 0);
            graphics.lineTo(x, 45);
            graphics.endFill();
            graphics.alpha = 0.1;
            graphics.cachedAsBitmap = true;
            this.addChild(graphics);
        }

        /**
         * Adds a home button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addHomeButton',
        value: function addHomeButton(x, color) {
            var _this2 = this;

            var options = {
                tint: color,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-home-normal')[0]
            };

            this.homeButton = new _button2.default(options);
            this.homeButton.tapped = function (e) {
                return _this2.homeButtonClick(e);
            };
            this.homeButton.position.set(x, this.buttonYOffset);
            this.addChild(this.homeButton);
        }

        /**
         * Home button clicked
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'homeButtonClick',
        value: function homeButtonClick(e) {
            window.SUGA.Sound.play('click');
            this.homeButtonHandler(e);
            e.stopPropagation();
        }

        /**
         * Adds a help button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addHelpButton',
        value: function addHelpButton(x, color) {
            var _this3 = this;

            var options = {
                tint: color,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-help-normal')[0]
            };

            this.helpButton = new _button2.default(options);
            this.helpButton.tapped = function (e) {
                return _this3.helpButtonClick(e);
            };
            this.helpButton.position.set(x, this.buttonYOffset);

            this.addChild(this.helpButton);
        }

        /**
         * Help button clicked
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'helpButtonClick',
        value: function helpButtonClick(e) {
            window.SUGA.Sound.play('click');
            this.helpButtonHandler(e);
            e.stopPropagation();
        }

        /**
         * Adds a help button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addSettingsButton',
        value: function addSettingsButton(x, color) {
            var _this4 = this;

            var options = {
                tint: color,
                toggleBtn: true,
                toggleState: false,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-settings-active')[0],
                buttonOffImage: window.SUGA.Loader.makeTexturesFromName('btn-settings-normal')[0]
            };

            this.settingsButton = new _button2.default(options);
            this.settingsButton.tapped = function (e) {
                return _this4.settingsButtonClick(e);
            };
            this.settingsButton.position.set(x, this.buttonYOffset);

            this.addChild(this.settingsButton);
        }

        /**
         * Help button clicked
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'settingsButtonClick',
        value: function settingsButtonClick(e) {
            window.SUGA.Sound.play('click');
            e.stopPropagation();

            this.settingsButtonHandler(e);
        }
    }, {
        key: 'toggleSettings',
        value: function toggleSettings(isOpen) {
            if (isOpen) {
                this.settingsButton.setOn();
            } else {
                this.settingsButton.setOff();
            }
        }

        /**
         * Adds a sound button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addSoundButton',
        value: function addSoundButton(x, color, mute) {
            var _this5 = this;

            var options = {
                tint: color,
                toggleBtn: true,
                toggleState: !mute,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-soundon-normal')[0],
                buttonOffImage: window.SUGA.Loader.makeTexturesFromName('btn-soundoff-normal')[0]
            };

            this.soundButton = new _button2.default(options);
            this.soundButton.position.set(x, this.buttonYOffset);
            this.addChild(this.soundButton);

            // Hack to always hide sound

            this.soundButton.tapped = function (e) {
                _this5.toggleSoundClick(e);
            };
        }

        /**
         * Toggle sound button
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'toggleSoundClick',
        value: function toggleSoundClick(e) {
            e.stopPropagation();

            window.SUGA.Sound.play('click');

            this.soundButton.toggleState();

            this.muteButtonHandler(e);
        }

        /**
         * Display the sound on button
         */

    }, {
        key: 'displaySoundOnButton',
        value: function displaySoundOnButton() {
            this.soundButton.setOn();
        }

        /**
         * Display the Sound off button
         */

    }, {
        key: 'displaySoundOffButton',
        value: function displaySoundOffButton() {
            this.soundButton.setOff();
        }
    }, {
        key: 'addFullscreenButton',
        value: function addFullscreenButton(x, color, fullscreen) {
            var _this6 = this;

            var options = {
                tint: color,
                toggleBtn: true,
                toggleState: fullscreen,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-fullscreen-active')[0],
                buttonOffImage: window.SUGA.Loader.makeTexturesFromName('btn-fullscreen-normal')[0]
            };

            this.fullscreenBtn = new _button2.default(options);
            this.fullscreenBtn.tapped = function (e) {
                return _this6.fullscreenClick(e);
            };
            this.fullscreenBtn.position.set(x, this.buttonYOffset);

            this.addChild(this.fullscreenBtn);
        }
    }, {
        key: 'fullscreenClick',
        value: function fullscreenClick(e) {
            e.stopPropagation();

            window.SUGA.Sound.play('click');

            this.fullscreenBtn.toggleState();

            this.fullscreenButtonHandler(e);
        }
    }, {
        key: 'enableNavigationButtons',
        value: function enableNavigationButtons() {
            // listen when to enable/disable
            if (this.helpButton) {
                this.helpButton.enable();
            }
            // listen when to enable/disable
            if (this.settingsButton) {
                this.settingsButton.enable();
            }
        }

        /**
         * Disables the navigation buttons.
         */

    }, {
        key: 'disableNavigationButtons',
        value: function disableNavigationButtons() {
            // listen when to enable/disable
            if (this.helpButton) {
                this.helpButton.disable();
            }
            // listen when to enable/disable
            if (this.settingsButton) {
                this.settingsButton.disable();
            }
        }
    }]);

    return ButtonContainer;
}(PIXI.Container);

exports.default = ButtonContainer;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Bottom bar visualization of the data that model contains.
 */
var Counter = function (_PIXI$Text) {
    _inherits(Counter, _PIXI$Text);

    /**
     * Constructs the object.
     *
     * @param  {Object}  gameModel        The game model
     * @param  {CurrencyManager}  currencyManager  The currency manager
     */
    function Counter(initCount, style, formatter, currencyMulitplier, maxPrize) {
        _classCallCheck(this, Counter);

        var _this = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this, initCount, style));

        _this.counterTween = null;
        _this.formatter = formatter;
        _this.currencyMulitplier = currencyMulitplier;
        _this.maxPrize = maxPrize;

        return _this;
    }

    /**
     * Finish count animation instantly
     */


    _createClass(Counter, [{
        key: 'instantFinish',
        value: function instantFinish() {
            // end current counter
            if (this.counterTween) {
                this.counterTween.totalProgress(1).kill();
            }
        }

        /**
         * { function_description }
         *
         * @param  {Number}    newCount  The new count
         * @param  {Function}  cb          { parameter_description }
         */

    }, {
        key: 'updateCount',
        value: function updateCount(newCount, cb) {
            var _this2 = this;

            this.instantFinish();

            var animate = true;

            if ((typeof newCount === 'undefined' ? 'undefined' : _typeof(newCount)) === 'object') {
                var _newCount = newCount;
                animate = _newCount.animate;

                newCount = newCount.count;
            }

            // if this is a debit or we are getting initial count
            if (this.currentCount >= newCount || this.currentCount < 0 || !animate) {
                this.setCount(newCount);
                this.centerCount();

                return;
            }

            if (!this.currentCount) {
                this.currentCount = 0;
            }

            var diff = newCount - this.currentCount;

            diff = Math.ceil(diff / this.currencyMulitplier);
            var maxPrize = this.maxPrize / this.currencyMulitplier;

            // max & min seconds
            var min = 2;
            var max = 15 - min;
            var scale = max / Math.log10(maxPrize);
            var timeLength = Math.log(diff) * Math.LOG10E * scale + min;
            var frames = timeLength * 60;
            var steps = Math.floor(frames / 2);

            var obj = {
                count: this.currentCount
            };

            var to = {
                ease: window.SteppedEase.config(steps),
                count: newCount,
                onUpdate: function onUpdate() {
                    _this2.setCount(obj.count);
                },
                // play sound here

                onComplete: function onComplete() {
                    _this2.setCount(obj.count);
                    _this2.counterTween = null;
                    // soundManager.play 'coin-done'
                    if (cb) {
                        cb();
                    }
                }
            };

            this.counterTween = window.TweenMax.to(obj, timeLength, to);
        }

        /**
         * Sets the count.
         *
         * @param  {(number|string)}  amount  The amount
         * @return {boolean}          { description_of_the_return_value }
         */

    }, {
        key: 'setCount',
        value: function setCount(amount) {
            if (this.currentCount === amount) {
                return false;
            }

            this.currentCount = amount;

            amount = this.formatter(amount);

            var newLength = amount.length;
            var oldLength = this.text.length;

            this.text = amount;
            this.centerCount();

            return true;
        }

        /**
         * Center's the count label
         */

    }, {
        key: 'centerCount',
        value: function centerCount() {
            this.centerX();
        }
    }]);

    return Counter;
}(PIXI.Text);

exports.default = Counter;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for base menu button.
 */
var Slider = function (_PIXI$Container) {
    _inherits(Slider, _PIXI$Container);

    function Slider(options) {
        _classCallCheck(this, Slider);

        var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this));

        var defaults = {
            enabled: true
        };

        options.barHeight = 6;
        options.barWidth = 274;
        options.handleRadius = options.handleImg.width / 2;
        options.animationSpeed = 0.2;

        _this.options = Object.assign({}, options, defaults);
        _this.value = _this.options.value;
        _this.isDragging = false;
        _this.barY = 10;

        // background bar
        // this.backgroundBar = new PIXI.Sprite(options.barBg)
        _this.backgroundBar = new PIXI.Sprite(options.barImg);
        _this.backgroundBar.width = options.barWidth;
        _this.backgroundBar.tint = 0x737373;
        _this.backgroundBar.position.y = _this.barY;
        _this.backgroundBar.interactive = true;
        _this.backgroundBar.buttonMode = true;
        _this.backgroundBar.pointerup = function (e) {
            return _this.click(e);
        };
        _this.addChild(_this.backgroundBar);

        // the colored endcap
        _this.endCapLeft = new PIXI.Sprite(options.endCapLeft);
        _this.endCapLeft.tint = options.primaryColor;
        _this.endCapLeft.x = -_this.endCapLeft.width;
        _this.endCapLeft.y = _this.barY;
        _this.addChild(_this.endCapLeft);

        _this.endCapRight = new PIXI.Sprite(options.endCapRight);
        _this.endCapRight.tint = 0x737373;
        _this.endCapRight.x = options.barWidth;
        _this.endCapRight.y = _this.barY;
        _this.addChild(_this.endCapRight);

        // the colored bar
        _this.highlightBar = new PIXI.Sprite(options.barImg);
        _this.highlightBar.y = _this.barY;
        _this.addChild(_this.highlightBar);

        // handle
        _this.handle = drawHandle(_this.barY + options.barHeight / 2, options.handleImg, function () {
            return _this.down();
        }, function (x) {
            return _this.slide(x);
        }, function (x) {
            return _this.snap(_this.value, true);
        });

        // slider title
        var style = {
            fontFamily: options.font,
            fill: 0xFFFFFF,
            fontSize: 14
        };

        _this.label = new PIXI.Text(options.title, style);
        _this.label.x = (options.barWidth - _this.label.width) / 2;
        _this.label.y = 20;

        // moving value
        var valueStyle = {
            fontFamily: options.font,
            fill: options.primaryColor,
            fontSize: 12
        };

        _this.valueLabel = new PIXI.Text('' + options.value, valueStyle);
        _this.valueLabel.y = _this.barY - 28;
        _this.valueLabel.defaultY = _this.barY - 28;
        _this.valueLabel.genieY = _this.barY - 55;
        _this.valueLabel.anchor.x = 0.5;

        // left & right labels
        _this.stopStyle = {
            fontFamily: options.font,
            fontWeigth: 100,
            fill: 0x737373,
            fontSize: 10
        };

        _this.stops = _this.addStops(options.stops, _this.stopStyle, options.barWidth, _this.barY);
        _this.marks = _this.addMarks(options.stops, options.barWidth, options.barHeight, _this.barY);
        _this.addChild(_this.label);
        _this.addChild(_this.handle);
        _this.addChild(_this.valueLabel);

        var x = calculateStepPosition(_this.value, options.barWidth, options.stops, options.maxValue);

        _this.slide(x);

        if (options.enabled === false) {
            _this.disable();
        } else {
            _this.enable();
        }
        return _this;
    }

    _createClass(Slider, [{
        key: 'down',
        value: function down() {
            genieGrow(this.valueLabel, this.options.animationSpeed);
        }
    }, {
        key: 'slide',
        value: function slide(x) {
            this.hideError();

            var pos = x - this.worldTransform.tx;

            if (pos < 0) {
                pos = 0;
            } else if (pos > this.options.barWidth) {
                pos = this.options.barWidth;
            }

            var value = void 0;

            value = calculateStepValue(pos, this.options.barWidth, this.options.stops, this.options.maxValue);

            this.handle.x = pos;
            this.highlightBar.width = pos;

            this.setValue(value);
            this.valueLabel.x = pos; // - (this.valueLabel.width/2)

            return value;
        }
    }, {
        key: 'snap',
        value: function snap(value, shouldGenie) {
            var pos = calculateStepPosition(value, this.options.barWidth, this.options.stops, this.options.maxValue);
            var labelPos = pos;

            window.TweenMax.to(this.handle, 0.2, { x: pos });
            window.TweenMax.to(this.valueLabel, 0.2, { x: labelPos });
            window.TweenMax.to(this.highlightBar, 0.2, { width: pos }); // minus semi circle endcap

            this.options.onChange(value);

            if (shouldGenie) {
                genieShrink(this.valueLabel, this.options.animationSpeed);
            }
        }
    }, {
        key: 'addStops',
        value: function addStops(stops, style, w, y) {
            y -= 12;
            var firstVal = formatValue(stops[0], this.options.isCurrency, this.options.hasOff);
            var lastVal = formatValue(stops[stops.length - 1], this.options.isCurrency, this.options.hasOff);
            var first = new PIXI.Text(firstVal, style);

            first.y = y;
            var last = new PIXI.Text(lastVal, style);

            last.y = y;
            last.x = w - last.width;
            this.addChild(first);
            this.addChild(last);

            return [first, last];
        }
    }, {
        key: 'removeStops',
        value: function removeStops(stops) {
            stops.map(function (item) {
                item.removeSelf();
            });

            return [];
        }
    }, {
        key: 'addMarks',
        value: function addMarks(stops, width, height, y) {
            var marks = [];
            var total = width;
            var stopSize = total / (stops.length - 1);
            var i = 1;

            while (i < stops.length - 1) {
                var x = stopSize * i;
                var line = drawRect(x, y, 1, height, 0x000000);

                this.addChild(line);
                marks.push(line);
                i++;
            }

            return marks;
        }
    }, {
        key: 'removeMarks',
        value: function removeMarks(marks) {
            marks.map(function (item) {
                item.removeSelf();
            });

            return [];
        }
    }, {
        key: 'setStops',
        value: function setStops(stops, value) {
            this.options.stops = stops;
            this.stops = this.removeStops(this.stops);
            this.marks = this.removeMarks(this.marks);
            this.stops = this.addStops(stops, this.stopStyle, this.options.barWidth, this.barY);
            this.marks = this.addMarks(stops, this.options.barWidth, this.options.barHeight, this.barY);
            this.handle.bringToFront();
            this.valueLabel.bringToFront();

            if (value !== undefined) {
                this.setValue(value);
            }

            this.snap(this.value, false);
        }
    }, {
        key: 'setValue',
        value: function setValue(value) {
            this.value = value;
            this.valueLabel.text = formatValue(value, this.options.isCurrency, this.options.hasOff);
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.interactiveChildren = true;
            this.backgroundBar.tint = 0x737373;
            this.highlightBar.tint = this.options.primaryColor;
            this.endCapLeft.tint = this.options.primaryColor;
            this.endCapRight.tint = 0x737373;
            this.handle.tint = 0xFFFFFF;
            this.stops[0].alpha = 1;
            this.stops[1].alpha = 1;
            this.label.alpha = 1;
            this.valueLabel.alpha = 1;
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.interactiveChildren = false;

            this.backgroundBar.tint = 0x333333;
            this.endCapRight.tint = 0x333333;

            this.highlightBar.tint = 0x555555;
            this.endCapLeft.tint = 0x555555;
            this.handle.tint = 0x555555;

            this.stops[0].alpha = 0.4;
            this.stops[1].alpha = 0.4;
            this.label.alpha = 0.4;
            this.valueLabel.alpha = 0.4;
        }
    }, {
        key: 'showError',
        value: function showError() {
            this.label.style.fill = 0xCE0020;
            this.valueLabel.style.fill = 0xCE0020;
        }
    }, {
        key: 'hideError',
        value: function hideError() {
            this.label.style.fill = 0xFFFFFF;
            this.valueLabel.style.fill = this.options.primaryColor;
        }
    }, {
        key: 'click',
        value: function click(e) {
            e.stopPropagation();
            var pos = e.data.global.x - this.worldTransform.tx;
            var value = calculateStepValue(pos, this.options.barWidth, this.options.stops);

            this.setValue(value);
            this.snap(value, false);
        }
    }]);

    return Slider;
}(PIXI.Container);

exports.default = Slider;


function formatValue(value, isCurrency, hasOff) {
    if (value == 0 && hasOff) return __t.str('Off');
    value = isCurrency ? __c.localize(value, true, false) : '' + Math.round(value);

    return value;
}

function calculateStepValue(x, total, stops, max) {
    var stopSize = total / (stops.length - 1);
    var index = Math.round(x / stopSize);
    var result = stops[index];

    if (max && result > max) {
        result = findNextLowestStopFromValue(max, stops);
    }

    return result;
}

function findNextLowestStopFromValue(val, stops) {
    var i = 0;

    while (i < stops.length) {
        if (val <= stops[i]) {
            return stops[i - 1];
        }
        i++;
    }

    return stops[stops.length - 1];
}

function calculateStepPosition(val, total, stops, max) {
    var i = 0;

    if (max && val > max) {
        val = findNextLowestStopFromValue(max, stops);
    }

    while (i < stops.length) {
        if (val <= stops[i]) {
            break;
        }
        i++;
    }
    var stopSize = total / (stops.length - 1);
    var result = stopSize * i;

    return result;
}

function drawHandle(y, texture, down, move, done) {
    var r = texture.width / 2;

    y -= r;
    var handle = new PIXI.Sprite(texture);

    handle.position.set(0, y);
    handle.anchor.set(0.5, 0);
    handle.interactive = true;
    handle.buttonMode = true;
    // handle.alpha = 0.5

    handle.pointerdown = function (e) {
        e.stopPropagation();
        this.isDragging = true;
        down();
    };

    handle.pointerup = function (e) {
        // e.stopPropagation()
        this.isDragging = false;
        done();
    };

    handle.pointerupoutside = function () {
        this.isDragging = false;
        done();
    };

    handle.pointermove = function (e) {
        if (!this.isDragging) return;
        move(e.data.global.x);
    };
    // const handle = new PIXI.Sprite.fromImage(img);
    // handle.position.set(x,y);
    return handle;
}

/**
 * Draws a rectangle.
 *
 * @param  {Number}  x      x coordinate
 * @param  {Number}  y      y coordinate
 * @param  {Number}  w      width
 * @param  {Number}  h      height
 * @param  {Number}  color  The color
 * @return {PIXI}    Rectangle
 */
function drawRect(x, y, w, h, color) {
    var bar = new PIXI.Graphics();

    bar.beginFill(0xFFFFFF);
    bar.drawRect(0, 0, w, h);
    bar.endFill();
    bar.position.set(x, y);
    bar.tint = color;

    return bar;
}

/**
 * Round number to neareset factor of N
 *
 * @param  {Number}  num  The number
 * @param  {Number}  by   the number to round to (e.g. nearest factor of 5)
 * @return {Number}  Rounded number
 */
function round(num, by) {
    if (num < by) return num;

    return Math.ceil(num / by) * by;
}

/**
 * Grow with genie effect
 *
 * @param  {PIXI.Text}  value  The value
 * @param  {Number}     speed  The speed
 */
function genieGrow(value, speed) {
    genie(value, 20, value.genieY, speed);
}

/**
 * Shrink with genie effect
 *
 * @param  {PIXI.Text}  value  The value
 * @param  {Number}     speed  The speed
 */
function genieShrink(value, speed) {
    genie(value, 12, value.defaultY, speed);
}

/**
 * Grow current value like a genie
 *
 * @param  {PIXI.Text}  value     The value
 * @param  {Number}     fontSize  The font size
 * @param  {Number}     y         { parameter_description }
 * @param  {Number}     speed     The speed
 */
function genie(value, fontSize, y, speed) {
    var style = {
        fontSize: fontSize
    };

    window.TweenMax.to(value.style, speed, style, speed);

    var position = {
        y: y,
        onUpdate: function onUpdate() {
            return value.clarify();
        }
    };

    window.TweenMax.to(value, speed, position);
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// stats.js - http://github.com/mrdoob/stats.js
(function(f,e){ true?module.exports=e():"function"===typeof define&&define.amd?define(e):f.Stats=e()})(this,function(){var f=function(){function e(a){c.appendChild(a.dom);return a}function u(a){for(var d=0;d<c.children.length;d++)c.children[d].style.display=d===a?"block":"none";l=a}var l=0,c=document.createElement("div");c.style.cssText="position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";c.addEventListener("click",function(a){a.preventDefault();
u(++l%c.children.length)},!1);var k=(performance||Date).now(),g=k,a=0,r=e(new f.Panel("FPS","#0ff","#002")),h=e(new f.Panel("MS","#0f0","#020"));if(self.performance&&self.performance.memory)var t=e(new f.Panel("MB","#f08","#201"));u(0);return{REVISION:16,dom:c,addPanel:e,showPanel:u,begin:function(){k=(performance||Date).now()},end:function(){a++;var c=(performance||Date).now();h.update(c-k,200);if(c>g+1E3&&(r.update(1E3*a/(c-g),100),g=c,a=0,t)){var d=performance.memory;t.update(d.usedJSHeapSize/
1048576,d.jsHeapSizeLimit/1048576)}return c},update:function(){k=this.end()},domElement:c,setMode:u}};f.Panel=function(e,f,l){var c=Infinity,k=0,g=Math.round,a=g(window.devicePixelRatio||1),r=80*a,h=48*a,t=3*a,v=2*a,d=3*a,m=15*a,n=74*a,p=30*a,q=document.createElement("canvas");q.width=r;q.height=h;q.style.cssText="width:80px;height:48px";var b=q.getContext("2d");b.font="bold "+9*a+"px Helvetica,Arial,sans-serif";b.textBaseline="top";b.fillStyle=l;b.fillRect(0,0,r,h);b.fillStyle=f;b.fillText(e,t,v);
b.fillRect(d,m,n,p);b.fillStyle=l;b.globalAlpha=.9;b.fillRect(d,m,n,p);return{dom:q,update:function(h,w){c=Math.min(c,h);k=Math.max(k,h);b.fillStyle=l;b.globalAlpha=1;b.fillRect(0,0,r,m);b.fillStyle=f;b.fillText(g(h)+" "+e+" ("+g(c)+"-"+g(k)+")",t,v);b.drawImage(q,d+a,m,n-a,p,d,m,n-a,p);b.fillRect(d+n-a,m,a,p);b.fillStyle=l;b.globalAlpha=.9;b.fillRect(d+n-a,m,a,g((1-h/w)*p))}}};return f});


/***/ })
/******/ ]);
});
//# sourceMappingURL=vue.js.map

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("accelerate", [], factory);
	else if(typeof exports === 'object')
		exports["accelerate"] = factory();
	else
		root["accelerate"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bezierFunctions = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class performs velocity changes on objects in 1-dimensional motion
 *
 * Provides two exposed methods
 *
 * -    getDistance(x)
 * -    isComplete()
 *
 * It does NOT keep track of the moving object outside of the velocity change
 * window
 *
 * Elapsed time is measured from the start of the velocity change
 *
 * You can only use an instance of this class once. Once the velocity change is
 * complete any call to getDistance() will result in an error. This is because
 * the values that define the bezier function used to describe the acceleration
 * are passed in via the constructor and those values cannot be changed (and hence the bezier curve cannot be changed)
 * without creating a new object
 *
 */
var BezierAccelerator = function () {
    /**
     * Constructs the object.
     *
     * @param  {number}    v0  The initial velocity - velocity before the acceleration
     * @param  {number}    vF  The final velocity to be atained
     * @param  {number}    tF  The time interval over which the acceleration is to be completed
     * @param  {number}    dF  The distance the object is to travel over the period of the acceleration
     *
     * @param  {Function}  cb  { parameter_description } NOTE - not tested
     */
    function BezierAccelerator(v0, vF, tF, dF) {
        var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        _classCallCheck(this, BezierAccelerator);

        // just changing the notation to what I am using
        var V = v0;
        var T = tF;
        var D = dF;
        var P0 = [];
        var P1 = [];
        var P2 = [];
        var P3 = [];

        this.callBack = cb;

        /**
         * This if statement is selecting the "best" bezier function for the set of defining values
         * given. The motivation for this is to ensure that the most common deceleration case
         *
         *  -   going from a high velocity to zero velocity
         *
         *  uses a curve that results in a uniform deceleration. This is achieved by slecting the
         *  Quadratic bezier for this particular circunstance.
         *
         *  It is possible to handle this particular case with a Cubic Bezier but the result would be that the
         *  motion decelerates too much and has to speed up or reverse course at the end
         *
         */
        if (v0 > 0 && vF === 0 && T * v0 > D) {
            // this is the one special case where a cubic will not do the job
            P0 = [0.0, 0.0];
            var p1X = (D - vF * T) / (v0 - vF);
            var p1Y = v0 * p1X;
            P1 = [p1X, p1Y];
            P2 = [T, D];

            this.func = (0, _bezierFunctions.QuadraticBezier)(P0, P1, P2);
        } else {
            P0 = [0.0, 0.0];
            P1 = [T / 3.0, V * T / 3.0];
            P2 = [2.0 / 3.0 * T, D - vF * T / 3.0];
            P3 = [T, D];
            this.func = (0, _bezierFunctions.CubicBezier)(P0, P1, P2, P3);
        }

        this.complete = false;

        this.V = v0;
        this.vF = vF;
        this.T = tF;
        this.D = dF;

        this.P0 = P0;
        this.P1 = P1;
        this.P2 = P2;
        this.P3 = P3;
    }

    /**
     * Function that is the tangent line at P0
     *
     * @param  {number}  t  independent variable
     * @return {number}  return value
     */


    _createClass(BezierAccelerator, [{
        key: 'tangentInitial',
        value: function tangentInitial(t) {
            return this.V * t;
        }

        /**
         * Function that is the tangent line at P3
         *
         * @return {Array}  { description_of_the_return_value }
         */

    }, {
        key: 'dotPositions',
        value: function dotPositions() {
            return [this.P0, this.P1, this.P2, this.P3];
        }

        /**
            * This function draws the trajectory of the final velocity.Used only for debugging and demonstration
            * not part of the final exposed package
            *
            * @param  {float}  t  the independent
            * @return {float}  the function return value
            */

    }, {
        key: 'tangentFinal',
        value: function tangentFinal(t) {
            var res = this.vF * t + (this.D - this.vF * this.T);

            return res;
        }

        /**
         * Gets an object that contains the distance that has been traveled after xValue time units of the acceleration,
         * and the velocity of travel at that same time
         *
         * NOTE :: This is one of only two methods exposed by the class that are not simply for debugging.
         *
         * @param  {number}  xValue  a number in the range  0..tF the elapsed time
         *                           of the velocity change
         * @return {object}   Of type
         *                      { distance : , velocity : }
         */

    }, {
        key: 'getDistanceAndVelocity',
        value: function getDistanceAndVelocity(xValue) {
            if (this.complete) {
                throw new Error('Accelerator: velocity change is complete. Cannot call this function');
            }

            var tmpX = xValue;

            if (xValue >= this.T && !this.complete) {
                this.complete = true;
                if (typeof this.callBack === 'function') {
                    this.callBack();
                }

                tmpX = this.T;
            }

            var obj = this.func(tmpX);

            return { distance: obj.yValue, velocity: obj.slopeValue };
        }
        /**
         * Returns true if the acceleration is complete false other wise
         *
         * This is the second method exposed by the class that is not purely debuggin
         *
         * @return     {boolean}  True if complete, False otherwise.
         */

    }, {
        key: 'isComplete',
        value: function isComplete() {
            return this.complete;
        }
    }]);

    return BezierAccelerator;
}();

exports.default = BezierAccelerator;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class performs velocity changes on objects in 1-dimensional motion,
 * but unlike the Bezier uses only the elapsed time OR distance as a constraint - not both.
 *
 * Hence one of the values dF or tF passed to the constructor MUST be set to false
 * to signify 'not provided'
 *
 * Hence the usual rules of physics can be applied and a constant acceleration
 * applied.
 *
 * Provides two exposed methods
 *
 * -    getDistance(x)
 * -    isComplete()
 *
 * It does NOT keep track of the moving object outside of the velocity change
 * window
 *
 * Elapsed time is measured from the start of the velocity change
 *
 * You can only use an instance of this class once. Once the velocity change is
 * complete any call to getDistance() will result in an error. This is because
 * the values that define the bezier function used to describe the acceleration
 * are passed in via the constructor and those values cannot be changed (and hence the bezier curve cannot be changed)
 * without creating a new object
 *
 */
var SimpleAccelerator = function () {
    /**
     * Constructs the object.
     *
     * @param  {number}    v0  The initial velocity - velocity before the acceleration
     * @param  {number}    vF  The final velocity to be atained
     * @param  {number}    tF  The time interval over which the acceleration is to be completed
     * @param  {float}     dF  is the distance that the object should move while changing velocity
     *
     * @param  {Function}  cb  { parameter_description } NOTE - not tested
     */
    function SimpleAccelerator(v0, vF, tF, dF) {
        var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        _classCallCheck(this, SimpleAccelerator);

        // just changing the notation to what I am using

        this.callBack = cb;
        this.complete = false;
        this.V = v0;
        this.vF = vF;
        this.D = dF;
        this.T = tF;
        if (dF === null && tF === null) {
            throw new Error('Only one of dF tF can be null tF:' + tF + ' dF:' + dF);
        } else if (dF !== null && tF !== null) {
            throw new Error('Exactly one of dF, tF MUST be false tF:' + tF + ' dF:' + dF);
        } else if (dF !== null) {
            var vAverage = (vF - v0) / 2.0;
            var t = dF / vAverage;

            this.acceleration = (vF - v0) / t;
            this.T = t;
        } else // dF === null, tF !== null
            {
                this.acceleration = (vF - v0) / tF;
                this.D = v0 * tF + 0.5 * this.acceleration * tF * tF;
            }
    }

    /**
     * Gets an object that contains the distance that has been traveled after xValue time units of the acceleration,
     * and the velocity of travel at that same time
     *
     * NOTE :: This is one of only two methods exposed by the class that are not simply for debugging.
     *
     * @param  {number}  xValue  a number in the range  0..tF the elapsed time
     *                           of the velocity change
     * @return {object}   Of type
     *                      { distance : , velocity : }
     */


    _createClass(SimpleAccelerator, [{
        key: 'getDistanceAndVelocity',
        value: function getDistanceAndVelocity(xValue) {
            if (this.complete) {
                throw new Error('Accelerator: velocity change is complete. Cannot call this function');
            }

            if (xValue >= this.T && !this.complete) {
                this.complete = true;
                if (typeof this.callBack === 'function') {
                    this.callBack();
                }
            }
            var v = this.V + xValue * this.acceleration;
            var d = this.V * xValue + 0.5 * this.acceleration * xValue * xValue;

            // console.log(`SimpleAccelerator xValue:${xValue}`
            //     +` isComplete:${this.complete}`
            //     +` this.T ${this.T}`
            //     +` d:${d}  v:${v}`
            //     )

            return { distance: d, velocity: v };
        }
        /**
         * Returns true if the acceleration is complete false other wise
         *
         * This is the second method exposed by the class that is not purely debuggin
         *
         * @return     {boolean}  True if complete, False otherwise.
         */

    }, {
        key: 'isComplete',
        value: function isComplete() {
            return this.complete;
        }
    }]);

    return SimpleAccelerator;
}();

exports.default = SimpleAccelerator;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class for bezier cubic class.
 */
var BezierCubic = exports.BezierCubic = function () {
    /**
     * Constructs the object.
     *
     * @param  {array}  P0  Inital Point
     * @param  {array}  P1  First attraction point
     * @param  {array}  P2  Second attraction point
     * @param  {array}  P3  End point
     */
    function BezierCubic(P0, P1, P2, P3) {
        _classCallCheck(this, BezierCubic);

        this.P0 = P0;
        this.P1 = P1;
        this.P2 = P2;
        this.P3 = P3;
    }

    /**
     * The derivative of a bezier function - calcs the derivative on a single coordinate
     *
     * @private
     *
     * @param  {number}  t   parameter value at which to calc the bezier coordinate
     * @param  {number}  p0  coordinate value from P0
     * @param  {number}  p1  coordinate value from P1
     * @param  {number}  p2  coordinate value from P2
     * @param  {number}  p3  coordinate value from P3
     * @return {number}  { description_of_the_return_value }
     */


    _createClass(BezierCubic, [{
        key: "derivative",
        value: function derivative(t, p0, p1, p2, p3) {
            function quadratic(p0, p1, p2, t) {
                var res = p0 * (1.0 - t) * (1.0 - t) + 2.0 * p1 * (1.0 - t) * t + p2 * t * t;

                return res;
            }
            var res = 3.0 * (quadratic(p1, p2, p3, t) - quadratic(p0, p1, p2, t));

            return res;
        }
        /**
         * Calculates the x or y coordinate of a bezier curve given a value of the parameterization
         *
         * @private
         *
         * @param  {number}  t   parameter value
         * @param  {number}  p0  The p 0
         * @param  {number}  p1  The p 1
         * @param  {number}  p2  The p 2
         * @param  {number}  p3  The p 3
         * @return {number}  { description_of_the_return_value }
         */

    }, {
        key: "bezFunc",
        value: function bezFunc(t, p0, p1, p2, p3) {
            var res = p0 * (1 - t) * (1 - t) * (1 - t) + 3.0 * p1 * (1 - t) * (1 - t) * t + 3.0 * p2 * (1 - t) * t * t + p3 * t * t * t;

            return res;
        }

        /**
         * Calculates an x value from a value t of the curves parameterization
         *
         * @param  {number}  t  parameter value
         * @return {number}  corresponding x value
         */

    }, {
        key: "xFromT",
        value: function xFromT(t) {
            var res = this.bezFunc(t, this.P0[0], this.P1[0], this.P2[0], this.P3[0]);

            return res;
        }

        /**
         * Calculates the derivative of xFromT
         *
         * @param  {number}  t value of parameter
         * @return {number}  slope of the xFromT curve at the value of t
         */

    }, {
        key: "xFromTDerivative",
        value: function xFromTDerivative(t) {
            var res = this.derivative(t, this.P0[0], this.P1[0], this.P2[0], this.P3[0]);

            return res;
        }

        /**
         * Calculates the y value of the point on the bezier curve corresponding to the
         * parameter value t
         *
         * @param  {number}  t  parameter value
         * @return {number}  y value corresponding to the value of t{ description_of_the_return_value }
         */

    }, {
        key: "yFromT",
        value: function yFromT(t) {
            var res = this.bezFunc(t, this.P0[1], this.P1[1], this.P2[1], this.P3[1]);

            return res;
        }
        /**
        * This function computes the slope of the bezier curve at the parameter value t.\
        * This is also the value of the derivate dy/dx at that value of t
        *
        * @param      {float}  t       parameter value
        * @return     {float}  slope
        */

    }, {
        key: "slopeAtT",
        value: function slopeAtT(t) {
            var dydt = this.derivative(t, this.P0[1], this.P1[1], this.P2[1], this.P3[1]);
            var dxdt = this.derivative(t, this.P0[0], this.P1[0], this.P2[0], this.P3[0]);
            var dydx = dydt / dxdt;

            return dydx;
        }
    }]);

    return BezierCubic;
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CubicBezier = CubicBezier;
exports.QuadraticBezier = QuadraticBezier;

var _bezierCubic = __webpack_require__(2);

var _bezierQuadratic = __webpack_require__(4);

var _newtonRaphson = __webpack_require__(6);

var _newtonRaphson2 = _interopRequireDefault(_newtonRaphson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * One of the challenges with bezier curves is that the equations that describe these curves are parametric.
 * This means that each point on the curve, say (x,y), is is a function of some "parameter" which is unfortunately
 * for this application usually called 't'.
 *
 * I have continued this use of 't' for the parameter but please note this is NOT time.
 * In the discussion below and this module
 * the variable x is time and the variable y is distance
 *
 * However to be useful in this application we need to find a way of expressing the curve as a set of points
 * where the y coordinate is a function of the x cordinate, that is, points on the curve are of the form
 *
 *      [x, someFunction(x)]
 *
 * Thats what this module does. The two exported functions take the options that define a bezier curve and create
 * and return a function so that [x, returnedFunction(x)] are on the bezier curve.
 *
 * This process unfortunately requires solving non-linear equations. Thats where newton-Raphson comes in.
 *
 * That returned function is what needs to be used to bild accelerators
 */

/**
 * This function returns a function which is a bezier Cubic curve as a
 * function of x so that (x, f(x)) is a point on the bezier curve.
 * Bezier functions are defined as curves (x(t), y(t)) for a parameter t between 0 .. 1
 * but cannot be rephrased as (x, f(x)). Getting itin this f(x) form takes computational work
 *
 * @param  {array}                      P0  The p 0
 * @param  {array}                      P1  The p 1
 * @param  {array}                      P2  The p 2
 * @param  {array}                      P3  The p 3
 * @return {function}                   returns a function that represents the bezier curve as a function of x
 */
function CubicBezier(P0, P1, P2, P3) {
    var bezObj = new _bezierCubic.BezierCubic(P0, P1, P2, P3);

    /**
     * Evaluates the bezier function and returns yValue and slope of the point
     * on the curve corresponding to the given xValue
     *
     * @param      {number}  xValue the independent variable
     * @return     {Object}  Returns object containing yValue and slopeValue
     */
    function functionOfX(xValue) {
        // find the t value that corresponds to the x value
        // get it by newton raphson

        function f(t) {
            return bezObj.xFromT(t) - xValue;
        }
        function fPrime(t) {
            return bezObj.xFromTDerivative(t);
        }

        var tValue = (0, _newtonRaphson2.default)(f, fPrime, 0.5, null);

        if (tValue === false) {
            throw new Error('cannot find t for x in CubicBezier');
        }
        // const checkXValue = bezObj.xFromT(tValue);
        // console.log(`xValue: ${xValue}  tValue: ${tValue} checkXValue: ${checkXValue}`)

        // let xValue = bezObj.xFromT(t)
        var yValue = bezObj.yFromT(tValue);
        var slopeValue = bezObj.slopeAtT(tValue);

        if (yValue === 0) {
            // console.log('CubicBezier: yValue is zero'); // eslint-disable-line
        }

        return { yValue: yValue, slopeValue: slopeValue };
    }

    return functionOfX;
}
/**
 * This function returns a function which is a bezier Quadratuc curve as a
 * function of x so that (x, f(x)) is a point on the bezier curve
 *
 * @param  {number}                          P0  The p 0
 * @param  {number}                          P1  The p 1
 * @param  {number}                          P2  The p 2
 * @return {function}  Returns a function which gives the bezier curve as a function of x
 */
function QuadraticBezier(P0, P1, P2) {
    var bezObj = new _bezierQuadratic.BezierQuadratic(P0, P1, P2);

    /**
     * Evaluates the bezier function and returns yValue and slope of the point
     * on the curve corresponding to the given xValue
     *
     * @param      {number}  xValue independent variable
     * @return     {Object}  Returns object containing yValue and slopeValue
     */
    function functionOfX(xValue) {
        function f(t) {
            return bezObj.xFromT(t) - xValue;
        }

        function fPrime(t) {
            return bezObj.xFromTDerivative(t);
        }

        var tValue = (0, _newtonRaphson2.default)(f, fPrime, 0.5, { maxIterations: 50, tolerance: 0.001 });

        if (tValue === false) {
            console.log([P0, P1, P2]); // eslint-disable-line
            throw new Error('cannot find t for x in QuadraticBezier xValue:' + xValue);
        }
        // const checkXValue = bezObj.xFromT(tValue);
        // console.log(`xValue: ${xValue}  tValue: ${tValue} checkXValue: ${checkXValue}`)

        // let x = bezObj.xFromT(t);
        var yValue = bezObj.yFromT(tValue);
        var slopeValue = bezObj.slopeAtT(tValue);

        if (yValue === 0) {
            console.log('CubicBezier: yValue is zero'); // eslint-disable-line
        }

        return { yValue: yValue, slopeValue: slopeValue };
    }

    return functionOfX;
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class for bezier quadratic class.
 */
var BezierQuadratic = exports.BezierQuadratic = function () {
    /**
     * Constructs the object.
     *
     * @param  {Float}  P0  Initial point
     * @param  {Float}  P1  Attraction point
     * @param  {Float}  P2  End point
     */
    function BezierQuadratic(P0, P1, P2) {
        _classCallCheck(this, BezierQuadratic);

        this.P0 = P0;
        this.P1 = P1;
        this.P2 = P2;

        // if(P0.length !== 2 || P1.length !== 2 || P2.length !== 2){
        //     debugger
        // }

        // const arr = P0.concat(P1,P2)
        // console.log(arr)
    }
    /**
    * The derivative of the bezier curve
    *
    * @param {number} t the curve parameter
    * @param {number} p0 a coordinate of the point P0
    * @param {number} p1 a coordinate of the point P1
    * @param {number} p2 a coordinate of the point P2
    *
    * @return {number} derivative at t
    */


    _createClass(BezierQuadratic, [{
        key: "derivative",
        value: function derivative(t, p0, p1, p2) {
            function linear(p0, p1, t) {
                var res = p0 * (1.0 - t) + p1 * t;

                return res;
            }

            var res = 2.0 * (linear(p1, p2, t) - linear(p0, p1, t));

            return res;
        }

        /**
        * The coordinate (x or y) of a point on the bezier curve as a function of the
        * variable that parameterizes the curve
        *
        * @param {number} t the curve parameter
        * @param {number} p0 a coordinate of the point P0
        * @param {number} p1 a coordinate of the point P1
        * @param {number} p2 a coordinate of the point P2
        *
        * @return {number} coordinate value at t
        */

    }, {
        key: "bezFunc",
        value: function bezFunc(t, p0, p1, p2) {
            var res = p0 * (1 - t) * (1 - t) + 2.0 * p1 * (1 - t) * t + p2 * t * t;

            return res;
        }

        /**
        * The value of the x coordinate of a point on the bezier curve as a function of the
        * variable that parameterizes the curve
        *
        * @param {number} t the curve parameter
        *
        * @return {number} coordinate value at t
        */

    }, {
        key: "xFromT",
        value: function xFromT(t) {
            var res = this.bezFunc(t, this.P0[0], this.P1[0], this.P2[0]);

            return res;
        }

        /**
        * The value of the derivative of xFromT as a function of the
        * variable that parameterizes the curve
        *
        * @param {number} t the curve parameter
        *
        * @return {number} derivative of XFromT at t
        */

    }, {
        key: "xFromTDerivative",
        value: function xFromTDerivative(t) {
            var res = this.derivative(t, this.P0[0], this.P1[0], this.P2[0]);

            return res;
        }

        /**
        * The value of the y coordinate of a point on the bezier curve as a function of the
        * variable that parameterizes the curve
        *
        * @param {number} t the curve parameter
        *
        * @return {number} coordinate value at t
        */

    }, {
        key: "yFromT",
        value: function yFromT(t) {
            var res = this.bezFunc(t, this.P0[1], this.P1[1], this.P2[1]);

            return res;
        }
        /**
         * This function computes the slope of the bezier curve at the parameter value t.\
         * This is also the value of the derivate dy/dx at that value of t
         *
         * @param      {float}  t       parameter value
         * @return     {float}  slope
         */

    }, {
        key: "slopeAtT",
        value: function slopeAtT(t) {
            var dydt = this.derivative(t, this.P0[1], this.P1[1], this.P2[1]);
            var dxdt = this.derivative(t, this.P0[0], this.P1[0], this.P2[0]);
            var dydx = dydt / dxdt;

            return dydx;
        }
    }]);

    return BezierQuadratic;
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bezierAccelerator = __webpack_require__(0);

var _bezierAccelerator2 = _interopRequireDefault(_bezierAccelerator);

var _simpleAccelerator = __webpack_require__(1);

var _simpleAccelerator2 = _interopRequireDefault(_simpleAccelerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function logger(s) {
    var enabled = false;

    if (enabled)
        /* eslint-disable no-console */
        {
            console.log(s);
        }
    /* eslint-enable no-console */
}
/*
* TODO
*   -   does not correctly support advancing by a time interval that jumps over the end of an acceleration
*/

/**
 * This class seeks to keep track of the 1 dimensional motion of an object that is subject to
 * multiple velocity changes.
 *
 * The two relevant properties of this object are position and velocity which can be obtained
 * at any time with methods getPosition() and getVelocity()
 *
 * A starting velocity is set via the constructor.
 *
 * Time is advanced, and the position and velocity updated, by calling the method
 *
 *  advanceByTimeInterval(timeInterval)
 *
 * with a timeInterval or deltaTime which is a time interval since the last update and is in SECONDS not FRAMES
 *
 *  An alternative advance() method is provided that works in 'ticks' where the tick value in seconds is
 *  defined via the constructor()
 *
 * An acceleration (either positive or negative) can be scheduled by calling the method accelerate(vF, tF, dF)
 * this call will have no effect on the position or velocity until the next call to advance() or advanceByTimeINterval()
 *
 * That method will apply the acceleration on successive calls until the ending condition is encountered
 * tF seconds of acceleration have elapsed AND the body has traveled dF distance during the acceleration
 *
 * On finishing the acceleration the advance() or advanceByTimeInterval() method will call the resolve() function
 * of the promise returned by call to accelerate() that setup the acceleration
 */

var Accelerator = function () {
    /**
     * Constructs the object.
     *
     * @param  {Float}  v0       The initial Velocity
     * @param  {Object} options  The options
     */
    function Accelerator(v0) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Accelerator);

        if (v0 === null || v0 === undefined || typeof v0 !== 'number') {
            throw new Error('Initial velocity not defined');
        }

        var defaults = {
            tickInterval: 1 / 60, // @FIX this is going away
            allowOverwrite: true,
            debug: false
        };

        var actual = Object.assign({}, defaults, options);

        this.tickInterval = actual.tickInterval;
        this.allowOverwrite = actual.allowOverwrite;
        this.debug = actual.debug;

        this.time = 0.0;
        this.elapsedTimeChangingVelocity = 0.0;
        this.totalDistance = 0.0;
        this.changingVelocity = false;
        this.isWaiting = false;
        this.bezAccelerator = null;
        this.currentVelocity = v0;
    }
    /**
     * Advance objects time by the equivalent of delta * PIXI tick value
     *
     * @param  {float}  delta   The delta
     * @return {Float}  Total distance traveled after this time interval is added to
     *                  total time of travel. Just for convenience as could get this with position()
     */


    _createClass(Accelerator, [{
        key: 'advance',
        value: function advance(delta) {
            var deltaTime = delta * this.tickInterval;

            return this.advanceByTimeInterval(deltaTime);
        }

        /**
         * Advance the moving objects time by a time interval
         *
         * @param  {Float}  deltaTime  Interval since the last call to this method
         * @return {Float}  Total distance traveled after this time interval is added to
         *                  total time of travel. Just for convenience as could get this with position()
         */

    }, {
        key: 'advanceByTimeInterval',
        value: function advanceByTimeInterval(deltaTime) {
            if (!this.changingVelocity && !this.isWaiting) {
                this._advanceTimeAndDistanceWhileCoasting(deltaTime);
            } else if (!this.changingVelocity && this.isWaiting) {
                // this.time += deltaTime; - this will be done in _advanceTimeAndDistance
                this.currentWaitingTime += deltaTime;
                if (this.currentWaitingTime >= this.requiredWaitingTime) {
                    this.isWaiting = false;
                    if (typeof this.resolvePromiseFunction === 'function') {
                        this.resolvePromiseFunction();
                    }
                }
                this._advanceTimeAndDistanceWhileCoasting(deltaTime);
            } else {
                this.time += deltaTime;
                this.elapsedTimeChangingVelocity += deltaTime;

                var obj = this.decelerator.getDistanceAndVelocity(this.elapsedTimeChangingVelocity);
                var tmp = obj.distance;
                var tmpV = obj.velocity;

                /**
                 * This is a crude estimate of the velocity. At some point I should work out a formular
                 * rather than do this approximation
                 */

                /**
                 * Trying a new calculation of velocity
                 */
                // this.currentVelocity = deltaDistance / (deltaTime);
                this.currentVelocity = tmpV;

                this.totalDistance = this.distanceBeforeVelocityChange + tmp;

                logger('Mover::advanceByTime  elapsedTimeChangingVelocity: ' + this.elapsedTimeChangingVelocity + (' timeForChange: ' + this.timeForChange) + (' DVdistance: ' + tmp + ' ') + (' totalDistance: ' + this.totalDistance) + (' velocity: ' + this.currentVelocity) + (' tmpV: ' + tmpV));

                /**
                 * There are a number of ways of detecting an end of an acceleration.
                 *
                 *  1.  we could ask the bezAccelerator with => if ( this.decelerator.isComplete() )
                 *  2.  we could use the test below => if (this.elapsedTimeChangingVelocity >= this.timeForChange)
                 *  3.  we could use the callback provided for in the BezAccelerator constructor. This approach
                 *      would require code something like below in _accelerateNoDelay
                 *
                 *          const promise = new Promise( (resolve) =>
                 *          {
                 *              this.decelerator = new BezierAccelerator(v0, vF, tF, dF, () => {
                 *                  resolve()
                 *              });
                 *          }
                 *          this.resolvePromiseFunction = promise
                 *          return promise;
                 *
                 *  @NOTE - how to do kill() in this last situation. Maybe have a kill method on
                 *  the BezierAccelerator ??
                 *
                 * @NOTE : I tried this solution but it gave me some type of race condition
                 * that I could not track down. To do with the fact that the promise does not get resolved until AFTER
                 * the tick handler exits and advance() needs to know we are done BEFORE the promise then function
                 * is called. The problem arose unit testing Kill()
                 *
                 */
                if (this.elapsedTimeChangingVelocity >= this.timeForChange) {
                    // Not sure why we need this - Brendon

                    logger('Mover::advanceTimeBy::velocity increase DONE newVelocity:' + this.newVelocity);
                    /**
                     * This next line is to force the velocity to the specific vF value at the end of the
                     * acceleration. The calculation of currentVelocity during an acceleration is only a crude
                     * approximation and would not get the right final velocity
                     */
                    this.currentVelocity = this.newVelocity;
                    this.changingVelocity = false;
                    if (typeof this.resolvePromiseFunction === 'function') {
                        this.resolvePromiseFunction();
                    }
                }
            }

            if (this.debug) {
                console.log(this.getPosition());
            }

            return this.getPosition();
        }

        /**
         * Gets the current position of the moving object
         *
         * @return {Float}  returns the current position of the moving object
         */

    }, {
        key: 'getPosition',
        value: function getPosition() {
            return this.totalDistance;
        }
    }, {
        key: 'setPosition',
        value: function setPosition(d) {
            this.totalDistance = d;
        }

        /**
         * Gets the current velocity of the moving object
         *
         * @return {Float}  returns the current velocity of the moving object
         */

    }, {
        key: 'getVelocity',
        value: function getVelocity() {
            return this.currentVelocity;
        }

        /**
         * Sets the velocity. This cannot bet set during an acceleration
         *
         * @param  {Float}  v  The currenct velocity
         */

    }, {
        key: 'setVelocity',
        value: function setVelocity(v) {
            if (this.changingVelocity) {
                throw new Error('cannot setVelocity during an acceleration');
            }
            this.currentVelocity = v;
        }

        /**
         * Instructs the object to start a velocity change
         *
         * @param  {float}    vF     - is the velocity the object is to change to
         * @param  {float}    tF     - is the time interval over which the change is to take place
         * @param  {float}    dF     - is the distance that the object should move while changing velocity
         * @return {Promise}  Promise which will be resolved when the acceleration
         *                    has completed
         *
        accelerate(vF, tF, dF)
        {
            return this._accelerateNoDelay(vF, tF, dF);
        }
        */
        /**
         * Implements the guts of the accelerate action. Sets up the necessary properties
         * and returns a promise.
         *
         * Under some circumstances it is permissible to start an acceleration even when one is already
         * active. This depends on the property this.allowOverwrite
         *
         * When permited an overwrite (new acceleration when one is already active)
         *  -   stops the current acceleration and resolves the associated promise
         *  -   sets up a new acceleration using the current velocity, total time and total
         *      distance left over from the kill'd
         *      acceleration as the initial velocity and starting time and distance
         *      for the new acceleration
         *
         *
         * @param  {Float}   vF  is the velocity the object is to change to
         *
         * @param  {Float}   tF  is the time interval over which the change is to take place
         * @param  {Float}   dF  is the distance that the object should move while changing velocity
         *
         * One of dF or tF can be set to null to apply an unconstrained acceleration. In such a
         * case the Bezier accelerator is not used but rather a simple accelerator
         *
         * @return {Promise}  Promise which will be resolved when the acceleration
         *                    has completed
         */

    }, {
        key: 'accelerate',
        value: function accelerate(vF, tF, dF) {
            var _this = this;

            logger('Accelerator::accelerate ' + vF + ' ' + tF + ' ' + dF);
            if (!this.allowOverwrite) {
                if (this.changingVelocity) {
                    throw new Error('cannot have two accelerations underway at the same time');
                }
                if (this.isWaiting) {
                    throw new Error('cannot have commence acceleration while wait is underway');
                }
            } else {
                this.kill();
            }

            var v0 = this.currentVelocity;

            this.distanceBeforeVelocityChange = this.totalDistance;
            this.changingVelocity = true;
            this.elapsedTimeChangingVelocity = 0.0;
            this.timeForChange = tF;
            this.newVelocity = vF;
            this.distanceForChange = dF;

            if (tF !== null && dF !== null) {
                this.decelerator = new _bezierAccelerator2.default(v0, vF, tF, dF);
            } else {
                this.decelerator = new _simpleAccelerator2.default(v0, vF, tF, dF);
            }

            return new Promise(function (resolve) {
                _this.resolvePromiseFunction = resolve;
            });
        }

        /**
         * Lets a timeinterval pass during which the accelerator moves along at a constant velocity.
         *
         * @param  {Float}   delay  The time interval
         * @return {Promise}  After waiting
         */

    }, {
        key: 'wait',
        value: function wait(delay) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                if (!delay || delay <= 0) {
                    resolve();

                    return;
                }

                if (_this2.changingVelocity) {
                    reject('Accelerator: cannot wait while acceleration is underway');

                    return;
                }

                if (_this2.isWaiting) {
                    reject('cannot have commence acceleration while wait is underway');

                    return;
                }
                _this2.isWaiting = true;
                _this2.requiredWaitingTime = delay;
                _this2.currentWaitingTime = 0.0;
                _this2.resolvePromiseFunction = resolve;
            });
        }

        /**
         * Stops any current acceleration or wait & resolves the promise
         *
         * @param  {boolean}  trigger  Whether or not to trigger the completion handler
         */

    }, {
        key: 'kill',
        value: function kill() {
            var trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this.changingVelocity) {
                this.changingVelocity = false;
                if (trigger && typeof this.resolvePromiseFunction === 'function') {
                    this.resolvePromiseFunction();
                }
            } else if (this.isWaiting) {
                this.isWaiting = false;
                if (trigger && typeof this.resolvePromiseFunction === 'function') {
                    this.resolvePromiseFunction();
                }
            } else {
                // console.log(`WARNING: Accelerator - kill not necessary when no acceleration active`);
            }
        }

        /**
         * Advances total time & distance when NO acceleration is active
         *
         * @private
         *
         * @param  {Float}  deltaTime  The delta time
         */

    }, {
        key: '_advanceTimeAndDistanceWhileCoasting',
        value: function _advanceTimeAndDistanceWhileCoasting(deltaTime) {
            this.time += deltaTime;
            this.totalDistance += this.currentVelocity * deltaTime;
            logger('\nMover::advanceTimeBy_VelocityNotChanging ' + (' velocity:' + this.currentVelocity) + (' distance:' + this.totalDistance) + (' time: ' + this.time) + ('deltaTime:' + deltaTime));
        }
    }]);

    return Accelerator;
}();

exports.default = Accelerator;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.newtonRaphson = factory();
  }
}(this, function () {
  return function findRoot(f, fprime, guess, options) {
    options = options || {};
    var tolerance = options.tolerance || 0.00000001;
    var epsilon = options.epsilon || 0.0000000000001;
    var maxIterations = options.maxIterations || 20;
    var haveWeFoundSolution = false; 
    var newtonX;
   
    for (var i = 0; i < maxIterations; ++i) {
      var denominator = fprime(guess);
      if (Math.abs(denominator) < epsilon) {
        return false
      }
   
      result = guess - (f(guess) / denominator);
      
      var resultWithinTolerance = Math.abs(result - guess) < tolerance;
      if (resultWithinTolerance) { 
        return result
      }

      guess = result;
    }
    
    return false;
  }
}));

/***/ })
/******/ ]);
});
//# sourceMappingURL=accelerate.js.map

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_suga__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_suga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_suga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_image_model__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_game_model__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tween__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tween___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_tween__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vendor_custom_ease__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vendor_custom_ease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__vendor_custom_ease__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Webpack loaders
var configDefaults = __webpack_require__(26);
var errorConfig = __webpack_require__(27);
var ThemeImageModel = __webpack_require__(16);

// Native



// Common Views


// Models



// Import tween library



console.log(__WEBPACK_IMPORTED_MODULE_1_suga__);

/**
 * Class for game.
 */

var Game = function () {
    /**
     * Constructs the object.
     */
    function Game() {
        var _this = this;

        _classCallCheck(this, Game);

        window.__log = __WEBPACK_IMPORTED_MODULE_0_loglevel___default.a;
        __WEBPACK_IMPORTED_MODULE_0_loglevel___default.a.disableAll();

        // inject the common & default config options
        this.gameModel = new __WEBPACK_IMPORTED_MODULE_4__model_game_model__["a" /* default */]();
        this.gameModel = Object.assign(this.gameModel, configDefaults);

        window.__dpi = 2; // SUGA.Device.getDpi()
        window.__postfix = __WEBPACK_IMPORTED_MODULE_1_suga__["Device"].getResPostfix(window.__dpi);

        // start the progress bar
        __WEBPACK_IMPORTED_MODULE_1_suga__["Progress"].init('progress-container');
        __WEBPACK_IMPORTED_MODULE_1_suga__["Progress"].start();

        // extend PIXI
        __WEBPACK_IMPORTED_MODULE_2_vue__["Pixi"].extend(__dpi);

        // choose the library
        var which = 'pariplay';

        // get the correct RGS integration
        switch (which) {
            case 'gluckgames':
                __webpack_require__.e/* import() */("gluckgames").then(__webpack_require__.bind(null, 105)).then(function (module) {
                    _this.loadGame(module.GluckGames);
                }).catch(function (error) {
                    throw new Error(error);
                });
                break;

            case 'pariplay':
            default:
                __webpack_require__.e/* import() */("pariplay").then(__webpack_require__.bind(null, 37)).then(function (module) {
                    _this.loadGame(module.Pariplay);
                }).catch(function (error) {
                    throw new Error(error);
                });
        }
    }

    /**
     * Loads a game. Get data from the query string and make the loadGame call
     *
     * @param  {Function}  RGS  The rgs libr
     */


    _createClass(Game, [{
        key: 'loadGame',
        value: function loadGame(RGS) {
            var _this2 = this;

            // get the query string
            var queryData = UTIL.getQueryAsObj();

            // overwrite games which dont have a code
            if (__theme.apiGameCode) {
                queryData.gameCode = __theme.apiGameCode;
            }

            // create an instance of the RGS lib &
            // set it up with the URL querystring data
            // if you are managing your own history you need to handle `back`
            this.rgs = new RGS(queryData, __isMobile, function () {
                return _this2.forceBack();
            });

            // toggle logging based on the this.gameModel.debug
            this.setupLogging();

            this.rgs.loadGame(function (err, rgsModel) {
                _this2.loadGameHandler(err, rgsModel);
            });
        }

        /**
         * Loads a game handler.
         *
         * @param  {object}  err       The error
         * @param  {object}  rgsModel  The rgs model
         */

    }, {
        key: 'loadGameHandler',
        value: function loadGameHandler(err, rgsModel) {
            var _this3 = this;

            // inject the data from the load game request
            this.gameModel = Object.assign(this.gameModel, rgsModel.getData());

            // inject the theme specific values
            this.gameModel = Object.assign(this.gameModel, __theme);

            // make the whole thing global, for easy logging
            window.__config = this.gameModel;

            // determine the state of the sound and mute, before making the UI
            this.gameModel.setSoundAndMute();

            // setup the currency manager
            this.setupCurrencyManager();

            // setup all the event listeners
            this.setupEventListeners();

            // toggle showing the debug info & options
            this.setupDebugging();

            // start Google Analytics tracking
            this.setupTrackingManager();

            // load fonts, images, etc
            this.setupIndependentManagers(function () {
                // this essentially starts PIXI
                // and the render loop
                _this3.setupCanvasManager(function () {
                    // setup some views, so we can either
                    // display the game or any errors
                    _this3.setupInitialViews();

                    // show the game and hide the loader
                    _this3.showGameAfterDelay();

                    // wait until we get a valid response
                    // this callback will be called multiple times
                    if (err) {
                        _this3.showNotificationView(err);

                        return;
                    }

                    // check we have the current & valid balance
                    _this3.getInitialBalance(rgsModel, function () {
                        // tell Google Analytics we are up and running
                        _this3.trackingManager.event('Request', 'LoadGame', !!err);

                        // set the default reality check timer
                        _this3.setupRealityCheckManager();

                        // setup & start sound
                        _this3.setupSoundManager();

                        // start a replay game first if there is one to show
                        if (_this3.gameModel.replayOutcome) {
                            _this3.showReplayMessage();

                            return;
                        }

                        // start a normal game (no replay)
                        _this3.startGame();
                    });
                });
            });
        }

        /**
         * Gets the initial balance.
         *
         * @param  {Object}    rgsModel  The rgs model
         * @param  {Function}  cb        Completion handler
         */

    }, {
        key: 'getInitialBalance',
        value: function getInitialBalance(rgsModel, cb) {
            var _this4 = this;

            // now we validate the state of the game
            // we wait until now so everything is setup
            // and any actions such as errors or replays
            // can be displayed to the user
            this.rgs.getInitialBalance(rgsModel, function (err, balance) {
                // wait until we get a valid response
                // this callback will be called multiple times
                if (err) {
                    _this4.showNotificationView(err);

                    return;
                }

                // if the balance is unknown. `-1` represents unknown
                if (balance === null || balance === undefined) {
                    balance = -1;
                }

                // tell the rest of the app about the balance
                _this4.setBalance(balance, false);

                // update the balance if the process got a new balance
                if (balance !== null && balance !== undefined) {
                    _this4.gameModel.setBalance(balance);
                }

                // tell Google Analytics we are up and running
                _this4.trackingManager.event('Request', 'LoadGame', !!err);

                cb();
            });
        }

        /**
         * Adds the event listeners
         */

    }, {
        key: 'setupEventListeners',
        value: function setupEventListeners() {
            var _this5 = this;

            // notification view events
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('start-replay', function (data) {
                return _this5.startReplay(data);
            });
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('end-replay', function (data) {
                return _this5.endReplay(data);
            });
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('reload', function (e) {
                return _this5.reload(e);
            });
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('hide-reality-check', function (data) {
                return _this5.hideRealityCheck(data);
            });
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('hide-error', function (err) {
                return _this5.hideNotificationView(err);
            });
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('home', function (e) {
                return _this5.rgs.goHome(e);
            }); // RGS external link
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('cashier', function (e) {
                return _this5.rgs.goCashier(e);
            }); // RGS external link
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('buy-more', function (e) {
                return _this5.rgs.goBuyMore(e);
            }); // RGS external link
            __WEBPACK_IMPORTED_MODULE_1_suga__["Event"].on('history', function (e) {
                return _this5.rgs.goHistory(e);
            }); // RGS external link
        }

        /**
         * To log or not to log, that is the question
         */

    }, {
        key: 'setupLogging',
        value: function setupLogging() {
            // turn loggin of by default
            if (this.gameModel.debug) {
                __WEBPACK_IMPORTED_MODULE_0_loglevel___default.a.enableAll();
            }
        }

        /**
         * Set up the vies we will nees initially
         */

    }, {
        key: 'setupInitialViews',
        value: function setupInitialViews() {
            var _this6 = this;

            // get size of all the elements
            var size = this.canvasManager.gameDimensions;

            // localize introtext
            var maxPrize = this.currencyManager.localize(this.gameModel.maxPrize);
            var introtext = __t.str('introtext', { maxPrize: maxPrize });

            var menuOpts = {
                logoUrl: this.themeImageModel.logo,
                logoY: this.gameModel.logoYTitle,
                introText: introtext,
                introTextStyle: this.gameModel.styles.introText,
                showBuyMore: this.gameModel.showBuyMore,
                isOutofTickets: this.gameModel.isOutOfTickets(),
                buttonHandler: function buttonHandler() {
                    return _this6.showGameView();
                }
            };

            // setup menu view
            var ThemeView = __webpack_require__(20).default;
            var themeView = new ThemeView();
            themeView.init(this.themeImageModel);

            this.menuView = new __WEBPACK_IMPORTED_MODULE_2_vue__["MenuView"](size, menuOpts, this.gameModel, this.themeImageModel, themeView);
            this.showMenuView();

            var gameOpts = {
                font: this.gameModel.font,
                showTicketId: this.gameModel.showTicketId,
                placeBet: function placeBet(data) {
                    return _this6.placeBet(data);
                },
                endBet: function endBet(data) {
                    return _this6.endBet(data);
                },
                resultShown: function resultShown(data) {
                    return _this6.resultShown(data);
                },
                stopAutoplay: function stopAutoplay(data) {
                    return _this6.stopAutoplay(true);
                }
            };

            var GameView = __webpack_require__(19).default;

            // setup game view aswell
            this.gameView = new GameView(size, gameOpts, this.themeImageModel);

            // setup this shit helpView
            if (this.gameModel.showHelpButton) {
                var helpOpts = {
                    font: this.gameModel.font,
                    helpUrl: this.gameModel.getHelpUrl(),
                    balanceBarHeight: 45,
                    onBackClick: function onBackClick() {
                        return _this6.back();
                    }
                };

                this.helpView = new __WEBPACK_IMPORTED_MODULE_2_vue__["HelpView"](size, helpOpts);
            }

            // make everything fit
            this.canvasManager.sizeToFit();
        }

        /**
         *  Setup the class that managers PIXI and all the view navigation
         *
         * @param  {Function}  cb  Handler when we are done
         */

    }, {
        key: 'setupCanvasManager',
        value: function setupCanvasManager(cb) {
            var _this7 = this;

            // build the views needed for the canvas manager
            this.gameBg = new PIXI.Sprite.fromImage(this.themeImageModel.bg);

            var bottomBarViewOptions = {
                bgAlpha: 1,
                onHelpClick: function onHelpClick(e) {
                    return _this7.showHelpView(e);
                },
                onHomeClick: function onHomeClick(e) {
                    return _this7.rgs.goHome(e);
                },
                onMuteClick: function onMuteClick(e) {
                    return _this7.toggleMute(e);
                },
                onSettingsClick: function onSettingsClick(e) {
                    return _this7.toggleSettingsView(e);
                }
            };

            this.bottomBarView = new __WEBPACK_IMPORTED_MODULE_2_vue__["BottomBarView"](this.gameModel, bottomBarViewOptions, this.currencyManager);

            var options = {
                dpi: __dpi,
                font: this.gameModel.font,
                showFPS: this.gameModel.fps,
                forceCanvas: this.gameModel.canvas,
                backgroundAnchor: this.gameModel.backgroundAnchor,
                transitionSpeed: 300,
                parallaxBgOffeset: this.gameModel.parallax,
                defaultGameWidth: this.gameModel.gameWidth,
                defaultGameHeight: this.gameModel.gameHeight,
                onResize: function onResize(size) {
                    return _this7.onResize(size);
                },
                onPageVisibility: function onPageVisibility(state) {
                    return _this7.onPageVisibility(state);
                }
            };

            this.canvasManager = new __WEBPACK_IMPORTED_MODULE_2_vue__["Canvas"](options, this.bottomBarView, this.gameBg);
            this.canvasManager.renderCanvas();
            this.canvasManager.sizeToFit();
            this.canvasManager.pushInitHistory('MenuView');

            this.addAdditionalViews();

            cb();
        }

        /**
         * Adds additional views.
         */

    }, {
        key: 'addAdditionalViews',
        value: function addAdditionalViews() {
            var _this8 = this;

            var size = this.canvasManager.gameDimensions;

            if (!this.gameModel.isBasketMode() && this.gameModel.paytable) {
                var settingsOptions = {
                    font: this.gameModel.font,
                    primaryColor: this.gameModel.primaryColor,
                    stake: this.gameModel.getStake(),
                    stakes: this.gameModel.stakes,
                    balance: this.gameModel.getBalance(),
                    paytable: this.gameModel.paytable,
                    autoplayRounds: this.gameModel.autoplayOptions,
                    ukRegulations: this.gameModel.ukRegulations,
                    onChange: function onChange(data) {
                        return _this8.settingsChanged(data);
                    },
                    onSubmit: function onSubmit(data) {
                        return _this8.settingsSubmitted(data);
                    },
                    onVisibilityChange: function onVisibilityChange(data) {
                        return _this8.onSettingsViewVisibilityChange(data);
                    }
                };

                this.settingsView = new __WEBPACK_IMPORTED_MODULE_2_vue__["SettingsView"](size, settingsOptions);

                this.canvasManager.addSettingsView(this.settingsView);
            }

            if (this.gameModel.hasBackgroundView) {
                var BackgroundView = __webpack_require__(17).default;

                if (!BackgroundView.empty) {
                    var backgroundView = new BackgroundView(size, this.themeImageModel);

                    this.canvasManager.addBackgroundView(backgroundView);
                }
            }

            if (this.gameModel.hasForegroundView) {
                var ForegroundView = __webpack_require__(18).default;

                if (!ForegroundView.empty) {
                    var foregroundView = new ForegroundView(size, this.themeImageModel);

                    this.canvasManager.addForegroundView(foregroundView);
                }
            }
        }

        /**
         * Setup the correct currency formatting
         */

    }, {
        key: 'setupCurrencyManager',
        value: function setupCurrencyManager() {
            var currCode = this.gameModel.currencyCode;
            var locale = this.gameModel.languageCode;

            this.currencyManager = new __WEBPACK_IMPORTED_MODULE_1_suga__["Currency"](__WEBPACK_IMPORTED_MODULE_1_suga__["Data"]);
            this.currencyManager.setup(locale, currCode);

            window.__c = this.currencyManager;

            if (this.rgs.currencyLoaded) {
                this.rgs.currencyLoaded({
                    cs: this.currencyManager.getCurrencySymbol(),
                    cc: this.gameModel.currencyCode
                });
            }
        }
    }, {
        key: 'setupIndependentManagers',
        value: function setupIndependentManagers(cb) {
            Promise.all([this.setupFontManager(), this.setupImageManager(), this.setupLocaleManager()]).then(cb).catch(function (reason) {

                cb();
            });
        }

        /**
         * Setup the image/asset loader
         */

    }, {
        key: 'setupImageManager',
        value: function setupImageManager() {
            var _this9 = this;

            return new Promise(function (resolve, reject) {
                try {
                    _this9.themeImageModel = new ThemeImageModel();

                    var themeUrls = _this9.themeImageModel.preload();

                    _this9.imageModel = new __WEBPACK_IMPORTED_MODULE_3__model_image_model__["a" /* default */](__dpi, __postfix);

                    var urls = themeUrls.concat(_this9.imageModel.preload);

                    __WEBPACK_IMPORTED_MODULE_1_suga__["Loader"].loadAssets(urls, resolve);
                } catch (e) {
                    reject();
                    // eslint-disable-line
                }
            });
        }

        /**
         * Load the correct locale/language files
         */

    }, {
        key: 'setupLocaleManager',
        value: function setupLocaleManager() {
            var _this10 = this;

            return new Promise(function (resolve) {
                var lang = _this10.gameModel.languageCode;

                var hackFunctionToLoadLangFiles = function hackFunctionToLoadLangFiles() // eslint-disable-line
                {
                    var path = __webpack_require__(30)("./" + lang + '.json'); // eslint-disable-line
                };

                _this10.localeManager = new __WEBPACK_IMPORTED_MODULE_1_suga__["Locale"](_this10.gameModel.defaultLanguage, './assets/lang/', __version);

                _this10.localeManager.setLocale(lang, resolve);

                window.__t = _this10.localeManager;
            });
        }

        /**
         * Load the fonts for the theme
         */

    }, {
        key: 'setupFontManager',
        value: function setupFontManager() {
            var _this11 = this;

            return new Promise(function (resolve) {
                // copy all the fonts over
                function fake(val) // eslint-disable-line
                {
                    __webpack_require__(31)("./" + val + '.eot');
                    __webpack_require__(32)("./" + val + '.svg');
                    __webpack_require__(33)("./" + val + '.ttf');
                    __webpack_require__(34)("./" + val + '.woff');
                    __webpack_require__(35)("./" + val + '.woff2');
                }

                // the css file loads those fonts
                var fontCssUrl = __webpack_require__(22);
                var fontsToLoad = [_this11.gameModel.getFontWithVariations(), _this11.gameModel.secondaryFont];

                __WEBPACK_IMPORTED_MODULE_1_suga__["Font"].loadFonts(fontsToLoad, fontCssUrl, __version, function (styles) {
                    styles.forEach(function (style) {
                        return new PIXI.Text('test', style);
                    });

                    resolve();
                });
            });
        }

        /**
         * Start up the audio
         */

    }, {
        key: 'setupSoundManager',
        value: function setupSoundManager() {
            var _this12 = this;

            if (__isMobile) {
                this.mute();
            }

            return new Promise(function (resolve, reject) {
                // get url of JSON sprite sheet
                var audioSpriteUrl = __webpack_require__(23);

                // fetch the JSON sprite sheet
                __WEBPACK_IMPORTED_MODULE_1_suga__["Network"].getJSON(audioSpriteUrl, __version, function (err, audioSpriteObj) {
                    // catch error
                    if (err || !audioSpriteObj) {
                        reject();

                        return;
                    }

                    resolve();

                    // make background audio loop
                    audioSpriteObj.sprite.music.push(true);

                    // get audio urls
                    var mp3 = __webpack_require__(24);
                    var ogg = __webpack_require__(25);

                    // build options
                    var options = {
                        mp3: mp3 + '?v=' + __version, // version audio files
                        ogg: ogg + '?v=' + __version, // version audio files
                        masterVolume: _this12.gameModel.getSound(),
                        volumes: _this12.gameModel.volumes,
                        mute: _this12.gameModel.getMute(),
                        audioSpriteObj: audioSpriteObj,
                        startOnInteraction: __isMobile, // whether to start immediately or after user interaction
                        element: document.getElementById('canvas')
                    };

                    var onStart = function onStart() {
                        console.log('started');
                        // start background audio
                        __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].play('music');
                    };

                    // Load the audio sprite json and setup for playback
                    __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].init(options, onStart);
                });
            });
        }

        /**
         * Start Google Analytics event and error tracking
         */

    }, {
        key: 'setupTrackingManager',
        value: function setupTrackingManager() {
            this.trackingManager = new __WEBPACK_IMPORTED_MODULE_1_suga__["Tracking"](this.gameModel.gameCode, __version);
        }

        /**
         * Show the debug options
         */

    }, {
        key: 'setupDebugging',
        value: function setupDebugging() {
            var prizeCount = this.gameModel.paytable ? this.gameModel.paytable.length : 0;

            if (this.gameModel.debug) {
                __webpack_require__.e/* import() */("debug").then(__webpack_require__.bind(null, 42)).then(function (module) {
                    var debugManager = module.default;

                    debugManager.render(prizeCount);
                }).catch(function (error) {
                    throw new Error(error);
                });
            }
        }

        /**
         * Set up reality check stuff
         */

    }, {
        key: 'setupRealityCheckManager',
        value: function setupRealityCheckManager() {
            var _this13 = this;

            if (this.gameModel.showRealityCheck) {
                this.trackingManager.event('RealityCheck', 'event', 'show');

                var interval = this.gameModel.realityCheckSeconds;

                var handler = function handler(msg) {
                    _this13.showRealityCheck(msg);
                };

                // initialize with reality check
                __WEBPACK_IMPORTED_MODULE_1_suga__["Reality"].init(interval, handler, false);

                // start the linterval listener
                __WEBPACK_IMPORTED_MODULE_1_suga__["Reality"].start();
            }
        }

        /**
         * Hide the load screen and display the game after short delay
         */

    }, {
        key: 'showGameAfterDelay',
        value: function showGameAfterDelay() {
            var _this14 = this;

            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_1_suga__["Progress"].done();

                var ele = document.getElementById('initial-loader');

                ele.style.opacity = 0;
                ele.style.display = 'none';

                _this14.canvasManager.showCanvasEle();
            }, this.gameModel.hideLoaderDelay);
        }

        /**
         * Starts a game, after any loading messages or replays
         */

    }, {
        key: 'startGame',
        value: function startGame() {
            var _this15 = this;

            this.gameView.reset();

            // start normal game
            this.enableUserActions();

            this.canvasManager.popOverlay();

            this.rgs.balanceHandler = function (balance) {
                if (window.UTIL.isNotNumeric(balance)) return;
                _this15.setBalance(balance);
            };

            this.setBalance(this.gameModel.getBalance());

            if (this.gameModel.isOutOfTickets() && this.gameModel.showBuyMoreButton) {
                this.showNotificationView({ code: 'NO_TICKETS_LEFT' });
            }
        }

        /**
         * Places a bet
         */

    }, {
        key: 'placeBet',
        value: function placeBet(delay) {
            var _this16 = this;

            if (this.gameModel.showRealityCheck) {
                __WEBPACK_IMPORTED_MODULE_1_suga__["Reality"].canShowRealityCheck(false);
            }

            if (this.gameModel.isOutOfTickets()) {
                this.noTicketsLeft();

                if (this.gameModel.showBuyMoreButton) {
                    this.showNotificationView({ code: 'NO_TICKETS_LEFT' });

                    return;
                }
            }

            // if we are using a delayed play e.g. autoplay
            if (delay) {
                PIXI.setTimeout(delay, function () {
                    // if the user cancelled autoplay in the meantime
                    if (_this16.gameModel.isAutoplaying()) {
                        _this16.placeBet();
                    } else {
                        _this16.gameView.enableInteraction();
                        _this16.enableUserActions();
                    }
                });
                return;
            }

            this.disableNavigationButtons();

            this.bottomBarView.autoplayClearReason();

            this.gameModel.hasUserStartedAutoplay = true;

            var stake = this.gameModel.getStake();

            this.rgs.placeBet(stake, function (err, betModel, code) {
                if (err) {
                    _this16.showNotificationView(err);

                    _this16.gameView.enableInteraction();

                    return;
                }

                betModel.isAutoplay = _this16.gameModel.isAutoplaying();

                if (betModel.isAutoplay) {
                    var roundsLeft = _this16.gameModel.decreaseAutoplay();

                    _this16.bottomBarView.updateAutoplay(roundsLeft, _this16.gameModel.autoplayRounds);
                }

                _this16.setBalance(betModel.balance.balanceBefore);

                _this16.setRemainingTickets(betModel.balance.roundsLeftAfter);

                _this16.canvasManager.popAllOverlays();

                _this16.gameView.executeBet(betModel, err, code);

                _this16.canvasManager.disableScrolling();
            });
        }

        /**
         * This happens as soon as the result is seen
         * aka before any winning animations
         *
         * @param  {<type>}  betModel  The bet model
         */

    }, {
        key: 'resultShown',
        value: function resultShown(betModel) {
            this.rgs.endBet(betModel.getEndBetData());
            if (this.gameModel.isAutoplaying() || betModel.isReplay) {
                return;
            }
            this.enableNavigationButtons();
        }

        /**
         * Ends a round. After any winning animations
         *
         * @param  {object}  data  The data
         */

    }, {
        key: 'endBet',
        value: function endBet(betModel) {
            this.setBalance(betModel.balance.balanceAfter);

            if (betModel.isReplay) {
                this.showEndReplayMessage();
                return;
            }

            if (this.gameModel.showRealityCheck) {
                var shouldStop = __WEBPACK_IMPORTED_MODULE_1_suga__["Reality"].canShowRealityCheck(true);

                if (shouldStop) {
                    // turn off autoplay here

                    return;
                }
            }

            if (this.gameModel.isAutoplaying()) {
                var ticket = betModel.ticket;
                var stopReason = this.gameModel.updateAutoplayState(ticket.totalWinAmount, ticket.totalBet);

                if (stopReason !== null) {
                    this.bottomBarView.autoplayStopped(stopReason);
                    this.enableNavigationButtons();
                }

                if (this.gameModel.autoplayedRounds > 0 && this.gameModel.hasUserStartedAutoplay) {
                    this.placeBet(2);
                } else {
                    this.gameModel.resetAutoplay();
                    this.gameView.resetAutoplay();
                    this.bottomBarView.updateAutoplay(this.gameModel.autoplayedRounds, this.gameModel.autoplayRounds);
                    this.enableNavigationButtons();
                }
            }
        }

        /**
         * Shows the replay message.
         */

    }, {
        key: 'showReplayMessage',
        value: function showReplayMessage() {
            this.showNotificationView({ code: 'REPLAY_START' });
        }

        /**
         * Starts a replay.
         */

    }, {
        key: 'startReplay',
        value: function startReplay() {
            var _this17 = this;

            var ticketModel = this.gameModel.replayOutcome;

            this.rgs.replayBet(ticketModel, function (err, betModel) {
                if (err) {
                    _this17.showNotificationView(err);

                    return;
                }

                _this17.trackingManager.event('Replay', 'event', 'start');

                _this17.setBalance(betModel.getBalanceBefore());
                _this17.showGameView(true);
                _this17.disableUserActions();

                PIXI.setTimeout(2, function () {
                    _this17.gameView.executeBet(betModel);
                });
            });
        }
    }, {
        key: 'stopAutoplay',
        value: function stopAutoplay(resetSettings) {
            if (resetSettings && this.settingsView) {
                this.settingsView.resetModel();
            }

            this.gameModel.stopAutoplay();
            this.bottomBarView.updateAutoplay(this.gameModel.autoplayedRounds, this.gameModel.autoplayRounds);

            this.gameView.enableInteraction();
            this.enableUserActions();
        }

        /**
         * Ends a replay.
         */

    }, {
        key: 'showEndReplayMessage',
        value: function showEndReplayMessage() {
            var _this18 = this;

            PIXI.setTimeout(2, function () {
                _this18.showNotificationView({ code: 'REPLAY_DONE' });
            });
        }
    }, {
        key: 'endReplay',
        value: function endReplay() {
            this.setBalance(this.gameModel.getBalance(), false);
            this.startGame();
            this.showMenuView();
        }

        /**
         * Shows the game view.
         *
         * @param  {boolean}  isReplay  Indicates if replay
         */

    }, {
        key: 'showGameView',
        value: function showGameView(isReplay) {
            this.trackingManager.event('GameView', 'views', 'show');

            var supressEvents = isReplay;

            this.canvasManager.popAllOverlays(supressEvents);
            this.canvasManager.popAllViews();
            this.canvasManager.pushView(this.gameView);
            this.gameView.enableInteraction();

            var duration = 2000;

            __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].fade('music', 0.2, duration);
        }

        /**
         * Shows the menu view.
         */

    }, {
        key: 'showMenuView',
        value: function showMenuView() {
            this.trackingManager.event('MenuView', 'views', 'show');

            this.canvasManager.popOverlay();
            this.canvasManager.popAllViews();
            this.canvasManager.pushView(this.menuView);
        }

        /**
         * Shows the help view.
         */

    }, {
        key: 'showHelpView',
        value: function showHelpView() {
            if (this.gameModel.getHelpUrl() === null) {
                return;
            }

            if (this.canvasManager.isTransitioning) {
                return;
            }

            if (this.helpView.isShowing) {
                this.back();

                return;
            }

            if (this.settingsView && this.settingsView.isOpen) {
                this.settingsView.close();
                return;
            }

            this.trackingManager.event('HelpView', 'views', 'show');

            this.canvasManager.pushView(this.helpView);
        }

        /**
         * Shows the error view
         *
         * @param  {object}  rawErr  The raw error
         */

    }, {
        key: 'showNotificationView',
        value: function showNotificationView(rawErr) {
            var code = void 0;
            var serverMsg = void 0;

            if (rawErr.code) {
                code = rawErr.code;
            }

            if (rawErr.msg) {
                serverMsg = rawErr.msg;
            }

            var err = UTIL.clone(errorConfig[code]);

            if (!err) {
                return;
            }

            if (err.showServerMsg && serverMsg) {
                err.msg = serverMsg;
            }

            if (err.buttons) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Array.from(err.buttons)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var button = _step.value;

                        button.text = __t.str(button.textKey);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                err.buttons = [];
            }

            if (err.fatal) {
                this.stopAutoplay(true);
                this.disableUserActions();
                this.mute();
                this.gameView.reset();
            }

            this.trackingManager.exception(code + ':' + serverMsg, err.fatal);

            var size = this.canvasManager.gameDimensions;

            if (!this.notificationView) {
                var options = {
                    font: this.gameModel.font,
                    primaryColor: this.gameModel.primaryColor,
                    showCashierButton: this.gameModel.showCashierButton,
                    showHistoryButton: this.gameModel.showHistoryButton,
                    showHomeButton: this.gameModel.showHomeButton,
                    showBuyMoreButton: this.gameModel.showBuyMoreButton,
                    buttonImages: {
                        // bgUrl: this.imageModel.buttonBgImage,
                        normalUrl: this.imageModel.buttonSecondaryNormalImage,
                        hoverUrl: this.imageModel.buttonSecondaryHoverImage
                    }
                };

                this.notificationView = new __WEBPACK_IMPORTED_MODULE_2_vue__["NotificationView"](size, options);
            }

            this.notificationView.setup(err.title, err.msg, err.buttons, size, function () {});

            this.canvasManager.pushOverlay(this.notificationView);
        }

        /**
         * Hides the error view
         */

    }, {
        key: 'hideNotificationView',
        value: function hideNotificationView() {
            // this.gameView.resetAfterNotification();

            this.canvasManager.popOverlay();
        }
    }, {
        key: 'toggleSettingsView',
        value: function toggleSettingsView(e) {
            if (this.canvasManager.isViewShowing('HelpView')) {
                this.canvasManager.popView();
                return;
            }

            if (this.settingsView && !this.settingsView.isOpen) {
                this.stopAutoplay(false);
            }

            this.settingsView.toggle();
        }
    }, {
        key: 'onSettingsViewVisibilityChange',
        value: function onSettingsViewVisibilityChange(isOpen) {
            this.bottomBarView.toggleSettings(isOpen);
        }

        /**
         * Sets the balance.
         *
         * @param  {Number}   balance  The balance
         * @param  {boolean}  animate  The animate
         */

    }, {
        key: 'setBalance',
        value: function setBalance(balance) {
            var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.bottomBarView.updateBalance({ balance: balance, animate: animate });

            if (balance !== this.gameModel.getBalance()) {
                this.rgs.balanceChanged(balance);
            }
        }
    }, {
        key: 'setRemainingTickets',
        value: function setRemainingTickets(tickets) {
            this.gameModel.setRoundsLeft(tickets);
            this.bottomBarView.updateTicketCount(tickets);
        }

        /**
         * Shows the reality check.
         *
         * @param  {string}  msg  The message to dispaly
         */

    }, {
        key: 'showRealityCheck',
        value: function showRealityCheck(time) {
            this.disableUserActions();

            var xHours = __t.str('%{smart_count} hours', { smart_count: time.hours });
            var xMins = __t.str('%{smart_count} mins', { smart_count: time.minutes });
            var msg = __t.str('You have been playing for %{xHours} and %{xMins}', { xHours: xHours, xMins: xMins });

            if (this.isShowingRealityCheck) {
                this.notificationView.updateMsg(msg);

                return;
            }

            this.showNotificationView({ code: 'REALITY_CHECK', msg: msg });
            this.isShowingRealityCheck = true;

            this.trackingManager.event('RealityView', 'views', 'show');
        }

        /**
         * Hides the reality check.
         */

    }, {
        key: 'hideRealityCheck',
        value: function hideRealityCheck() {
            this.isShowingRealityCheck = false;
            this.canvasManager.popOverlay();
            this.enableUserActions();

            // this.gameView.resetAfterNotification();
        }

        /**
         * Called on resize
         */

    }, {
        key: 'onResize',
        value: function onResize(size) {
            this.rgs.resize(size.viewportWidth, size.viewportHeight);
        }

        /**
         * Reload the game
         */

    }, {
        key: 'reload',
        value: function reload() {
            location.reload();
        }

        /**
         * When page becomes visible or not
         *
         * @param  {boolean}  isVisible  Indicates if visible
         */

    }, {
        key: 'onPageVisibility',
        value: function onPageVisibility(isVisible) {
            if (isVisible) {
                __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].resumeAll();
            } else {
                __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].pauseAll();
            }
        }

        /**
         * Toggle the sound
         */

    }, {
        key: 'toggleMute',
        value: function toggleMute() {
            if (!this.gameModel.getMute()) {
                this.mute();
            } else {
                this.unMute();
            }
        }

        /**
         * Method to mute game
         */

    }, {
        key: 'mute',
        value: function mute() {
            this.gameModel.setMute(true);
            __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].setMute(true);
            this.bottomBarView.displaySoundOffButton();

            this.trackingManager.event('Mute', 'button', true);
        }

        /**
         * Method to unmute the games
         */

    }, {
        key: 'unMute',
        value: function unMute() {
            this.gameModel.setMute(false);
            __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].setMute(false);
            this.bottomBarView.displaySoundOnButton();

            this.trackingManager.event('Mute', 'button', false);
        }
    }, {
        key: 'settingsChanged',
        value: function settingsChanged(data) {
            this.gameModel.stake = data.stake;

            this.bottomBarView.updateStake(this.gameModel.getStake());
        }
    }, {
        key: 'settingsSubmitted',
        value: function settingsSubmitted(data) {
            Object.assign(this.gameModel, data);

            this.gameModel.resetAutoplay();

            this.bottomBarView.updateStake(this.gameModel.getStake());
            this.bottomBarView.updateAutoplay(this.gameModel.autoplayedRounds, this.gameModel.autoplayRounds);

            if (this.helpView) {
                var h = this.gameModel.autoplayRounds > 0 ? 45 + 21 : 45;
                this.helpView.setBalanceBarHeight(h);
            }
        }

        /**
         * Called when we are out of tickets
         */

    }, {
        key: 'noTicketsLeft',
        value: function noTicketsLeft() {
            this.rgs.noTicketsLeft();
        }

        /**
         * Called when game will reveal all
         */

    }, {
        key: 'willRevealAll',
        value: function willRevealAll() {
            this.rgs.willRevealAll();
        }

        /**
         * Enables the user actions.
         */

    }, {
        key: 'enableUserActions',
        value: function enableUserActions() {
            this.canvasManager.enableUserActions();
        }

        /**
         * Disables the user actions.
         */

    }, {
        key: 'disableUserActions',
        value: function disableUserActions() {
            this.canvasManager.disableUserActions();
        }

        /**
         * Enables the navigation buttons.
         */

    }, {
        key: 'enableNavigationButtons',
        value: function enableNavigationButtons() {
            this.bottomBarView.enableNavigationButtons();
        }

        /**
         * Disables the navigation buttons.
         */

    }, {
        key: 'disableNavigationButtons',
        value: function disableNavigationButtons() {
            this.bottomBarView.disableNavigationButtons();
        }

        /**
         * Go back - we are mananging our own history
         */

    }, {
        key: 'back',
        value: function back() {
            this.canvasManager.back();
        }

        /**
         * Force the game to the previous page
         * Needed when we manage our own history
         */

    }, {
        key: 'forceBack',
        value: function forceBack() {
            this.canvasManager.forceBack();
        }

        /**
         * Tracks events to Google Analy
         *
         * @param  {array}  data  The data
         */

    }, {
        key: 'trackEvent',
        value: function trackEvent(data) {
            this.trackingManager.event(data[0], data[1], data[2]);
        }
    }]);

    return Game;
}();

new Game(); // eslint-disable-line

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Model;
var compose = function compose() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
    }

    return fns.reduce(function (f, g) {
        return function () {
            return f(g.apply(undefined, arguments));
        };
    });
};
var buildArray = compose(sortByFrequency, getPrizesFromPaytable);
var calcSize = compose(countPrizes, countOccurences);

/**
 * Class for wheels & sas model.
 */
function Model(options) {
    Object.assign(this, options);
}

/**
 * Build the model from the prize array
 *
 * @param  {Array}   arr  The arr
 * @return {Object}  The model
 */
Model.prototype.build = function (betModel) {
    var arr = buildArray(betModel);
    var size = calcSize(arr);

    var isWin = size === 1;
    var hasSas = size < 3 && arr[0] >= this.sasIndex;
    var wheels = buildWheels.call(this, arr, hasSas);

    return {
        isWin: isWin,
        wheels: wheels,
        hasSas: hasSas
    };
};

function buildWheels(arr, hasSas) {
    var _this = this;

    return arr.map(function (index, i) {
        var isSas = hasSas && i === 2;

        var sliceIndex = _this.map[index - 1];

        var startDelay = _this.startDelay * i;
        var startDuration = _this.startDuration - startDelay;
        var startRevolutions = _this.startRevolutions;

        var stopDelay = _this.stopDelay * i;
        var stopDuration = isSas ? _this.sasDuration : _this.stopDuration;
        var stopRevolutions = isSas ? _this.sasRevolutions : _this.stopRevolutions;
        var bounceDegrees = isSas ? _this.sasBounceDegrees : _this.bounceDegrees;
        var bounceDuration = isSas ? _this.sasBounceDuration : _this.bounceDuration;

        var totalDuration = startDelay + startDuration + stopDelay + stopDuration + bounceDuration;
        totalDuration = Math.round(totalDuration * 100) / 100;

        return {
            index: index,
            sliceIndex: sliceIndex,
            startDelay: startDelay,
            startDuration: startDuration,
            startRevolutions: startRevolutions,
            stopDelay: stopDelay,
            stopDuration: stopDuration,
            stopRevolutions: stopRevolutions,
            bounceDegrees: bounceDegrees,
            bounceDuration: bounceDuration,
            totalDuration: totalDuration,
            isSas: isSas
        };
    });
}

function countDuplicates(obj, num) {
    obj[num] = ++obj[num] || 1;
    return obj;
}

function countOccurences(arr) {
    return arr.reduce(countDuplicates, {});
}

function getPrizesFromPaytable(betModel) {
    var arr = [];

    if (betModel.ticket.winIndex > 0) {
        arr = [betModel.ticket.winIndex, betModel.ticket.winIndex, betModel.ticket.winIndex];
    } else {
        arr = betModel.ticket.matrixIndexes.slice(0, 3);
    }

    return arr;
}

/**
 * Sorts an array by its frequency
 *
 * @param  {Array}  array  The array
 * @return {Array}  Sorted array
 */
function sortByFrequency(array) {
    var frequency = {};

    array.forEach(function (value) {
        frequency[value] = 0;
    });

    var uniques = array.filter(function (value) {
        frequency[value] += 1;

        return frequency[value] === 1;
    });

    array = uniques.sort(function (a, b) {
        return frequency[b] - frequency[a];
    });

    while (array.length < 3) {
        array.unshift(array[0]);
    }

    return array;
}

function countPrizes(count) {
    return Object.keys(count).length;
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tween__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tween___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tween__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_suga__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_suga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_suga__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * Game visualization of the data that model contains.
 */

var SpinButton = function (_PIXI$Container) {
    _inherits(SpinButton, _PIXI$Container);

    /**
     * Adds the eye button.
     *
     * @param  {String}  size           The size
     * @param  {String}  url            The url
     * @param  {String}  iconUrl        The icon url
     * @param  {String}  reflectionUrl  The reflection url
     * @param  {String}  font           The font
     */
    function SpinButton(size, url, iconUrl, reflectionUrl, font, handler) {
        _classCallCheck(this, SpinButton);

        var _this = _possibleConstructorReturn(this, (SpinButton.__proto__ || Object.getPrototypeOf(SpinButton)).call(this));

        _this.STOP_PERCENT = 0.90;

        _this.buttonClick = handler;

        _this.button = new PIXI.Sprite.fromImage(url);
        _this.addChild(_this.button);
        _this.button.interactive = true;
        _this.button.buttonMode = true;

        _this.button.pointerup = function (e) {
            _this.click(e);
        };

        _this.button.pointerupoutside = function () {
            _this.buttonPulse.scale.set(1);
        };

        var style = {
            fontFamily: font,
            fontSize: 20
        };

        _this.addButtonPulse();
        _this.addText(_this.getSpinText(), style);
        _this.addIcon(iconUrl);
        _this.addReflection(reflectionUrl);
        return _this;
    }

    _createClass(SpinButton, [{
        key: 'addButtonPulse',
        value: function addButtonPulse() {
            var textures = __WEBPACK_IMPORTED_MODULE_1_suga__["Loader"].makeTexturesFromName('button-pulse');
            this.buttonPulse = new PIXI.extras.AnimatedSprite(textures);
            this.button.addChild(this.buttonPulse);
            this.buttonPulse.anchor.set(0.5);
            this.buttonPulse.centerX();
            this.buttonPulse.centerY();
            this.buttonPulse.animationSpeed = 0.2;
            this.buttonPulse.play();
        }
    }, {
        key: 'addText',
        value: function addText(text, style) {
            this.text = new PIXI.Text(text, style);
            this.button.addChild(this.text);
            this.text.centerX();
            this.text.centerY();
        }
    }, {
        key: 'addIcon',
        value: function addIcon(iconUrl) {
            this.icon = new PIXI.Sprite.fromImage(iconUrl);
            this.button.addChild(this.icon);
            this.icon.anchor.set(0.5);
            this.icon.centerX();
            this.icon.centerY();
        }
    }, {
        key: 'addReflection',
        value: function addReflection(reflectionUrl) {
            var reflection = new PIXI.Sprite.fromImage(reflectionUrl);
            this.button.addChild(reflection);
        }
    }, {
        key: 'click',
        value: function click(e) {
            __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].play('spin-button');

            this.buttonClick(e);
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.text.text = this.getSpinText();
            this.text.centerX();
        }
    }, {
        key: 'showStopText',
        value: function showStopText(delay, isAuto) {
            var _this2 = this;

            if (isAuto) {
                this.text.text = this.getStopText();
                this.text.centerX();
                return;
            }

            this.fadeTextOut();
            PIXI.setTimeout(delay, function () {
                _this2.fadeTextIn(_this2.getStopText());
            });
        }
    }, {
        key: 'showSpinText',
        value: function showSpinText(delay, isAuto) {
            var _this3 = this;

            if (isAuto) return;
            PIXI.setTimeout(delay, function () {
                _this3.fadeTextIn(_this3.getSpinText());
            });
        }
    }, {
        key: 'hideText',
        value: function hideText(isAuto, cb) {

            if (isAuto) {
                if (cb) {
                    cb();
                }
                return;
            }
            this.fadeTextOut(cb);
        }

        /**
         * Set button text and fed it in
         *
         * @param  {String}    label    The label
         * @param  {Boolean}    disable  The disable
         * @param  {Function}  cb       Completion Handler
         */

    }, {
        key: 'fadeTextIn',
        value: function fadeTextIn(label) {
            var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var cb = arguments[2];

            this.text.text = label;
            this.text.centerX();

            var opts = {
                alpha: 1,
                onComplete: function onComplete() {
                    if (cb) {
                        cb();
                    }
                }
            };

            __WEBPACK_IMPORTED_MODULE_0_tween___default.a.to(this.text, 0.1, opts);
        }

        /**
         * Fade button text out
         *
         * @param  {Function}  cb     Completion Handler
         */

    }, {
        key: 'fadeTextOut',
        value: function fadeTextOut(cb) {
            if (this.isAutoplay) {
                if (cb) {
                    cb();
                }
                return;
            }

            var opts = {
                alpha: 0,
                onComplete: function onComplete() {
                    if (cb) {
                        cb();
                    }
                }
            };

            __WEBPACK_IMPORTED_MODULE_0_tween___default.a.to(this.text, 0.1, opts);
        }

        /**
         * Spin the icon in the spin button
         *
         * @param  {Number}  degrees   The degrees
         * @param  {Number}  duration  The duration
         */

    }, {
        key: 'spin',
        value: function spin(degrees, duration) {
            var _this4 = this;

            var opts = {
                rotation: window.degToRad(degrees),
                ease: window.Power1.easeInOut,
                onComplete: function onComplete() {
                    _this4.icon.rotation = 0;
                    _this4.iconTween = null;
                }
            };

            this.iconTween = __WEBPACK_IMPORTED_MODULE_0_tween___default.a.to(this.icon, duration, opts);
        }
    }, {
        key: 'stopSpin',
        value: function stopSpin() {
            if (this.iconTween) {
                this.iconTween.totalProgress(this.STOP_PERCENT);
            }
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.interactiveChildren = true;
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.interactiveChildren = false;
        }
    }, {
        key: 'getSpinText',
        value: function getSpinText() {
            return __t.str('Spin').toUpperCase();
        }
    }, {
        key: 'getStopText',
        value: function getStopText() {
            return __t.str('Stop').toUpperCase();
        }
    }]);

    return SpinButton;
}(PIXI.Container);

/* harmony default export */ __webpack_exports__["a"] = (SpinButton);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accelerate_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accelerate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_accelerate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_suga__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_suga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_suga__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * Wheel visualization of the data that model contains.
 */

var WheelView = function (_PIXI$Container) {
    _inherits(WheelView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {String}  url         The url
     * @param  {Array}   scales      The scales of the 3 wheels
     * @param  {Number}  sliceCount  The slice count
     */
    function WheelView(url, scales, sliceCount) {
        _classCallCheck(this, WheelView);

        // Set some constants
        var _this = _possibleConstructorReturn(this, (WheelView.__proto__ || Object.getPrototypeOf(WheelView)).call(this));

        _this.PIE_ANGLE = 360 / sliceCount;
        var PIE_MIDDLE = _this.PIE_ANGLE / 2;
        var PIE_OFFSET = 90 - PIE_MIDDLE;

        // Get the wheel texture
        var texture = new PIXI.Texture.fromImage(url);

        // Build the container and place it
        var container = new PIXI.Container();

        _this.addChild(container);
        container.x = texture.width / 2;
        container.y = texture.height / 2;

        // Build wheels
        _this.containerOuter = _this.makeContainer(texture, scales[0], 0, -PIE_OFFSET);
        _this.containerMiddle = _this.makeContainer(texture, scales[1], 1, -PIE_OFFSET);
        _this.containerInner = _this.makeContainer(texture, scales[2], 2, -PIE_OFFSET);

        // Add wheels
        container.addChild(_this.containerOuter);
        container.addChild(_this.containerMiddle);
        container.addChild(_this.containerInner);

        _this.acceleratorOuter = new __WEBPACK_IMPORTED_MODULE_0_accelerate_js___default.a(0, { allowOverride: true, debug: false });
        _this.acceleratorMiddle = new __WEBPACK_IMPORTED_MODULE_0_accelerate_js___default.a(0, { allowOverride: true });
        _this.acceleratorInner = new __WEBPACK_IMPORTED_MODULE_0_accelerate_js___default.a(0, { allowOverride: true });

        _this.ticker = function (delta) {
            _this.containerOuter.wheel.rotation = window.degToRad(_this.acceleratorOuter.advance(delta));
            _this.containerMiddle.wheel.rotation = window.degToRad(_this.acceleratorMiddle.advance(delta));
            _this.containerInner.wheel.rotation = window.degToRad(_this.acceleratorInner.advance(delta));
        };
        return _this;
    }

    /**
     * Set wheels back to initial position
     */


    _createClass(WheelView, [{
        key: 'reset',
        value: function reset() {
            this.acceleratorOuter.setPosition(0);
            this.acceleratorMiddle.setPosition(0);
            this.acceleratorInner.setPosition(0);
            this.containerOuter.wheel.rotation = 0;
            this.containerMiddle.wheel.rotation = 0;
            this.containerInner.wheel.rotation = 0;
        }

        /**
         * Spin all the wheels
         *
         * @param  {Object}    model              The model
         * @param  {Function}  maxSpeedHandler    The handler when maximum speed is reached
         * @param  {Function}  completionHandler  The completion handler
         */

    }, {
        key: 'spin',
        value: function spin(model, completionHandler) {
            var _this2 = this;

            this.model = model;
            this.spinning = true;
            this.completionHandler = completionHandler;
            this.addAccelerators();

            this.startAllWheels(this.model.wheels).then(function () {
                return _this2.stopAllWheels(_this2.model.wheels, false);
            });
        }

        /**
         * Starts all the wheels spinning
         *
         * @param  {Array}    wheels - The wheels
         * @return {Promise}  Completion Handler for all wheels
         */

    }, {
        key: 'startAllWheels',
        value: function startAllWheels(wheels) {
            var p1 = this.startWheel(this.acceleratorInner, this.containerInner, wheels[0]);
            var p2 = this.startWheel(this.acceleratorMiddle, this.containerMiddle, wheels[1]);
            var p3 = this.startWheel(this.acceleratorOuter, this.containerOuter, wheels[2]);

            return Promise.all([p1, p2, p3]); // .then(cb)
        }

        /**
         * Starts a wheel.
         *
         * @param  {Accelerator}     accelerator  The accelerator
         * @param  {PIXI.Container}  container    The container
         * @param  {Number}          model        The delay
         * @return {Promise}         The motion promise chain
         */

    }, {
        key: 'startWheel',
        value: function startWheel(accelerator, container, model) {
            var _this3 = this;

            var duration = model.startDuration;
            var delay = model.startDelay;

            container.stopped = false;

            return accelerator.wait(delay).then(function () {
                return accelerator.accelerate(1100, duration, null);
            }).then(function () {
                accelerator.setPosition(_this3.PIE_ANGLE * model.sliceIndex);
            });
        }

        /**
         * Slow all the wheels down
         *
         * @param  {Array}    wheels      - The wheels
         * @param  {Number}   timeToStop  - The time to stop
         * @param  {Number}   revs        - The revolutions
         * @param  {Number}   bounceBack  - The bounce back
         * @return {Promise}  Promise when all are completed
         */

    }, {
        key: 'stopAllWheels',
        value: function stopAllWheels(wheels, instant) {
            var _this4 = this;

            if (!this.spinning) {
                return null;
            }

            this.isSlowingDown = true;
            var pDown1 = this.stopWheel(this.acceleratorInner, this.containerInner, wheels[0], instant);
            var pDown2 = this.stopWheel(this.acceleratorMiddle, this.containerMiddle, wheels[1], instant);
            var pDown3 = this.stopWheel(this.acceleratorOuter, this.containerOuter, wheels[2], instant);

            Promise.all([pDown1, pDown2, pDown3]).then(function () {
                _this4.completed();
            });
        }

        /**
         * Slow a wheel down
         *
         * @param  {Object}          model        - The model
         * @param  {Number}          timeToStop   - The time to stop
         * @param  {Number}          revolutions  - The revolutions
         * @param  {PIXI.Container}  container    - The container
         * @param  {Accelerate}      accelerator  - The accelerator
         * @return {Promise}         The motion promise chain
         */

    }, {
        key: 'stopWheel',
        value: function stopWheel(accelerator, container, model, instant) {
            var _this5 = this;

            if (container.stopped) {
                return;
            }

            accelerator.kill(false);

            var finalVelocity = 0;
            var bounceDegrees = model.bounceDegrees;
            var bounceDuration = model.bounceDuration;
            var delay = model.stopDelay;

            return accelerator.wait(delay).then(function () {
                var prizeAngle = _this5.PIE_ANGLE * model.sliceIndex;
                var currentAngle = accelerator.getPosition() % 360;
                var degreesToPrize = prizeAngle - currentAngle;

                if (degreesToPrize < 0) {
                    degreesToPrize += 360;
                }

                var duration = model.stopDuration;
                var degreesToAdd = 360 * model.stopRevolutions;
                var degreesToEnd = bounceDegrees + degreesToAdd + degreesToPrize;
                // offset wheels to prize

                return accelerator.accelerate(finalVelocity, duration, degreesToEnd);
            }).then(function () {
                return accelerator.accelerate(finalVelocity, bounceDuration, -bounceDegrees);
            }).then(function () {
                container.stopped = true;

                if (model.isSas) {
                    return;
                }
                var i = 3 - container.index;

                __WEBPACK_IMPORTED_MODULE_1_suga__["Sound"].play('stop-' + i);

                return;
            });
        }

        /**
         * Stops all the wheels (this is the user action stop)
         *
         * @return {Promise}  Completion handler for all wheels
         */

    }, {
        key: 'stop',
        value: function stop() {
            this.acceleratorInner.setPosition(this.PIE_ANGLE * this.model.wheels[0].sliceIndex);
            this.acceleratorMiddle.setPosition(this.PIE_ANGLE * this.model.wheels[1].sliceIndex);
            this.acceleratorOuter.setPosition(this.PIE_ANGLE * this.model.wheels[2].sliceIndex);

            this.calculateStoppingDistance(this.acceleratorInner, this.model.wheels[0]);
            this.calculateStoppingDistance(this.acceleratorMiddle, this.model.wheels[1]);
            this.calculateStoppingDistance(this.acceleratorOuter, this.model.wheels[2]);

            return this.stopAllWheels(this.model.wheels, true);
        }
    }, {
        key: 'calculateStoppingDistance',
        value: function calculateStoppingDistance(accelerator, model) {
            var v0 = accelerator.getVelocity();
            var maxRevolutions = Math.floor(v0 / 360);

            model.isSas = false;
            model.stopDelay = 0;
            model.stopDuration = 0.5;
            model.stopRevolutions = 0;
            model.bounceDegrees = maxRevolutions;
            model.bounceDuration = 0.2;
        }

        /**
         * When the animation is complete
         */

    }, {
        key: 'completed',
        value: function completed() {
            this.completionHandler();
            this.removeAccelerators();
            this.isSlowingDown = false;
            this.spinning = false;
        }

        /**
         * Adds accelerators.
         */

    }, {
        key: 'addAccelerators',
        value: function addAccelerators() {
            // Create accelerators
            // this.acceleratorOuter = new Accelerate(0);
            // this.acceleratorMiddle = new Accelerate(0);
            // this.acceleratorInner = new Accelerate(0);
            window.__ticker.add(this.ticker);
        }

        /**
         * Removes accelerators.
         */

    }, {
        key: 'removeAccelerators',
        value: function removeAccelerators() {
            // this.acceleratorOuter = null;
            // this.acceleratorMiddle = null;
            // this.acceleratorInner = null;
            window.__ticker.remove(this.ticker);
        }

        /**
         * Makes a container.
         *
         * @param  {PIXI.Texture}    texture     The texture
         * @param  {Number}          scale       The scale
         * @param  {number}          wheelIndex  The wheel index
         * @param  {number}          offset      The offset
         * @return {PIXI.Container}  The Wheel
         */

    }, {
        key: 'makeContainer',
        value: function makeContainer(texture, scale, wheelIndex, offset) {
            var container = new PIXI.Container();

            container.pivot.x = 0;
            container.pivot.y = 0;
            container.scale.set(scale);
            container.index = wheelIndex;
            container.stopped = true;

            var wheel = new PIXI.Sprite(texture);

            container.addChild(wheel);
            container.wheel = wheel;
            wheel.anchor.set(0.5);

            return container;
        }
    }]);

    return WheelView;
}(PIXI.Container);

/* harmony default export */ __webpack_exports__["a"] = (WheelView);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/SignPainter-HouseScript.svg";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-bold-webfont.svg";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-regular-webfont.svg";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary-hover.png";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary-hover@2x.png";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary-normal.png";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary-normal@2x.png";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons.png";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons@2x.png";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/background.jpg";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/background@2x.jpg";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/button.png";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/button@2x.png";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/character.png";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/character@2x.png";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/frame.png";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/frame@2x.png";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/logo-title.png";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/spin-sign.png";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/spin-sign@2x.png";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/star.png";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/star@2x.png";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/wheel1.png";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/wheel1@2x.png";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/green-button.png";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/green-button@2x.png";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/queenhand.png";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/sas-small-reduced.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/win-frame.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/win-sign.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/win-sign@2x.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/cs.json";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/de.json";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/en.json";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/hu.json";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/pl.json";

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/pt.json";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/sk.json";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/sv.json";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons.json";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons@2x.json";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/SignPainter-HouseScript.eot";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/SignPainter-HouseScript.ttf";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/SignPainter-HouseScript.woff";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-bold-webfont.eot";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-bold-webfont.ttf";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-bold-webfont.woff";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-bold-webfont.woff2";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-regular-webfont.eot";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-regular-webfont.ttf";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-regular-webfont.woff";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/font/proximasoft-regular-webfont.woff2";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/green-button.json";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/green-button@2x.json";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/queenhand.json";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/sas-small-reduced.json";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/win-frame.json";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/win-sign.json";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/sprite/win-sign@2x.json";

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-secondary-hover.png": 49,
	"./button-secondary-hover@2x.png": 50
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-secondary-normal.png": 51,
	"./button-secondary-normal@2x.png": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./buttons.json": 85,
	"./buttons@2x.json": 86
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./buttons.png": 53,
	"./buttons@2x.png": 54
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./background.jpg": 55,
	"./background@2x.jpg": 56
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-hover.png": 5,
	"./button-hover@2x.png": 6,
	"./button-normal.png": 7,
	"./button-normal@2x.png": 8,
	"./button.png": 57,
	"./button@2x.png": 58
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-hover.png": 5,
	"./button-hover@2x.png": 6
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-normal.png": 7,
	"./button-normal@2x.png": 8
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./character.png": 59,
	"./character@2x.png": 60
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./frame-center-spec-overlay.png": 3,
	"./frame-center-spec-overlay@2x.png": 4,
	"./frame-center.png": 9,
	"./frame-center@2x.png": 10,
	"./frame.png": 61,
	"./frame@2x.png": 62
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./frame-center-spec-overlay.png": 3,
	"./frame-center-spec-overlay@2x.png": 4,
	"./frame-center.png": 9,
	"./frame-center@2x.png": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./frame-center-spec-overlay.png": 3,
	"./frame-center-spec-overlay@2x.png": 4
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./logo-title.png": 63,
	"./logo-title@2x.png": 2
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./spin-sign.png": 64,
	"./spin-sign@2x.png": 65
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./star.png": 66,
	"./star@2x.png": 67
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./wheel1.png": 68,
	"./wheel1@2x.png": 69
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./green-button.json": 98,
	"./green-button@2x.json": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./green-button.png": 70,
	"./green-button@2x.png": 71
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./win-sign.json": 103,
	"./win-sign@2x.json": 104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./win-sign.png": 75,
	"./win-sign@2x.png": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// d-game.js